// this file is automatically generated.
// !!! DO NOT EDIT !!!

import _ from 'lodash'



export let dirtyFlag = false
function doAlert(s) { console.log(s) }

// enum AUSengine
export const AUS_DU = 'DU'
export const AUS_LPA = 'LPA'
export const AUS_Other = 'other'

// enum AUSrecommondation
export const AUS_Approve_eligible = 'approve-eligible'
export const AUS_Approve_ineligible = 'approve-ineligible'
export const AUS_Referwithcaution = 'referwithcaution'
export const AUS_Outofscope = 'outofscope'

// enum AccountType
export const AccountType_CheckingAccount = 'CheckingAccount'
export const AccountType_SavingsAccount = 'SavingsAccount'
export const AT_MoneyMarket = 'MoneyMarket'
export const AT_CertificateOfDeposit = 'CertificateOfDeposit'
export const AT_Retirement = 'Retirement'
export const AT_Bonds = 'Bonds'
export const AT_Stocks = 'Stocks'
export const AccountType_StockOptions = 'StockOptions'
export const AT_BridgeLoanProceeds = 'BridgeLoanProceeds'
export const AccountType_IndividualDevelopmentAccount = 'IndividualDevelopmentAccount'
export const AccountType_TrustAccount = 'TrustAccount'
export const AT_CashValueLifeInsurance = 'CashValueLifeInsurance'
export const AccountType_MutualFund = 'MutualFund'

// enum AlimonyOrSupport
export const AOS_Alimony = 'alimony'
export const AOS_Childsupport = 'childsupport'
export const AOS_Maintenancepayments = 'maintenancepayments'
export const AOS_Jobrelatedexpenses = 'jobrelatedexpenses'
export const AOS_Other = 'other'

// enum AlimonyStretch
export const AS_Lessthan10 = 'lessthan10'
export const AS_Morethan10 = 'morethan10'
export const AS_Notsure = 'notsure'

// enum ApplicationStatus
export const AS_Loinitialized = 'loinitialized'
export const AS_Interviewstarted = 'interviewstarted'
export const AS_Productselected = 'productselected'
export const AS_Interviewfinished = 'interviewfinished'
export const AS_Documentationrequested = 'documentationrequested'
export const AS_Loansubmitted = 'loansubmitted'
export const AS_Conditionallyapproved = 'conditionallyapproved'
export const AS_Loanafinalapproved = 'loanafinalapproved'
export const AS_Submittedtoescrow = 'submittedtoescrow'
export const AS_Finaldocssigned = 'finaldocssigned'
export const AS_Fundsreleased = 'fundsreleased'
export const AS_Applicationwithdrawn = 'applicationwithdrawn'
export const AS_Applicationabandoned = 'applicationabandoned'
export const AS_Aplicationrejected = 'aplicationrejected'
export const AS_Borrowerwithdrew = 'borrowerwithdrew'
export const AS_Loancanceled = 'loancanceled'
export const AS_Loandenied = 'loandenied'

// enum AssetType
export const AT_Bond = 'Bond'
export const AT_BridgeLoanNotDeposited = 'BridgeLoanNotDeposited'
export const AT_CashOnHand = 'CashOnHand'
export const AT_CertificateOfDepositTimeDeposit = 'CertificateOfDepositTimeDeposit'
export const AssetType_CheckingAccount = 'CheckingAccount'
export const AT_GiftOfCash = 'GiftOfCash'
export const AT_GiftOfPropertyEquity = 'GiftOfPropertyEquity'
export const AT_Grant = 'Grant'
export const AssetType_IndividualDevelopmentAccount = 'IndividualDevelopmentAccount'
export const AT_LifeInsurance = 'LifeInsurance'
export const AT_MoneyMarketFund = 'MoneyMarketFund'
export const AssetType_MutualFund = 'MutualFund'
export const AT_Other = 'Other'
export const AT_PendingNetSaleProceedsFromRealEstateAssets = 'PendingNetSaleProceedsFromRealEstateAssets'
export const AT_ProceedsFromSaleOfNonRealEstateAsset = 'ProceedsFromSaleOfNonRealEstateAsset'
export const AT_ProceedsFromSecuredLoan = 'ProceedsFromSecuredLoan'
export const AT_ProceedsFromUnsecuredLoan = 'ProceedsFromUnsecuredLoan'
export const AT_RetirementFund = 'RetirementFund'
export const AssetType_SavingsAccount = 'SavingsAccount'
export const AT_Stock = 'Stock'
export const AssetType_StockOptions = 'StockOptions'
export const AssetType_TrustAccount = 'TrustAccount'

// enum Citizenship
export const C_Citizen = 'citizen'
export const C_Permanent = 'permanent'
export const C_Alien = 'alien'

// enum Correction
export const C_None = 'none'
export const C_Wrongperson = 'wrongperson'
export const C_Alreadyclosed = 'alreadyclosed'
export const C_Paidbybusiness = 'paidbybusiness'
export const C_Duplicate = 'duplicate'
export const C_Other = 'other'

// enum CreditAccountType
export const CAT_SoftPull = 'SoftPull'
export const CAT_HardPull = 'HardPull'
export const CAT_Universal = 'Universal'

// enum CreditAccountVendor
export const CAV_KCB = 'KCB'
export const CAV_AdvantageCredit = 'AdvantageCredit'

// enum CreditBureau
export const CB_Equifax = 'Equifax'
export const CB_Experian = 'Experian'
export const CB_TransUnion = 'TransUnion'

// enum CreditLiabilityAccountOwnershipType
export const CLAOT_AuthorizedUser = 'AuthorizedUser'
export const CLAOT_Comaker = 'Comaker'
export const CLAOT_Deceased = 'Deceased'
export const CLAOT_Individual = 'Individual'
export const CLAOT_JointContractualLiability = 'JointContractualLiability'
export const CLAOT_JointParticipating = 'JointParticipating'
export const CLAOT_Maker = 'Maker'
export const CLAOT_OnBehalfOf = 'OnBehalfOf'
export const CLAOT_Terminated = 'Terminated'
export const CLAOT_Undesignated = 'Undesignated'

// enum CreditLiabilityAccountStatusType
export const CLAST_Closed = 'Closed'
export const CLAST_Frozen = 'Frozen'
export const CLAST_Open = 'Open'
export const CLAST_Paid = 'Paid'
export const CLAST_Refinanced = 'Refinanced'
export const CLAST_Transferred = 'Transferred'

// enum CreditLiabilityAccountType
export const CLAT_CreditLine = 'CreditLine'
export const CLAT_Installment = 'Installment'
export const CLAT_Mortgage = 'Mortgage'
export const CLAT_Open = 'Open'
export const CLAT_Revolving = 'Revolving'
export const CLAT_Unknown = 'Unknown'

// enum CreditLiabilityHighestAdverseRating
export const CLHAR_AsAgreed = 'AsAgreed'
export const CLHAR_BankruptcyOrWageEarnerPlan = 'BankruptcyOrWageEarnerPlan'
export const CLHAR_ChargeOff = 'ChargeOff'
export const CLHAR_Collection = 'Collection'
export const CLHAR_CollectionOrChargeOff = 'CollectionOrChargeOff'
export const CLHAR_Foreclosure = 'Foreclosure'
export const CLHAR_ForeclosureOrRepossession = 'ForeclosureOrRepossession'
export const CLHAR_Late30Days = 'Late30Days'
export const CLHAR_Late60Days = 'Late60Days'
export const CLHAR_Late90Days = 'Late90Days'
export const CLHAR_LateOver120Days = 'LateOver120Days'
export const CLHAR_NoDataAvailable = 'NoDataAvailable'
export const CLHAR_Repossession = 'Repossession'
export const CLHAR_TooNew = 'TooNew'
export const CLHAR_WageEarnerPlan = 'WageEarnerPlan'

// enum CreditLoanType
export const CLT_Agriculture = 'Agriculture'
export const CLT_Airplane = 'Airplane'
export const CLT_ApplianceOrFurniture = 'ApplianceOrFurniture'
export const CLT_AttorneyFees = 'AttorneyFees'
export const CLT_AutoLease = 'AutoLease'
export const CLT_AutoLoanEquityTransfer = 'AutoLoanEquityTransfer'
export const CLT_Automobile = 'Automobile'
export const CLT_AutoRefinance = 'AutoRefinance'
export const CLT_BiMonthlyMortgageTermsInYears = 'BiMonthlyMortgageTermsInYears'
export const CLT_Boat = 'Boat'
export const CLT_Business = 'Business'
export const CLT_BusinessCreditCard = 'BusinessCreditCard'
export const CLT_Camper = 'Camper'
export const CLT_ChargeAccount = 'ChargeAccount'
export const CLT_CheckCreditOrLineOfCredit = 'CheckCreditOrLineOfCredit'
export const CLT_ChildSupport = 'ChildSupport'
export const CLT_Collection = 'Collection'
export const CLT_CollectionAttorney = 'CollectionAttorney'
export const CLT_Comaker = 'Comaker'
export const CLT_CombinedCreditPlan = 'CombinedCreditPlan'
export const CLT_CommercialCreditObligation = 'CommercialCreditObligation'
export const CLT_CommercialLineOfCredit = 'CommercialLineOfCredit'
export const CLT_CommercialMortgage = 'CommercialMortgage'
export const CLT_ConditionalSalesContract = 'ConditionalSalesContract'
export const CLT_ConditionalSalesContractRefinance = 'ConditionalSalesContractRefinance'
export const CLT_Consolidation = 'Consolidation'
export const CLT_ConstructionLoan = 'ConstructionLoan'
export const CLT_ConventionalRealEstateMortgage = 'ConventionalRealEstateMortgage'
export const CLT_CreditCard = 'CreditCard'
export const CLT_CreditLineSecured = 'CreditLineSecured'
export const CLT_DebitCard = 'DebitCard'
export const CLT_DebtCounselingService = 'DebtCounselingService'
export const CLT_DeferredStudentLoan = 'DeferredStudentLoan'
export const CLT_DepositRelated = 'DepositRelated'
export const CLT_Educational = 'Educational'
export const CLT_Employment = 'Employment'
export const CLT_FactoringCompanyAccount = 'FactoringCompanyAccount'
export const CLT_FamilySupport = 'FamilySupport'
export const CLT_FarmersHomeAdministrationFHMA = 'FarmersHomeAdministrationFHMA'
export const CLT_FederalConsolidatedLoan = 'FederalConsolidatedLoan'
export const CLT_FHAComakerNotBorrower = 'FHAComakerNotBorrower'
export const CLT_FHAHomeImprovement = 'FHAHomeImprovement'
export const CLT_FHARealEstateMortgage = 'FHARealEstateMortgage'
export const CLT_FinanceStatement = 'FinanceStatement'
export const CLT_GovernmentBenefit = 'GovernmentBenefit'
export const CLT_GovernmentEmployeeAdvance = 'GovernmentEmployeeAdvance'
export const CLT_GovernmentFeeForService = 'GovernmentFeeForService'
export const CLT_GovernmentFine = 'GovernmentFine'
export const CLT_GovernmentGrant = 'GovernmentGrant'
export const CLT_GovernmentMiscellaneousDebt = 'GovernmentMiscellaneousDebt'
export const CLT_GovernmentOverpayment = 'GovernmentOverpayment'
export const CLT_GovernmentSecuredDirectLoan = 'GovernmentSecuredDirectLoan'
export const CLT_GovernmentSecuredGuaranteeLoan = 'GovernmentSecuredGuaranteeLoan'
export const CLT_GovernmentUnsecuredDirectLoan = 'GovernmentUnsecuredDirectLoan'
export const CLT_GovernmentUnsecuredGuaranteeLoan = 'GovernmentUnsecuredGuaranteeLoan'
export const CLT_HomeEquity = 'HomeEquity'
export const CLT_HomeEquityLineOfCredit = 'HomeEquityLineOfCredit'
export const CLT_HomeImprovement = 'HomeImprovement'
export const CLT_HouseholdGoods = 'HouseholdGoods'
export const CLT_HouseholdGoodsAndOtherCollateralAuto = 'HouseholdGoodsAndOtherCollateralAuto'
export const CLT_HouseholdGoodsSecured = 'HouseholdGoodsSecured'
export const CLT_InstallmentLoan = 'InstallmentLoan'
export const CLT_InstallmentSalesContract = 'InstallmentSalesContract'
export const CLT_InsuranceClaims = 'InsuranceClaims'
export const CLT_Lease = 'Lease'
export const CLT_LenderPlacedInsurance = 'LenderPlacedInsurance'
export const CLT_ManualMortgage = 'ManualMortgage'
export const CLT_ManufacturedHome = 'ManufacturedHome'
export const CLT_MedicalDebt = 'MedicalDebt'
export const CLT_MobileHome = 'MobileHome'
export const CLT_MobilePhone = 'MobilePhone'
export const CLT_Mortgage = 'Mortgage'
export const CLT_NoteLoan = 'NoteLoan'
export const CLT_NoteLoanWithComaker = 'NoteLoanWithComaker'
export const CLT_Other = 'Other'
export const CLT_PartiallySecured = 'PartiallySecured'
export const CLT_PersonalLoan = 'PersonalLoan'
export const CLT_RealEstateJuniorLiens = 'RealEstateJuniorLiens'
export const CLT_RealEstateLoanEquityTransfer = 'RealEstateLoanEquityTransfer'
export const CLT_RealEstateMortgageWithoutOtherCollateral = 'RealEstateMortgageWithoutOtherCollateral'
export const CLT_RealEstateSpecificTypeUnknown = 'RealEstateSpecificTypeUnknown'
export const CLT_Recreational = 'Recreational'
export const CLT_RecreationalVehicle = 'RecreationalVehicle'
export const CLT_Refinance = 'Refinance'
export const CLT_RefundAnticipationLoan = 'RefundAnticipationLoan'
export const CLT_RentalAgreement = 'RentalAgreement'
export const CLT_ResidentialLoan = 'ResidentialLoan'
export const CLT_ReturnedCheck = 'ReturnedCheck'
export const CLT_RevolvingBusinessLines = 'RevolvingBusinessLines'
export const CLT_SecondMortgage = 'SecondMortgage'
export const CLT_Secured = 'Secured'
export const CLT_SecuredByCosigner = 'SecuredByCosigner'
export const CLT_SecuredCreditCard = 'SecuredCreditCard'
export const CLT_SecuredHomeImprovement = 'SecuredHomeImprovement'
export const CLT_SemiMonthlyMortgagePayment = 'SemiMonthlyMortgagePayment'
export const CLT_SinglePaymentLoan = 'SinglePaymentLoan'
export const CLT_SpouseSupport = 'SpouseSupport'
export const CLT_SummaryOfAccountsWithSameStatus = 'SummaryOfAccountsWithSameStatus'
export const CLT_TimeSharedLoan = 'TimeSharedLoan'
export const CLT_Title1Loan = 'Title1Loan'
export const CLT_UnknownLoanType = 'UnknownLoanType'
export const CLT_Unsecured = 'Unsecured'
export const CLT_USDA_RD = 'USDA-RD'
export const CLT_UtilityCompany = 'UtilityCompany'
export const CLT_VeteransAdministrationLoan = 'VeteransAdministrationLoan'
export const CLT_VeteransAdministrationRealEstateMortgage = 'VeteransAdministrationRealEstateMortgage'

// enum CurrentRatingType
export const CRT_NoDataAvailable = 'NoDataAvailable'
export const CRT_TooNew = 'TooNew'
export const CRT_AsAgreed = 'AsAgreed'
export const CRT_Late30Days = 'Late30Days'
export const CRT_Late60Days = 'Late60Days'
export const CRT_Late90Days = 'Late90Days'
export const CRT_LateOver120Days = 'LateOver120Days'
export const CRT_WageEarnerPlan = 'WageEarnerPlan'
export const CRT_BankruptcyOrWageEarnerPlan = 'BankruptcyOrWageEarnerPlan'
export const CRT_Foreclosure = 'Foreclosure'
export const CRT_Repossession = 'Repossession'
export const CRT_ForeclosureOrRepossession = 'ForeclosureOrRepossession'
export const CRT_Collection = 'Collection'
export const CRT_ChargeOff = 'ChargeOff'
export const CRT_CollectionOrChargeOff = 'CollectionOrChargeOff'

// enum DetailCreditBusinessType
export const DCBT_AdvertisingAgencies = 'AdvertisingAgencies'
export const DCBT_AdvertisingMiscellaneous = 'AdvertisingMiscellaneous'
export const DCBT_AdvertisingNewsMedia = 'AdvertisingNewsMedia'
export const DCBT_AutomotiveAuctionsWholesale = 'AutomotiveAuctionsWholesale'
export const DCBT_AutomotiveDealersNew = 'AutomotiveDealersNew'
export const DCBT_AutomotiveDealersUsed = 'AutomotiveDealersUsed'
export const DCBT_AutomotiveFarmImplementDealers = 'AutomotiveFarmImplementDealers'
export const DCBT_AutomotiveLeasing = 'AutomotiveLeasing'
export const DCBT_AutomotiveMiscellaneous = 'AutomotiveMiscellaneous'
export const DCBT_AutomotiveParts = 'AutomotiveParts'
export const DCBT_AutomotiveRental = 'AutomotiveRental'
export const DCBT_AutomotiveRepairBodyShops = 'AutomotiveRepairBodyShops'
export const DCBT_AutomotiveServiceStations = 'AutomotiveServiceStations'
export const DCBT_AutomotiveTBAStoresTireDealers = 'AutomotiveTBAStoresTireDealers'
export const DCBT_AutomotiveTruckDealers = 'AutomotiveTruckDealers'
export const DCBT_BankingAllBanks = 'BankingAllBanks'
export const DCBT_BankingBankcard = 'BankingBankcard'
export const DCBT_BankingCommercialIndustrial = 'BankingCommercialIndustrial'
export const DCBT_BankingInstallmentLoansCreditLine = 'BankingInstallmentLoansCreditLine'
export const DCBT_BankingMiscellaneous = 'BankingMiscellaneous'
export const DCBT_BankingMortgageDepartment = 'BankingMortgageDepartment'
export const DCBT_BankingSavingsBanks = 'BankingSavingsBanks'
export const DCBT_ClothingGeneral = 'ClothingGeneral'
export const DCBT_ClothingMiscellaneous = 'ClothingMiscellaneous'
export const DCBT_ClothingSpecialtyShoeHatEtc = 'ClothingSpecialtyShoeHatEtc'
export const DCBT_CollectionServicesACBOfA = 'CollectionServicesACBOfA'
export const DCBT_CollectionServicesOther = 'CollectionServicesOther'
export const DCBT_ContractorsGeneral = 'ContractorsGeneral'
export const DCBT_ContractorsHomeImprovement = 'ContractorsHomeImprovement'
export const DCBT_ContractorsMiscellaneous = 'ContractorsMiscellaneous'
export const DCBT_ContractorsSubcontractors = 'ContractorsSubcontractors'
export const DCBT_DepartmentAndMailOrderCompleteDepartmentStores = 'DepartmentAndMailOrderCompleteDepartmentStores'
export const DCBT_DepartmentAndMailOrderMailOrderFirms = 'DepartmentAndMailOrderMailOrderFirms'
export const DCBT_DepartmentAndMailOrderMiscellaneous = 'DepartmentAndMailOrderMiscellaneous'
export const DCBT_DepartmentAndMailOrderVarietyStores = 'DepartmentAndMailOrderVarietyStores'
export const DCBT_EmploymentServices = 'EmploymentServices'
export const DCBT_FarmAndGardenSuppliesChemicalAndFertilizer = 'FarmAndGardenSuppliesChemicalAndFertilizer'
export const DCBT_FarmAndGardenSuppliesFeedAndSeed = 'FarmAndGardenSuppliesFeedAndSeed'
export const DCBT_FarmAndGardenSuppliesMiscellaneous = 'FarmAndGardenSuppliesMiscellaneous'
export const DCBT_FarmAndGardenSuppliesNurseryAndLandscaping = 'FarmAndGardenSuppliesNurseryAndLandscaping'
export const DCBT_FinanceAutomobile = 'FinanceAutomobile'
export const DCBT_FinanceBailBonds = 'FinanceBailBonds'
export const DCBT_FinanceBrokerageAndInvestmentFirms = 'FinanceBrokerageAndInvestmentFirms'
export const DCBT_FinanceBulkPurchase = 'FinanceBulkPurchase'
export const DCBT_FinanceCreditUnions = 'FinanceCreditUnions'
export const DCBT_FinanceEducation = 'FinanceEducation'
export const DCBT_FinanceFactoringCompanies = 'FinanceFactoringCompanies'
export const DCBT_FinanceMiscellaneous = 'FinanceMiscellaneous'
export const DCBT_FinanceMortgageBrokers = 'FinanceMortgageBrokers'
export const DCBT_FinanceMortgageCompanies = 'FinanceMortgageCompanies'
export const DCBT_FinanceMortgageReporters = 'FinanceMortgageReporters'
export const DCBT_FinancePersonalLoanCompanies = 'FinancePersonalLoanCompanies'
export const DCBT_FinanceSales = 'FinanceSales'
export const DCBT_FinanceSavingsAndLoanAssociations = 'FinanceSavingsAndLoanAssociations'
export const DCBT_GovernmentCityAndCounty = 'GovernmentCityAndCounty'
export const DCBT_GovernmentFederal = 'GovernmentFederal'
export const DCBT_GovernmentMiscellaneous = 'GovernmentMiscellaneous'
export const DCBT_GovernmentState = 'GovernmentState'
export const DCBT_GroceryDairies = 'GroceryDairies'
export const DCBT_GroceryMiscellaneous = 'GroceryMiscellaneous'
export const DCBT_GroceryNeighborhood = 'GroceryNeighborhood'
export const DCBT_GrocerySupermarkets = 'GrocerySupermarkets'
export const DCBT_HomeFurnishingApplianceSalesAndService = 'HomeFurnishingApplianceSalesAndService'
export const DCBT_HomeFurnishingCarpetAndFloorCoverings = 'HomeFurnishingCarpetAndFloorCoverings'
export const DCBT_HomeFurnishingElectronicsTelevisionAndRadio = 'HomeFurnishingElectronicsTelevisionAndRadio'
export const DCBT_HomeFurnishingFurniture = 'HomeFurnishingFurniture'
export const DCBT_HomeFurnishingFurnitureRental = 'HomeFurnishingFurnitureRental'
export const DCBT_HomeFurnishingInteriorDecoratorsDesign = 'HomeFurnishingInteriorDecoratorsDesign'
export const DCBT_HomeFurnishingMiscellaneous = 'HomeFurnishingMiscellaneous'
export const DCBT_HomeFurnishingMusicAndRecords = 'HomeFurnishingMusicAndRecords'
export const DCBT_InsuranceGeneral = 'InsuranceGeneral'
export const DCBT_InsuranceLife = 'InsuranceLife'
export const DCBT_InsuranceMiscellaneous = 'InsuranceMiscellaneous'
export const DCBT_JewelryAndCameraCameras = 'JewelryAndCameraCameras'
export const DCBT_JewelryAndCameraComputerSalesAndServices = 'JewelryAndCameraComputerSalesAndServices'
export const DCBT_JewelryAndCameraJewelry = 'JewelryAndCameraJewelry'
export const DCBT_JewelryAndCameraMiscellaneous = 'JewelryAndCameraMiscellaneous'
export const DCBT_JewelryAndCameraVideoTapeRentalAndSales = 'JewelryAndCameraVideoTapeRentalAndSales'
export const DCBT_LumberAndHardwareAirConditioningPlumbingElectrical = 'LumberAndHardwareAirConditioningPlumbingElectrical'
export const DCBT_LumberAndHardwareFixtureAndCabinet = 'LumberAndHardwareFixtureAndCabinet'
export const DCBT_LumberAndHardwareLumberYards = 'LumberAndHardwareLumberYards'
export const DCBT_LumberAndHardwareMiscellaneous = 'LumberAndHardwareMiscellaneous'
export const DCBT_LumberAndHardwarePaintGlassAndPaper = 'LumberAndHardwarePaintGlassAndPaper'
export const DCBT_LumberAndHardwareStores = 'LumberAndHardwareStores'
export const DCBT_MedicalAndHealthAnimalHospitals = 'MedicalAndHealthAnimalHospitals'
export const DCBT_MedicalAndHealthChiropractors = 'MedicalAndHealthChiropractors'
export const DCBT_MedicalAndHealthDentists = 'MedicalAndHealthDentists'
export const DCBT_MedicalAndHealthDoctorsAndClinics = 'MedicalAndHealthDoctorsAndClinics'
export const DCBT_MedicalAndHealthFuneralHomesAndCemeteries = 'MedicalAndHealthFuneralHomesAndCemeteries'
export const DCBT_MedicalAndHealthHospitals = 'MedicalAndHealthHospitals'
export const DCBT_MedicalAndHealthMedicalEquipment = 'MedicalAndHealthMedicalEquipment'
export const DCBT_MedicalAndHealthMiscellaneous = 'MedicalAndHealthMiscellaneous'
export const DCBT_MedicalAndHealthOptometristsAndOpticalStores = 'MedicalAndHealthOptometristsAndOpticalStores'
export const DCBT_MedicalAndHealthOsteopaths = 'MedicalAndHealthOsteopaths'
export const DCBT_MedicalAndHealthPharmaciesAndDrugs = 'MedicalAndHealthPharmaciesAndDrugs'
export const DCBT_MedicalAndHealthVeterinarians = 'MedicalAndHealthVeterinarians'
export const DCBT_MiscellaneousAuthenticationProducts = 'MiscellaneousAuthenticationProducts'
export const DCBT_MiscellaneousCreditBureaus = 'MiscellaneousCreditBureaus'
export const DCBT_MiscellaneousCreditReportBrokers = 'MiscellaneousCreditReportBrokers'
export const DCBT_MiscellaneousOther = 'MiscellaneousOther'
export const DCBT_MiscellaneousRetail = 'MiscellaneousRetail'
export const DCBT_MiscellaneousServices = 'MiscellaneousServices'
export const DCBT_MiscellaneousWholesale = 'MiscellaneousWholesale'
export const DCBT_OilAndNationalCreditCardsAirlineTravelCards = 'OilAndNationalCreditCardsAirlineTravelCards'
export const DCBT_OilAndNationalCreditCardsCreditCardCompanies = 'OilAndNationalCreditCardsCreditCardCompanies'
export const DCBT_OilAndNationalCreditCardsMiscellaneous = 'OilAndNationalCreditCardsMiscellaneous'
export const DCBT_OilAndNationalCreditCardsOilCompanies = 'OilAndNationalCreditCardsOilCompanies'
export const DCBT_PersonalServicesNotMedicalAccountants = 'PersonalServicesNotMedicalAccountants'
export const DCBT_PersonalServicesNotMedicalBarbersBeautyShops = 'PersonalServicesNotMedicalBarbersBeautyShops'
export const DCBT_PersonalServicesNotMedicalCountryClubsRestaurants = 'PersonalServicesNotMedicalCountryClubsRestaurants'
export const DCBT_PersonalServicesNotMedicalDetectiveInvestigativeServices = 'PersonalServicesNotMedicalDetectiveInvestigativeServices'
export const DCBT_PersonalServicesNotMedicalDryCleaningLaundry = 'PersonalServicesNotMedicalDryCleaningLaundry'
export const DCBT_PersonalServicesNotMedicalEngineering = 'PersonalServicesNotMedicalEngineering'
export const DCBT_PersonalServicesNotMedicalEquipmentLeasing = 'PersonalServicesNotMedicalEquipmentLeasing'
export const DCBT_PersonalServicesNotMedicalFlorists = 'PersonalServicesNotMedicalFlorists'
export const DCBT_PersonalServicesNotMedicalHealthAndFitnessClubs = 'PersonalServicesNotMedicalHealthAndFitnessClubs'
export const DCBT_PersonalServicesNotMedicalLegal = 'PersonalServicesNotMedicalLegal'
export const DCBT_PersonalServicesNotMedicalMiscellaneous = 'PersonalServicesNotMedicalMiscellaneous'
export const DCBT_PersonalServicesNotMedicalPestControl = 'PersonalServicesNotMedicalPestControl'
export const DCBT_PersonalServicesNotMedicalPhotographers = 'PersonalServicesNotMedicalPhotographers'
export const DCBT_RealEstateAndPublicAccommodationApartments = 'RealEstateAndPublicAccommodationApartments'
export const DCBT_RealEstateAndPublicAccommodationHotels = 'RealEstateAndPublicAccommodationHotels'
export const DCBT_RealEstateAndPublicAccommodationMiscellaneous = 'RealEstateAndPublicAccommodationMiscellaneous'
export const DCBT_RealEstateAndPublicAccommodationMobileHomes = 'RealEstateAndPublicAccommodationMobileHomes'
export const DCBT_RealEstateAndPublicAccommodationMotels = 'RealEstateAndPublicAccommodationMotels'
export const DCBT_RealEstateAndPublicAccommodationOfficeLeasing = 'RealEstateAndPublicAccommodationOfficeLeasing'
export const DCBT_RealEstateAndPublicAccommodationPropertyManagement = 'RealEstateAndPublicAccommodationPropertyManagement'
export const DCBT_RealEstateAndPublicAccommodationRealEstateSales = 'RealEstateAndPublicAccommodationRealEstateSales'
export const DCBT_SportingGoodsAircraftSalesAndService = 'SportingGoodsAircraftSalesAndService'
export const DCBT_SportingGoodsBoatAndMarinas = 'SportingGoodsBoatAndMarinas'
export const DCBT_SportingGoodsMiscellaneous = 'SportingGoodsMiscellaneous'
export const DCBT_SportingGoodsMotorcycleAndBicycle = 'SportingGoodsMotorcycleAndBicycle'
export const DCBT_SportingGoodsStores = 'SportingGoodsStores'
export const DCBT_UtilitiesAndFuelCableSatelliteCompanies = 'UtilitiesAndFuelCableSatelliteCompanies'
export const DCBT_UtilitiesAndFuelCoalAndWoodDealers = 'UtilitiesAndFuelCoalAndWoodDealers'
export const DCBT_UtilitiesAndFuelElectricalLightAndPower = 'UtilitiesAndFuelElectricalLightAndPower'
export const DCBT_UtilitiesAndFuelFuelOilDealers = 'UtilitiesAndFuelFuelOilDealers'
export const DCBT_UtilitiesAndFuelGarbageAndRubbishDisposals = 'UtilitiesAndFuelGarbageAndRubbishDisposals'
export const DCBT_UtilitiesAndFuelGasNaturalAndBottled = 'UtilitiesAndFuelGasNaturalAndBottled'
export const DCBT_UtilitiesAndFuelMiscellaneous = 'UtilitiesAndFuelMiscellaneous'
export const DCBT_UtilitiesAndFuelTelephoneCompanies = 'UtilitiesAndFuelTelephoneCompanies'
export const DCBT_UtilitiesAndFuelWaterCompanies = 'UtilitiesAndFuelWaterCompanies'
export const DCBT_WholesaleAutomotiveSupplies = 'WholesaleAutomotiveSupplies'
export const DCBT_WholesaleBuildingAndHardwareSupply = 'WholesaleBuildingAndHardwareSupply'
export const DCBT_WholesaleClothingAndDryGoods = 'WholesaleClothingAndDryGoods'
export const DCBT_WholesaleCreditCardProcessing = 'WholesaleCreditCardProcessing'
export const DCBT_WholesaleDrugsAndChemicals = 'WholesaleDrugsAndChemicals'
export const DCBT_WholesaleGroceries = 'WholesaleGroceries'
export const DCBT_WholesaleHomeFurnishings = 'WholesaleHomeFurnishings'
export const DCBT_WholesaleMachineryAndEquipment = 'WholesaleMachineryAndEquipment'
export const DCBT_WholesaleMiscellaneous = 'WholesaleMiscellaneous'

// enum DocType
export const DT_Full = 'full'
export const DT_Partial = 'partial'

// enum EmailServiceProviders
export const ESP_Gmail = 'Gmail'
export const ESP_Bluehost = 'Bluehost'
export const ESP_PersonalGmail = 'PersonalGmail'
export const ESP_Outlook = 'Outlook'
export const ESP_PersonalOutlook = 'PersonalOutlook'

// enum EstateHeldIn
export const EHI_Feesimple = 'feesimple'
export const EHI_Leasehold = 'leasehold'

// enum Ethnicity
export const E_Donttell = 'donttell'
export const E_Hispanic = 'hispanic'
export const E_Nonhispanic = 'nonhispanic'

// enum FundsSourceType
export const FST_CommunityNonProfit = 'CommunityNonProfit'
export const FST_Employer = 'Employer'
export const FST_FederalAgency = 'FederalAgency'
export const FST_LocalAgency = 'LocalAgency'
export const FST_Relative = 'Relative'
export const FST_ReligiousNonProfit = 'ReligiousNonProfit'
export const FST_StateAgency = 'StateAgency'
export const FST_UnmarriedPartner = 'UnmarriedPartner'
export const FST_Lender = 'Lender'
export const FST_Other = 'Other'

// enum HardMoneyLoanBorrowerType
export const HMLBT_LLC = 'LLC'
export const HMLBT_Individual = 'Individual'
export const HMLBT_Corporation = 'Corporation'
export const HMLBT_Partnership = 'Partnership'
export const HMLBT_Trust = 'Trust'

// enum HardMoneyLoanExitStrategy
export const HMLES_Fixandflip = 'fixandflip'
export const HMLES_Fixandrent = 'fixandrent'
export const HMLES_Buildandflip = 'buildandflip'
export const HMLES_Buildandrent = 'buildandrent'
export const HMLES_Refitoconventional = 'refitoconventional'
export const HMLES_Refitobuild = 'refitobuild'
export const HMLES_Refitoflip = 'refitoflip'
export const HMLES_Refitorent = 'refitorent'
export const HMLES_Forsale = 'forsale'
export const HMLES_Longtermrental = 'longtermrental'
export const HMLES_Others = 'others'

// enum HardMoneyLoanType
export const HMLT_Fixflip = 'fixflip'
export const HMLT_Fixrent = 'fixrent'
export const HMLT_Bridge = 'bridge'
export const HMLT_Groundup = 'groundup'
export const HMLT_Scrapebuild = 'scrapebuild'
export const HMLT_Rental = 'rental'
export const HMLT_Rehab = 'rehab'

// enum HasCoborrower
export const HC_Alone = 'alone'
export const HC_Withcoborrower = 'withcoborrower'
export const HC_Multiple = 'multiple'
export const HC_Remote = 'remote'

// enum ImprovementsStatus
export const IS_Noimprovements = 'noimprovements'
export const IS_Made = 'made'
export const IS_Tobemade = 'tobemade'

// enum IncomeDocumentationType
export const IDT_FullDoc = 'FullDoc'
export const IDT_FullDoc12Mo = 'FullDoc12Mo'
export const IDT_FullDocWithAssets = 'FullDocWithAssets'
export const IDT_VOE = 'VOE'
export const IDT_VOE24Mo = 'VOE24Mo'
export const IDT_PersonalBankStatement12Mo = 'PersonalBankStatement12Mo'
export const IDT_PersonalBankStatement24Mo = 'PersonalBankStatement24Mo'
export const IDT_BusinessBankStatement12Mo = 'BusinessBankStatement12Mo'
export const IDT_BusinessBankStatement24Mo = 'BusinessBankStatement24Mo'
export const IDT_Form109924Mo = 'Form109924Mo'
export const IDT_Form109912Mo = 'Form109912Mo'
export const IDT_PL24 = 'PL24'
export const IDT_PL12 = 'PL12'
export const IDT_PL = 'PL'
export const IDT_AssetDepletion = 'AssetDepletion'
export const IDT_AssetUtilization = 'AssetUtilization'
export const IDT_DebtServiceCoverageRatio = 'DebtServiceCoverageRatio'
export const IDT_NoRatio = 'NoRatio'

// enum IncomeType
export const IT_AccessoryUnitIncome = 'AccessoryUnitIncome'
export const IT_Alimony = 'Alimony'
export const IT_AutomobileAllowance = 'AutomobileAllowance'
export const IT_Base = 'Base'
export const IT_BoarderIncome = 'BoarderIncome'
export const IT_Bonus = 'Bonus'
export const IT_CapitalGains = 'CapitalGains'
export const IT_ChildSupport = 'ChildSupport'
export const IT_Commissions = 'Commissions'
export const IT_ContractBasis = 'ContractBasis'
export const IT_DefinedContributionPlan = 'DefinedContributionPlan'
export const IT_Disability = 'Disability'
export const IT_DividendsInterest = 'DividendsInterest'
export const IT_EmploymentRelatedAccount = 'EmploymentRelatedAccount'
export const IT_FosterCare = 'FosterCare'
export const IT_HousingAllowance = 'HousingAllowance'
export const IT_HousingChoiceVoucherProgram = 'HousingChoiceVoucherProgram'
export const IT_MilitaryBasePay = 'MilitaryBasePay'
export const IT_MilitaryClothesAllowance = 'MilitaryClothesAllowance'
export const IT_MilitaryCombatPay = 'MilitaryCombatPay'
export const IT_MilitaryFlightPay = 'MilitaryFlightPay'
export const IT_MilitaryHazardPay = 'MilitaryHazardPay'
export const IT_MilitaryOverseasPay = 'MilitaryOverseasPay'
export const IT_MilitaryPropPay = 'MilitaryPropPay'
export const IT_MilitaryQuartersAllowance = 'MilitaryQuartersAllowance'
export const IT_MilitaryRationsAllowance = 'MilitaryRationsAllowance'
export const IT_MilitaryVariableHousingAllowance = 'MilitaryVariableHousingAllowance'
export const IT_MortgageCreditCertificate = 'MortgageCreditCertificate'
export const IT_MortgageDifferential = 'MortgageDifferential'
export const IT_NetRentalIncome = 'NetRentalIncome'
export const IT_NonBorrowerContribution = 'NonBorrowerContribution'
export const IT_NonBorrowerHouseholdIncome = 'NonBorrowerHouseholdIncome'
export const IT_NotesReceivableInstallment = 'NotesReceivableInstallment'
export const IT_Other = 'Other'
export const IT_Overtime = 'Overtime'
export const IT_Pension = 'Pension'
export const IT_ProposedGrossRentForSubjectProperty = 'ProposedGrossRentForSubjectProperty'
export const IT_PublicAssistance = 'PublicAssistance'
export const IT_RealEstateOwnedGrossRentalIncome = 'RealEstateOwnedGrossRentalIncome'
export const IT_Royalties = 'Royalties'
export const IT_SeparateMaintenance = 'SeparateMaintenance'
export const IT_SocialSecurity = 'SocialSecurity'
export const IT_TemporaryLeave = 'TemporaryLeave'
export const IT_TipIncome = 'TipIncome'
export const IT_Trust = 'Trust'
export const IT_Unemployment = 'Unemployment'
export const IT_VABenefitsNonEducational = 'VABenefitsNonEducational'
export const IT_VACompensation = 'VACompensation'
export const IT_Retirement = 'Retirement'
export const IT_HousingParsonage = 'HousingParsonage'

// enum LoanOfficerBoardStage
export const LOBS_TODOs = 'TODOs'
export const LOBS_In_Progress = 'In_Progress'
export const LOBS_Done = 'Done'

// enum LoanProgram
export const LP_Fixed = 'fixed'
export const LP_Arm = 'arm'
export const LP_Baloon = 'baloon'
export const LP_Heloc = 'heloc'
export const LP_Negativeamortization = 'negativeamortization'
export const LP_Interestonly = 'interestonly'
export const LP_Noloan = 'noloan'

// enum LoanStage
export const LS_Application = 'Application'
export const LS_Processing = 'Processing'
export const LS_Closing = 'Closing'
export const LS_Archived = 'Archived'

// enum LoanStatus
export const LS_ApplicationStarted = 'ApplicationStarted'
export const LS_ApplicationFinished = 'ApplicationFinished'
export const LS_PrequalSent = 'PrequalSent'
export const LS_InContract = 'InContract'
export const LS_OpenEscrow = 'OpenEscrow'
export const LS_ConditionsRequested = 'ConditionsRequested'
export const LS_ConditionsReviewed = 'ConditionsReviewed'
export const LS_OrderAppraisal = 'OrderAppraisal'
export const LS_TitleSearch = 'TitleSearch'
export const LS_PreApproved = 'PreApproved'
export const LS_SubmittedToUnderwriting = 'SubmittedToUnderwriting'
export const LS_ConditionalApproval = 'ConditionalApproval'
export const LS_ClearToClose = 'ClearToClose'
export const LS_DocsOut = 'DocsOut'
export const LS_DocsSigned = 'DocsSigned'
export const LS_LoanFunded = 'LoanFunded'
export const LS_ApplicationAbandoned = 'ApplicationAbandoned'
export const LS_ApplicationRejected = 'ApplicationRejected'
export const LS_PreApprovalDenied = 'PreApprovalDenied'
export const LS_FileClosedForIncompleteness = 'FileClosedForIncompleteness'
export const LS_ApplicationWithdrawn = 'ApplicationWithdrawn'
export const LS_ApplicationDenied = 'ApplicationDenied'
export const LS_ApprovedButNotAccepted = 'ApprovedButNotAccepted'
export const LS_Other = 'Other'

// enum Lock
export const L_Days30 = 'days30'
export const L_Days15 = 'days15'
export const L_Days45 = 'days45'

// enum LockStatus
export const LS_None = 'none'
export const LS_Requested = 'requested'
export const LS_Locked = 'locked'
export const LS_Expired = 'expired'

// enum MannerOfPaymentCode
export const MOPC__ = '-'
export const MOPC_X = 'X'
export const MOPC_C = 'C'
export const MOPC_1 = '1'
export const MOPC_2 = '2'
export const MOPC_3 = '3'
export const MOPC_4 = '4'
export const MOPC_5 = '5'
export const MOPC_6 = '6'
export const MOPC_7 = '7'
export const MOPC_8 = '8'
export const MOPC_9 = '9'

// enum MaritalStatus
export const MS_Married = 'married'
export const MS_Separated = 'separated'
export const MS_Unmarried = 'unmarried'
export const MS_Single = 'single'

// enum MeridianLinkServiceType
export const MLST_CustomerSoftCreditReport = 'CustomerSoftCreditReport'
export const MLST_CustomerHardCreditReport = 'CustomerHardCreditReport'

// enum MobileHomeDescription
export const MHD_New = 'New'
export const MHD_Used = 'Used'
export const MHD_Repo = 'Repo'

// enum MobileHomeLocation
export const MHL_Park = 'Park'
export const MHL_LandorHome = 'LandorHome'
export const MHL_CoopPark = 'CoopPark'
export const MHL_SharedPark = 'SharedPark'

// enum MobileHomeType
export const MHT_SingleWide = 'SingleWide'
export const MHT_DoubleWide = 'DoubleWide'
export const MHT_TripleWide = 'TripleWide'

// enum MortgageAmortization
export const MA_Fixed = 'fixed'
export const MA_Fixed_biweekly = 'fixed-biweekly'
export const MA_Arm51 = 'arm51'
export const MA_Arm71 = 'arm71'
export const MA_Arm101 = 'arm101'
export const MA_Arm56 = 'arm56'
export const MA_Arm76 = 'arm76'
export const MA_Arm106 = 'arm106'
export const MA_Gpm = 'gpm'
export const MA_Interestonly = 'interestonly'
export const MA_Statedincome = 'statedincome'
export const MA_Baloon = 'baloon'
export const MA_Otheramortization = 'otheramortization'
export const MA_Buydown321 = 'buydown321'
export const MA_Buydown21 = 'buydown21'
export const MA_Buydown11 = 'buydown11'

// enum MortgageTerm
export const MT_Year30 = 'year30'
export const MT_Year25 = 'year25'
export const MT_Year20 = 'year20'
export const MT_Year15 = 'year15'
export const MT_Year10 = 'year10'
export const MT_Year7 = 'year7'
export const MT_Year5 = 'year5'
export const MT_Other = 'other'

// enum Occupancy
export const O_Principal = 'principal'
export const O_Secondhome = 'secondhome'
export const O_Investment = 'investment'
export const O_Fhasecond = 'fhasecond'
export const O_Other = 'other'

// enum OtherAssetOrCredit
export const OAOC_ProceedsFromRealEstatePropertyToBeSoldOnOrBeforeClosing = 'ProceedsFromRealEstatePropertyToBeSoldOnOrBeforeClosing'
export const OAOC_ProceedsFromSaleOfNonRealEstateAsset = 'ProceedsFromSaleOfNonRealEstateAsset'
export const OAOC_SecuredBorrowedFunds = 'SecuredBorrowedFunds'
export const OAOC_UnsecuredBorrowedFunds = 'UnsecuredBorrowedFunds'
export const OAOC_Other = 'Other'
export const OAOC_EarnestMoney = 'EarnestMoney'
export const OAOC_EmployerAssistance = 'EmployerAssistance'
export const OAOC_LotEquity = 'LotEquity'
export const OAOC_RelocationFunds = 'RelocationFunds'
export const OAOC_RentCredit = 'RentCredit'
export const OAOC_SweatEquity = 'SweatEquity'
export const OAOC_TradeEquity = 'TradeEquity'

// enum Ownership
export const O_Own = 'own'
export const O_Rent = 'rent'
export const O_Rentfree = 'rentfree'

// enum Period
export const P_Monthly = 'monthly'
export const P_Yearly = 'yearly'
export const P_Daily = 'daily'
export const P_Hourly = 'hourly'

// enum ProjectClassification
export const PC_Streamlinereview_freddiemac = 'streamlinereview-freddiemac'
export const PC_Establishedproject_freddiemac = 'establishedproject-freddiemac'
export const PC_Newproject_freddiemac = 'newproject-freddiemac'
export const PC_Detachedproject_freddiemac = 'detachedproject-freddiemac'
export const PC_Twotofourunit_freddiemac = 'twotofourunit-freddiemac'
export const PC_Reciprocalreview_freddiemac = 'reciprocalreview-freddiemac'
export const PC_Exemptfromreview_freddiemac = 'exemptfromreview-freddiemac'
export const PC_Plimitedreviewnewdetached_fanniemae = 'plimitedreviewnewdetached-fanniemae'
export const PC_Qlimitedreviewestablised_fanniemae = 'qlimitedreviewestablised-fanniemae'
export const PC_Rexpectedreviewnew_fanniemae = 'rexpectedreviewnew-fanniemae'
export const PC_Sexpectedreviewestablished_fanniemae = 'sexpectedreviewestablished-fanniemae'
export const PC_Tfanniemaereview_fanniemae = 'tfanniemaereview-fanniemae'
export const PC_Ufhaapproved_fanniemae = 'ufhaapproved-fanniemae'
export const PC_Vrefiplus_fanniemae = 'vrefiplus-fanniemae'
export const PC_Epud_fanniemae = 'epud-fanniemae'
export const PC_Fpud_fanniemae = 'fpud-fanniemae'
export const PC_Tpud_fanniemae = 'tpud-fanniemae'
export const PC_Onecoop_fanniemae = 'onecoop-fanniemae'
export const PC_Twocoop_fanniemae = 'twocoop-fanniemae'
export const PC_Tcoop_fanniemae = 'tcoop-fanniemae'

// enum PropertyStatus
export const PS_Pending = 'pending'
export const PS_Sold = 'sold'
export const PS_Retained = 'retained'

// enum PropertyType
export const PT_Singlefamilyattached = 'singlefamilyattached'
export const PT_Singlefamilydetached = 'singlefamilydetached'
export const PT_Condominium = 'condominium'
export const PT_Condominiumdetached = 'condominiumdetached'
export const PT_Pudattached = 'pudattached'
export const PT_Puddetached = 'puddetached'
export const PT_Twotofourfamily = 'twotofourfamily'
export const PT_Twofamily = 'twofamily'
export const PT_Threefamily = 'threefamily'
export const PT_Fourfamily = 'fourfamily'
export const PT_Multistory = 'multistory'
export const PT_Manufacturedhome = 'manufacturedhome'
export const PT_Land = 'land'
export const PT_Commercial = 'commercial'
export const PT_Townhouse = 'townhouse'
export const PT_Mixeduse = 'mixeduse'
export const PT_Mobilehome = 'mobilehome'

// enum PublicRecordDispositionType
export const PRDT_Adjudicated = 'Adjudicated'
export const PRDT_Appealed = 'Appealed'
export const PRDT_Canceled = 'Canceled'
export const PRDT_Completed = 'Completed'
export const PRDT_Converted = 'Converted'
export const PRDT_Discharged = 'Discharged'
export const PRDT_Dismissed = 'Dismissed'
export const PRDT_Distributed = 'Distributed'
export const PRDT_Filed = 'Filed'
export const PRDT_Granted = 'Granted'
export const PRDT_InvoluntarilyDischarged = 'InvoluntarilyDischarged'
export const PRDT_Nonadjudicated = 'Nonadjudicated'
export const PRDT_Other = 'Other'
export const PRDT_Paid = 'Paid'
export const PRDT_PaidNotSatisfied = 'PaidNotSatisfied'
export const PRDT_Pending = 'Pending'
export const PRDT_RealEstateSold = 'RealEstateSold'
export const PRDT_Released = 'Released'
export const PRDT_Rescinded = 'Rescinded'
export const PRDT_Satisfied = 'Satisfied'
export const PRDT_Settled = 'Settled'
export const PRDT_Unknown = 'Unknown'
export const PRDT_Unreleased = 'Unreleased'
export const PRDT_Unsatisfied = 'Unsatisfied'
export const PRDT_Vacated = 'Vacated'
export const PRDT_VoluntarilyDischarged = 'VoluntarilyDischarged'
export const PRDT_Withdrawn = 'Withdrawn'

// enum PublicRecordOwnershipType
export const PROT_Individual = 'Individual'
export const PROT_Joint = 'Joint'
export const PROT_Terminated = 'Terminated'

// enum PublicRecordType
export const PRT_Annulment = 'Annulment'
export const PRT_Attachment = 'Attachment'
export const PRT_BankruptcyChapter11 = 'BankruptcyChapter11'
export const PRT_BankruptcyChapter12 = 'BankruptcyChapter12'
export const PRT_BankruptcyChapter13 = 'BankruptcyChapter13'
export const PRT_BankruptcyChapter7 = 'BankruptcyChapter7'
export const PRT_BankruptcyChapter7Involuntary = 'BankruptcyChapter7Involuntary'
export const PRT_BankruptcyChapter7Voluntary = 'BankruptcyChapter7Voluntary'
export const PRT_BankruptcyTypeUnknown = 'BankruptcyTypeUnknown'
export const PRT_ChildSupport = 'ChildSupport'
export const PRT_Collection = 'Collection'
export const PRT_CustodyAgreement = 'CustodyAgreement'
export const PRT_DivorceDecree = 'DivorceDecree'
export const PRT_FamilySupport = 'FamilySupport'
export const PRT_FictitiousName = 'FictitiousName'
export const PRT_FinancialCounseling = 'FinancialCounseling'
export const PRT_FinancingStatement = 'FinancingStatement'
export const PRT_ForcibleDetainer = 'ForcibleDetainer'
export const PRT_Foreclosure = 'Foreclosure'
export const PRT_Garnishment = 'Garnishment'
export const PRT_Judgment = 'Judgment'
export const PRT_LawSuit = 'LawSuit'
export const PRT_Lien = 'Lien'
export const PRT_MechanicsLien = 'MechanicsLien'
export const PRT_MedicalLien = 'MedicalLien'
export const PRT_NonResponsibility = 'NonResponsibility'
export const PRT_NoticeOfDefault = 'NoticeOfDefault'
export const PRT_Other = 'Other'
export const PRT_PublicSale = 'PublicSale'
export const PRT_RealEstateRecording = 'RealEstateRecording'
export const PRT_Repossession = 'Repossession'
export const PRT_SpouseSupport = 'SpouseSupport'
export const PRT_SupportDebt = 'SupportDebt'
export const PRT_TaxLienCity = 'TaxLienCity'
export const PRT_TaxLienCounty = 'TaxLienCounty'
export const PRT_TaxLienFederal = 'TaxLienFederal'
export const PRT_TaxLienOther = 'TaxLienOther'
export const PRT_TaxLienState = 'TaxLienState'
export const PRT_Trusteeship = 'Trusteeship'
export const PRT_Unknown = 'Unknown'
export const PRT_UnlawfulDetainer = 'UnlawfulDetainer'

// enum PurposeOfHardMoneyLoan
export const POHML_Purchase = 'purchase'
export const POHML_Refinance = 'refinance'
export const POHML_Consolidation = 'consolidation'

// enum PurposeOfLoan
export const POL_Refinance = 'refinance'
export const POL_Purchase = 'purchase'
export const POL_Purchaserehab = 'purchaserehab'
export const POL_Construction = 'construction'
export const POL_Construction_permanent = 'construction-permanent'
export const POL_Improvement = 'improvement'
export const POL_Cashoutrefinance = 'cashoutrefinance'

// enum PurposeOfRefinance
export const POR_Debtconsolidation = 'debtconsolidation'
export const POR_Homeimprovement = 'homeimprovement'
export const POR_Paytorelatives = 'paytorelatives'
export const POR_Cashforreserves = 'cashforreserves'
export const POR_Paidcashforsubjectproperty = 'paidcashforsubjectproperty'
export const POR_Payingoffheloc = 'payingoffheloc'
export const POR_Payingotherproperties = 'payingotherproperties'
export const POR_Payingstudentloans = 'payingstudentloans'
export const POR_Other = 'other'

// enum ReminderFrequency
export const RF_Daily = 'daily'
export const RF_Every2Days = 'every2Days'
export const RF_Every3Days = 'every3Days'
export const RF_Weekly = 'weekly'
export const RF_BiWeekly = 'biWeekly'

// enum RentalPropertyType
export const RPT_Singlefamily = 'singlefamily'
export const RPT_Condominium = 'condominium'
export const RPT_Townhouse = 'townhouse'
export const RPT_Twotofour = 'twotofour'
export const RPT_Mobilehome = 'mobilehome'
export const RPT_Commercial = 'commercial'
export const RPT_Homeandbusinesscombined = 'homeandbusinesscombined'
export const RPT_Mixeduse = 'mixeduse'
export const RPT_Farm = 'farm'
export const RPT_Land = 'land'

// enum SMSKeys
export const SMSK_RateLock = 'RateLock'
export const SMSK_CustomerTaskNotification = 'CustomerTaskNotification'

// enum SMSServiceProviders
export const SMSSP_AmazonSNS10DLC = 'AmazonSNS10DLC'

// enum SelectionSort
export const SS_Selectbyrate = 'selectbyrate'
export const SS_Selectbyapr = 'selectbyapr'
export const SS_Selectbyinterestterm = 'selectbyinterestterm'
export const SS_Selectbyinteresttotal = 'selectbyinteresttotal'
export const SS_Selectbymonthlypayment = 'selectbymonthlypayment'
export const SS_Selectbyclosingcosts = 'selectbyclosingcosts'
export const SS_Selectbyadvanced = 'selectbyadvanced'

// enum Sex
export const S_Donttell = 'donttell'
export const S_Male = 'male'
export const S_Female = 'female'
export const S_Other = 'other'

// enum ShownOwnership
export const SO_Borrower = 'Borrower'
export const SO_CoBorrower = 'CoBorrower'
export const SO_Joint = 'Joint'

// enum TaskCategory
export const TC_Identification = 'identification'
export const TC_Income = 'income'
export const TC_Assets = 'assets'
export const TC_Credit = 'credit'
export const TC_Property = 'property'
export const TC_Miscellaneous = 'miscellaneous'
export const TC_InternalDocuments = 'internalDocuments'

// enum TaskTimeRange
export const TTR_Recent30Days = 'recent30Days'
export const TTR_Recent2Months = 'recent2Months'
export const TTR_Recent3Months = 'recent3Months'
export const TTR_Recent6Months = 'recent6Months'
export const TTR_Recent1Year = 'recent1Year'
export const TTR_Recent2Years = 'recent2Years'

// enum TitleHeld
export const TH_Yourself = 'yourself'
export const TH_Jointwithspouse = 'jointwithspouse'
export const TH_Jointwithother = 'jointwithother'

// enum TypeOfMortgage
export const TOM_Conventional = 'conventional'
export const TOM_Va = 'va'
export const TOM_Fha = 'fha'
export const TOM_Usda = 'usda'
export const TOM_Nonconventional = 'nonconventional'
export const TOM_Nonqm = 'nonqm'
export const TOM_Landloan = 'landloan'
export const TOM_Constructionloan = 'constructionloan'
export const TOM_Heloc = 'heloc'
export const TOM_Hardmoneyloan = 'hardmoneyloan'
export const TOM_Other = 'other'

// enum UserRoles
export const UR_LoanOfficer = 'LoanOfficer'
export const UR_LoanOfficerManager = 'LoanOfficerManager'
export const UR_Owner = 'Owner'
export const UR_RealEstateAgent = 'RealEstateAgent'
export const UR_LoanProcessor = 'LoanProcessor'
export const UR_PriceEngineUser = 'PriceEngineUser'
export const UR_Underwriter = 'Underwriter'
export const UR_Closer = 'Closer'

// enum VisaType
export const VT_A_1 = 'A-1'
export const VT_A_2 = 'A-2'
export const VT_A_3 = 'A-3'
export const VT_B_1 = 'B-1'
export const VT_B_2 = 'B-2'
export const VT_B_3 = 'B-3'
export const VT_C_1 = 'C-1'
export const VT_C_2 = 'C-2'
export const VT_C_3 = 'C-3'
export const VT_C_4 = 'C-4'
export const VT_C_1D = 'C-1D'
export const VT_CP = 'CP'
export const VT_D_1 = 'D-1'
export const VT_D_2 = 'D-2'
export const VT_E_1 = 'E-1'
export const VT_E_2 = 'E-2'
export const VT_E_3 = 'E-3'
export const VT_F_1 = 'F-1'
export const VT_F_2 = 'F-2'
export const VT_F_3 = 'F-3'
export const VT_G_1 = 'G-1'
export const VT_G_2 = 'G-2'
export const VT_G_3 = 'G-3'
export const VT_G_4 = 'G-4'
export const VT_G_5 = 'G-5'
export const VT_H_1A = 'H-1A'
export const VT_H_1B = 'H-1B'
export const VT_H_1B1 = 'H-1B1'
export const VT_H_2 = 'H-2'
export const VT_H_2A = 'H-2A'
export const VT_H_2B = 'H-2B'
export const VT_H_3 = 'H-3'
export const VT_H_4 = 'H-4'
export const VT_I = 'I'
export const VT_OR_1 = 'OR-1'
export const VT_J_1 = 'J-1'
export const VT_J_2 = 'J-2'
export const VT_K_1 = 'K-1'
export const VT_K_2 = 'K-2'
export const VT_K_3 = 'K-3'
export const VT_K_4 = 'K-4'
export const VT_L_1 = 'L-1'
export const VT_L_2 = 'L-2'
export const VT_M_1 = 'M-1'
export const VT_M_2 = 'M-2'
export const VT_M_3 = 'M-3'
export const VT_N_8 = 'N-8'
export const VT_N_9 = 'N-9'
export const VT_NACARA = 'NACARA'
export const VT_NATO_1_5 = 'NATO-1-5'
export const VT_NATO_7 = 'NATO-7'
export const VT_O_1 = 'O-1'
export const VT_O_2 = 'O-2'
export const VT_O_3 = 'O-3'
export const VT_P_1 = 'P-1'
export const VT_P_2 = 'P-2'
export const VT_P_3 = 'P-3'
export const VT_P_4 = 'P-4'
export const VT_Q_1 = 'Q-1'
export const VT_Q_2 = 'Q-2'
export const VT_Q_3 = 'Q-3'
export const VT_R_1 = 'R-1'
export const VT_R_2 = 'R-2'
export const VT_S_5 = 'S-5'
export const VT_S_6 = 'S-6'
export const VT_S_7 = 'S-7'
export const VT_T_1 = 'T-1'
export const VT_T_2 = 'T-2'
export const VT_T_3 = 'T-3'
export const VT_T_4 = 'T-4'
export const VT_TD = 'TD'
export const VT_TN = 'TN'
export const VT_U_1 = 'U-1'
export const VT_U_2 = 'U-2'
export const VT_U_3 = 'U-3'
export const VT_U_4 = 'U-4'
export const VT_V_1 = 'V-1'
export const VT_V_2 = 'V-2'
export const VT_V_3 = 'V-3'

// enum WaiverYesNo
export const WYN_Waiverno = 'waiverno'
export const WYN_Waiveryes = 'waiveryes'

// enum YesNo
export const YN_No = 'no'
export const YN_Yes = 'yes'

// enum armindex
export const A_LIBOR = 'LIBOR'
export const A_PrimeRate = 'PrimeRate'
export const A_COSI = 'COSI'
export const A_COFI = 'COFI'
export const A_MTA = 'MTA'
export const A_TBill = 'TBill'
export const A_CMT = 'CMT'
export const A_CMT5YR = 'CMT5YR'
export const A_CMT10YR = 'CMT10YR'
export const A_SOFR = 'SOFR'

// enum coborrowerstatus
export const C_Created = 'created'
export const C_Invited = 'invited'
export const C_Accepted = 'accepted'
export const C_Prequalified = 'prequalified'
export const C_Fullyfilled = 'fullyfilled'
export const C_Documentsdone = 'documentsdone'

// enum company
export const C_Fanniemae = 'fanniemae'
export const C_Freddiemac = 'freddiemac'

// enum constructiontype
export const C_ADU = 'ADU'

// enum howloansatisfied
export const H_Not = 'not'
export const H_Withproceeds = 'withproceeds'
export const H_Withownfunds = 'withownfunds'

// enum incomedoc
export const I_Schedulec = 'schedulec'
export const I_Schedulef = 'schedulef'
export const I_F1065 = 'f1065'
export const I_F1120S = 'f1120S'
export const I_F1120 = 'f1120'
export const I_W2paystub = 'w2paystub'
export const I_Schedulek1 = 'schedulek1'

// enum levelofpropertyreview
export const L_Exterioraandintertior = 'exterioraandintertior'
export const L_Exterioronly = 'exterioronly'
export const L_Noappraisal = 'noappraisal'

// enum lientype
export const L_Firstlien = 'firstlien'
export const L_Subordinatelien = 'subordinatelien'

// enum occupationtype
export const O_Unemployed = 'unemployed'
export const O_Retired = 'retired'
export const O_Employed = 'employed'

export class AUSreport {
  constructor() {
    this['_recommendation'] = 'approve-eligible'
    this['_AUSengine'] = 'DU'
    this['_id'] = ''
    this['_lpadocclass'] = ''
    this['_requireddfundtoclose'] = ''
    this['_verifiedassets'] = ''
    this['_sourceoffunds'] = ''
    this['_nomonthsofreserves'] = 0
  }
  get recommendation() { return this['_recommendation'] }
  set recommendation(__a__) {
    let __v__ = enumReader(['approve-eligible','approve-ineligible','referwithcaution','outofscope'],'approve-eligible')(__a__)
    if(!_.isEqual(__v__,this['_recommendation'])) {
      setDirtyFlag()
      this['_recommendation'] = __v__
    }
  }
  get AUSengine() { return this['_AUSengine'] }
  set AUSengine(__a__) {
    let __v__ = enumReader(['DU','LPA','other'],'DU')(__a__)
    if(!_.isEqual(__v__,this['_AUSengine'])) {
      setDirtyFlag()
      this['_AUSengine'] = __v__
    }
  }
  get id() { return this['_id'] }
  set id(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_id'])) {
      setDirtyFlag()
      this['_id'] = __v__
    }
  }
  get lpadocclass() { return this['_lpadocclass'] }
  set lpadocclass(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_lpadocclass'])) {
      setDirtyFlag()
      this['_lpadocclass'] = __v__
    }
  }
  get requireddfundtoclose() { return this['_requireddfundtoclose'] }
  set requireddfundtoclose(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_requireddfundtoclose'])) {
      setDirtyFlag()
      this['_requireddfundtoclose'] = __v__
    }
  }
  get verifiedassets() { return this['_verifiedassets'] }
  set verifiedassets(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_verifiedassets'])) {
      setDirtyFlag()
      this['_verifiedassets'] = __v__
    }
  }
  get sourceoffunds() { return this['_sourceoffunds'] }
  set sourceoffunds(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_sourceoffunds'])) {
      setDirtyFlag()
      this['_sourceoffunds'] = __v__
    }
  }
  get nomonthsofreserves() { return this['_nomonthsofreserves'] }
  set nomonthsofreserves(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_nomonthsofreserves'])) {
      setDirtyFlag()
      this['_nomonthsofreserves'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new AUSreport()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.recommendation = __a__['recommendation']
       cls.AUSengine = __a__['AUSengine']
       cls.id = __a__['id']
       cls.lpadocclass = __a__['lpadocclass']
       cls.requireddfundtoclose = __a__['requireddfundtoclose']
       cls.verifiedassets = __a__['verifiedassets']
       cls.sourceoffunds = __a__['sourceoffunds']
       cls.nomonthsofreserves = __a__['nomonthsofreserves']
    } else {
       doAlert(`AUSreport: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class Asian {
  constructor() {
    this['_asianindian'] = false
    this['_chinese'] = false
    this['_filipino'] = false
    this['_japanese'] = false
    this['_korean'] = false
    this['_vietnamese'] = false
    this['_otherasian'] = false
    this['_otherdesctiption'] = ''
  }
  get asianindian() { return this['_asianindian'] }
  set asianindian(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_asianindian'])) {
      setDirtyFlag()
      this['_asianindian'] = __v__
    }
  }
  get chinese() { return this['_chinese'] }
  set chinese(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_chinese'])) {
      setDirtyFlag()
      this['_chinese'] = __v__
    }
  }
  get filipino() { return this['_filipino'] }
  set filipino(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_filipino'])) {
      setDirtyFlag()
      this['_filipino'] = __v__
    }
  }
  get japanese() { return this['_japanese'] }
  set japanese(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_japanese'])) {
      setDirtyFlag()
      this['_japanese'] = __v__
    }
  }
  get korean() { return this['_korean'] }
  set korean(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_korean'])) {
      setDirtyFlag()
      this['_korean'] = __v__
    }
  }
  get vietnamese() { return this['_vietnamese'] }
  set vietnamese(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_vietnamese'])) {
      setDirtyFlag()
      this['_vietnamese'] = __v__
    }
  }
  get otherasian() { return this['_otherasian'] }
  set otherasian(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_otherasian'])) {
      setDirtyFlag()
      this['_otherasian'] = __v__
    }
  }
  get otherdesctiption() { return this['_otherdesctiption'] }
  set otherdesctiption(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_otherdesctiption'])) {
      setDirtyFlag()
      this['_otherdesctiption'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new Asian()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.asianindian = __a__['asianindian']
       cls.chinese = __a__['chinese']
       cls.filipino = __a__['filipino']
       cls.japanese = __a__['japanese']
       cls.korean = __a__['korean']
       cls.vietnamese = __a__['vietnamese']
       cls.otherasian = __a__['otherasian']
       cls.otherdesctiption = __a__['otherdesctiption']
    } else {
       doAlert(`Asian: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class Buydown {
  constructor() {
    this['_isbuydown'] = false
    this['_buydownterm'] = 0
    this['_buydownrate'] = 0.0
  }
  get isbuydown() { return this['_isbuydown'] }
  set isbuydown(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_isbuydown'])) {
      setDirtyFlag()
      this['_isbuydown'] = __v__
    }
  }
  get buydownterm() { return this['_buydownterm'] }
  set buydownterm(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_buydownterm'])) {
      setDirtyFlag()
      this['_buydownterm'] = __v__
    }
  }
  get buydownrate() { return this['_buydownrate'] }
  set buydownrate(__a__) {
    let __v__ = floatReader(0.0)(__a__)
    if(!_.isEqual(__v__,this['_buydownrate'])) {
      setDirtyFlag()
      this['_buydownrate'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new Buydown()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.isbuydown = __a__['isbuydown']
       cls.buydownterm = __a__['buydownterm']
       cls.buydownrate = __a__['buydownrate']
    } else {
       doAlert(`Buydown: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class CategorizedLoans {
  constructor() {
    this['_Mortgage'] = null
    this['_CreditLine'] = null
    this['_Open'] = null
    this['_Installment'] = null
    this['_Revolving'] = null
    this['_Unknown'] = null
  }
  get Mortgage() { return this['_Mortgage'] }
  set Mortgage(__a__) {
    setDirtyFlag()
    this['_Mortgage'] = __a__
  }
  get CreditLine() { return this['_CreditLine'] }
  set CreditLine(__a__) {
    setDirtyFlag()
    this['_CreditLine'] = __a__
  }
  get Open() { return this['_Open'] }
  set Open(__a__) {
    setDirtyFlag()
    this['_Open'] = __a__
  }
  get Installment() { return this['_Installment'] }
  set Installment(__a__) {
    setDirtyFlag()
    this['_Installment'] = __a__
  }
  get Revolving() { return this['_Revolving'] }
  set Revolving(__a__) {
    setDirtyFlag()
    this['_Revolving'] = __a__
  }
  get Unknown() { return this['_Unknown'] }
  set Unknown(__a__) {
    setDirtyFlag()
    this['_Unknown'] = __a__
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new CategorizedLoans()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.Mortgage = __a__['Mortgage'] == null ? null : array1Reader(stringReader(''))(__a__['Mortgage'])
       cls.CreditLine = __a__['CreditLine'] == null ? null : array1Reader(stringReader(''))(__a__['CreditLine'])
       cls.Open = __a__['Open'] == null ? null : array1Reader(stringReader(''))(__a__['Open'])
       cls.Installment = __a__['Installment'] == null ? null : array1Reader(stringReader(''))(__a__['Installment'])
       cls.Revolving = __a__['Revolving'] == null ? null : array1Reader(stringReader(''))(__a__['Revolving'])
       cls.Unknown = __a__['Unknown'] == null ? null : array1Reader(stringReader(''))(__a__['Unknown'])
    } else {
       doAlert(`CategorizedLoans: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class ChosenLoan {
  constructor() {
    this['_hash'] = ''
    this['_APR'] = 0.0
    this['_Arm'] = null
    this['_amortization'] = 'fixed'
    this['_Mtype'] = ''
    this['_Term'] = 0
    this['_base_rate'] = 0.0
    this['_closing_cost'] = 0.0
    this['_features'] = new productfeatures()
    this['_high_cost_mortgage'] = false
    this['_lender_credit'] = 0.0
    this['_lender_fee'] = 0.0
    this['_lockDay'] = 0
    this['_min_months_reserves'] = 0
    this['_monthly_payment'] = 0.0
    this['_prepaid_interest'] = 0.0
    this['_points'] = 0.0
    this['_loansize'] = 0
    this['_downpayment'] = 0
    this['_paydown'] = 0
    this['_cashout'] = 0
    this['_pmi'] = 0.0
    this['_FHAMIP'] = null
    this['_matchingproducts'] = []
    this['_lockstatus'] = 'none'
    this['_lockdate'] = ''
    this['_purpose'] = 'refinance'
    this['_estimatedclosingcosts'] = null
    this['_ourfee'] = null
    this['_prepaiddays'] = null
    this['_productname'] = null
    this['_DTI'] = null
    this['_maxcashout'] = null
    this['_payout'] = null
  }
  get hash() { return this['_hash'] }
  set hash(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_hash'])) {
      setDirtyFlag()
      this['_hash'] = __v__
    }
  }
  get APR() { return this['_APR'] }
  set APR(__a__) {
    let __v__ = floatReader(0.0)(__a__)
    if(!_.isEqual(__v__,this['_APR'])) {
      setDirtyFlag()
      this['_APR'] = __v__
    }
  }
  get Arm() { return this['_Arm'] }
  set Arm(__a__) {
    if(__a__ == null) {
      if(this['_Arm'] == null) { return }
      setDirtyFlag()
      this['_Arm'] = null
      return
    } else {
      setDirtyFlag()
      this['_Arm'] = __a__
    }
  }
  get amortization() { return this['_amortization'] }
  set amortization(__a__) {
    let __v__ = enumReader(['fixed','fixed-biweekly','arm51','arm71','arm101','arm56','arm76','arm106','gpm','interestonly','statedincome','baloon','otheramortization','buydown321','buydown21','buydown11'],'fixed')(__a__)
    if(!_.isEqual(__v__,this['_amortization'])) {
      setDirtyFlag()
      this['_amortization'] = __v__
    }
  }
  get Mtype() { return this['_Mtype'] }
  set Mtype(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_Mtype'])) {
      setDirtyFlag()
      this['_Mtype'] = __v__
    }
  }
  get Term() { return this['_Term'] }
  set Term(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_Term'])) {
      setDirtyFlag()
      this['_Term'] = __v__
    }
  }
  get base_rate() { return this['_base_rate'] }
  set base_rate(__a__) {
    let __v__ = floatReader(0.0)(__a__)
    if(!_.isEqual(__v__,this['_base_rate'])) {
      setDirtyFlag()
      this['_base_rate'] = __v__
    }
  }
  get closing_cost() { return this['_closing_cost'] }
  set closing_cost(__a__) {
    let __v__ = floatReader(0.0)(__a__)
    if(!_.isEqual(__v__,this['_closing_cost'])) {
      setDirtyFlag()
      this['_closing_cost'] = __v__
    }
  }
  get features() { return this['_features'] }
  set features(__a__) {
    setDirtyFlag()
    this['_features'] = __a__
  }
  get high_cost_mortgage() { return this['_high_cost_mortgage'] }
  set high_cost_mortgage(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_high_cost_mortgage'])) {
      setDirtyFlag()
      this['_high_cost_mortgage'] = __v__
    }
  }
  get lender_credit() { return this['_lender_credit'] }
  set lender_credit(__a__) {
    let __v__ = floatReader(0.0)(__a__)
    if(!_.isEqual(__v__,this['_lender_credit'])) {
      setDirtyFlag()
      this['_lender_credit'] = __v__
    }
  }
  get lender_fee() { return this['_lender_fee'] }
  set lender_fee(__a__) {
    let __v__ = floatReader(0.0)(__a__)
    if(!_.isEqual(__v__,this['_lender_fee'])) {
      setDirtyFlag()
      this['_lender_fee'] = __v__
    }
  }
  get lockDay() { return this['_lockDay'] }
  set lockDay(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_lockDay'])) {
      setDirtyFlag()
      this['_lockDay'] = __v__
    }
  }
  get min_months_reserves() { return this['_min_months_reserves'] }
  set min_months_reserves(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_min_months_reserves'])) {
      setDirtyFlag()
      this['_min_months_reserves'] = __v__
    }
  }
  get monthly_payment() { return this['_monthly_payment'] }
  set monthly_payment(__a__) {
    let __v__ = floatReader(0.0)(__a__)
    if(!_.isEqual(__v__,this['_monthly_payment'])) {
      setDirtyFlag()
      this['_monthly_payment'] = __v__
    }
  }
  get prepaid_interest() { return this['_prepaid_interest'] }
  set prepaid_interest(__a__) {
    let __v__ = floatReader(0.0)(__a__)
    if(!_.isEqual(__v__,this['_prepaid_interest'])) {
      setDirtyFlag()
      this['_prepaid_interest'] = __v__
    }
  }
  get points() { return this['_points'] }
  set points(__a__) {
    let __v__ = floatReader(0.0)(__a__)
    if(!_.isEqual(__v__,this['_points'])) {
      setDirtyFlag()
      this['_points'] = __v__
    }
  }
  get loansize() { return this['_loansize'] }
  set loansize(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_loansize'])) {
      setDirtyFlag()
      this['_loansize'] = __v__
    }
  }
  get downpayment() { return this['_downpayment'] }
  set downpayment(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_downpayment'])) {
      setDirtyFlag()
      this['_downpayment'] = __v__
    }
  }
  get paydown() { return this['_paydown'] }
  set paydown(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_paydown'])) {
      setDirtyFlag()
      this['_paydown'] = __v__
    }
  }
  get cashout() { return this['_cashout'] }
  set cashout(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_cashout'])) {
      setDirtyFlag()
      this['_cashout'] = __v__
    }
  }
  get pmi() { return this['_pmi'] }
  set pmi(__a__) {
    let __v__ = floatReader(0.0)(__a__)
    if(!_.isEqual(__v__,this['_pmi'])) {
      setDirtyFlag()
      this['_pmi'] = __v__
    }
  }
  get FHAMIP() { return this['_FHAMIP'] }
  set FHAMIP(__a__) {
    if(__a__ == null) {
      if(this['_FHAMIP'] == null) { return }
      setDirtyFlag()
      this['_FHAMIP'] = null
      return
    } else {
      setDirtyFlag()
      this['_FHAMIP'] = __a__
    }
  }
  get matchingproducts() { return this['_matchingproducts'] }
  set matchingproducts(__a__) {
    setDirtyFlag()
    this['_matchingproducts'] = __a__
  }
  get lockstatus() { return this['_lockstatus'] }
  set lockstatus(__a__) {
    let __v__ = enumReader(['none','requested','locked','expired'],'none')(__a__)
    if(!_.isEqual(__v__,this['_lockstatus'])) {
      setDirtyFlag()
      this['_lockstatus'] = __v__
    }
  }
  get lockdate() { return this['_lockdate'] }
  set lockdate(__a__) {
    let __v__ = DateSReader('')(__a__)
    if(!_.isEqual(__v__,this['_lockdate'])) {
      setDirtyFlag()
      this['_lockdate'] = __v__
    }
  }
  get purpose() { return this['_purpose'] }
  set purpose(__a__) {
    let __v__ = enumReader(['refinance','purchase','purchaserehab','construction','construction-permanent','improvement','cashoutrefinance'],'refinance')(__a__)
    if(!_.isEqual(__v__,this['_purpose'])) {
      setDirtyFlag()
      this['_purpose'] = __v__
    }
  }
  get estimatedclosingcosts() { return this['_estimatedclosingcosts'] }
  set estimatedclosingcosts(__a__) {
    if(__a__ == null) {
      if(this['_estimatedclosingcosts'] == null) { return }
      setDirtyFlag()
      this['_estimatedclosingcosts'] = null
      return
    } else {
      setDirtyFlag()
      this['_estimatedclosingcosts'] = __a__
    }
  }
  get ourfee() { return this['_ourfee'] }
  set ourfee(__a__) {
    if(__a__ == null) {
      if(this['_ourfee'] == null) { return }
      setDirtyFlag()
      this['_ourfee'] = null
      return
    } else {
      let __v__ = floatReader(0.0)(__a__)
      if(!_.isEqual(__v__,this['_ourfee'])) {
        setDirtyFlag()
        this['_ourfee'] = __v__
      }
    }
  }
  get prepaiddays() { return this['_prepaiddays'] }
  set prepaiddays(__a__) {
    if(__a__ == null) {
      if(this['_prepaiddays'] == null) { return }
      setDirtyFlag()
      this['_prepaiddays'] = null
      return
    } else {
      let __v__ = intReader(0)(__a__)
      if(!_.isEqual(__v__,this['_prepaiddays'])) {
        setDirtyFlag()
        this['_prepaiddays'] = __v__
      }
    }
  }
  get productname() { return this['_productname'] }
  set productname(__a__) {
    if(__a__ == null) {
      if(this['_productname'] == null) { return }
      setDirtyFlag()
      this['_productname'] = null
      return
    } else {
      let __v__ = stringReader('')(__a__)
      if(!_.isEqual(__v__,this['_productname'])) {
        setDirtyFlag()
        this['_productname'] = __v__
      }
    }
  }
  get DTI() { return this['_DTI'] }
  set DTI(__a__) {
    if(__a__ == null) {
      if(this['_DTI'] == null) { return }
      setDirtyFlag()
      this['_DTI'] = null
      return
    } else {
      let __v__ = floatReader(0.0)(__a__)
      if(!_.isEqual(__v__,this['_DTI'])) {
        setDirtyFlag()
        this['_DTI'] = __v__
      }
    }
  }
  get maxcashout() { return this['_maxcashout'] }
  set maxcashout(__a__) {
    if(__a__ == null) {
      if(this['_maxcashout'] == null) { return }
      setDirtyFlag()
      this['_maxcashout'] = null
      return
    } else {
      let __v__ = floatReader(0.0)(__a__)
      if(!_.isEqual(__v__,this['_maxcashout'])) {
        setDirtyFlag()
        this['_maxcashout'] = __v__
      }
    }
  }
  get payout() { return this['_payout'] }
  set payout(__a__) {
    if(__a__ == null) {
      if(this['_payout'] == null) { return }
      setDirtyFlag()
      this['_payout'] = null
      return
    } else {
      let __v__ = floatReader(0.0)(__a__)
      if(!_.isEqual(__v__,this['_payout'])) {
        setDirtyFlag()
        this['_payout'] = __v__
      }
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new ChosenLoan()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.hash = __a__['hash']
       cls.APR = __a__['APR']
       cls.Arm = __a__['Arm'] == null ? null : armterms.fromJson(__a__['Arm'])
       cls.amortization = __a__['amortization']
       cls.Mtype = __a__['Mtype']
       cls.Term = __a__['Term']
       cls.base_rate = __a__['base_rate']
       cls.closing_cost = __a__['closing_cost']
       cls.features = productfeatures.fromJson(__a__['features'])
       cls.high_cost_mortgage = __a__['high_cost_mortgage']
       cls.lender_credit = __a__['lender_credit']
       cls.lender_fee = __a__['lender_fee']
       cls.lockDay = __a__['lockDay']
       cls.min_months_reserves = __a__['min_months_reserves']
       cls.monthly_payment = __a__['monthly_payment']
       cls.prepaid_interest = __a__['prepaid_interest']
       cls.points = __a__['points']
       cls.loansize = __a__['loansize']
       cls.downpayment = __a__['downpayment']
       cls.paydown = __a__['paydown']
       cls.cashout = __a__['cashout']
       cls.pmi = __a__['pmi']
       cls.FHAMIP = __a__['FHAMIP'] == null ? null : FHAMIP.fromJson(__a__['FHAMIP'])
       cls.matchingproducts = array1Reader(LoanProduct.fromJson)(__a__['matchingproducts'])
       cls.lockstatus = __a__['lockstatus']
       cls.lockdate = __a__['lockdate']
       cls.purpose = __a__['purpose']
       cls.estimatedclosingcosts = __a__['estimatedclosingcosts'] == null ? null : fees.fromJson(__a__['estimatedclosingcosts'])
       cls.ourfee = __a__['ourfee'] == null ? null : __a__['ourfee']
       cls.prepaiddays = __a__['prepaiddays'] == null ? null : __a__['prepaiddays']
       cls.productname = __a__['productname'] == null ? null : __a__['productname']
       cls.DTI = __a__['DTI'] == null ? null : __a__['DTI']
       cls.maxcashout = __a__['maxcashout'] == null ? null : __a__['maxcashout']
       cls.payout = __a__['payout'] == null ? null : __a__['payout']
    } else {
       doAlert(`ChosenLoan: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class ClosingCostsDetail {
  constructor() {
    this['_originationCharges'] = []
    this['_canNotShopServices'] = []
    this['_canShopServices'] = []
    this['_taxesAndOtherGovernmentFees'] = []
    this['_prepaids'] = []
    this['_initialEscrowPaymentsAtClosing'] = []
    this['_other'] = []
  }
  get originationCharges() { return this['_originationCharges'] }
  set originationCharges(__a__) {
    setDirtyFlag()
    this['_originationCharges'] = __a__
  }
  get canNotShopServices() { return this['_canNotShopServices'] }
  set canNotShopServices(__a__) {
    setDirtyFlag()
    this['_canNotShopServices'] = __a__
  }
  get canShopServices() { return this['_canShopServices'] }
  set canShopServices(__a__) {
    setDirtyFlag()
    this['_canShopServices'] = __a__
  }
  get taxesAndOtherGovernmentFees() { return this['_taxesAndOtherGovernmentFees'] }
  set taxesAndOtherGovernmentFees(__a__) {
    setDirtyFlag()
    this['_taxesAndOtherGovernmentFees'] = __a__
  }
  get prepaids() { return this['_prepaids'] }
  set prepaids(__a__) {
    setDirtyFlag()
    this['_prepaids'] = __a__
  }
  get initialEscrowPaymentsAtClosing() { return this['_initialEscrowPaymentsAtClosing'] }
  set initialEscrowPaymentsAtClosing(__a__) {
    setDirtyFlag()
    this['_initialEscrowPaymentsAtClosing'] = __a__
  }
  get other() { return this['_other'] }
  set other(__a__) {
    setDirtyFlag()
    this['_other'] = __a__
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new ClosingCostsDetail()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.originationCharges = array1Reader(service.fromJson)(__a__['originationCharges'])
       cls.canNotShopServices = array1Reader(service.fromJson)(__a__['canNotShopServices'])
       cls.canShopServices = array1Reader(service.fromJson)(__a__['canShopServices'])
       cls.taxesAndOtherGovernmentFees = array1Reader(service.fromJson)(__a__['taxesAndOtherGovernmentFees'])
       cls.prepaids = array1Reader(service.fromJson)(__a__['prepaids'])
       cls.initialEscrowPaymentsAtClosing = array1Reader(service.fromJson)(__a__['initialEscrowPaymentsAtClosing'])
       cls.other = array1Reader(service.fromJson)(__a__['other'])
    } else {
       doAlert(`ClosingCostsDetail: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class CostFilter {
  constructor() {
    this['_lowvalue'] = 0
    this['_highvalue'] = -1
  }
  get lowvalue() { return this['_lowvalue'] }
  set lowvalue(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_lowvalue'])) {
      setDirtyFlag()
      this['_lowvalue'] = __v__
    }
  }
  get highvalue() { return this['_highvalue'] }
  set highvalue(__a__) {
    let __v__ = intReader(-1)(__a__)
    if(!_.isEqual(__v__,this['_highvalue'])) {
      setDirtyFlag()
      this['_highvalue'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new CostFilter()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.lowvalue = __a__['lowvalue']
       cls.highvalue = __a__['highvalue']
    } else {
       doAlert(`CostFilter: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class CreditAccount {
  constructor() {
    this['_Vendor'] = ''
    this['_Username'] = ''
    this['_Password'] = ''
    this['_UseExperian'] = false
    this['_UseEquifax'] = false
    this['_UseTransUnion'] = false
    this['_AutomatedSoftCreditPull'] = false
    this['_Type'] = 'SoftPull'
    this['_IsDefault'] = false
  }
  get Vendor() { return this['_Vendor'] }
  set Vendor(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_Vendor'])) {
      setDirtyFlag()
      this['_Vendor'] = __v__
    }
  }
  get Username() { return this['_Username'] }
  set Username(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_Username'])) {
      setDirtyFlag()
      this['_Username'] = __v__
    }
  }
  get Password() { return this['_Password'] }
  set Password(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_Password'])) {
      setDirtyFlag()
      this['_Password'] = __v__
    }
  }
  get UseExperian() { return this['_UseExperian'] }
  set UseExperian(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_UseExperian'])) {
      setDirtyFlag()
      this['_UseExperian'] = __v__
    }
  }
  get UseEquifax() { return this['_UseEquifax'] }
  set UseEquifax(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_UseEquifax'])) {
      setDirtyFlag()
      this['_UseEquifax'] = __v__
    }
  }
  get UseTransUnion() { return this['_UseTransUnion'] }
  set UseTransUnion(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_UseTransUnion'])) {
      setDirtyFlag()
      this['_UseTransUnion'] = __v__
    }
  }
  get AutomatedSoftCreditPull() { return this['_AutomatedSoftCreditPull'] }
  set AutomatedSoftCreditPull(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_AutomatedSoftCreditPull'])) {
      setDirtyFlag()
      this['_AutomatedSoftCreditPull'] = __v__
    }
  }
  get Type() { return this['_Type'] }
  set Type(__a__) {
    let __v__ = enumReader(['SoftPull','HardPull','Universal'],'SoftPull')(__a__)
    if(!_.isEqual(__v__,this['_Type'])) {
      setDirtyFlag()
      this['_Type'] = __v__
    }
  }
  get IsDefault() { return this['_IsDefault'] }
  set IsDefault(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_IsDefault'])) {
      setDirtyFlag()
      this['_IsDefault'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new CreditAccount()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.Vendor = __a__['Vendor']
       cls.Username = __a__['Username']
       cls.Password = __a__['Password']
       cls.UseExperian = __a__['UseExperian']
       cls.UseEquifax = __a__['UseEquifax']
       cls.UseTransUnion = __a__['UseTransUnion']
       cls.AutomatedSoftCreditPull = __a__['AutomatedSoftCreditPull']
       cls.Type = __a__['Type']
       cls.IsDefault = __a__['IsDefault']
    } else {
       doAlert(`CreditAccount: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class CreditAccountConfiguration {
  constructor() {
    this['_Accounts'] = []
  }
  get Accounts() { return this['_Accounts'] }
  set Accounts(__a__) {
    setDirtyFlag()
    this['_Accounts'] = __a__
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new CreditAccountConfiguration()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.Accounts = array1Reader(CreditAccount.fromJson)(__a__['Accounts'])
    } else {
       doAlert(`CreditAccountConfiguration: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class CurrentDTIResult {
  constructor() {
    this['_OverallDTI'] = new DTIResult()
    this['_BorrowerDTI'] = new DTIResult()
    this['_CoborrowerDTI'] = new DTIResult()
  }
  get OverallDTI() { return this['_OverallDTI'] }
  set OverallDTI(__a__) {
    setDirtyFlag()
    this['_OverallDTI'] = __a__
  }
  get BorrowerDTI() { return this['_BorrowerDTI'] }
  set BorrowerDTI(__a__) {
    setDirtyFlag()
    this['_BorrowerDTI'] = __a__
  }
  get CoborrowerDTI() { return this['_CoborrowerDTI'] }
  set CoborrowerDTI(__a__) {
    setDirtyFlag()
    this['_CoborrowerDTI'] = __a__
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new CurrentDTIResult()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.OverallDTI = DTIResult.fromJson(__a__['OverallDTI'])
       cls.BorrowerDTI = DTIResult.fromJson(__a__['BorrowerDTI'])
       cls.CoborrowerDTI = DTIResult.fromJson(__a__['CoborrowerDTI'])
    } else {
       doAlert(`CurrentDTIResult: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class CustomerConfigurations {
  constructor() {
    this['_isBetaCustomer'] = false
    this['_isNonQMCustomer'] = false
    this['_isMobileHomeOnly'] = false
    this['_isNonQMInclusive'] = false
    this['_isNonQMExclusive'] = false
    this['_estimatedClosingCostsDetail'] = null
    this['_lodeStarConfig'] = null
  }
  get isBetaCustomer() { return this['_isBetaCustomer'] }
  set isBetaCustomer(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_isBetaCustomer'])) {
      setDirtyFlag()
      this['_isBetaCustomer'] = __v__
    }
  }
  get isNonQMCustomer() { return this['_isNonQMCustomer'] }
  set isNonQMCustomer(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_isNonQMCustomer'])) {
      setDirtyFlag()
      this['_isNonQMCustomer'] = __v__
    }
  }
  get isMobileHomeOnly() { return this['_isMobileHomeOnly'] }
  set isMobileHomeOnly(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_isMobileHomeOnly'])) {
      setDirtyFlag()
      this['_isMobileHomeOnly'] = __v__
    }
  }
  get isNonQMInclusive() { return this['_isNonQMInclusive'] }
  set isNonQMInclusive(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_isNonQMInclusive'])) {
      setDirtyFlag()
      this['_isNonQMInclusive'] = __v__
    }
  }
  get isNonQMExclusive() { return this['_isNonQMExclusive'] }
  set isNonQMExclusive(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_isNonQMExclusive'])) {
      setDirtyFlag()
      this['_isNonQMExclusive'] = __v__
    }
  }
  get estimatedClosingCostsDetail() { return this['_estimatedClosingCostsDetail'] }
  set estimatedClosingCostsDetail(__a__) {
    if(__a__ == null) {
      if(this['_estimatedClosingCostsDetail'] == null) { return }
      setDirtyFlag()
      this['_estimatedClosingCostsDetail'] = null
      return
    } else {
      setDirtyFlag()
      this['_estimatedClosingCostsDetail'] = __a__
    }
  }
  get lodeStarConfig() { return this['_lodeStarConfig'] }
  set lodeStarConfig(__a__) {
    if(__a__ == null) {
      if(this['_lodeStarConfig'] == null) { return }
      setDirtyFlag()
      this['_lodeStarConfig'] = null
      return
    } else {
      setDirtyFlag()
      this['_lodeStarConfig'] = __a__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new CustomerConfigurations()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.isBetaCustomer = __a__['isBetaCustomer']
       cls.isNonQMCustomer = __a__['isNonQMCustomer']
       cls.isMobileHomeOnly = __a__['isMobileHomeOnly']
       cls.isNonQMInclusive = __a__['isNonQMInclusive']
       cls.isNonQMExclusive = __a__['isNonQMExclusive']
       cls.estimatedClosingCostsDetail = __a__['estimatedClosingCostsDetail'] == null ? null : ClosingCostsDetail.fromJson(__a__['estimatedClosingCostsDetail'])
       cls.lodeStarConfig = __a__['lodeStarConfig'] == null ? null : LodeStarConfig.fromJson(__a__['lodeStarConfig'])
    } else {
       doAlert(`CustomerConfigurations: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class DTICalculation {
  constructor() {
    this['_rate'] = 0.0
    this['_monthlyPayment'] = ''
  }
  get rate() { return this['_rate'] }
  set rate(__a__) {
    let __v__ = floatReader(0.0)(__a__)
    if(!_.isEqual(__v__,this['_rate'])) {
      setDirtyFlag()
      this['_rate'] = __v__
    }
  }
  get monthlyPayment() { return this['_monthlyPayment'] }
  set monthlyPayment(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_monthlyPayment'])) {
      setDirtyFlag()
      this['_monthlyPayment'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new DTICalculation()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.rate = __a__['rate']
       cls.monthlyPayment = __a__['monthlyPayment']
    } else {
       doAlert(`DTICalculation: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class DTIResult {
  constructor() {
    this['_FrontDTIIncome'] = 0.0
    this['_FrontDTILiability'] = 0.0
    this['_OverallDTIIncome'] = 0.0
    this['_OverallDTILiability'] = 0.0
  }
  get FrontDTIIncome() { return this['_FrontDTIIncome'] }
  set FrontDTIIncome(__a__) {
    let __v__ = floatReader(0.0)(__a__)
    if(!_.isEqual(__v__,this['_FrontDTIIncome'])) {
      setDirtyFlag()
      this['_FrontDTIIncome'] = __v__
    }
  }
  get FrontDTILiability() { return this['_FrontDTILiability'] }
  set FrontDTILiability(__a__) {
    let __v__ = floatReader(0.0)(__a__)
    if(!_.isEqual(__v__,this['_FrontDTILiability'])) {
      setDirtyFlag()
      this['_FrontDTILiability'] = __v__
    }
  }
  get OverallDTIIncome() { return this['_OverallDTIIncome'] }
  set OverallDTIIncome(__a__) {
    let __v__ = floatReader(0.0)(__a__)
    if(!_.isEqual(__v__,this['_OverallDTIIncome'])) {
      setDirtyFlag()
      this['_OverallDTIIncome'] = __v__
    }
  }
  get OverallDTILiability() { return this['_OverallDTILiability'] }
  set OverallDTILiability(__a__) {
    let __v__ = floatReader(0.0)(__a__)
    if(!_.isEqual(__v__,this['_OverallDTILiability'])) {
      setDirtyFlag()
      this['_OverallDTILiability'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new DTIResult()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.FrontDTIIncome = __a__['FrontDTIIncome']
       cls.FrontDTILiability = __a__['FrontDTILiability']
       cls.OverallDTIIncome = __a__['OverallDTIIncome']
       cls.OverallDTILiability = __a__['OverallDTILiability']
    } else {
       doAlert(`DTIResult: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class DocumentsAutoReminderConfiguration {
  constructor() {
    this['_TurnedOn'] = false
    this['_ReminderFrequency'] = 'every2Days'
    this['_EndWhen'] = new DocumentsAutoReminderEndWhen()
  }
  get TurnedOn() { return this['_TurnedOn'] }
  set TurnedOn(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_TurnedOn'])) {
      setDirtyFlag()
      this['_TurnedOn'] = __v__
    }
  }
  get ReminderFrequency() { return this['_ReminderFrequency'] }
  set ReminderFrequency(__a__) {
    let __v__ = enumReader(['daily','every2Days','every3Days','weekly','biWeekly'],'every2Days')(__a__)
    if(!_.isEqual(__v__,this['_ReminderFrequency'])) {
      setDirtyFlag()
      this['_ReminderFrequency'] = __v__
    }
  }
  get EndWhen() { return this['_EndWhen'] }
  set EndWhen(__a__) {
    setDirtyFlag()
    this['_EndWhen'] = __a__
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new DocumentsAutoReminderConfiguration()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.TurnedOn = __a__['TurnedOn']
       cls.ReminderFrequency = __a__['ReminderFrequency']
       cls.EndWhen = DocumentsAutoReminderEndWhen.fromJson(__a__['EndWhen'])
    } else {
       doAlert(`DocumentsAutoReminderConfiguration: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class DocumentsAutoReminderEndWhen {
  constructor() {
    this['_WhenLoanFunded'] = null
    this['_AfterNumberOfDays'] = null
    this['_WhenDate'] = null
  }
  get WhenLoanFunded() { return this['_WhenLoanFunded'] }
  set WhenLoanFunded(__a__) {
    if(__a__ == null) {
      if(this['_WhenLoanFunded'] == null) { return }
      setDirtyFlag()
      this['_WhenLoanFunded'] = null
      return
    } else {
      let __v__ = boolReader(false)(__a__)
      if(!_.isEqual(__v__,this['_WhenLoanFunded'])) {
        setDirtyFlag()
        this['_WhenLoanFunded'] = __v__
      }
    }
  }
  get AfterNumberOfDays() { return this['_AfterNumberOfDays'] }
  set AfterNumberOfDays(__a__) {
    if(__a__ == null) {
      if(this['_AfterNumberOfDays'] == null) { return }
      setDirtyFlag()
      this['_AfterNumberOfDays'] = null
      return
    } else {
      let __v__ = intReader(0)(__a__)
      if(!_.isEqual(__v__,this['_AfterNumberOfDays'])) {
        setDirtyFlag()
        this['_AfterNumberOfDays'] = __v__
      }
    }
  }
  get WhenDate() { return this['_WhenDate'] }
  set WhenDate(__a__) {
    if(__a__ == null) {
      if(this['_WhenDate'] == null) { return }
      setDirtyFlag()
      this['_WhenDate'] = null
      return
    } else {
      let __v__ = stringReader('')(__a__)
      if(!_.isEqual(__v__,this['_WhenDate'])) {
        setDirtyFlag()
        this['_WhenDate'] = __v__
      }
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new DocumentsAutoReminderEndWhen()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.WhenLoanFunded = __a__['WhenLoanFunded'] == null ? null : __a__['WhenLoanFunded']
       cls.AfterNumberOfDays = __a__['AfterNumberOfDays'] == null ? null : __a__['AfterNumberOfDays']
       cls.WhenDate = __a__['WhenDate'] == null ? null : __a__['WhenDate']
    } else {
       doAlert(`DocumentsAutoReminderEndWhen: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class FHAMIP {
  constructor() {
    this['_upfrontMIP'] = 0.0
    this['_monthlyMIP'] = 0.0
  }
  get upfrontMIP() { return this['_upfrontMIP'] }
  set upfrontMIP(__a__) {
    let __v__ = floatReader(0.0)(__a__)
    if(!_.isEqual(__v__,this['_upfrontMIP'])) {
      setDirtyFlag()
      this['_upfrontMIP'] = __v__
    }
  }
  get monthlyMIP() { return this['_monthlyMIP'] }
  set monthlyMIP(__a__) {
    let __v__ = floatReader(0.0)(__a__)
    if(!_.isEqual(__v__,this['_monthlyMIP'])) {
      setDirtyFlag()
      this['_monthlyMIP'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new FHAMIP()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.upfrontMIP = __a__['upfrontMIP']
       cls.monthlyMIP = __a__['monthlyMIP']
    } else {
       doAlert(`FHAMIP: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class FinancingOption {
  constructor() {
    this['_NewLoanAmount'] = 0.0
    this['_NoCostRate'] = 0.0
  }
  get NewLoanAmount() { return this['_NewLoanAmount'] }
  set NewLoanAmount(__a__) {
    let __v__ = floatReader(0.0)(__a__)
    if(!_.isEqual(__v__,this['_NewLoanAmount'])) {
      setDirtyFlag()
      this['_NewLoanAmount'] = __v__
    }
  }
  get NoCostRate() { return this['_NoCostRate'] }
  set NoCostRate(__a__) {
    let __v__ = floatReader(0.0)(__a__)
    if(!_.isEqual(__v__,this['_NoCostRate'])) {
      setDirtyFlag()
      this['_NoCostRate'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new FinancingOption()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.NewLoanAmount = __a__['NewLoanAmount']
       cls.NoCostRate = __a__['NoCostRate']
    } else {
       doAlert(`FinancingOption: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class FutureExpenses {
  constructor() {
    this['_otherfinancing'] = ''
    this['_otherfinancingperiod'] = 'monthly'
    this['_homeownersinsurance'] = ''
    this['_homeownersinsuranceperiod'] = 'monthly'
    this['_realestatetaxes'] = ''
    this['_realestatetaxesperiod'] = 'monthly'
    this['_hoa'] = ''
    this['_hoaperiod'] = 'monthly'
    this['_floodinsurance'] = ''
    this['_floodinsuranceperiod'] = 'monthly'
    this['_estimatedmonthlytotal'] = ''
  }
  get otherfinancing() { return this['_otherfinancing'] }
  set otherfinancing(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_otherfinancing'])) {
      setDirtyFlag()
      this['_otherfinancing'] = __v__
    }
  }
  get otherfinancingperiod() { return this['_otherfinancingperiod'] }
  set otherfinancingperiod(__a__) {
    let __v__ = enumReader(['monthly','yearly','daily','hourly'],'monthly')(__a__)
    if(!_.isEqual(__v__,this['_otherfinancingperiod'])) {
      setDirtyFlag()
      this['_otherfinancingperiod'] = __v__
    }
  }
  get homeownersinsurance() { return this['_homeownersinsurance'] }
  set homeownersinsurance(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_homeownersinsurance'])) {
      setDirtyFlag()
      this['_homeownersinsurance'] = __v__
    }
  }
  get homeownersinsuranceperiod() { return this['_homeownersinsuranceperiod'] }
  set homeownersinsuranceperiod(__a__) {
    let __v__ = enumReader(['monthly','yearly','daily','hourly'],'monthly')(__a__)
    if(!_.isEqual(__v__,this['_homeownersinsuranceperiod'])) {
      setDirtyFlag()
      this['_homeownersinsuranceperiod'] = __v__
    }
  }
  get realestatetaxes() { return this['_realestatetaxes'] }
  set realestatetaxes(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_realestatetaxes'])) {
      setDirtyFlag()
      this['_realestatetaxes'] = __v__
    }
  }
  get realestatetaxesperiod() { return this['_realestatetaxesperiod'] }
  set realestatetaxesperiod(__a__) {
    let __v__ = enumReader(['monthly','yearly','daily','hourly'],'monthly')(__a__)
    if(!_.isEqual(__v__,this['_realestatetaxesperiod'])) {
      setDirtyFlag()
      this['_realestatetaxesperiod'] = __v__
    }
  }
  get hoa() { return this['_hoa'] }
  set hoa(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_hoa'])) {
      setDirtyFlag()
      this['_hoa'] = __v__
    }
  }
  get hoaperiod() { return this['_hoaperiod'] }
  set hoaperiod(__a__) {
    let __v__ = enumReader(['monthly','yearly','daily','hourly'],'monthly')(__a__)
    if(!_.isEqual(__v__,this['_hoaperiod'])) {
      setDirtyFlag()
      this['_hoaperiod'] = __v__
    }
  }
  get floodinsurance() { return this['_floodinsurance'] }
  set floodinsurance(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_floodinsurance'])) {
      setDirtyFlag()
      this['_floodinsurance'] = __v__
    }
  }
  get floodinsuranceperiod() { return this['_floodinsuranceperiod'] }
  set floodinsuranceperiod(__a__) {
    let __v__ = enumReader(['monthly','yearly','daily','hourly'],'monthly')(__a__)
    if(!_.isEqual(__v__,this['_floodinsuranceperiod'])) {
      setDirtyFlag()
      this['_floodinsuranceperiod'] = __v__
    }
  }
  get estimatedmonthlytotal() { return this['_estimatedmonthlytotal'] }
  set estimatedmonthlytotal(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_estimatedmonthlytotal'])) {
      setDirtyFlag()
      this['_estimatedmonthlytotal'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new FutureExpenses()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.otherfinancing = __a__['otherfinancing']
       cls.otherfinancingperiod = __a__['otherfinancingperiod']
       cls.homeownersinsurance = __a__['homeownersinsurance']
       cls.homeownersinsuranceperiod = __a__['homeownersinsuranceperiod']
       cls.realestatetaxes = __a__['realestatetaxes']
       cls.realestatetaxesperiod = __a__['realestatetaxesperiod']
       cls.hoa = __a__['hoa']
       cls.hoaperiod = __a__['hoaperiod']
       cls.floodinsurance = __a__['floodinsurance']
       cls.floodinsuranceperiod = __a__['floodinsuranceperiod']
       cls.estimatedmonthlytotal = __a__['estimatedmonthlytotal']
    } else {
       doAlert(`FutureExpenses: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class HardMoneyLoan {
  constructor() {
    this['_serialnumber'] = ''
    this['_estimatedfico'] = 0
    this['_coborrowerestimatedfico'] = 0
    this['_targetclosingdate'] = ''
    this['_initialloanamount'] = ''
    this['_mortgagetermmonths'] = 0
    this['_rehaborconstructionloan'] = false
    this['_rehaborconstructionloanamount'] = ''
    this['_timesofflippingaproperty'] = 0
    this['_timesofpurchasingarentalproperty'] = 0
    this['_refinanceloanamount'] = ''
    this['_constructiontype'] = null
    this['_projectedafterrepairvalue'] = ''
    this['_borrowertype'] = 'LLC'
    this['_entityinfo'] = null
    this['_loantype'] = 'fixflip'
    this['_propertyflippingexperiences'] = []
    this['_rentalpropertyexperiences'] = []
    this['_initialadvancerequested'] = ''
    this['_assignmentfee'] = false
    this['_assignmentfeeamount'] = ''
    this['_liquidity'] = ''
    this['_exitstrategy'] = null
    this['_rehaborconstructiondetails'] = new rehaborconstructiondetails()
    this['_refinancedetails'] = new refinancedetails()
    this['_titlecontact'] = new thirdpartycontact()
    this['_escrowcontact'] = new thirdpartycontact()
    this['_insurancecontact'] = new thirdpartycontact()
    this['_appraisalschedulecontact'] = new thirdpartycontact()
    this['_appraisalpaymentcontact'] = new thirdpartycontact()
  }
  get serialnumber() { return this['_serialnumber'] }
  set serialnumber(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_serialnumber'])) {
      setDirtyFlag()
      this['_serialnumber'] = __v__
    }
  }
  get estimatedfico() { return this['_estimatedfico'] }
  set estimatedfico(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_estimatedfico'])) {
      setDirtyFlag()
      this['_estimatedfico'] = __v__
    }
  }
  get coborrowerestimatedfico() { return this['_coborrowerestimatedfico'] }
  set coborrowerestimatedfico(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_coborrowerestimatedfico'])) {
      setDirtyFlag()
      this['_coborrowerestimatedfico'] = __v__
    }
  }
  get targetclosingdate() { return this['_targetclosingdate'] }
  set targetclosingdate(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_targetclosingdate'])) {
      setDirtyFlag()
      this['_targetclosingdate'] = __v__
    }
  }
  get initialloanamount() { return this['_initialloanamount'] }
  set initialloanamount(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_initialloanamount'])) {
      setDirtyFlag()
      this['_initialloanamount'] = __v__
    }
  }
  get mortgagetermmonths() { return this['_mortgagetermmonths'] }
  set mortgagetermmonths(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_mortgagetermmonths'])) {
      setDirtyFlag()
      this['_mortgagetermmonths'] = __v__
    }
  }
  get rehaborconstructionloan() { return this['_rehaborconstructionloan'] }
  set rehaborconstructionloan(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_rehaborconstructionloan'])) {
      setDirtyFlag()
      this['_rehaborconstructionloan'] = __v__
    }
  }
  get rehaborconstructionloanamount() { return this['_rehaborconstructionloanamount'] }
  set rehaborconstructionloanamount(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_rehaborconstructionloanamount'])) {
      setDirtyFlag()
      this['_rehaborconstructionloanamount'] = __v__
    }
  }
  get timesofflippingaproperty() { return this['_timesofflippingaproperty'] }
  set timesofflippingaproperty(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_timesofflippingaproperty'])) {
      setDirtyFlag()
      this['_timesofflippingaproperty'] = __v__
    }
  }
  get timesofpurchasingarentalproperty() { return this['_timesofpurchasingarentalproperty'] }
  set timesofpurchasingarentalproperty(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_timesofpurchasingarentalproperty'])) {
      setDirtyFlag()
      this['_timesofpurchasingarentalproperty'] = __v__
    }
  }
  get refinanceloanamount() { return this['_refinanceloanamount'] }
  set refinanceloanamount(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_refinanceloanamount'])) {
      setDirtyFlag()
      this['_refinanceloanamount'] = __v__
    }
  }
  get constructiontype() { return this['_constructiontype'] }
  set constructiontype(__a__) {
    if(__a__ == null) {
      if(this['_constructiontype'] == null) { return }
      setDirtyFlag()
      this['_constructiontype'] = null
      return
    } else {
      let __v__ = enumReader(['ADU'],'ADU')(__a__)
      if(!_.isEqual(__v__,this['_constructiontype'])) {
        setDirtyFlag()
        this['_constructiontype'] = __v__
      }
    }
  }
  get projectedafterrepairvalue() { return this['_projectedafterrepairvalue'] }
  set projectedafterrepairvalue(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_projectedafterrepairvalue'])) {
      setDirtyFlag()
      this['_projectedafterrepairvalue'] = __v__
    }
  }
  get borrowertype() { return this['_borrowertype'] }
  set borrowertype(__a__) {
    let __v__ = enumReader(['LLC','Individual','Corporation','Partnership','Trust'],'LLC')(__a__)
    if(!_.isEqual(__v__,this['_borrowertype'])) {
      setDirtyFlag()
      this['_borrowertype'] = __v__
    }
  }
  get entityinfo() { return this['_entityinfo'] }
  set entityinfo(__a__) {
    if(__a__ == null) {
      if(this['_entityinfo'] == null) { return }
      setDirtyFlag()
      this['_entityinfo'] = null
      return
    } else {
      setDirtyFlag()
      this['_entityinfo'] = __a__
    }
  }
  get loantype() { return this['_loantype'] }
  set loantype(__a__) {
    let __v__ = enumReader(['fixflip','fixrent','bridge','groundup','scrapebuild','rental','rehab'],'fixflip')(__a__)
    if(!_.isEqual(__v__,this['_loantype'])) {
      setDirtyFlag()
      this['_loantype'] = __v__
    }
  }
  get propertyflippingexperiences() { return this['_propertyflippingexperiences'] }
  set propertyflippingexperiences(__a__) {
    setDirtyFlag()
    this['_propertyflippingexperiences'] = __a__
  }
  get rentalpropertyexperiences() { return this['_rentalpropertyexperiences'] }
  set rentalpropertyexperiences(__a__) {
    setDirtyFlag()
    this['_rentalpropertyexperiences'] = __a__
  }
  get initialadvancerequested() { return this['_initialadvancerequested'] }
  set initialadvancerequested(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_initialadvancerequested'])) {
      setDirtyFlag()
      this['_initialadvancerequested'] = __v__
    }
  }
  get assignmentfee() { return this['_assignmentfee'] }
  set assignmentfee(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_assignmentfee'])) {
      setDirtyFlag()
      this['_assignmentfee'] = __v__
    }
  }
  get assignmentfeeamount() { return this['_assignmentfeeamount'] }
  set assignmentfeeamount(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_assignmentfeeamount'])) {
      setDirtyFlag()
      this['_assignmentfeeamount'] = __v__
    }
  }
  get liquidity() { return this['_liquidity'] }
  set liquidity(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_liquidity'])) {
      setDirtyFlag()
      this['_liquidity'] = __v__
    }
  }
  get exitstrategy() { return this['_exitstrategy'] }
  set exitstrategy(__a__) {
    if(__a__ == null) {
      if(this['_exitstrategy'] == null) { return }
      setDirtyFlag()
      this['_exitstrategy'] = null
      return
    } else {
      let __v__ = enumReader(['fixandflip','fixandrent','buildandflip','buildandrent','refitoconventional','refitobuild','refitoflip','refitorent','forsale','longtermrental','others'],'fixandflip')(__a__)
      if(!_.isEqual(__v__,this['_exitstrategy'])) {
        setDirtyFlag()
        this['_exitstrategy'] = __v__
      }
    }
  }
  get rehaborconstructiondetails() { return this['_rehaborconstructiondetails'] }
  set rehaborconstructiondetails(__a__) {
    setDirtyFlag()
    this['_rehaborconstructiondetails'] = __a__
  }
  get refinancedetails() { return this['_refinancedetails'] }
  set refinancedetails(__a__) {
    setDirtyFlag()
    this['_refinancedetails'] = __a__
  }
  get titlecontact() { return this['_titlecontact'] }
  set titlecontact(__a__) {
    setDirtyFlag()
    this['_titlecontact'] = __a__
  }
  get escrowcontact() { return this['_escrowcontact'] }
  set escrowcontact(__a__) {
    setDirtyFlag()
    this['_escrowcontact'] = __a__
  }
  get insurancecontact() { return this['_insurancecontact'] }
  set insurancecontact(__a__) {
    setDirtyFlag()
    this['_insurancecontact'] = __a__
  }
  get appraisalschedulecontact() { return this['_appraisalschedulecontact'] }
  set appraisalschedulecontact(__a__) {
    setDirtyFlag()
    this['_appraisalschedulecontact'] = __a__
  }
  get appraisalpaymentcontact() { return this['_appraisalpaymentcontact'] }
  set appraisalpaymentcontact(__a__) {
    setDirtyFlag()
    this['_appraisalpaymentcontact'] = __a__
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new HardMoneyLoan()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.serialnumber = __a__['serialnumber']
       cls.estimatedfico = __a__['estimatedfico']
       cls.coborrowerestimatedfico = __a__['coborrowerestimatedfico']
       cls.targetclosingdate = __a__['targetclosingdate']
       cls.initialloanamount = __a__['initialloanamount']
       cls.mortgagetermmonths = __a__['mortgagetermmonths']
       cls.rehaborconstructionloan = __a__['rehaborconstructionloan']
       cls.rehaborconstructionloanamount = __a__['rehaborconstructionloanamount']
       cls.timesofflippingaproperty = __a__['timesofflippingaproperty']
       cls.timesofpurchasingarentalproperty = __a__['timesofpurchasingarentalproperty']
       cls.refinanceloanamount = __a__['refinanceloanamount']
       cls.constructiontype = __a__['constructiontype'] == null ? null : __a__['constructiontype']
       cls.projectedafterrepairvalue = __a__['projectedafterrepairvalue']
       cls.borrowertype = __a__['borrowertype']
       cls.entityinfo = __a__['entityinfo'] == null ? null : HardMoneyLoanEntityInfo.fromJson(__a__['entityinfo'])
       cls.loantype = __a__['loantype']
       cls.propertyflippingexperiences = array1Reader(propertyflippingexperience.fromJson)(__a__['propertyflippingexperiences'])
       cls.rentalpropertyexperiences = array1Reader(rentalpropertyexperience.fromJson)(__a__['rentalpropertyexperiences'])
       cls.initialadvancerequested = __a__['initialadvancerequested']
       cls.assignmentfee = __a__['assignmentfee']
       cls.assignmentfeeamount = __a__['assignmentfeeamount']
       cls.liquidity = __a__['liquidity']
       cls.exitstrategy = __a__['exitstrategy'] == null ? null : __a__['exitstrategy']
       cls.rehaborconstructiondetails = rehaborconstructiondetails.fromJson(__a__['rehaborconstructiondetails'])
       cls.refinancedetails = refinancedetails.fromJson(__a__['refinancedetails'])
       cls.titlecontact = thirdpartycontact.fromJson(__a__['titlecontact'])
       cls.escrowcontact = thirdpartycontact.fromJson(__a__['escrowcontact'])
       cls.insurancecontact = thirdpartycontact.fromJson(__a__['insurancecontact'])
       cls.appraisalschedulecontact = thirdpartycontact.fromJson(__a__['appraisalschedulecontact'])
       cls.appraisalpaymentcontact = thirdpartycontact.fromJson(__a__['appraisalpaymentcontact'])
    } else {
       doAlert(`HardMoneyLoan: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class HardMoneyLoanEntityInfo {
  constructor() {
    this['_entityname'] = ''
    this['_tin'] = ''
    this['_percentageown'] = 0
    this['_streetline1'] = ''
    this['_streetline2'] = ''
    this['_city'] = ''
    this['_state'] = ''
    this['_zip'] = ''
    this['_phone'] = ''
    this['_email'] = ''
    this['_contactfirstname'] = ''
    this['_contactlastname'] = ''
    this['_contactposition'] = ''
  }
  get entityname() { return this['_entityname'] }
  set entityname(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_entityname'])) {
      setDirtyFlag()
      this['_entityname'] = __v__
    }
  }
  get tin() { return this['_tin'] }
  set tin(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_tin'])) {
      setDirtyFlag()
      this['_tin'] = __v__
    }
  }
  get percentageown() { return this['_percentageown'] }
  set percentageown(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_percentageown'])) {
      setDirtyFlag()
      this['_percentageown'] = __v__
    }
  }
  get streetline1() { return this['_streetline1'] }
  set streetline1(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_streetline1'])) {
      setDirtyFlag()
      this['_streetline1'] = __v__
    }
  }
  get streetline2() { return this['_streetline2'] }
  set streetline2(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_streetline2'])) {
      setDirtyFlag()
      this['_streetline2'] = __v__
    }
  }
  get city() { return this['_city'] }
  set city(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_city'])) {
      setDirtyFlag()
      this['_city'] = __v__
    }
  }
  get state() { return this['_state'] }
  set state(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_state'])) {
      setDirtyFlag()
      this['_state'] = __v__
    }
  }
  get zip() { return this['_zip'] }
  set zip(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_zip'])) {
      setDirtyFlag()
      this['_zip'] = __v__
    }
  }
  get phone() { return this['_phone'] }
  set phone(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_phone'])) {
      setDirtyFlag()
      this['_phone'] = __v__
    }
  }
  get email() { return this['_email'] }
  set email(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_email'])) {
      setDirtyFlag()
      this['_email'] = __v__
    }
  }
  get contactfirstname() { return this['_contactfirstname'] }
  set contactfirstname(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_contactfirstname'])) {
      setDirtyFlag()
      this['_contactfirstname'] = __v__
    }
  }
  get contactlastname() { return this['_contactlastname'] }
  set contactlastname(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_contactlastname'])) {
      setDirtyFlag()
      this['_contactlastname'] = __v__
    }
  }
  get contactposition() { return this['_contactposition'] }
  set contactposition(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_contactposition'])) {
      setDirtyFlag()
      this['_contactposition'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new HardMoneyLoanEntityInfo()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.entityname = __a__['entityname']
       cls.tin = __a__['tin']
       cls.percentageown = __a__['percentageown']
       cls.streetline1 = __a__['streetline1']
       cls.streetline2 = __a__['streetline2']
       cls.city = __a__['city']
       cls.state = __a__['state']
       cls.zip = __a__['zip']
       cls.phone = __a__['phone']
       cls.email = __a__['email']
       cls.contactfirstname = __a__['contactfirstname']
       cls.contactlastname = __a__['contactlastname']
       cls.contactposition = __a__['contactposition']
    } else {
       doAlert(`HardMoneyLoanEntityInfo: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class Hispanic {
  constructor() {
    this['_mexican'] = false
    this['_puertorican'] = false
    this['_cuban'] = false
    this['_other'] = false
    this['_otherdesctiption'] = ''
  }
  get mexican() { return this['_mexican'] }
  set mexican(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_mexican'])) {
      setDirtyFlag()
      this['_mexican'] = __v__
    }
  }
  get puertorican() { return this['_puertorican'] }
  set puertorican(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_puertorican'])) {
      setDirtyFlag()
      this['_puertorican'] = __v__
    }
  }
  get cuban() { return this['_cuban'] }
  set cuban(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_cuban'])) {
      setDirtyFlag()
      this['_cuban'] = __v__
    }
  }
  get other() { return this['_other'] }
  set other(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_other'])) {
      setDirtyFlag()
      this['_other'] = __v__
    }
  }
  get otherdesctiption() { return this['_otherdesctiption'] }
  set otherdesctiption(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_otherdesctiption'])) {
      setDirtyFlag()
      this['_otherdesctiption'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new Hispanic()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.mexican = __a__['mexican']
       cls.puertorican = __a__['puertorican']
       cls.cuban = __a__['cuban']
       cls.other = __a__['other']
       cls.otherdesctiption = __a__['otherdesctiption']
    } else {
       doAlert(`Hispanic: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class LienPosition {
  constructor() {
    this['_firstlien'] = 0.0
    this['_firstlienowner'] = 'fanniemae'
    this['_issecondlien'] = false
  }
  get firstlien() { return this['_firstlien'] }
  set firstlien(__a__) {
    let __v__ = floatReader(0.0)(__a__)
    if(!_.isEqual(__v__,this['_firstlien'])) {
      setDirtyFlag()
      this['_firstlien'] = __v__
    }
  }
  get firstlienowner() { return this['_firstlienowner'] }
  set firstlienowner(__a__) {
    let __v__ = enumReader(['fanniemae','freddiemac'],'fanniemae')(__a__)
    if(!_.isEqual(__v__,this['_firstlienowner'])) {
      setDirtyFlag()
      this['_firstlienowner'] = __v__
    }
  }
  get issecondlien() { return this['_issecondlien'] }
  set issecondlien(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_issecondlien'])) {
      setDirtyFlag()
      this['_issecondlien'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new LienPosition()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.firstlien = __a__['firstlien']
       cls.firstlienowner = __a__['firstlienowner']
       cls.issecondlien = __a__['issecondlien']
    } else {
       doAlert(`LienPosition: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class LoState {
  constructor() {
    this['_application'] = new application()
    this['_progress'] = new progress()
    this['_borrower'] = new borrowerinternal()
    this['_notifications'] = new notifications()
    this['_locreditreportadditions'] = new locreditreportadditions()
  }
  get application() { return this['_application'] }
  set application(__a__) {
    setDirtyFlag()
    this['_application'] = __a__
  }
  get progress() { return this['_progress'] }
  set progress(__a__) {
    setDirtyFlag()
    this['_progress'] = __a__
  }
  get borrower() { return this['_borrower'] }
  set borrower(__a__) {
    setDirtyFlag()
    this['_borrower'] = __a__
  }
  get notifications() { return this['_notifications'] }
  set notifications(__a__) {
    setDirtyFlag()
    this['_notifications'] = __a__
  }
  get locreditreportadditions() { return this['_locreditreportadditions'] }
  set locreditreportadditions(__a__) {
    setDirtyFlag()
    this['_locreditreportadditions'] = __a__
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new LoState()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.application = application.fromJson(__a__['application'])
       cls.progress = progress.fromJson(__a__['progress'])
       cls.borrower = borrowerinternal.fromJson(__a__['borrower'])
       cls.notifications = notifications.fromJson(__a__['notifications'])
       cls.locreditreportadditions = locreditreportadditions.fromJson(__a__['locreditreportadditions'])
    } else {
       doAlert(`LoState: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class LoanOfficerConfigurations {
  constructor() {
    this['_AutomatedCreditPull'] = false
    this['_AutomatedPreQualLetter'] = false
    this['_DocumentsTransitionVisited'] = false
    this['_DocumentsAutoReminder'] = new DocumentsAutoReminderConfiguration()
    this['_OnMarketplace'] = false
    this['_CreditAccounts'] = []
    this['_PromptVerified'] = false
    this['_JoinMarketplace'] = false
  }
  get AutomatedCreditPull() { return this['_AutomatedCreditPull'] }
  set AutomatedCreditPull(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_AutomatedCreditPull'])) {
      setDirtyFlag()
      this['_AutomatedCreditPull'] = __v__
    }
  }
  get AutomatedPreQualLetter() { return this['_AutomatedPreQualLetter'] }
  set AutomatedPreQualLetter(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_AutomatedPreQualLetter'])) {
      setDirtyFlag()
      this['_AutomatedPreQualLetter'] = __v__
    }
  }
  get DocumentsTransitionVisited() { return this['_DocumentsTransitionVisited'] }
  set DocumentsTransitionVisited(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_DocumentsTransitionVisited'])) {
      setDirtyFlag()
      this['_DocumentsTransitionVisited'] = __v__
    }
  }
  get DocumentsAutoReminder() { return this['_DocumentsAutoReminder'] }
  set DocumentsAutoReminder(__a__) {
    setDirtyFlag()
    this['_DocumentsAutoReminder'] = __a__
  }
  get OnMarketplace() { return this['_OnMarketplace'] }
  set OnMarketplace(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_OnMarketplace'])) {
      setDirtyFlag()
      this['_OnMarketplace'] = __v__
    }
  }
  get CreditAccounts() { return this['_CreditAccounts'] }
  set CreditAccounts(__a__) {
    setDirtyFlag()
    this['_CreditAccounts'] = __a__
  }
  get PromptVerified() { return this['_PromptVerified'] }
  set PromptVerified(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_PromptVerified'])) {
      setDirtyFlag()
      this['_PromptVerified'] = __v__
    }
  }
  get JoinMarketplace() { return this['_JoinMarketplace'] }
  set JoinMarketplace(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_JoinMarketplace'])) {
      setDirtyFlag()
      this['_JoinMarketplace'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new LoanOfficerConfigurations()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.AutomatedCreditPull = __a__['AutomatedCreditPull']
       cls.AutomatedPreQualLetter = __a__['AutomatedPreQualLetter']
       cls.DocumentsTransitionVisited = __a__['DocumentsTransitionVisited']
       cls.DocumentsAutoReminder = DocumentsAutoReminderConfiguration.fromJson(__a__['DocumentsAutoReminder'])
       cls.OnMarketplace = __a__['OnMarketplace']
       cls.CreditAccounts = array1Reader(CreditAccount.fromJson)(__a__['CreditAccounts'])
       cls.PromptVerified = __a__['PromptVerified']
       cls.JoinMarketplace = __a__['JoinMarketplace']
    } else {
       doAlert(`LoanOfficerConfigurations: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class LoanProduct {
  constructor() {
    this['_hash'] = ''
    this['_Lender'] = ''
    this['_Name'] = ''
    this['_lenderinfo'] = null
    this['_aus'] = []
  }
  get hash() { return this['_hash'] }
  set hash(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_hash'])) {
      setDirtyFlag()
      this['_hash'] = __v__
    }
  }
  get Lender() { return this['_Lender'] }
  set Lender(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_Lender'])) {
      setDirtyFlag()
      this['_Lender'] = __v__
    }
  }
  get Name() { return this['_Name'] }
  set Name(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_Name'])) {
      setDirtyFlag()
      this['_Name'] = __v__
    }
  }
  get lenderinfo() { return this['_lenderinfo'] }
  set lenderinfo(__a__) {
    if(__a__ == null) {
      if(this['_lenderinfo'] == null) { return }
      setDirtyFlag()
      this['_lenderinfo'] = null
      return
    } else {
      setDirtyFlag()
      this['_lenderinfo'] = __a__
    }
  }
  get aus() { return this['_aus'] }
  set aus(__a__) {
    setDirtyFlag()
    this['_aus'] = __a__
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new LoanProduct()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.hash = __a__['hash']
       cls.Lender = __a__['Lender']
       cls.Name = __a__['Name']
       cls.lenderinfo = __a__['lenderinfo'] == null ? null : lender.fromJson(__a__['lenderinfo'])
       cls.aus = array1Reader(stringReader(''))(__a__['aus'])
    } else {
       doAlert(`LoanProduct: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class LodeStarConfig {
  constructor() {
    this['_isModified'] = false
    this['_suggestEnableCount'] = null
    this['_enableOriginationCharges'] = false
    this['_enableCanNotShopServices'] = false
    this['_enableCanShopServices'] = false
    this['_enableTaxesAndOtherGovernmentFees'] = false
    this['_enablePrepaids'] = false
    this['_enableInitialEscrowPaymentsAtClosing'] = false
    this['_enableOther'] = false
  }
  get isModified() { return this['_isModified'] }
  set isModified(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_isModified'])) {
      setDirtyFlag()
      this['_isModified'] = __v__
    }
  }
  get suggestEnableCount() { return this['_suggestEnableCount'] }
  set suggestEnableCount(__a__) {
    if(__a__ == null) {
      if(this['_suggestEnableCount'] == null) { return }
      setDirtyFlag()
      this['_suggestEnableCount'] = null
      return
    } else {
      let __v__ = intReader(0)(__a__)
      if(!_.isEqual(__v__,this['_suggestEnableCount'])) {
        setDirtyFlag()
        this['_suggestEnableCount'] = __v__
      }
    }
  }
  get enableOriginationCharges() { return this['_enableOriginationCharges'] }
  set enableOriginationCharges(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_enableOriginationCharges'])) {
      setDirtyFlag()
      this['_enableOriginationCharges'] = __v__
    }
  }
  get enableCanNotShopServices() { return this['_enableCanNotShopServices'] }
  set enableCanNotShopServices(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_enableCanNotShopServices'])) {
      setDirtyFlag()
      this['_enableCanNotShopServices'] = __v__
    }
  }
  get enableCanShopServices() { return this['_enableCanShopServices'] }
  set enableCanShopServices(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_enableCanShopServices'])) {
      setDirtyFlag()
      this['_enableCanShopServices'] = __v__
    }
  }
  get enableTaxesAndOtherGovernmentFees() { return this['_enableTaxesAndOtherGovernmentFees'] }
  set enableTaxesAndOtherGovernmentFees(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_enableTaxesAndOtherGovernmentFees'])) {
      setDirtyFlag()
      this['_enableTaxesAndOtherGovernmentFees'] = __v__
    }
  }
  get enablePrepaids() { return this['_enablePrepaids'] }
  set enablePrepaids(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_enablePrepaids'])) {
      setDirtyFlag()
      this['_enablePrepaids'] = __v__
    }
  }
  get enableInitialEscrowPaymentsAtClosing() { return this['_enableInitialEscrowPaymentsAtClosing'] }
  set enableInitialEscrowPaymentsAtClosing(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_enableInitialEscrowPaymentsAtClosing'])) {
      setDirtyFlag()
      this['_enableInitialEscrowPaymentsAtClosing'] = __v__
    }
  }
  get enableOther() { return this['_enableOther'] }
  set enableOther(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_enableOther'])) {
      setDirtyFlag()
      this['_enableOther'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new LodeStarConfig()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.isModified = __a__['isModified']
       cls.suggestEnableCount = __a__['suggestEnableCount'] == null ? null : __a__['suggestEnableCount']
       cls.enableOriginationCharges = __a__['enableOriginationCharges']
       cls.enableCanNotShopServices = __a__['enableCanNotShopServices']
       cls.enableCanShopServices = __a__['enableCanShopServices']
       cls.enableTaxesAndOtherGovernmentFees = __a__['enableTaxesAndOtherGovernmentFees']
       cls.enablePrepaids = __a__['enablePrepaids']
       cls.enableInitialEscrowPaymentsAtClosing = __a__['enableInitialEscrowPaymentsAtClosing']
       cls.enableOther = __a__['enableOther']
    } else {
       doAlert(`LodeStarConfig: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class MilitaryService {
  constructor() {
    this['_currentlyserving'] = false
    this['_projectedexpirationdate'] = ''
    this['_currentlyretired'] = false
    this['_nonactive'] = false
    this['_survivingspouse'] = false
  }
  get currentlyserving() { return this['_currentlyserving'] }
  set currentlyserving(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_currentlyserving'])) {
      setDirtyFlag()
      this['_currentlyserving'] = __v__
    }
  }
  get projectedexpirationdate() { return this['_projectedexpirationdate'] }
  set projectedexpirationdate(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_projectedexpirationdate'])) {
      setDirtyFlag()
      this['_projectedexpirationdate'] = __v__
    }
  }
  get currentlyretired() { return this['_currentlyretired'] }
  set currentlyretired(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_currentlyretired'])) {
      setDirtyFlag()
      this['_currentlyretired'] = __v__
    }
  }
  get nonactive() { return this['_nonactive'] }
  set nonactive(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_nonactive'])) {
      setDirtyFlag()
      this['_nonactive'] = __v__
    }
  }
  get survivingspouse() { return this['_survivingspouse'] }
  set survivingspouse(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_survivingspouse'])) {
      setDirtyFlag()
      this['_survivingspouse'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new MilitaryService()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.currentlyserving = __a__['currentlyserving']
       cls.projectedexpirationdate = __a__['projectedexpirationdate']
       cls.currentlyretired = __a__['currentlyretired']
       cls.nonactive = __a__['nonactive']
       cls.survivingspouse = __a__['survivingspouse']
    } else {
       doAlert(`MilitaryService: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class MobileHomeDebtToBePaid {
  constructor() {
    this['_amount'] = ''
    this['_description'] = ''
  }
  get amount() { return this['_amount'] }
  set amount(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_amount'])) {
      setDirtyFlag()
      this['_amount'] = __v__
    }
  }
  get description() { return this['_description'] }
  set description(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_description'])) {
      setDirtyFlag()
      this['_description'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new MobileHomeDebtToBePaid()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.amount = __a__['amount']
       cls.description = __a__['description']
    } else {
       doAlert(`MobileHomeDebtToBePaid: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class MobileHomeInfo {
  constructor() {
    this['_mobilehomeparkfullname'] = ''
    this['_leasedSpaceRentAmount'] = ''
    this['_year'] = ''
    this['_lengthft'] = ''
    this['_lengthinch'] = ''
    this['_widthft'] = ''
    this['_widthinch'] = ''
    this['_space'] = ''
    this['_mobilehometype'] = 'SingleWide'
    this['_mobilehomedescription'] = 'New'
    this['_mobilehomelocation'] = 'Park'
    this['_originalpurchaseprice'] = ''
    this['_debtsToBePaid'] = []
    this['_cashOutRequested'] = ''
    this['_parkAddress'] = ''
    this['_manufacturerMake'] = ''
    this['_manufacturerModel'] = ''
  }
  get mobilehomeparkfullname() { return this['_mobilehomeparkfullname'] }
  set mobilehomeparkfullname(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_mobilehomeparkfullname'])) {
      setDirtyFlag()
      this['_mobilehomeparkfullname'] = __v__
    }
  }
  get leasedSpaceRentAmount() { return this['_leasedSpaceRentAmount'] }
  set leasedSpaceRentAmount(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_leasedSpaceRentAmount'])) {
      setDirtyFlag()
      this['_leasedSpaceRentAmount'] = __v__
    }
  }
  get year() { return this['_year'] }
  set year(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_year'])) {
      setDirtyFlag()
      this['_year'] = __v__
    }
  }
  get lengthft() { return this['_lengthft'] }
  set lengthft(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_lengthft'])) {
      setDirtyFlag()
      this['_lengthft'] = __v__
    }
  }
  get lengthinch() { return this['_lengthinch'] }
  set lengthinch(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_lengthinch'])) {
      setDirtyFlag()
      this['_lengthinch'] = __v__
    }
  }
  get widthft() { return this['_widthft'] }
  set widthft(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_widthft'])) {
      setDirtyFlag()
      this['_widthft'] = __v__
    }
  }
  get widthinch() { return this['_widthinch'] }
  set widthinch(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_widthinch'])) {
      setDirtyFlag()
      this['_widthinch'] = __v__
    }
  }
  get space() { return this['_space'] }
  set space(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_space'])) {
      setDirtyFlag()
      this['_space'] = __v__
    }
  }
  get mobilehometype() { return this['_mobilehometype'] }
  set mobilehometype(__a__) {
    let __v__ = enumReader(['SingleWide','DoubleWide','TripleWide'],'SingleWide')(__a__)
    if(!_.isEqual(__v__,this['_mobilehometype'])) {
      setDirtyFlag()
      this['_mobilehometype'] = __v__
    }
  }
  get mobilehomedescription() { return this['_mobilehomedescription'] }
  set mobilehomedescription(__a__) {
    let __v__ = enumReader(['New','Used','Repo'],'New')(__a__)
    if(!_.isEqual(__v__,this['_mobilehomedescription'])) {
      setDirtyFlag()
      this['_mobilehomedescription'] = __v__
    }
  }
  get mobilehomelocation() { return this['_mobilehomelocation'] }
  set mobilehomelocation(__a__) {
    let __v__ = enumReader(['Park','LandorHome','CoopPark','SharedPark'],'Park')(__a__)
    if(!_.isEqual(__v__,this['_mobilehomelocation'])) {
      setDirtyFlag()
      this['_mobilehomelocation'] = __v__
    }
  }
  get originalpurchaseprice() { return this['_originalpurchaseprice'] }
  set originalpurchaseprice(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_originalpurchaseprice'])) {
      setDirtyFlag()
      this['_originalpurchaseprice'] = __v__
    }
  }
  get debtsToBePaid() { return this['_debtsToBePaid'] }
  set debtsToBePaid(__a__) {
    setDirtyFlag()
    this['_debtsToBePaid'] = __a__
  }
  get cashOutRequested() { return this['_cashOutRequested'] }
  set cashOutRequested(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_cashOutRequested'])) {
      setDirtyFlag()
      this['_cashOutRequested'] = __v__
    }
  }
  get parkAddress() { return this['_parkAddress'] }
  set parkAddress(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_parkAddress'])) {
      setDirtyFlag()
      this['_parkAddress'] = __v__
    }
  }
  get manufacturerMake() { return this['_manufacturerMake'] }
  set manufacturerMake(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_manufacturerMake'])) {
      setDirtyFlag()
      this['_manufacturerMake'] = __v__
    }
  }
  get manufacturerModel() { return this['_manufacturerModel'] }
  set manufacturerModel(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_manufacturerModel'])) {
      setDirtyFlag()
      this['_manufacturerModel'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new MobileHomeInfo()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.mobilehomeparkfullname = __a__['mobilehomeparkfullname']
       cls.leasedSpaceRentAmount = __a__['leasedSpaceRentAmount']
       cls.year = __a__['year']
       cls.lengthft = __a__['lengthft']
       cls.lengthinch = __a__['lengthinch']
       cls.widthft = __a__['widthft']
       cls.widthinch = __a__['widthinch']
       cls.space = __a__['space']
       cls.mobilehometype = __a__['mobilehometype']
       cls.mobilehomedescription = __a__['mobilehomedescription']
       cls.mobilehomelocation = __a__['mobilehomelocation']
       cls.originalpurchaseprice = __a__['originalpurchaseprice']
       cls.debtsToBePaid = array1Reader(MobileHomeDebtToBePaid.fromJson)(__a__['debtsToBePaid'])
       cls.cashOutRequested = __a__['cashOutRequested']
       cls.parkAddress = __a__['parkAddress']
       cls.manufacturerMake = __a__['manufacturerMake']
       cls.manufacturerModel = __a__['manufacturerModel']
    } else {
       doAlert(`MobileHomeInfo: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class OwnedProperty {
  constructor() {
    this['_address'] = ''
    this['_unit'] = ''
    this['_state'] = ''
    this['_county'] = ''
    this['_city'] = ''
    this['_zipcode'] = ''
    this['_ownedfreeandclear'] = null
    this['_loans'] = []
    this['_status'] = 'pending'
    this['_occupancy'] = 'principal'
    this['_propertytype'] = 'singlefamily'
    this['_marketvalue'] = ''
    this['_liens'] = ''
    this['_grossrentalincome'] = ''
    this['_insurancemaintenancetaxes'] = ''
    this['_netrentalincome'] = ''
    this['_attribution'] = null
    this['_key'] = ''
  }
  get address() { return this['_address'] }
  set address(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_address'])) {
      setDirtyFlag()
      this['_address'] = __v__
    }
  }
  get unit() { return this['_unit'] }
  set unit(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_unit'])) {
      setDirtyFlag()
      this['_unit'] = __v__
    }
  }
  get state() { return this['_state'] }
  set state(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_state'])) {
      setDirtyFlag()
      this['_state'] = __v__
    }
  }
  get county() { return this['_county'] }
  set county(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_county'])) {
      setDirtyFlag()
      this['_county'] = __v__
    }
  }
  get city() { return this['_city'] }
  set city(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_city'])) {
      setDirtyFlag()
      this['_city'] = __v__
    }
  }
  get zipcode() { return this['_zipcode'] }
  set zipcode(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_zipcode'])) {
      setDirtyFlag()
      this['_zipcode'] = __v__
    }
  }
  get ownedfreeandclear() { return this['_ownedfreeandclear'] }
  set ownedfreeandclear(__a__) {
    if(__a__ == null) {
      if(this['_ownedfreeandclear'] == null) { return }
      setDirtyFlag()
      this['_ownedfreeandclear'] = null
      return
    } else {
      let __v__ = boolReader(false)(__a__)
      if(!_.isEqual(__v__,this['_ownedfreeandclear'])) {
        setDirtyFlag()
        this['_ownedfreeandclear'] = __v__
      }
    }
  }
  get loans() { return this['_loans'] }
  set loans(__a__) {
    setDirtyFlag()
    this['_loans'] = __a__
  }
  get status() { return this['_status'] }
  set status(__a__) {
    let __v__ = enumReader(['pending','sold','retained'],'pending')(__a__)
    if(!_.isEqual(__v__,this['_status'])) {
      setDirtyFlag()
      this['_status'] = __v__
    }
  }
  get occupancy() { return this['_occupancy'] }
  set occupancy(__a__) {
    let __v__ = enumReader(['principal','secondhome','investment','fhasecond','other'],'principal')(__a__)
    if(!_.isEqual(__v__,this['_occupancy'])) {
      setDirtyFlag()
      this['_occupancy'] = __v__
    }
  }
  get propertytype() { return this['_propertytype'] }
  set propertytype(__a__) {
    let __v__ = enumReader(['singlefamily','condominium','townhouse','twotofour','mobilehome','commercial','homeandbusinesscombined','mixeduse','farm','land'],'singlefamily')(__a__)
    if(!_.isEqual(__v__,this['_propertytype'])) {
      setDirtyFlag()
      this['_propertytype'] = __v__
    }
  }
  get marketvalue() { return this['_marketvalue'] }
  set marketvalue(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_marketvalue'])) {
      setDirtyFlag()
      this['_marketvalue'] = __v__
    }
  }
  get liens() { return this['_liens'] }
  set liens(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_liens'])) {
      setDirtyFlag()
      this['_liens'] = __v__
    }
  }
  get grossrentalincome() { return this['_grossrentalincome'] }
  set grossrentalincome(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_grossrentalincome'])) {
      setDirtyFlag()
      this['_grossrentalincome'] = __v__
    }
  }
  get insurancemaintenancetaxes() { return this['_insurancemaintenancetaxes'] }
  set insurancemaintenancetaxes(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_insurancemaintenancetaxes'])) {
      setDirtyFlag()
      this['_insurancemaintenancetaxes'] = __v__
    }
  }
  get netrentalincome() { return this['_netrentalincome'] }
  set netrentalincome(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_netrentalincome'])) {
      setDirtyFlag()
      this['_netrentalincome'] = __v__
    }
  }
  get attribution() { return this['_attribution'] }
  set attribution(__a__) {
    if(__a__ == null) {
      if(this['_attribution'] == null) { return }
      setDirtyFlag()
      this['_attribution'] = null
      return
    } else {
      let __v__ = intReader(0)(__a__)
      if(!_.isEqual(__v__,this['_attribution'])) {
        setDirtyFlag()
        this['_attribution'] = __v__
      }
    }
  }
  get key() { return this['_key'] }
  set key(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_key'])) {
      setDirtyFlag()
      this['_key'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new OwnedProperty()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.address = __a__['address']
       cls.unit = __a__['unit']
       cls.state = __a__['state']
       cls.county = __a__['county']
       cls.city = __a__['city']
       cls.zipcode = __a__['zipcode']
       cls.ownedfreeandclear = __a__['ownedfreeandclear'] == null ? null : __a__['ownedfreeandclear']
       cls.loans = array1Reader(loan.fromJson)(__a__['loans'])
       cls.status = __a__['status']
       cls.occupancy = __a__['occupancy']
       cls.propertytype = __a__['propertytype']
       cls.marketvalue = __a__['marketvalue']
       cls.liens = __a__['liens']
       cls.grossrentalincome = __a__['grossrentalincome']
       cls.insurancemaintenancetaxes = __a__['insurancemaintenancetaxes']
       cls.netrentalincome = __a__['netrentalincome']
       cls.attribution = __a__['attribution'] == null ? null : __a__['attribution']
       cls.key = __a__['key']
    } else {
       doAlert(`OwnedProperty: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class Pacific {
  constructor() {
    this['_hawaian'] = false
    this['_guamanian'] = false
    this['_samoan'] = false
    this['_other'] = false
    this['_otherdetails'] = ''
  }
  get hawaian() { return this['_hawaian'] }
  set hawaian(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_hawaian'])) {
      setDirtyFlag()
      this['_hawaian'] = __v__
    }
  }
  get guamanian() { return this['_guamanian'] }
  set guamanian(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_guamanian'])) {
      setDirtyFlag()
      this['_guamanian'] = __v__
    }
  }
  get samoan() { return this['_samoan'] }
  set samoan(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_samoan'])) {
      setDirtyFlag()
      this['_samoan'] = __v__
    }
  }
  get other() { return this['_other'] }
  set other(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_other'])) {
      setDirtyFlag()
      this['_other'] = __v__
    }
  }
  get otherdetails() { return this['_otherdetails'] }
  set otherdetails(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_otherdetails'])) {
      setDirtyFlag()
      this['_otherdetails'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new Pacific()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.hawaian = __a__['hawaian']
       cls.guamanian = __a__['guamanian']
       cls.samoan = __a__['samoan']
       cls.other = __a__['other']
       cls.otherdetails = __a__['otherdetails']
    } else {
       doAlert(`Pacific: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class PrepayPenalty {
  constructor() {
    this['_PrepayTerm'] = 0
    this['_PenaltyPoint'] = 0.0
  }
  get PrepayTerm() { return this['_PrepayTerm'] }
  set PrepayTerm(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_PrepayTerm'])) {
      setDirtyFlag()
      this['_PrepayTerm'] = __v__
    }
  }
  get PenaltyPoint() { return this['_PenaltyPoint'] }
  set PenaltyPoint(__a__) {
    let __v__ = floatReader(0.0)(__a__)
    if(!_.isEqual(__v__,this['_PenaltyPoint'])) {
      setDirtyFlag()
      this['_PenaltyPoint'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new PrepayPenalty()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.PrepayTerm = __a__['PrepayTerm']
       cls.PenaltyPoint = __a__['PenaltyPoint']
    } else {
       doAlert(`PrepayPenalty: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class Prices {
  constructor() {
    this['_baseRate'] = 0.0
    this['_lockDayPoint'] = 0.0
    this['_adjustmentPoint'] = 0.0
    this['_compensationPoint'] = 0.0
    this['_closeOverPoint'] = 0.0
  }
  get baseRate() { return this['_baseRate'] }
  set baseRate(__a__) {
    let __v__ = floatReader(0.0)(__a__)
    if(!_.isEqual(__v__,this['_baseRate'])) {
      setDirtyFlag()
      this['_baseRate'] = __v__
    }
  }
  get lockDayPoint() { return this['_lockDayPoint'] }
  set lockDayPoint(__a__) {
    let __v__ = floatReader(0.0)(__a__)
    if(!_.isEqual(__v__,this['_lockDayPoint'])) {
      setDirtyFlag()
      this['_lockDayPoint'] = __v__
    }
  }
  get adjustmentPoint() { return this['_adjustmentPoint'] }
  set adjustmentPoint(__a__) {
    let __v__ = floatReader(0.0)(__a__)
    if(!_.isEqual(__v__,this['_adjustmentPoint'])) {
      setDirtyFlag()
      this['_adjustmentPoint'] = __v__
    }
  }
  get compensationPoint() { return this['_compensationPoint'] }
  set compensationPoint(__a__) {
    let __v__ = floatReader(0.0)(__a__)
    if(!_.isEqual(__v__,this['_compensationPoint'])) {
      setDirtyFlag()
      this['_compensationPoint'] = __v__
    }
  }
  get closeOverPoint() { return this['_closeOverPoint'] }
  set closeOverPoint(__a__) {
    let __v__ = floatReader(0.0)(__a__)
    if(!_.isEqual(__v__,this['_closeOverPoint'])) {
      setDirtyFlag()
      this['_closeOverPoint'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new Prices()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.baseRate = __a__['baseRate']
       cls.lockDayPoint = __a__['lockDayPoint']
       cls.adjustmentPoint = __a__['adjustmentPoint']
       cls.compensationPoint = __a__['compensationPoint']
       cls.closeOverPoint = __a__['closeOverPoint']
    } else {
       doAlert(`Prices: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class ProjectReview {
  constructor() {
    this['_projectclassification'] = 'streamlinereview-freddiemac'
    this['_projectname'] = ''
    this['_cpmprojectid'] = 0
  }
  get projectclassification() { return this['_projectclassification'] }
  set projectclassification(__a__) {
    let __v__ = enumReader(['streamlinereview-freddiemac','establishedproject-freddiemac','newproject-freddiemac','detachedproject-freddiemac','twotofourunit-freddiemac','reciprocalreview-freddiemac','exemptfromreview-freddiemac','plimitedreviewnewdetached-fanniemae','qlimitedreviewestablised-fanniemae','rexpectedreviewnew-fanniemae','sexpectedreviewestablished-fanniemae','tfanniemaereview-fanniemae','ufhaapproved-fanniemae','vrefiplus-fanniemae','epud-fanniemae','fpud-fanniemae','tpud-fanniemae','onecoop-fanniemae','twocoop-fanniemae','tcoop-fanniemae'],'streamlinereview-freddiemac')(__a__)
    if(!_.isEqual(__v__,this['_projectclassification'])) {
      setDirtyFlag()
      this['_projectclassification'] = __v__
    }
  }
  get projectname() { return this['_projectname'] }
  set projectname(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_projectname'])) {
      setDirtyFlag()
      this['_projectname'] = __v__
    }
  }
  get cpmprojectid() { return this['_cpmprojectid'] }
  set cpmprojectid(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_cpmprojectid'])) {
      setDirtyFlag()
      this['_cpmprojectid'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new ProjectReview()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.projectclassification = __a__['projectclassification']
       cls.projectname = __a__['projectname']
       cls.cpmprojectid = __a__['cpmprojectid']
    } else {
       doAlert(`ProjectReview: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class Race {
  constructor() {
    this['_notfurnished'] = false
    this['_asian'] = false
    this['_asiandetails'] = new Asian()
    this['_pacific'] = false
    this['_pacificdetails'] = new Pacific()
    this['_black'] = false
    this['_americanindian'] = false
    this['_indiantribe'] = ''
    this['_white'] = false
  }
  get notfurnished() { return this['_notfurnished'] }
  set notfurnished(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_notfurnished'])) {
      setDirtyFlag()
      this['_notfurnished'] = __v__
    }
  }
  get asian() { return this['_asian'] }
  set asian(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_asian'])) {
      setDirtyFlag()
      this['_asian'] = __v__
    }
  }
  get asiandetails() { return this['_asiandetails'] }
  set asiandetails(__a__) {
    setDirtyFlag()
    this['_asiandetails'] = __a__
  }
  get pacific() { return this['_pacific'] }
  set pacific(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_pacific'])) {
      setDirtyFlag()
      this['_pacific'] = __v__
    }
  }
  get pacificdetails() { return this['_pacificdetails'] }
  set pacificdetails(__a__) {
    setDirtyFlag()
    this['_pacificdetails'] = __a__
  }
  get black() { return this['_black'] }
  set black(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_black'])) {
      setDirtyFlag()
      this['_black'] = __v__
    }
  }
  get americanindian() { return this['_americanindian'] }
  set americanindian(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_americanindian'])) {
      setDirtyFlag()
      this['_americanindian'] = __v__
    }
  }
  get indiantribe() { return this['_indiantribe'] }
  set indiantribe(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_indiantribe'])) {
      setDirtyFlag()
      this['_indiantribe'] = __v__
    }
  }
  get white() { return this['_white'] }
  set white(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_white'])) {
      setDirtyFlag()
      this['_white'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new Race()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.notfurnished = __a__['notfurnished']
       cls.asian = __a__['asian']
       cls.asiandetails = Asian.fromJson(__a__['asiandetails'])
       cls.pacific = __a__['pacific']
       cls.pacificdetails = Pacific.fromJson(__a__['pacificdetails'])
       cls.black = __a__['black']
       cls.americanindian = __a__['americanindian']
       cls.indiantribe = __a__['indiantribe']
       cls.white = __a__['white']
    } else {
       doAlert(`Race: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class Selection {
  constructor() {
    this['_downpayment'] = 0
    this['_paydown'] = 0
    this['_cashout'] = 0
    this['_mincashout'] = 0
    this['_loansize'] = ''
    this['_financeClosingCosts'] = false
    this['_sortby'] = 'selectbyrate'
    this['_loanamortizations'] = []
    this['_loanterms'] = []
    this['_maxupfrontcost'] = null
    this['_selectedloan'] = new ChosenLoan()
    this['_loSelectedLoans'] = []
    this['_estimatedclosingcosts'] = null
    this['_ourfee'] = null
    this['_prepaiddays'] = null
  }
  get downpayment() { return this['_downpayment'] }
  set downpayment(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_downpayment'])) {
      setDirtyFlag()
      this['_downpayment'] = __v__
    }
  }
  get paydown() { return this['_paydown'] }
  set paydown(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_paydown'])) {
      setDirtyFlag()
      this['_paydown'] = __v__
    }
  }
  get cashout() { return this['_cashout'] }
  set cashout(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_cashout'])) {
      setDirtyFlag()
      this['_cashout'] = __v__
    }
  }
  get mincashout() { return this['_mincashout'] }
  set mincashout(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_mincashout'])) {
      setDirtyFlag()
      this['_mincashout'] = __v__
    }
  }
  get loansize() { return this['_loansize'] }
  set loansize(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_loansize'])) {
      setDirtyFlag()
      this['_loansize'] = __v__
    }
  }
  get financeClosingCosts() { return this['_financeClosingCosts'] }
  set financeClosingCosts(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_financeClosingCosts'])) {
      setDirtyFlag()
      this['_financeClosingCosts'] = __v__
    }
  }
  get sortby() { return this['_sortby'] }
  set sortby(__a__) {
    let __v__ = enumReader(['selectbyrate','selectbyapr','selectbyinterestterm','selectbyinteresttotal','selectbymonthlypayment','selectbyclosingcosts','selectbyadvanced'],'selectbyrate')(__a__)
    if(!_.isEqual(__v__,this['_sortby'])) {
      setDirtyFlag()
      this['_sortby'] = __v__
    }
  }
  get loanamortizations() { return this['_loanamortizations'] }
  set loanamortizations(__a__) {
    setDirtyFlag()
    this['_loanamortizations'] = __a__
  }
  get loanterms() { return this['_loanterms'] }
  set loanterms(__a__) {
    setDirtyFlag()
    this['_loanterms'] = __a__
  }
  get maxupfrontcost() { return this['_maxupfrontcost'] }
  set maxupfrontcost(__a__) {
    if(__a__ == null) {
      if(this['_maxupfrontcost'] == null) { return }
      setDirtyFlag()
      this['_maxupfrontcost'] = null
      return
    } else {
      let __v__ = stringReader('')(__a__)
      if(!_.isEqual(__v__,this['_maxupfrontcost'])) {
        setDirtyFlag()
        this['_maxupfrontcost'] = __v__
      }
    }
  }
  get selectedloan() { return this['_selectedloan'] }
  set selectedloan(__a__) {
    setDirtyFlag()
    this['_selectedloan'] = __a__
  }
  get loSelectedLoans() { return this['_loSelectedLoans'] }
  set loSelectedLoans(__a__) {
    setDirtyFlag()
    this['_loSelectedLoans'] = __a__
  }
  get estimatedclosingcosts() { return this['_estimatedclosingcosts'] }
  set estimatedclosingcosts(__a__) {
    if(__a__ == null) {
      if(this['_estimatedclosingcosts'] == null) { return }
      setDirtyFlag()
      this['_estimatedclosingcosts'] = null
      return
    } else {
      setDirtyFlag()
      this['_estimatedclosingcosts'] = __a__
    }
  }
  get ourfee() { return this['_ourfee'] }
  set ourfee(__a__) {
    if(__a__ == null) {
      if(this['_ourfee'] == null) { return }
      setDirtyFlag()
      this['_ourfee'] = null
      return
    } else {
      let __v__ = floatReader(0.0)(__a__)
      if(!_.isEqual(__v__,this['_ourfee'])) {
        setDirtyFlag()
        this['_ourfee'] = __v__
      }
    }
  }
  get prepaiddays() { return this['_prepaiddays'] }
  set prepaiddays(__a__) {
    if(__a__ == null) {
      if(this['_prepaiddays'] == null) { return }
      setDirtyFlag()
      this['_prepaiddays'] = null
      return
    } else {
      let __v__ = intReader(0)(__a__)
      if(!_.isEqual(__v__,this['_prepaiddays'])) {
        setDirtyFlag()
        this['_prepaiddays'] = __v__
      }
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new Selection()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.downpayment = __a__['downpayment']
       cls.paydown = __a__['paydown']
       cls.cashout = __a__['cashout']
       cls.mincashout = __a__['mincashout']
       cls.loansize = __a__['loansize']
       cls.financeClosingCosts = __a__['financeClosingCosts']
       cls.sortby = __a__['sortby']
       cls.loanamortizations = array1Reader(enumReader(['fixed','fixed-biweekly','arm51','arm71','arm101','arm56','arm76','arm106','gpm','interestonly','statedincome','baloon','otheramortization','buydown321','buydown21','buydown11'],'fixed'))(__a__['loanamortizations'])
       cls.loanterms = array1Reader(enumReader(['year30','year25','year20','year15','year10','year7','year5','other'],'year30'))(__a__['loanterms'])
       cls.maxupfrontcost = __a__['maxupfrontcost'] == null ? null : __a__['maxupfrontcost']
       cls.selectedloan = ChosenLoan.fromJson(__a__['selectedloan'])
       cls.loSelectedLoans = array1Reader(ChosenLoan.fromJson)(__a__['loSelectedLoans'])
       cls.estimatedclosingcosts = __a__['estimatedclosingcosts'] == null ? null : fees.fromJson(__a__['estimatedclosingcosts'])
       cls.ourfee = __a__['ourfee'] == null ? null : __a__['ourfee']
       cls.prepaiddays = __a__['prepaiddays'] == null ? null : __a__['prepaiddays']
    } else {
       doAlert(`Selection: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class SolarPanels {
  constructor() {
    this['_havesolarpanels'] = null
    this['_remainonproperty'] = false
    this['_takeoverthelease'] = false
    this['_monthlypayment'] = ''
    this['_areleased'] = null
  }
  get havesolarpanels() { return this['_havesolarpanels'] }
  set havesolarpanels(__a__) {
    if(__a__ == null) {
      if(this['_havesolarpanels'] == null) { return }
      setDirtyFlag()
      this['_havesolarpanels'] = null
      return
    } else {
      let __v__ = boolReader(false)(__a__)
      if(!_.isEqual(__v__,this['_havesolarpanels'])) {
        setDirtyFlag()
        this['_havesolarpanels'] = __v__
      }
    }
  }
  get remainonproperty() { return this['_remainonproperty'] }
  set remainonproperty(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_remainonproperty'])) {
      setDirtyFlag()
      this['_remainonproperty'] = __v__
    }
  }
  get takeoverthelease() { return this['_takeoverthelease'] }
  set takeoverthelease(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_takeoverthelease'])) {
      setDirtyFlag()
      this['_takeoverthelease'] = __v__
    }
  }
  get monthlypayment() { return this['_monthlypayment'] }
  set monthlypayment(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_monthlypayment'])) {
      setDirtyFlag()
      this['_monthlypayment'] = __v__
    }
  }
  get areleased() { return this['_areleased'] }
  set areleased(__a__) {
    if(__a__ == null) {
      if(this['_areleased'] == null) { return }
      setDirtyFlag()
      this['_areleased'] = null
      return
    } else {
      let __v__ = boolReader(false)(__a__)
      if(!_.isEqual(__v__,this['_areleased'])) {
        setDirtyFlag()
        this['_areleased'] = __v__
      }
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new SolarPanels()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.havesolarpanels = __a__['havesolarpanels'] == null ? null : __a__['havesolarpanels']
       cls.remainonproperty = __a__['remainonproperty']
       cls.takeoverthelease = __a__['takeoverthelease']
       cls.monthlypayment = __a__['monthlypayment']
       cls.areleased = __a__['areleased'] == null ? null : __a__['areleased']
    } else {
       doAlert(`SolarPanels: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class State {
  constructor() {
    this['_application'] = new application()
    this['_progress'] = new progress()
  }
  get application() { return this['_application'] }
  set application(__a__) {
    setDirtyFlag()
    this['_application'] = __a__
  }
  get progress() { return this['_progress'] }
  set progress(__a__) {
    setDirtyFlag()
    this['_progress'] = __a__
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new State()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.application = application.fromJson(__a__['application'])
       cls.progress = progress.fromJson(__a__['progress'])
    } else {
       doAlert(`State: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class Underwriting {
  constructor() {
    this['_company'] = 'fanniemae'
    this['_underwritername'] = ''
    this['_appraisername'] = ''
    this['_appraiserlicense'] = ''
    this['_appraisalcompanyname'] = ''
    this['_levelofpropertyreview'] = 'exterioraandintertior'
    this['_appraisalformnumber'] = ''
    this['_ismannualunderwriting'] = false
    this['_underwritercomments'] = ''
  }
  get company() { return this['_company'] }
  set company(__a__) {
    let __v__ = enumReader(['fanniemae','freddiemac'],'fanniemae')(__a__)
    if(!_.isEqual(__v__,this['_company'])) {
      setDirtyFlag()
      this['_company'] = __v__
    }
  }
  get underwritername() { return this['_underwritername'] }
  set underwritername(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_underwritername'])) {
      setDirtyFlag()
      this['_underwritername'] = __v__
    }
  }
  get appraisername() { return this['_appraisername'] }
  set appraisername(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_appraisername'])) {
      setDirtyFlag()
      this['_appraisername'] = __v__
    }
  }
  get appraiserlicense() { return this['_appraiserlicense'] }
  set appraiserlicense(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_appraiserlicense'])) {
      setDirtyFlag()
      this['_appraiserlicense'] = __v__
    }
  }
  get appraisalcompanyname() { return this['_appraisalcompanyname'] }
  set appraisalcompanyname(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_appraisalcompanyname'])) {
      setDirtyFlag()
      this['_appraisalcompanyname'] = __v__
    }
  }
  get levelofpropertyreview() { return this['_levelofpropertyreview'] }
  set levelofpropertyreview(__a__) {
    let __v__ = enumReader(['exterioraandintertior','exterioronly','noappraisal'],'exterioraandintertior')(__a__)
    if(!_.isEqual(__v__,this['_levelofpropertyreview'])) {
      setDirtyFlag()
      this['_levelofpropertyreview'] = __v__
    }
  }
  get appraisalformnumber() { return this['_appraisalformnumber'] }
  set appraisalformnumber(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_appraisalformnumber'])) {
      setDirtyFlag()
      this['_appraisalformnumber'] = __v__
    }
  }
  get ismannualunderwriting() { return this['_ismannualunderwriting'] }
  set ismannualunderwriting(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_ismannualunderwriting'])) {
      setDirtyFlag()
      this['_ismannualunderwriting'] = __v__
    }
  }
  get underwritercomments() { return this['_underwritercomments'] }
  set underwritercomments(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_underwritercomments'])) {
      setDirtyFlag()
      this['_underwritercomments'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new Underwriting()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.company = __a__['company']
       cls.underwritername = __a__['underwritername']
       cls.appraisername = __a__['appraisername']
       cls.appraiserlicense = __a__['appraiserlicense']
       cls.appraisalcompanyname = __a__['appraisalcompanyname']
       cls.levelofpropertyreview = __a__['levelofpropertyreview']
       cls.appraisalformnumber = __a__['appraisalformnumber']
       cls.ismannualunderwriting = __a__['ismannualunderwriting']
       cls.underwritercomments = __a__['underwritercomments']
    } else {
       doAlert(`Underwriting: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class account {
  constructor() {
    this['_key'] = ''
    this['_bankname'] = ''
    this['_account'] = ''
    this['_accounttype'] = 'CheckingAccount'
    this['_balance'] = ''
    this['_attribution'] = null
    this['_isretirement'] = false
    this['_ownership'] = 'Borrower'
  }
  get key() { return this['_key'] }
  set key(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_key'])) {
      setDirtyFlag()
      this['_key'] = __v__
    }
  }
  get bankname() { return this['_bankname'] }
  set bankname(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_bankname'])) {
      setDirtyFlag()
      this['_bankname'] = __v__
    }
  }
  get account() { return this['_account'] }
  set account(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_account'])) {
      setDirtyFlag()
      this['_account'] = __v__
    }
  }
  get accounttype() { return this['_accounttype'] }
  set accounttype(__a__) {
    let __v__ = enumReader(['CheckingAccount','SavingsAccount','MoneyMarket','CertificateOfDeposit','Retirement','Bonds','Stocks','StockOptions','BridgeLoanProceeds','IndividualDevelopmentAccount','TrustAccount','CashValueLifeInsurance','MutualFund'],'CheckingAccount')(__a__)
    if(!_.isEqual(__v__,this['_accounttype'])) {
      setDirtyFlag()
      this['_accounttype'] = __v__
    }
  }
  get balance() { return this['_balance'] }
  set balance(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_balance'])) {
      setDirtyFlag()
      this['_balance'] = __v__
    }
  }
  get attribution() { return this['_attribution'] }
  set attribution(__a__) {
    if(__a__ == null) {
      if(this['_attribution'] == null) { return }
      setDirtyFlag()
      this['_attribution'] = null
      return
    } else {
      let __v__ = intReader(0)(__a__)
      if(!_.isEqual(__v__,this['_attribution'])) {
        setDirtyFlag()
        this['_attribution'] = __v__
      }
    }
  }
  get isretirement() { return this['_isretirement'] }
  set isretirement(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_isretirement'])) {
      setDirtyFlag()
      this['_isretirement'] = __v__
    }
  }
  get ownership() { return this['_ownership'] }
  set ownership(__a__) {
    let __v__ = enumReader(['Borrower','CoBorrower','Joint'],'Borrower')(__a__)
    if(!_.isEqual(__v__,this['_ownership'])) {
      setDirtyFlag()
      this['_ownership'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new account()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.key = __a__['key']
       cls.bankname = __a__['bankname']
       cls.account = __a__['account']
       cls.accounttype = __a__['accounttype']
       cls.balance = __a__['balance']
       cls.attribution = __a__['attribution'] == null ? null : __a__['attribution']
       cls.isretirement = __a__['isretirement']
       cls.ownership = __a__['ownership']
    } else {
       doAlert(`account: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class address {
  constructor() {
    this['_street'] = ''
    this['_unit'] = null
    this['_city'] = ''
    this['_state'] = ''
    this['_zip'] = ''
    this['_years'] = ''
    this['_months'] = ''
    this['_ownership'] = null
    this['_rent'] = ''
    this['_rentperiod'] = 'monthly'
  }
  get street() { return this['_street'] }
  set street(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_street'])) {
      setDirtyFlag()
      this['_street'] = __v__
    }
  }
  get unit() { return this['_unit'] }
  set unit(__a__) {
    if(__a__ == null) {
      if(this['_unit'] == null) { return }
      setDirtyFlag()
      this['_unit'] = null
      return
    } else {
      let __v__ = stringReader('')(__a__)
      if(!_.isEqual(__v__,this['_unit'])) {
        setDirtyFlag()
        this['_unit'] = __v__
      }
    }
  }
  get city() { return this['_city'] }
  set city(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_city'])) {
      setDirtyFlag()
      this['_city'] = __v__
    }
  }
  get state() { return this['_state'] }
  set state(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_state'])) {
      setDirtyFlag()
      this['_state'] = __v__
    }
  }
  get zip() { return this['_zip'] }
  set zip(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_zip'])) {
      setDirtyFlag()
      this['_zip'] = __v__
    }
  }
  get years() { return this['_years'] }
  set years(__a__) {
    let __v__ = IntSReader('')(__a__)
    if(!_.isEqual(__v__,this['_years'])) {
      setDirtyFlag()
      this['_years'] = __v__
    }
  }
  get months() { return this['_months'] }
  set months(__a__) {
    let __v__ = IntSReader('')(__a__)
    if(!_.isEqual(__v__,this['_months'])) {
      setDirtyFlag()
      this['_months'] = __v__
    }
  }
  get ownership() { return this['_ownership'] }
  set ownership(__a__) {
    if(__a__ == null) {
      if(this['_ownership'] == null) { return }
      setDirtyFlag()
      this['_ownership'] = null
      return
    } else {
      let __v__ = enumReader(['own','rent','rentfree'],'own')(__a__)
      if(!_.isEqual(__v__,this['_ownership'])) {
        setDirtyFlag()
        this['_ownership'] = __v__
      }
    }
  }
  get rent() { return this['_rent'] }
  set rent(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_rent'])) {
      setDirtyFlag()
      this['_rent'] = __v__
    }
  }
  get rentperiod() { return this['_rentperiod'] }
  set rentperiod(__a__) {
    let __v__ = enumReader(['monthly','yearly','daily','hourly'],'monthly')(__a__)
    if(!_.isEqual(__v__,this['_rentperiod'])) {
      setDirtyFlag()
      this['_rentperiod'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new address()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.street = __a__['street']
       cls.unit = __a__['unit'] == null ? null : __a__['unit']
       cls.city = __a__['city']
       cls.state = __a__['state']
       cls.zip = __a__['zip']
       cls.years = __a__['years']
       cls.months = __a__['months']
       cls.ownership = __a__['ownership'] == null ? null : __a__['ownership']
       cls.rent = __a__['rent']
       cls.rentperiod = __a__['rentperiod']
    } else {
       doAlert(`address: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class alimony {
  constructor() {
    this['_amount'] = ''
    this['_owedto'] = ''
    this['_alimonyorsupport'] = 'alimony'
    this['_lessthan10'] = null
    this['_monthstopay'] = null
    this['_key'] = ''
  }
  get amount() { return this['_amount'] }
  set amount(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_amount'])) {
      setDirtyFlag()
      this['_amount'] = __v__
    }
  }
  get owedto() { return this['_owedto'] }
  set owedto(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_owedto'])) {
      setDirtyFlag()
      this['_owedto'] = __v__
    }
  }
  get alimonyorsupport() { return this['_alimonyorsupport'] }
  set alimonyorsupport(__a__) {
    let __v__ = enumReader(['alimony','childsupport','maintenancepayments','jobrelatedexpenses','other'],'alimony')(__a__)
    if(!_.isEqual(__v__,this['_alimonyorsupport'])) {
      setDirtyFlag()
      this['_alimonyorsupport'] = __v__
    }
  }
  get lessthan10() { return this['_lessthan10'] }
  set lessthan10(__a__) {
    if(__a__ == null) {
      if(this['_lessthan10'] == null) { return }
      setDirtyFlag()
      this['_lessthan10'] = null
      return
    } else {
      let __v__ = enumReader(['lessthan10','morethan10','notsure'],'lessthan10')(__a__)
      if(!_.isEqual(__v__,this['_lessthan10'])) {
        setDirtyFlag()
        this['_lessthan10'] = __v__
      }
    }
  }
  get monthstopay() { return this['_monthstopay'] }
  set monthstopay(__a__) {
    if(__a__ == null) {
      if(this['_monthstopay'] == null) { return }
      setDirtyFlag()
      this['_monthstopay'] = null
      return
    } else {
      let __v__ = intReader(0)(__a__)
      if(!_.isEqual(__v__,this['_monthstopay'])) {
        setDirtyFlag()
        this['_monthstopay'] = __v__
      }
    }
  }
  get key() { return this['_key'] }
  set key(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_key'])) {
      setDirtyFlag()
      this['_key'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new alimony()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.amount = __a__['amount']
       cls.owedto = __a__['owedto']
       cls.alimonyorsupport = __a__['alimonyorsupport']
       cls.lessthan10 = __a__['lessthan10'] == null ? null : __a__['lessthan10']
       cls.monthstopay = __a__['monthstopay'] == null ? null : __a__['monthstopay']
       cls.key = __a__['key']
    } else {
       doAlert(`alimony: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class allocation {
  constructor() {
    this['_stocks'] = 0.0
    this['_bonds'] = 0.0
    this['_cash'] = 0.0
  }
  get stocks() { return this['_stocks'] }
  set stocks(__a__) {
    let __v__ = floatReader(0.0)(__a__)
    if(!_.isEqual(__v__,this['_stocks'])) {
      setDirtyFlag()
      this['_stocks'] = __v__
    }
  }
  get bonds() { return this['_bonds'] }
  set bonds(__a__) {
    let __v__ = floatReader(0.0)(__a__)
    if(!_.isEqual(__v__,this['_bonds'])) {
      setDirtyFlag()
      this['_bonds'] = __v__
    }
  }
  get cash() { return this['_cash'] }
  set cash(__a__) {
    let __v__ = floatReader(0.0)(__a__)
    if(!_.isEqual(__v__,this['_cash'])) {
      setDirtyFlag()
      this['_cash'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new allocation()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.stocks = __a__['stocks']
       cls.bonds = __a__['bonds']
       cls.cash = __a__['cash']
    } else {
       doAlert(`allocation: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class application {
  constructor() {
    this['_status'] = 'loinitialized'
    this['_currentStage'] = 'Application'
    this['_currentStatus'] = 'ApplicationStarted'
    this['_visitedMenus'] = []
    this['_hascoborrower'] = null
    this['_cohabiting'] = null
    this['_married'] = null
    this['_firsttimebuyer'] = null
    this['_qualifiesforassistance'] = null
    this['_askedforassistance'] = null
    this['_loanbalance'] = ''
    this['_keepinghousefor'] = null
    this['_financingsameproperty'] = null
    this['_hascreditfreeze'] = null
    this['_assetsandliabilities'] = new assetsandliabilities()
    this['_otherliens'] = null
    this['_borrower'] = new borrower()
    this['_coborrower'] = new borrower()
    this['_remotecoborrowers'] = []
    this['_scre'] = 0
    this['_property'] = new subjectproperty()
    this['_product'] = new product()
    this['_transaction'] = new transaction()
    this['_assetsofotherpersonused'] = false
    this['_liabilitiesofotherpersonrequired'] = false
    this['_selection'] = new Selection()
    this['_lienposition'] = new LienPosition()
    this['_underwriting'] = new Underwriting()
    this['_escrowti'] = false
    this['_issueddate'] = ''
    this['_closingdate'] = ''
    this['_isAHI'] = false
    this['_isCommunityLending'] = false
    this['_AUSreport'] = new AUSreport()
    this['_IPCs'] = ''
    this['_deposit'] = 0
    this['_brokerinfo'] = new broker()
    this['_aloneMarriedWantsFHA'] = null
    this['_loanid'] = null
    this['_hardmoneyloan'] = new HardMoneyLoan()
    this['_escrowInfo'] = null
    this['_appraisalInfo'] = null
    this['_dtiCalculation'] = null
    this['_currentDTIResult'] = null
  }
  get status() { return this['_status'] }
  set status(__a__) {
    let __v__ = enumReader(['loinitialized','interviewstarted','productselected','interviewfinished','documentationrequested','loansubmitted','conditionallyapproved','loanafinalapproved','submittedtoescrow','finaldocssigned','fundsreleased','applicationwithdrawn','applicationabandoned','aplicationrejected','borrowerwithdrew','loancanceled','loandenied'],'loinitialized')(__a__)
    if(!_.isEqual(__v__,this['_status'])) {
      setDirtyFlag()
      this['_status'] = __v__
    }
  }
  get currentStage() { return this['_currentStage'] }
  set currentStage(__a__) {
    let __v__ = enumReader(['Application','Processing','Closing','Archived'],'Application')(__a__)
    if(!_.isEqual(__v__,this['_currentStage'])) {
      setDirtyFlag()
      this['_currentStage'] = __v__
    }
  }
  get currentStatus() { return this['_currentStatus'] }
  set currentStatus(__a__) {
    let __v__ = enumReader(['ApplicationStarted','ApplicationFinished','PrequalSent','InContract','OpenEscrow','ConditionsRequested','ConditionsReviewed','OrderAppraisal','TitleSearch','PreApproved','SubmittedToUnderwriting','ConditionalApproval','ClearToClose','DocsOut','DocsSigned','LoanFunded','ApplicationAbandoned','ApplicationRejected','PreApprovalDenied','FileClosedForIncompleteness','ApplicationWithdrawn','ApplicationDenied','ApprovedButNotAccepted','Other'],'ApplicationStarted')(__a__)
    if(!_.isEqual(__v__,this['_currentStatus'])) {
      setDirtyFlag()
      this['_currentStatus'] = __v__
    }
  }
  get visitedMenus() { return this['_visitedMenus'] }
  set visitedMenus(__a__) {
    setDirtyFlag()
    this['_visitedMenus'] = __a__
  }
  get hascoborrower() { return this['_hascoborrower'] }
  set hascoborrower(__a__) {
    if(__a__ == null) {
      if(this['_hascoborrower'] == null) { return }
      setDirtyFlag()
      this['_hascoborrower'] = null
      return
    } else {
      let __v__ = enumReader(['alone','withcoborrower','multiple','remote'],'alone')(__a__)
      if(!_.isEqual(__v__,this['_hascoborrower'])) {
        setDirtyFlag()
        this['_hascoborrower'] = __v__
      }
    }
  }
  get cohabiting() { return this['_cohabiting'] }
  set cohabiting(__a__) {
    if(__a__ == null) {
      if(this['_cohabiting'] == null) { return }
      setDirtyFlag()
      this['_cohabiting'] = null
      return
    } else {
      let __v__ = boolReader(false)(__a__)
      if(!_.isEqual(__v__,this['_cohabiting'])) {
        setDirtyFlag()
        this['_cohabiting'] = __v__
      }
    }
  }
  get married() { return this['_married'] }
  set married(__a__) {
    if(__a__ == null) {
      if(this['_married'] == null) { return }
      setDirtyFlag()
      this['_married'] = null
      return
    } else {
      let __v__ = boolReader(false)(__a__)
      if(!_.isEqual(__v__,this['_married'])) {
        setDirtyFlag()
        this['_married'] = __v__
      }
    }
  }
  get firsttimebuyer() { return this['_firsttimebuyer'] }
  set firsttimebuyer(__a__) {
    if(__a__ == null) {
      if(this['_firsttimebuyer'] == null) { return }
      setDirtyFlag()
      this['_firsttimebuyer'] = null
      return
    } else {
      let __v__ = boolReader(false)(__a__)
      if(!_.isEqual(__v__,this['_firsttimebuyer'])) {
        setDirtyFlag()
        this['_firsttimebuyer'] = __v__
      }
    }
  }
  get qualifiesforassistance() { return this['_qualifiesforassistance'] }
  set qualifiesforassistance(__a__) {
    if(__a__ == null) {
      if(this['_qualifiesforassistance'] == null) { return }
      setDirtyFlag()
      this['_qualifiesforassistance'] = null
      return
    } else {
      let __v__ = intReader(0)(__a__)
      if(!_.isEqual(__v__,this['_qualifiesforassistance'])) {
        setDirtyFlag()
        this['_qualifiesforassistance'] = __v__
      }
    }
  }
  get askedforassistance() { return this['_askedforassistance'] }
  set askedforassistance(__a__) {
    if(__a__ == null) {
      if(this['_askedforassistance'] == null) { return }
      setDirtyFlag()
      this['_askedforassistance'] = null
      return
    } else {
      let __v__ = boolReader(false)(__a__)
      if(!_.isEqual(__v__,this['_askedforassistance'])) {
        setDirtyFlag()
        this['_askedforassistance'] = __v__
      }
    }
  }
  get loanbalance() { return this['_loanbalance'] }
  set loanbalance(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_loanbalance'])) {
      setDirtyFlag()
      this['_loanbalance'] = __v__
    }
  }
  get keepinghousefor() { return this['_keepinghousefor'] }
  set keepinghousefor(__a__) {
    if(__a__ == null) {
      if(this['_keepinghousefor'] == null) { return }
      setDirtyFlag()
      this['_keepinghousefor'] = null
      return
    } else {
      let __v__ = intReader(0)(__a__)
      if(!_.isEqual(__v__,this['_keepinghousefor'])) {
        setDirtyFlag()
        this['_keepinghousefor'] = __v__
      }
    }
  }
  get financingsameproperty() { return this['_financingsameproperty'] }
  set financingsameproperty(__a__) {
    if(__a__ == null) {
      if(this['_financingsameproperty'] == null) { return }
      setDirtyFlag()
      this['_financingsameproperty'] = null
      return
    } else {
      let __v__ = boolReader(false)(__a__)
      if(!_.isEqual(__v__,this['_financingsameproperty'])) {
        setDirtyFlag()
        this['_financingsameproperty'] = __v__
      }
    }
  }
  get hascreditfreeze() { return this['_hascreditfreeze'] }
  set hascreditfreeze(__a__) {
    if(__a__ == null) {
      if(this['_hascreditfreeze'] == null) { return }
      setDirtyFlag()
      this['_hascreditfreeze'] = null
      return
    } else {
      let __v__ = boolReader(false)(__a__)
      if(!_.isEqual(__v__,this['_hascreditfreeze'])) {
        setDirtyFlag()
        this['_hascreditfreeze'] = __v__
      }
    }
  }
  get assetsandliabilities() { return this['_assetsandliabilities'] }
  set assetsandliabilities(__a__) {
    setDirtyFlag()
    this['_assetsandliabilities'] = __a__
  }
  get otherliens() { return this['_otherliens'] }
  set otherliens(__a__) {
    setDirtyFlag()
    this['_otherliens'] = __a__
  }
  get borrower() { return this['_borrower'] }
  set borrower(__a__) {
    setDirtyFlag()
    this['_borrower'] = __a__
  }
  get coborrower() { return this['_coborrower'] }
  set coborrower(__a__) {
    setDirtyFlag()
    this['_coborrower'] = __a__
  }
  get remotecoborrowers() { return this['_remotecoborrowers'] }
  set remotecoborrowers(__a__) {
    setDirtyFlag()
    this['_remotecoborrowers'] = __a__
  }
  get scre() { return this['_scre'] }
  set scre(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_scre'])) {
      setDirtyFlag()
      this['_scre'] = __v__
    }
  }
  get property() { return this['_property'] }
  set property(__a__) {
    setDirtyFlag()
    this['_property'] = __a__
  }
  get product() { return this['_product'] }
  set product(__a__) {
    setDirtyFlag()
    this['_product'] = __a__
  }
  get transaction() { return this['_transaction'] }
  set transaction(__a__) {
    setDirtyFlag()
    this['_transaction'] = __a__
  }
  get assetsofotherpersonused() { return this['_assetsofotherpersonused'] }
  set assetsofotherpersonused(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_assetsofotherpersonused'])) {
      setDirtyFlag()
      this['_assetsofotherpersonused'] = __v__
    }
  }
  get liabilitiesofotherpersonrequired() { return this['_liabilitiesofotherpersonrequired'] }
  set liabilitiesofotherpersonrequired(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_liabilitiesofotherpersonrequired'])) {
      setDirtyFlag()
      this['_liabilitiesofotherpersonrequired'] = __v__
    }
  }
  get selection() { return this['_selection'] }
  set selection(__a__) {
    setDirtyFlag()
    this['_selection'] = __a__
  }
  get lienposition() { return this['_lienposition'] }
  set lienposition(__a__) {
    setDirtyFlag()
    this['_lienposition'] = __a__
  }
  get underwriting() { return this['_underwriting'] }
  set underwriting(__a__) {
    setDirtyFlag()
    this['_underwriting'] = __a__
  }
  get escrowti() { return this['_escrowti'] }
  set escrowti(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_escrowti'])) {
      setDirtyFlag()
      this['_escrowti'] = __v__
    }
  }
  get issueddate() { return this['_issueddate'] }
  set issueddate(__a__) {
    let __v__ = DateSReader('')(__a__)
    if(!_.isEqual(__v__,this['_issueddate'])) {
      setDirtyFlag()
      this['_issueddate'] = __v__
    }
  }
  get closingdate() { return this['_closingdate'] }
  set closingdate(__a__) {
    let __v__ = DateSReader('')(__a__)
    if(!_.isEqual(__v__,this['_closingdate'])) {
      setDirtyFlag()
      this['_closingdate'] = __v__
    }
  }
  get isAHI() { return this['_isAHI'] }
  set isAHI(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_isAHI'])) {
      setDirtyFlag()
      this['_isAHI'] = __v__
    }
  }
  get isCommunityLending() { return this['_isCommunityLending'] }
  set isCommunityLending(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_isCommunityLending'])) {
      setDirtyFlag()
      this['_isCommunityLending'] = __v__
    }
  }
  get AUSreport() { return this['_AUSreport'] }
  set AUSreport(__a__) {
    setDirtyFlag()
    this['_AUSreport'] = __a__
  }
  get IPCs() { return this['_IPCs'] }
  set IPCs(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_IPCs'])) {
      setDirtyFlag()
      this['_IPCs'] = __v__
    }
  }
  get deposit() { return this['_deposit'] }
  set deposit(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_deposit'])) {
      setDirtyFlag()
      this['_deposit'] = __v__
    }
  }
  get brokerinfo() { return this['_brokerinfo'] }
  set brokerinfo(__a__) {
    setDirtyFlag()
    this['_brokerinfo'] = __a__
  }
  get aloneMarriedWantsFHA() { return this['_aloneMarriedWantsFHA'] }
  set aloneMarriedWantsFHA(__a__) {
    if(__a__ == null) {
      if(this['_aloneMarriedWantsFHA'] == null) { return }
      setDirtyFlag()
      this['_aloneMarriedWantsFHA'] = null
      return
    } else {
      let __v__ = boolReader(false)(__a__)
      if(!_.isEqual(__v__,this['_aloneMarriedWantsFHA'])) {
        setDirtyFlag()
        this['_aloneMarriedWantsFHA'] = __v__
      }
    }
  }
  get loanid() { return this['_loanid'] }
  set loanid(__a__) {
    if(__a__ == null) {
      if(this['_loanid'] == null) { return }
      setDirtyFlag()
      this['_loanid'] = null
      return
    } else {
      let __v__ = stringReader('')(__a__)
      if(!_.isEqual(__v__,this['_loanid'])) {
        setDirtyFlag()
        this['_loanid'] = __v__
      }
    }
  }
  get hardmoneyloan() { return this['_hardmoneyloan'] }
  set hardmoneyloan(__a__) {
    setDirtyFlag()
    this['_hardmoneyloan'] = __a__
  }
  get escrowInfo() { return this['_escrowInfo'] }
  set escrowInfo(__a__) {
    if(__a__ == null) {
      if(this['_escrowInfo'] == null) { return }
      setDirtyFlag()
      this['_escrowInfo'] = null
      return
    } else {
      setDirtyFlag()
      this['_escrowInfo'] = __a__
    }
  }
  get appraisalInfo() { return this['_appraisalInfo'] }
  set appraisalInfo(__a__) {
    if(__a__ == null) {
      if(this['_appraisalInfo'] == null) { return }
      setDirtyFlag()
      this['_appraisalInfo'] = null
      return
    } else {
      setDirtyFlag()
      this['_appraisalInfo'] = __a__
    }
  }
  get dtiCalculation() { return this['_dtiCalculation'] }
  set dtiCalculation(__a__) {
    if(__a__ == null) {
      if(this['_dtiCalculation'] == null) { return }
      setDirtyFlag()
      this['_dtiCalculation'] = null
      return
    } else {
      setDirtyFlag()
      this['_dtiCalculation'] = __a__
    }
  }
  get currentDTIResult() { return this['_currentDTIResult'] }
  set currentDTIResult(__a__) {
    if(__a__ == null) {
      if(this['_currentDTIResult'] == null) { return }
      setDirtyFlag()
      this['_currentDTIResult'] = null
      return
    } else {
      setDirtyFlag()
      this['_currentDTIResult'] = __a__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new application()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.status = __a__['status']
       cls.currentStage = __a__['currentStage']
       cls.currentStatus = __a__['currentStatus']
       cls.visitedMenus = array1Reader(stringReader(''))(__a__['visitedMenus'])
       cls.hascoborrower = __a__['hascoborrower'] == null ? null : __a__['hascoborrower']
       cls.cohabiting = __a__['cohabiting'] == null ? null : __a__['cohabiting']
       cls.married = __a__['married'] == null ? null : __a__['married']
       cls.firsttimebuyer = __a__['firsttimebuyer'] == null ? null : __a__['firsttimebuyer']
       cls.qualifiesforassistance = __a__['qualifiesforassistance'] == null ? null : __a__['qualifiesforassistance']
       cls.askedforassistance = __a__['askedforassistance'] == null ? null : __a__['askedforassistance']
       cls.loanbalance = __a__['loanbalance']
       cls.keepinghousefor = __a__['keepinghousefor'] == null ? null : __a__['keepinghousefor']
       cls.financingsameproperty = __a__['financingsameproperty'] == null ? null : __a__['financingsameproperty']
       cls.hascreditfreeze = __a__['hascreditfreeze'] == null ? null : __a__['hascreditfreeze']
       cls.assetsandliabilities = assetsandliabilities.fromJson(__a__['assetsandliabilities'])
       cls.otherliens = __a__['otherliens'] == null ? null : array1Reader(otherlien.fromJson)(__a__['otherliens'])
       cls.borrower = borrower.fromJson(__a__['borrower'])
       cls.coborrower = borrower.fromJson(__a__['coborrower'])
       cls.remotecoborrowers = array1Reader(remotecoborrower.fromJson)(__a__['remotecoborrowers'])
       cls.scre = __a__['scre']
       cls.property = subjectproperty.fromJson(__a__['property'])
       cls.product = product.fromJson(__a__['product'])
       cls.transaction = transaction.fromJson(__a__['transaction'])
       cls.assetsofotherpersonused = __a__['assetsofotherpersonused']
       cls.liabilitiesofotherpersonrequired = __a__['liabilitiesofotherpersonrequired']
       cls.selection = Selection.fromJson(__a__['selection'])
       cls.lienposition = LienPosition.fromJson(__a__['lienposition'])
       cls.underwriting = Underwriting.fromJson(__a__['underwriting'])
       cls.escrowti = __a__['escrowti']
       cls.issueddate = __a__['issueddate']
       cls.closingdate = __a__['closingdate']
       cls.isAHI = __a__['isAHI']
       cls.isCommunityLending = __a__['isCommunityLending']
       cls.AUSreport = AUSreport.fromJson(__a__['AUSreport'])
       cls.IPCs = __a__['IPCs']
       cls.deposit = __a__['deposit']
       cls.brokerinfo = broker.fromJson(__a__['brokerinfo'])
       cls.aloneMarriedWantsFHA = __a__['aloneMarriedWantsFHA'] == null ? null : __a__['aloneMarriedWantsFHA']
       cls.loanid = __a__['loanid'] == null ? null : __a__['loanid']
       cls.hardmoneyloan = HardMoneyLoan.fromJson(__a__['hardmoneyloan'])
       cls.escrowInfo = __a__['escrowInfo'] == null ? null : escrowinfo.fromJson(__a__['escrowInfo'])
       cls.appraisalInfo = __a__['appraisalInfo'] == null ? null : appraisalinfo.fromJson(__a__['appraisalInfo'])
       cls.dtiCalculation = __a__['dtiCalculation'] == null ? null : DTICalculation.fromJson(__a__['dtiCalculation'])
       cls.currentDTIResult = __a__['currentDTIResult'] == null ? null : CurrentDTIResult.fromJson(__a__['currentDTIResult'])
    } else {
       doAlert(`application: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class appraisaldetails {
  constructor() {
    this['_orderdate'] = ''
    this['_datecompleted'] = ''
    this['_appraisalvalue'] = ''
    this['_appraisalname'] = ''
    this['_appraisername'] = ''
    this['_email'] = ''
    this['_phone'] = ''
  }
  get orderdate() { return this['_orderdate'] }
  set orderdate(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_orderdate'])) {
      setDirtyFlag()
      this['_orderdate'] = __v__
    }
  }
  get datecompleted() { return this['_datecompleted'] }
  set datecompleted(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_datecompleted'])) {
      setDirtyFlag()
      this['_datecompleted'] = __v__
    }
  }
  get appraisalvalue() { return this['_appraisalvalue'] }
  set appraisalvalue(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_appraisalvalue'])) {
      setDirtyFlag()
      this['_appraisalvalue'] = __v__
    }
  }
  get appraisalname() { return this['_appraisalname'] }
  set appraisalname(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_appraisalname'])) {
      setDirtyFlag()
      this['_appraisalname'] = __v__
    }
  }
  get appraisername() { return this['_appraisername'] }
  set appraisername(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_appraisername'])) {
      setDirtyFlag()
      this['_appraisername'] = __v__
    }
  }
  get email() { return this['_email'] }
  set email(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_email'])) {
      setDirtyFlag()
      this['_email'] = __v__
    }
  }
  get phone() { return this['_phone'] }
  set phone(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_phone'])) {
      setDirtyFlag()
      this['_phone'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new appraisaldetails()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.orderdate = __a__['orderdate']
       cls.datecompleted = __a__['datecompleted']
       cls.appraisalvalue = __a__['appraisalvalue']
       cls.appraisalname = __a__['appraisalname']
       cls.appraisername = __a__['appraisername']
       cls.email = __a__['email']
       cls.phone = __a__['phone']
    } else {
       doAlert(`appraisaldetails: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class appraisalinfo {
  constructor() {
    this['_appraisaldetails'] = []
    this['_appraisalopened'] = false
  }
  get appraisaldetails() { return this['_appraisaldetails'] }
  set appraisaldetails(__a__) {
    setDirtyFlag()
    this['_appraisaldetails'] = __a__
  }
  get appraisalopened() { return this['_appraisalopened'] }
  set appraisalopened(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_appraisalopened'])) {
      setDirtyFlag()
      this['_appraisalopened'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new appraisalinfo()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.appraisaldetails = array1Reader(appraisaldetails.fromJson)(__a__['appraisaldetails'])
       cls.appraisalopened = __a__['appraisalopened']
    } else {
       doAlert(`appraisalinfo: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class armterms {
  constructor() {
    this['_index'] = 'LIBOR'
    this['_margin'] = 0.0
    this['_fixedperiod'] = 0
    this['_adjustmentperiod'] = 0
    this['_initialcap'] = 0
    this['_periodiccap'] = 0
    this['_lifetimecap'] = 0
    this['_lifetimefloor'] = 0.0
  }
  get index() { return this['_index'] }
  set index(__a__) {
    let __v__ = enumReader(['LIBOR','PrimeRate','COSI','COFI','MTA','TBill','CMT','CMT5YR','CMT10YR','SOFR'],'LIBOR')(__a__)
    if(!_.isEqual(__v__,this['_index'])) {
      setDirtyFlag()
      this['_index'] = __v__
    }
  }
  get margin() { return this['_margin'] }
  set margin(__a__) {
    let __v__ = floatReader(0.0)(__a__)
    if(!_.isEqual(__v__,this['_margin'])) {
      setDirtyFlag()
      this['_margin'] = __v__
    }
  }
  get fixedperiod() { return this['_fixedperiod'] }
  set fixedperiod(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_fixedperiod'])) {
      setDirtyFlag()
      this['_fixedperiod'] = __v__
    }
  }
  get adjustmentperiod() { return this['_adjustmentperiod'] }
  set adjustmentperiod(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_adjustmentperiod'])) {
      setDirtyFlag()
      this['_adjustmentperiod'] = __v__
    }
  }
  get initialcap() { return this['_initialcap'] }
  set initialcap(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_initialcap'])) {
      setDirtyFlag()
      this['_initialcap'] = __v__
    }
  }
  get periodiccap() { return this['_periodiccap'] }
  set periodiccap(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_periodiccap'])) {
      setDirtyFlag()
      this['_periodiccap'] = __v__
    }
  }
  get lifetimecap() { return this['_lifetimecap'] }
  set lifetimecap(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_lifetimecap'])) {
      setDirtyFlag()
      this['_lifetimecap'] = __v__
    }
  }
  get lifetimefloor() { return this['_lifetimefloor'] }
  set lifetimefloor(__a__) {
    let __v__ = floatReader(0.0)(__a__)
    if(!_.isEqual(__v__,this['_lifetimefloor'])) {
      setDirtyFlag()
      this['_lifetimefloor'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new armterms()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.index = __a__['index']
       cls.margin = __a__['margin']
       cls.fixedperiod = __a__['fixedperiod']
       cls.adjustmentperiod = __a__['adjustmentperiod']
       cls.initialcap = __a__['initialcap']
       cls.periodiccap = __a__['periodiccap']
       cls.lifetimecap = __a__['lifetimecap']
       cls.lifetimefloor = __a__['lifetimefloor']
    } else {
       doAlert(`armterms: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class assetsandliabilities {
  constructor() {
    this['_accounts'] = null
    this['_brokerages'] = null
    this['_ownedproperties'] = []
    this['_properties'] = null
    this['_propertiesfrompull'] = null
    this['_loans'] = null
    this['_gifts'] = null
    this['_newloans'] = null
    this['_otherassets'] = null
    this['_lifeinsurance'] = null
    this['_propertyownedfreeandclear'] = null
    this['_loansreviewed'] = null
    this['_warnings'] = null
  }
  get accounts() { return this['_accounts'] }
  set accounts(__a__) {
    setDirtyFlag()
    this['_accounts'] = __a__
  }
  get brokerages() { return this['_brokerages'] }
  set brokerages(__a__) {
    setDirtyFlag()
    this['_brokerages'] = __a__
  }
  get ownedproperties() { return this['_ownedproperties'] }
  set ownedproperties(__a__) {
    setDirtyFlag()
    this['_ownedproperties'] = __a__
  }
  get properties() { return this['_properties'] }
  set properties(__a__) {
    setDirtyFlag()
    this['_properties'] = __a__
  }
  get propertiesfrompull() { return this['_propertiesfrompull'] }
  set propertiesfrompull(__a__) {
    setDirtyFlag()
    this['_propertiesfrompull'] = __a__
  }
  get loans() { return this['_loans'] }
  set loans(__a__) {
    setDirtyFlag()
    this['_loans'] = __a__
  }
  get gifts() { return this['_gifts'] }
  set gifts(__a__) {
    setDirtyFlag()
    this['_gifts'] = __a__
  }
  get newloans() { return this['_newloans'] }
  set newloans(__a__) {
    setDirtyFlag()
    this['_newloans'] = __a__
  }
  get otherassets() { return this['_otherassets'] }
  set otherassets(__a__) {
    setDirtyFlag()
    this['_otherassets'] = __a__
  }
  get lifeinsurance() { return this['_lifeinsurance'] }
  set lifeinsurance(__a__) {
    setDirtyFlag()
    this['_lifeinsurance'] = __a__
  }
  get propertyownedfreeandclear() { return this['_propertyownedfreeandclear'] }
  set propertyownedfreeandclear(__a__) {
    if(__a__ == null) {
      if(this['_propertyownedfreeandclear'] == null) { return }
      setDirtyFlag()
      this['_propertyownedfreeandclear'] = null
      return
    } else {
      let __v__ = boolReader(false)(__a__)
      if(!_.isEqual(__v__,this['_propertyownedfreeandclear'])) {
        setDirtyFlag()
        this['_propertyownedfreeandclear'] = __v__
      }
    }
  }
  get loansreviewed() { return this['_loansreviewed'] }
  set loansreviewed(__a__) {
    if(__a__ == null) {
      if(this['_loansreviewed'] == null) { return }
      setDirtyFlag()
      this['_loansreviewed'] = null
      return
    } else {
      let __v__ = intReader(0)(__a__)
      if(!_.isEqual(__v__,this['_loansreviewed'])) {
        setDirtyFlag()
        this['_loansreviewed'] = __v__
      }
    }
  }
  get warnings() { return this['_warnings'] }
  set warnings(__a__) {
    setDirtyFlag()
    this['_warnings'] = __a__
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new assetsandliabilities()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.accounts = __a__['accounts'] == null ? null : array1Reader(account.fromJson)(__a__['accounts'])
       cls.brokerages = __a__['brokerages'] == null ? null : array1Reader(brokerageaccount.fromJson)(__a__['brokerages'])
       cls.ownedproperties = array1Reader(OwnedProperty.fromJson)(__a__['ownedproperties'])
       cls.properties = __a__['properties'] == null ? null : array1Reader(property.fromJson)(__a__['properties'])
       cls.propertiesfrompull = __a__['propertiesfrompull'] == null ? null : array1Reader(property.fromJson)(__a__['propertiesfrompull'])
       cls.loans = __a__['loans'] == null ? null : array1Reader(loan.fromJson)(__a__['loans'])
       cls.gifts = __a__['gifts'] == null ? null : array1Reader(gift.fromJson)(__a__['gifts'])
       cls.newloans = __a__['newloans'] == null ? null : array1Reader(newmortgage.fromJson)(__a__['newloans'])
       cls.otherassets = __a__['otherassets'] == null ? null : array1Reader(otherasset.fromJson)(__a__['otherassets'])
       cls.lifeinsurance = __a__['lifeinsurance'] == null ? null : array1Reader(insurance.fromJson)(__a__['lifeinsurance'])
       cls.propertyownedfreeandclear = __a__['propertyownedfreeandclear'] == null ? null : __a__['propertyownedfreeandclear']
       cls.loansreviewed = __a__['loansreviewed'] == null ? null : __a__['loansreviewed']
       cls.warnings = __a__['warnings'] == null ? null : array1Reader(stringReader(''))(__a__['warnings'])
    } else {
       doAlert(`assetsandliabilities: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class automobile {
  constructor() {
    this['_make'] = ''
    this['_year'] = ''
    this['_value'] = ''
    this['_key'] = ''
    this['_attribution'] = null
  }
  get make() { return this['_make'] }
  set make(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_make'])) {
      setDirtyFlag()
      this['_make'] = __v__
    }
  }
  get year() { return this['_year'] }
  set year(__a__) {
    let __v__ = YearSReader('')(__a__)
    if(!_.isEqual(__v__,this['_year'])) {
      setDirtyFlag()
      this['_year'] = __v__
    }
  }
  get value() { return this['_value'] }
  set value(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_value'])) {
      setDirtyFlag()
      this['_value'] = __v__
    }
  }
  get key() { return this['_key'] }
  set key(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_key'])) {
      setDirtyFlag()
      this['_key'] = __v__
    }
  }
  get attribution() { return this['_attribution'] }
  set attribution(__a__) {
    if(__a__ == null) {
      if(this['_attribution'] == null) { return }
      setDirtyFlag()
      this['_attribution'] = null
      return
    } else {
      let __v__ = intReader(0)(__a__)
      if(!_.isEqual(__v__,this['_attribution'])) {
        setDirtyFlag()
        this['_attribution'] = __v__
      }
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new automobile()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.make = __a__['make']
       cls.year = __a__['year']
       cls.value = __a__['value']
       cls.key = __a__['key']
       cls.attribution = __a__['attribution'] == null ? null : __a__['attribution']
    } else {
       doAlert(`automobile: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class borrower {
  constructor() {
    this['_firstname'] = ''
    this['_middlename'] = ''
    this['_lastname'] = ''
    this['_suffix'] = ''
    this['_email'] = ''
    this['_presentaddressstreet'] = ''
    this['_presentaddressunit'] = null
    this['_presentaddresscity'] = ''
    this['_presentaddresscounty'] = ''
    this['_presentaddressstate'] = ''
    this['_presentaddresszip'] = ''
    this['_presentaddressyears'] = ''
    this['_presentaddressmonths'] = ''
    this['_presentaddressownership'] = null
    this['_marketvalue'] = ''
    this['_liens'] = ''
    this['_grossrentalincome'] = ''
    this['_status'] = 'pending'
    this['_propertytype'] = 'singlefamilyattached'
    this['_mortgagepayment'] = ''
    this['_insurancemaintenancetaxes'] = ''
    this['_netrentalincome'] = ''
    this['_isrented'] = false
    this['_previousaddresses'] = []
    this['_samemailingaddress'] = true
    this['_mailingaddressstreet'] = ''
    this['_mailingaddressunit'] = ''
    this['_mailingaddresscounty'] = ''
    this['_mailingaddresscity'] = ''
    this['_mailingaddressstate'] = ''
    this['_mailingaddresszip'] = ''
    this['_dateofbirth'] = ''
    this['_maritalstatus'] = null
    this['_haspartner'] = null
    this['_relationship'] = ''
    this['_relationshiptype'] = '"other"'
    this['_stateofrelationship'] = ''
    this['_socialsecurity'] = ''
    this['_homephone'] = ''
    this['_mobilephone'] = ''
    this['_workphone'] = ''
    this['_yearsofschool'] = ''
    this['_stateid'] = ''
    this['_citizenship'] = null
    this['_visa'] = 'A-1'
    this['_visaexpiration'] = ''
    this['_numberofdependents'] = ''
    this['_dependentsages'] = ''
    this['_occupation'] = new occupation()
    this['_otheroccupations'] = null
    this['_previousoccupations'] = null
    this['_income'] = new income()
    this['_expenses'] = new expenses()
    this['_finances'] = new finances()
    this['_declarations'] = new declarations()
    this['_equalopportunity'] = new equalopportunity()
    this['_creditreport'] = new borrowercreditreport()
    this['_hashomebuyereducationcertificate'] = false
    this['_driverlicense'] = ''
    this['_driverlicenseexpiration'] = ''
    this['_ownedproperties'] = []
    this['_nonqm'] = new nonqm()
    this['_completedsteps'] = new completedsteps()
  }
  get firstname() { return this['_firstname'] }
  set firstname(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_firstname'])) {
      setDirtyFlag()
      this['_firstname'] = __v__
    }
  }
  get middlename() { return this['_middlename'] }
  set middlename(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_middlename'])) {
      setDirtyFlag()
      this['_middlename'] = __v__
    }
  }
  get lastname() { return this['_lastname'] }
  set lastname(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_lastname'])) {
      setDirtyFlag()
      this['_lastname'] = __v__
    }
  }
  get suffix() { return this['_suffix'] }
  set suffix(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_suffix'])) {
      setDirtyFlag()
      this['_suffix'] = __v__
    }
  }
  get email() { return this['_email'] }
  set email(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_email'])) {
      setDirtyFlag()
      this['_email'] = __v__
    }
  }
  get presentaddressstreet() { return this['_presentaddressstreet'] }
  set presentaddressstreet(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_presentaddressstreet'])) {
      setDirtyFlag()
      this['_presentaddressstreet'] = __v__
    }
  }
  get presentaddressunit() { return this['_presentaddressunit'] }
  set presentaddressunit(__a__) {
    if(__a__ == null) {
      if(this['_presentaddressunit'] == null) { return }
      setDirtyFlag()
      this['_presentaddressunit'] = null
      return
    } else {
      let __v__ = stringReader('')(__a__)
      if(!_.isEqual(__v__,this['_presentaddressunit'])) {
        setDirtyFlag()
        this['_presentaddressunit'] = __v__
      }
    }
  }
  get presentaddresscity() { return this['_presentaddresscity'] }
  set presentaddresscity(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_presentaddresscity'])) {
      setDirtyFlag()
      this['_presentaddresscity'] = __v__
    }
  }
  get presentaddresscounty() { return this['_presentaddresscounty'] }
  set presentaddresscounty(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_presentaddresscounty'])) {
      setDirtyFlag()
      this['_presentaddresscounty'] = __v__
    }
  }
  get presentaddressstate() { return this['_presentaddressstate'] }
  set presentaddressstate(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_presentaddressstate'])) {
      setDirtyFlag()
      this['_presentaddressstate'] = __v__
    }
  }
  get presentaddresszip() { return this['_presentaddresszip'] }
  set presentaddresszip(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_presentaddresszip'])) {
      setDirtyFlag()
      this['_presentaddresszip'] = __v__
    }
  }
  get presentaddressyears() { return this['_presentaddressyears'] }
  set presentaddressyears(__a__) {
    let __v__ = IntSReader('')(__a__)
    if(!_.isEqual(__v__,this['_presentaddressyears'])) {
      setDirtyFlag()
      this['_presentaddressyears'] = __v__
    }
  }
  get presentaddressmonths() { return this['_presentaddressmonths'] }
  set presentaddressmonths(__a__) {
    let __v__ = IntSReader('')(__a__)
    if(!_.isEqual(__v__,this['_presentaddressmonths'])) {
      setDirtyFlag()
      this['_presentaddressmonths'] = __v__
    }
  }
  get presentaddressownership() { return this['_presentaddressownership'] }
  set presentaddressownership(__a__) {
    if(__a__ == null) {
      if(this['_presentaddressownership'] == null) { return }
      setDirtyFlag()
      this['_presentaddressownership'] = null
      return
    } else {
      let __v__ = enumReader(['own','rent','rentfree'],'own')(__a__)
      if(!_.isEqual(__v__,this['_presentaddressownership'])) {
        setDirtyFlag()
        this['_presentaddressownership'] = __v__
      }
    }
  }
  get marketvalue() { return this['_marketvalue'] }
  set marketvalue(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_marketvalue'])) {
      setDirtyFlag()
      this['_marketvalue'] = __v__
    }
  }
  get liens() { return this['_liens'] }
  set liens(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_liens'])) {
      setDirtyFlag()
      this['_liens'] = __v__
    }
  }
  get grossrentalincome() { return this['_grossrentalincome'] }
  set grossrentalincome(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_grossrentalincome'])) {
      setDirtyFlag()
      this['_grossrentalincome'] = __v__
    }
  }
  get status() { return this['_status'] }
  set status(__a__) {
    let __v__ = enumReader(['pending','sold','retained'],'pending')(__a__)
    if(!_.isEqual(__v__,this['_status'])) {
      setDirtyFlag()
      this['_status'] = __v__
    }
  }
  get propertytype() { return this['_propertytype'] }
  set propertytype(__a__) {
    let __v__ = enumReader(['singlefamilyattached','singlefamilydetached','condominium','condominiumdetached','pudattached','puddetached','twotofourfamily','twofamily','threefamily','fourfamily','multistory','manufacturedhome','land','commercial','townhouse','mixeduse','mobilehome'],'singlefamilyattached')(__a__)
    if(!_.isEqual(__v__,this['_propertytype'])) {
      setDirtyFlag()
      this['_propertytype'] = __v__
    }
  }
  get mortgagepayment() { return this['_mortgagepayment'] }
  set mortgagepayment(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_mortgagepayment'])) {
      setDirtyFlag()
      this['_mortgagepayment'] = __v__
    }
  }
  get insurancemaintenancetaxes() { return this['_insurancemaintenancetaxes'] }
  set insurancemaintenancetaxes(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_insurancemaintenancetaxes'])) {
      setDirtyFlag()
      this['_insurancemaintenancetaxes'] = __v__
    }
  }
  get netrentalincome() { return this['_netrentalincome'] }
  set netrentalincome(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_netrentalincome'])) {
      setDirtyFlag()
      this['_netrentalincome'] = __v__
    }
  }
  get isrented() { return this['_isrented'] }
  set isrented(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_isrented'])) {
      setDirtyFlag()
      this['_isrented'] = __v__
    }
  }
  get previousaddresses() { return this['_previousaddresses'] }
  set previousaddresses(__a__) {
    setDirtyFlag()
    this['_previousaddresses'] = __a__
  }
  get samemailingaddress() { return this['_samemailingaddress'] }
  set samemailingaddress(__a__) {
    let __v__ = boolReader(true)(__a__)
    if(!_.isEqual(__v__,this['_samemailingaddress'])) {
      setDirtyFlag()
      this['_samemailingaddress'] = __v__
    }
  }
  get mailingaddressstreet() { return this['_mailingaddressstreet'] }
  set mailingaddressstreet(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_mailingaddressstreet'])) {
      setDirtyFlag()
      this['_mailingaddressstreet'] = __v__
    }
  }
  get mailingaddressunit() { return this['_mailingaddressunit'] }
  set mailingaddressunit(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_mailingaddressunit'])) {
      setDirtyFlag()
      this['_mailingaddressunit'] = __v__
    }
  }
  get mailingaddresscounty() { return this['_mailingaddresscounty'] }
  set mailingaddresscounty(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_mailingaddresscounty'])) {
      setDirtyFlag()
      this['_mailingaddresscounty'] = __v__
    }
  }
  get mailingaddresscity() { return this['_mailingaddresscity'] }
  set mailingaddresscity(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_mailingaddresscity'])) {
      setDirtyFlag()
      this['_mailingaddresscity'] = __v__
    }
  }
  get mailingaddressstate() { return this['_mailingaddressstate'] }
  set mailingaddressstate(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_mailingaddressstate'])) {
      setDirtyFlag()
      this['_mailingaddressstate'] = __v__
    }
  }
  get mailingaddresszip() { return this['_mailingaddresszip'] }
  set mailingaddresszip(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_mailingaddresszip'])) {
      setDirtyFlag()
      this['_mailingaddresszip'] = __v__
    }
  }
  get dateofbirth() { return this['_dateofbirth'] }
  set dateofbirth(__a__) {
    let __v__ = DateSReader('')(__a__)
    if(!_.isEqual(__v__,this['_dateofbirth'])) {
      setDirtyFlag()
      this['_dateofbirth'] = __v__
    }
  }
  get maritalstatus() { return this['_maritalstatus'] }
  set maritalstatus(__a__) {
    if(__a__ == null) {
      if(this['_maritalstatus'] == null) { return }
      setDirtyFlag()
      this['_maritalstatus'] = null
      return
    } else {
      let __v__ = enumReader(['married','separated','unmarried','single'],'married')(__a__)
      if(!_.isEqual(__v__,this['_maritalstatus'])) {
        setDirtyFlag()
        this['_maritalstatus'] = __v__
      }
    }
  }
  get haspartner() { return this['_haspartner'] }
  set haspartner(__a__) {
    if(__a__ == null) {
      if(this['_haspartner'] == null) { return }
      setDirtyFlag()
      this['_haspartner'] = null
      return
    } else {
      let __v__ = boolReader(false)(__a__)
      if(!_.isEqual(__v__,this['_haspartner'])) {
        setDirtyFlag()
        this['_haspartner'] = __v__
      }
    }
  }
  get relationship() { return this['_relationship'] }
  set relationship(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_relationship'])) {
      setDirtyFlag()
      this['_relationship'] = __v__
    }
  }
  get relationshiptype() { return this['_relationshiptype'] }
  set relationshiptype(__a__) {
    let __v__ = stringReader('"other"')(__a__)
    if(!_.isEqual(__v__,this['_relationshiptype'])) {
      setDirtyFlag()
      this['_relationshiptype'] = __v__
    }
  }
  get stateofrelationship() { return this['_stateofrelationship'] }
  set stateofrelationship(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_stateofrelationship'])) {
      setDirtyFlag()
      this['_stateofrelationship'] = __v__
    }
  }
  get socialsecurity() { return this['_socialsecurity'] }
  set socialsecurity(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_socialsecurity'])) {
      setDirtyFlag()
      this['_socialsecurity'] = __v__
    }
  }
  get homephone() { return this['_homephone'] }
  set homephone(__a__) {
    let __v__ = PhoneSReader('')(__a__)
    if(!_.isEqual(__v__,this['_homephone'])) {
      setDirtyFlag()
      this['_homephone'] = __v__
    }
  }
  get mobilephone() { return this['_mobilephone'] }
  set mobilephone(__a__) {
    let __v__ = PhoneSReader('')(__a__)
    if(!_.isEqual(__v__,this['_mobilephone'])) {
      setDirtyFlag()
      this['_mobilephone'] = __v__
    }
  }
  get workphone() { return this['_workphone'] }
  set workphone(__a__) {
    let __v__ = PhoneSReader('')(__a__)
    if(!_.isEqual(__v__,this['_workphone'])) {
      setDirtyFlag()
      this['_workphone'] = __v__
    }
  }
  get yearsofschool() { return this['_yearsofschool'] }
  set yearsofschool(__a__) {
    let __v__ = IntSReader('')(__a__)
    if(!_.isEqual(__v__,this['_yearsofschool'])) {
      setDirtyFlag()
      this['_yearsofschool'] = __v__
    }
  }
  get stateid() { return this['_stateid'] }
  set stateid(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_stateid'])) {
      setDirtyFlag()
      this['_stateid'] = __v__
    }
  }
  get citizenship() { return this['_citizenship'] }
  set citizenship(__a__) {
    if(__a__ == null) {
      if(this['_citizenship'] == null) { return }
      setDirtyFlag()
      this['_citizenship'] = null
      return
    } else {
      let __v__ = enumReader(['citizen','permanent','alien'],'citizen')(__a__)
      if(!_.isEqual(__v__,this['_citizenship'])) {
        setDirtyFlag()
        this['_citizenship'] = __v__
      }
    }
  }
  get visa() { return this['_visa'] }
  set visa(__a__) {
    let __v__ = enumReader(['A-1','A-2','A-3','B-1','B-2','B-3','C-1','C-2','C-3','C-4','C-1D','CP','D-1','D-2','E-1','E-2','E-3','F-1','F-2','F-3','G-1','G-2','G-3','G-4','G-5','H-1A','H-1B','H-1B1','H-2','H-2A','H-2B','H-3','H-4','I','OR-1','J-1','J-2','K-1','K-2','K-3','K-4','L-1','L-2','M-1','M-2','M-3','N-8','N-9','NACARA','NATO-1-5','NATO-7','O-1','O-2','O-3','P-1','P-2','P-3','P-4','Q-1','Q-2','Q-3','R-1','R-2','S-5','S-6','S-7','T-1','T-2','T-3','T-4','TD','TN','U-1','U-2','U-3','U-4','V-1','V-2','V-3'],'A-1')(__a__)
    if(!_.isEqual(__v__,this['_visa'])) {
      setDirtyFlag()
      this['_visa'] = __v__
    }
  }
  get visaexpiration() { return this['_visaexpiration'] }
  set visaexpiration(__a__) {
    let __v__ = DateSReader('')(__a__)
    if(!_.isEqual(__v__,this['_visaexpiration'])) {
      setDirtyFlag()
      this['_visaexpiration'] = __v__
    }
  }
  get numberofdependents() { return this['_numberofdependents'] }
  set numberofdependents(__a__) {
    let __v__ = IntSReader('')(__a__)
    if(!_.isEqual(__v__,this['_numberofdependents'])) {
      setDirtyFlag()
      this['_numberofdependents'] = __v__
    }
  }
  get dependentsages() { return this['_dependentsages'] }
  set dependentsages(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_dependentsages'])) {
      setDirtyFlag()
      this['_dependentsages'] = __v__
    }
  }
  get occupation() { return this['_occupation'] }
  set occupation(__a__) {
    setDirtyFlag()
    this['_occupation'] = __a__
  }
  get otheroccupations() { return this['_otheroccupations'] }
  set otheroccupations(__a__) {
    setDirtyFlag()
    this['_otheroccupations'] = __a__
  }
  get previousoccupations() { return this['_previousoccupations'] }
  set previousoccupations(__a__) {
    setDirtyFlag()
    this['_previousoccupations'] = __a__
  }
  get income() { return this['_income'] }
  set income(__a__) {
    setDirtyFlag()
    this['_income'] = __a__
  }
  get expenses() { return this['_expenses'] }
  set expenses(__a__) {
    setDirtyFlag()
    this['_expenses'] = __a__
  }
  get finances() { return this['_finances'] }
  set finances(__a__) {
    setDirtyFlag()
    this['_finances'] = __a__
  }
  get declarations() { return this['_declarations'] }
  set declarations(__a__) {
    setDirtyFlag()
    this['_declarations'] = __a__
  }
  get equalopportunity() { return this['_equalopportunity'] }
  set equalopportunity(__a__) {
    setDirtyFlag()
    this['_equalopportunity'] = __a__
  }
  get creditreport() { return this['_creditreport'] }
  set creditreport(__a__) {
    setDirtyFlag()
    this['_creditreport'] = __a__
  }
  get hashomebuyereducationcertificate() { return this['_hashomebuyereducationcertificate'] }
  set hashomebuyereducationcertificate(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_hashomebuyereducationcertificate'])) {
      setDirtyFlag()
      this['_hashomebuyereducationcertificate'] = __v__
    }
  }
  get driverlicense() { return this['_driverlicense'] }
  set driverlicense(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_driverlicense'])) {
      setDirtyFlag()
      this['_driverlicense'] = __v__
    }
  }
  get driverlicenseexpiration() { return this['_driverlicenseexpiration'] }
  set driverlicenseexpiration(__a__) {
    let __v__ = DateSReader('')(__a__)
    if(!_.isEqual(__v__,this['_driverlicenseexpiration'])) {
      setDirtyFlag()
      this['_driverlicenseexpiration'] = __v__
    }
  }
  get ownedproperties() { return this['_ownedproperties'] }
  set ownedproperties(__a__) {
    setDirtyFlag()
    this['_ownedproperties'] = __a__
  }
  get nonqm() { return this['_nonqm'] }
  set nonqm(__a__) {
    setDirtyFlag()
    this['_nonqm'] = __a__
  }
  get completedsteps() { return this['_completedsteps'] }
  set completedsteps(__a__) {
    setDirtyFlag()
    this['_completedsteps'] = __a__
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new borrower()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.firstname = __a__['firstname']
       cls.middlename = __a__['middlename']
       cls.lastname = __a__['lastname']
       cls.suffix = __a__['suffix']
       cls.email = __a__['email']
       cls.presentaddressstreet = __a__['presentaddressstreet']
       cls.presentaddressunit = __a__['presentaddressunit'] == null ? null : __a__['presentaddressunit']
       cls.presentaddresscity = __a__['presentaddresscity']
       cls.presentaddresscounty = __a__['presentaddresscounty']
       cls.presentaddressstate = __a__['presentaddressstate']
       cls.presentaddresszip = __a__['presentaddresszip']
       cls.presentaddressyears = __a__['presentaddressyears']
       cls.presentaddressmonths = __a__['presentaddressmonths']
       cls.presentaddressownership = __a__['presentaddressownership'] == null ? null : __a__['presentaddressownership']
       cls.marketvalue = __a__['marketvalue']
       cls.liens = __a__['liens']
       cls.grossrentalincome = __a__['grossrentalincome']
       cls.status = __a__['status']
       cls.propertytype = __a__['propertytype']
       cls.mortgagepayment = __a__['mortgagepayment']
       cls.insurancemaintenancetaxes = __a__['insurancemaintenancetaxes']
       cls.netrentalincome = __a__['netrentalincome']
       cls.isrented = __a__['isrented']
       cls.previousaddresses = array1Reader(address.fromJson)(__a__['previousaddresses'])
       cls.samemailingaddress = __a__['samemailingaddress']
       cls.mailingaddressstreet = __a__['mailingaddressstreet']
       cls.mailingaddressunit = __a__['mailingaddressunit']
       cls.mailingaddresscounty = __a__['mailingaddresscounty']
       cls.mailingaddresscity = __a__['mailingaddresscity']
       cls.mailingaddressstate = __a__['mailingaddressstate']
       cls.mailingaddresszip = __a__['mailingaddresszip']
       cls.dateofbirth = __a__['dateofbirth']
       cls.maritalstatus = __a__['maritalstatus'] == null ? null : __a__['maritalstatus']
       cls.haspartner = __a__['haspartner'] == null ? null : __a__['haspartner']
       cls.relationship = __a__['relationship']
       cls.relationshiptype = __a__['relationshiptype']
       cls.stateofrelationship = __a__['stateofrelationship']
       cls.socialsecurity = __a__['socialsecurity']
       cls.homephone = __a__['homephone']
       cls.mobilephone = __a__['mobilephone']
       cls.workphone = __a__['workphone']
       cls.yearsofschool = __a__['yearsofschool']
       cls.stateid = __a__['stateid']
       cls.citizenship = __a__['citizenship'] == null ? null : __a__['citizenship']
       cls.visa = __a__['visa']
       cls.visaexpiration = __a__['visaexpiration']
       cls.numberofdependents = __a__['numberofdependents']
       cls.dependentsages = __a__['dependentsages']
       cls.occupation = occupation.fromJson(__a__['occupation'])
       cls.otheroccupations = __a__['otheroccupations'] == null ? null : array1Reader(otheroccupation.fromJson)(__a__['otheroccupations'])
       cls.previousoccupations = __a__['previousoccupations'] == null ? null : array1Reader(previousoccupation.fromJson)(__a__['previousoccupations'])
       cls.income = income.fromJson(__a__['income'])
       cls.expenses = expenses.fromJson(__a__['expenses'])
       cls.finances = finances.fromJson(__a__['finances'])
       cls.declarations = declarations.fromJson(__a__['declarations'])
       cls.equalopportunity = equalopportunity.fromJson(__a__['equalopportunity'])
       cls.creditreport = borrowercreditreport.fromJson(__a__['creditreport'])
       cls.hashomebuyereducationcertificate = __a__['hashomebuyereducationcertificate']
       cls.driverlicense = __a__['driverlicense']
       cls.driverlicenseexpiration = __a__['driverlicenseexpiration']
       cls.ownedproperties = array1Reader(OwnedProperty.fromJson)(__a__['ownedproperties'])
       cls.nonqm = nonqm.fromJson(__a__['nonqm'])
       cls.completedsteps = completedsteps.fromJson(__a__['completedsteps'])
    } else {
       doAlert(`borrower: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class borrowercreditreport {
  constructor() {
    this['_errorMessages'] = null
    this['_creditscore'] = ''
    this['_personswithresidencies'] = []
    this['_liabilities'] = []
    this['_publicrecords'] = []
  }
  get errorMessages() { return this['_errorMessages'] }
  set errorMessages(__a__) {
    setDirtyFlag()
    this['_errorMessages'] = __a__
  }
  get creditscore() { return this['_creditscore'] }
  set creditscore(__a__) {
    let __v__ = IntSReader('')(__a__)
    if(!_.isEqual(__v__,this['_creditscore'])) {
      setDirtyFlag()
      this['_creditscore'] = __v__
    }
  }
  get personswithresidencies() { return this['_personswithresidencies'] }
  set personswithresidencies(__a__) {
    setDirtyFlag()
    this['_personswithresidencies'] = __a__
  }
  get liabilities() { return this['_liabilities'] }
  set liabilities(__a__) {
    setDirtyFlag()
    this['_liabilities'] = __a__
  }
  get publicrecords() { return this['_publicrecords'] }
  set publicrecords(__a__) {
    setDirtyFlag()
    this['_publicrecords'] = __a__
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new borrowercreditreport()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.errorMessages = __a__['errorMessages'] == null ? null : array1Reader(stringReader(''))(__a__['errorMessages'])
       cls.creditscore = __a__['creditscore']
       cls.personswithresidencies = array1Reader(personwithresidencies.fromJson)(__a__['personswithresidencies'])
       cls.liabilities = array1Reader(loan.fromJson)(__a__['liabilities'])
       cls.publicrecords = array1Reader(publicrecordwithattribution.fromJson)(__a__['publicrecords'])
    } else {
       doAlert(`borrowercreditreport: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class borrowerinternal {
  constructor() {
    this['_id'] = ''
    this['_loan_id'] = ''
    this['_fullname'] = ''
  }
  get id() { return this['_id'] }
  set id(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_id'])) {
      setDirtyFlag()
      this['_id'] = __v__
    }
  }
  get loan_id() { return this['_loan_id'] }
  set loan_id(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_loan_id'])) {
      setDirtyFlag()
      this['_loan_id'] = __v__
    }
  }
  get fullname() { return this['_fullname'] }
  set fullname(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_fullname'])) {
      setDirtyFlag()
      this['_fullname'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new borrowerinternal()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.id = __a__['id']
       cls.loan_id = __a__['loan_id']
       cls.fullname = __a__['fullname']
    } else {
       doAlert(`borrowerinternal: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class broker {
  constructor() {
    this['_name'] = ''
    this['_street'] = ''
    this['_unit'] = ''
    this['_city'] = ''
    this['_state'] = ''
    this['_zip'] = ''
    this['_licenseid'] = ''
    this['_nmls'] = ''
    this['_loanofficername'] = ''
    this['_loanofficerlicenseid'] = ''
    this['_loanofficernmls'] = ''
    this['_email'] = ''
    this['_phone'] = ''
  }
  get name() { return this['_name'] }
  set name(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_name'])) {
      setDirtyFlag()
      this['_name'] = __v__
    }
  }
  get street() { return this['_street'] }
  set street(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_street'])) {
      setDirtyFlag()
      this['_street'] = __v__
    }
  }
  get unit() { return this['_unit'] }
  set unit(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_unit'])) {
      setDirtyFlag()
      this['_unit'] = __v__
    }
  }
  get city() { return this['_city'] }
  set city(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_city'])) {
      setDirtyFlag()
      this['_city'] = __v__
    }
  }
  get state() { return this['_state'] }
  set state(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_state'])) {
      setDirtyFlag()
      this['_state'] = __v__
    }
  }
  get zip() { return this['_zip'] }
  set zip(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_zip'])) {
      setDirtyFlag()
      this['_zip'] = __v__
    }
  }
  get licenseid() { return this['_licenseid'] }
  set licenseid(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_licenseid'])) {
      setDirtyFlag()
      this['_licenseid'] = __v__
    }
  }
  get nmls() { return this['_nmls'] }
  set nmls(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_nmls'])) {
      setDirtyFlag()
      this['_nmls'] = __v__
    }
  }
  get loanofficername() { return this['_loanofficername'] }
  set loanofficername(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_loanofficername'])) {
      setDirtyFlag()
      this['_loanofficername'] = __v__
    }
  }
  get loanofficerlicenseid() { return this['_loanofficerlicenseid'] }
  set loanofficerlicenseid(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_loanofficerlicenseid'])) {
      setDirtyFlag()
      this['_loanofficerlicenseid'] = __v__
    }
  }
  get loanofficernmls() { return this['_loanofficernmls'] }
  set loanofficernmls(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_loanofficernmls'])) {
      setDirtyFlag()
      this['_loanofficernmls'] = __v__
    }
  }
  get email() { return this['_email'] }
  set email(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_email'])) {
      setDirtyFlag()
      this['_email'] = __v__
    }
  }
  get phone() { return this['_phone'] }
  set phone(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_phone'])) {
      setDirtyFlag()
      this['_phone'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new broker()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.name = __a__['name']
       cls.street = __a__['street']
       cls.unit = __a__['unit']
       cls.city = __a__['city']
       cls.state = __a__['state']
       cls.zip = __a__['zip']
       cls.licenseid = __a__['licenseid']
       cls.nmls = __a__['nmls']
       cls.loanofficername = __a__['loanofficername']
       cls.loanofficerlicenseid = __a__['loanofficerlicenseid']
       cls.loanofficernmls = __a__['loanofficernmls']
       cls.email = __a__['email']
       cls.phone = __a__['phone']
    } else {
       doAlert(`broker: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class brokerageaccount {
  constructor() {
    this['_key'] = ''
    this['_bankname'] = ''
    this['_account'] = ''
    this['_balance'] = ''
    this['_attribution'] = null
    this['_allocation'] = new allocation()
    this['_isretirement'] = false
  }
  get key() { return this['_key'] }
  set key(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_key'])) {
      setDirtyFlag()
      this['_key'] = __v__
    }
  }
  get bankname() { return this['_bankname'] }
  set bankname(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_bankname'])) {
      setDirtyFlag()
      this['_bankname'] = __v__
    }
  }
  get account() { return this['_account'] }
  set account(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_account'])) {
      setDirtyFlag()
      this['_account'] = __v__
    }
  }
  get balance() { return this['_balance'] }
  set balance(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_balance'])) {
      setDirtyFlag()
      this['_balance'] = __v__
    }
  }
  get attribution() { return this['_attribution'] }
  set attribution(__a__) {
    if(__a__ == null) {
      if(this['_attribution'] == null) { return }
      setDirtyFlag()
      this['_attribution'] = null
      return
    } else {
      let __v__ = intReader(0)(__a__)
      if(!_.isEqual(__v__,this['_attribution'])) {
        setDirtyFlag()
        this['_attribution'] = __v__
      }
    }
  }
  get allocation() { return this['_allocation'] }
  set allocation(__a__) {
    setDirtyFlag()
    this['_allocation'] = __a__
  }
  get isretirement() { return this['_isretirement'] }
  set isretirement(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_isretirement'])) {
      setDirtyFlag()
      this['_isretirement'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new brokerageaccount()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.key = __a__['key']
       cls.bankname = __a__['bankname']
       cls.account = __a__['account']
       cls.balance = __a__['balance']
       cls.attribution = __a__['attribution'] == null ? null : __a__['attribution']
       cls.allocation = allocation.fromJson(__a__['allocation'])
       cls.isretirement = __a__['isretirement']
    } else {
       doAlert(`brokerageaccount: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class charge {
  constructor() {
    this['_chargeName'] = ''
    this['_estimateAmount'] = 0.0
  }
  get chargeName() { return this['_chargeName'] }
  set chargeName(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_chargeName'])) {
      setDirtyFlag()
      this['_chargeName'] = __v__
    }
  }
  get estimateAmount() { return this['_estimateAmount'] }
  set estimateAmount(__a__) {
    let __v__ = floatReader(0.0)(__a__)
    if(!_.isEqual(__v__,this['_estimateAmount'])) {
      setDirtyFlag()
      this['_estimateAmount'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new charge()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.chargeName = __a__['chargeName']
       cls.estimateAmount = __a__['estimateAmount']
    } else {
       doAlert(`charge: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class completedsteps {
  constructor() {
    this['_yourinfo'] = false
    this['_residence'] = false
    this['_property'] = false
    this['_employment'] = false
    this['_otherincome'] = false
    this['_assets'] = false
    this['_creditcheck'] = false
    this['_liabilities'] = false
    this['_propertymoney'] = false
    this['_finances'] = false
  }
  get yourinfo() { return this['_yourinfo'] }
  set yourinfo(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_yourinfo'])) {
      setDirtyFlag()
      this['_yourinfo'] = __v__
    }
  }
  get residence() { return this['_residence'] }
  set residence(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_residence'])) {
      setDirtyFlag()
      this['_residence'] = __v__
    }
  }
  get property() { return this['_property'] }
  set property(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_property'])) {
      setDirtyFlag()
      this['_property'] = __v__
    }
  }
  get employment() { return this['_employment'] }
  set employment(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_employment'])) {
      setDirtyFlag()
      this['_employment'] = __v__
    }
  }
  get otherincome() { return this['_otherincome'] }
  set otherincome(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_otherincome'])) {
      setDirtyFlag()
      this['_otherincome'] = __v__
    }
  }
  get assets() { return this['_assets'] }
  set assets(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_assets'])) {
      setDirtyFlag()
      this['_assets'] = __v__
    }
  }
  get creditcheck() { return this['_creditcheck'] }
  set creditcheck(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_creditcheck'])) {
      setDirtyFlag()
      this['_creditcheck'] = __v__
    }
  }
  get liabilities() { return this['_liabilities'] }
  set liabilities(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_liabilities'])) {
      setDirtyFlag()
      this['_liabilities'] = __v__
    }
  }
  get propertymoney() { return this['_propertymoney'] }
  set propertymoney(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_propertymoney'])) {
      setDirtyFlag()
      this['_propertymoney'] = __v__
    }
  }
  get finances() { return this['_finances'] }
  set finances(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_finances'])) {
      setDirtyFlag()
      this['_finances'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new completedsteps()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.yourinfo = __a__['yourinfo']
       cls.residence = __a__['residence']
       cls.property = __a__['property']
       cls.employment = __a__['employment']
       cls.otherincome = __a__['otherincome']
       cls.assets = __a__['assets']
       cls.creditcheck = __a__['creditcheck']
       cls.liabilities = __a__['liabilities']
       cls.propertymoney = __a__['propertymoney']
       cls.finances = __a__['finances']
    } else {
       doAlert(`completedsteps: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class construction {
  constructor() {
    this['_yearacquired'] = ''
    this['_originalcost'] = ''
    this['_existingliens'] = ''
    this['_presentvalue'] = ''
    this['_costofimprovements'] = ''
  }
  get yearacquired() { return this['_yearacquired'] }
  set yearacquired(__a__) {
    let __v__ = YearSReader('')(__a__)
    if(!_.isEqual(__v__,this['_yearacquired'])) {
      setDirtyFlag()
      this['_yearacquired'] = __v__
    }
  }
  get originalcost() { return this['_originalcost'] }
  set originalcost(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_originalcost'])) {
      setDirtyFlag()
      this['_originalcost'] = __v__
    }
  }
  get existingliens() { return this['_existingliens'] }
  set existingliens(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_existingliens'])) {
      setDirtyFlag()
      this['_existingliens'] = __v__
    }
  }
  get presentvalue() { return this['_presentvalue'] }
  set presentvalue(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_presentvalue'])) {
      setDirtyFlag()
      this['_presentvalue'] = __v__
    }
  }
  get costofimprovements() { return this['_costofimprovements'] }
  set costofimprovements(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_costofimprovements'])) {
      setDirtyFlag()
      this['_costofimprovements'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new construction()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.yearacquired = __a__['yearacquired']
       cls.originalcost = __a__['originalcost']
       cls.existingliens = __a__['existingliens']
       cls.presentvalue = __a__['presentvalue']
       cls.costofimprovements = __a__['costofimprovements']
    } else {
       doAlert(`construction: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class creditunderothername {
  constructor() {
    this['_altname'] = ''
    this['_creditor'] = ''
    this['_account'] = ''
    this['_key'] = ''
  }
  get altname() { return this['_altname'] }
  set altname(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_altname'])) {
      setDirtyFlag()
      this['_altname'] = __v__
    }
  }
  get creditor() { return this['_creditor'] }
  set creditor(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_creditor'])) {
      setDirtyFlag()
      this['_creditor'] = __v__
    }
  }
  get account() { return this['_account'] }
  set account(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_account'])) {
      setDirtyFlag()
      this['_account'] = __v__
    }
  }
  get key() { return this['_key'] }
  set key(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_key'])) {
      setDirtyFlag()
      this['_key'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new creditunderothername()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.altname = __a__['altname']
       cls.creditor = __a__['creditor']
       cls.account = __a__['account']
       cls.key = __a__['key']
    } else {
       doAlert(`creditunderothername: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class declarations {
  constructor() {
    this['_judgements'] = null
    this['_bancrupt'] = null
    this['_chapter7'] = false
    this['_chapter11'] = false
    this['_chapter12'] = false
    this['_chapter13'] = false
    this['_propertyforeclosure'] = null
    this['_lawsuit'] = null
    this['_familyrelationship'] = null
    this['_conveyedtitle'] = null
    this['_delinquentondebt'] = null
    this['_applyingonanother'] = null
    this['_applyingnewcredit'] = null
    this['_cleanenergylien'] = null
    this['_loanforeclosure'] = null
    this['_downpaymentborrowed'] = null
    this['_moneyborrowed'] = ''
    this['_comakeronnote'] = null
    this['_occupyasprimary'] = null
    this['_ownershipinterest'] = null
    this['_servearmedforces'] = null
    this['_militaryservice'] = new MilitaryService()
    this['_propertyowned'] = 'principal'
    this['_titleheld'] = 'yourself'
    this['_loansinforebearance'] = null
  }
  get judgements() { return this['_judgements'] }
  set judgements(__a__) {
    if(__a__ == null) {
      if(this['_judgements'] == null) { return }
      setDirtyFlag()
      this['_judgements'] = null
      return
    } else {
      let __v__ = enumReader(['no','yes'],'no')(__a__)
      if(!_.isEqual(__v__,this['_judgements'])) {
        setDirtyFlag()
        this['_judgements'] = __v__
      }
    }
  }
  get bancrupt() { return this['_bancrupt'] }
  set bancrupt(__a__) {
    if(__a__ == null) {
      if(this['_bancrupt'] == null) { return }
      setDirtyFlag()
      this['_bancrupt'] = null
      return
    } else {
      let __v__ = enumReader(['no','yes'],'no')(__a__)
      if(!_.isEqual(__v__,this['_bancrupt'])) {
        setDirtyFlag()
        this['_bancrupt'] = __v__
      }
    }
  }
  get chapter7() { return this['_chapter7'] }
  set chapter7(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_chapter7'])) {
      setDirtyFlag()
      this['_chapter7'] = __v__
    }
  }
  get chapter11() { return this['_chapter11'] }
  set chapter11(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_chapter11'])) {
      setDirtyFlag()
      this['_chapter11'] = __v__
    }
  }
  get chapter12() { return this['_chapter12'] }
  set chapter12(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_chapter12'])) {
      setDirtyFlag()
      this['_chapter12'] = __v__
    }
  }
  get chapter13() { return this['_chapter13'] }
  set chapter13(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_chapter13'])) {
      setDirtyFlag()
      this['_chapter13'] = __v__
    }
  }
  get propertyforeclosure() { return this['_propertyforeclosure'] }
  set propertyforeclosure(__a__) {
    if(__a__ == null) {
      if(this['_propertyforeclosure'] == null) { return }
      setDirtyFlag()
      this['_propertyforeclosure'] = null
      return
    } else {
      let __v__ = enumReader(['no','yes'],'no')(__a__)
      if(!_.isEqual(__v__,this['_propertyforeclosure'])) {
        setDirtyFlag()
        this['_propertyforeclosure'] = __v__
      }
    }
  }
  get lawsuit() { return this['_lawsuit'] }
  set lawsuit(__a__) {
    if(__a__ == null) {
      if(this['_lawsuit'] == null) { return }
      setDirtyFlag()
      this['_lawsuit'] = null
      return
    } else {
      let __v__ = enumReader(['no','yes'],'no')(__a__)
      if(!_.isEqual(__v__,this['_lawsuit'])) {
        setDirtyFlag()
        this['_lawsuit'] = __v__
      }
    }
  }
  get familyrelationship() { return this['_familyrelationship'] }
  set familyrelationship(__a__) {
    if(__a__ == null) {
      if(this['_familyrelationship'] == null) { return }
      setDirtyFlag()
      this['_familyrelationship'] = null
      return
    } else {
      let __v__ = enumReader(['no','yes'],'no')(__a__)
      if(!_.isEqual(__v__,this['_familyrelationship'])) {
        setDirtyFlag()
        this['_familyrelationship'] = __v__
      }
    }
  }
  get conveyedtitle() { return this['_conveyedtitle'] }
  set conveyedtitle(__a__) {
    if(__a__ == null) {
      if(this['_conveyedtitle'] == null) { return }
      setDirtyFlag()
      this['_conveyedtitle'] = null
      return
    } else {
      let __v__ = enumReader(['no','yes'],'no')(__a__)
      if(!_.isEqual(__v__,this['_conveyedtitle'])) {
        setDirtyFlag()
        this['_conveyedtitle'] = __v__
      }
    }
  }
  get delinquentondebt() { return this['_delinquentondebt'] }
  set delinquentondebt(__a__) {
    if(__a__ == null) {
      if(this['_delinquentondebt'] == null) { return }
      setDirtyFlag()
      this['_delinquentondebt'] = null
      return
    } else {
      let __v__ = enumReader(['no','yes'],'no')(__a__)
      if(!_.isEqual(__v__,this['_delinquentondebt'])) {
        setDirtyFlag()
        this['_delinquentondebt'] = __v__
      }
    }
  }
  get applyingonanother() { return this['_applyingonanother'] }
  set applyingonanother(__a__) {
    if(__a__ == null) {
      if(this['_applyingonanother'] == null) { return }
      setDirtyFlag()
      this['_applyingonanother'] = null
      return
    } else {
      let __v__ = enumReader(['no','yes'],'no')(__a__)
      if(!_.isEqual(__v__,this['_applyingonanother'])) {
        setDirtyFlag()
        this['_applyingonanother'] = __v__
      }
    }
  }
  get applyingnewcredit() { return this['_applyingnewcredit'] }
  set applyingnewcredit(__a__) {
    if(__a__ == null) {
      if(this['_applyingnewcredit'] == null) { return }
      setDirtyFlag()
      this['_applyingnewcredit'] = null
      return
    } else {
      let __v__ = enumReader(['no','yes'],'no')(__a__)
      if(!_.isEqual(__v__,this['_applyingnewcredit'])) {
        setDirtyFlag()
        this['_applyingnewcredit'] = __v__
      }
    }
  }
  get cleanenergylien() { return this['_cleanenergylien'] }
  set cleanenergylien(__a__) {
    if(__a__ == null) {
      if(this['_cleanenergylien'] == null) { return }
      setDirtyFlag()
      this['_cleanenergylien'] = null
      return
    } else {
      let __v__ = enumReader(['no','yes'],'no')(__a__)
      if(!_.isEqual(__v__,this['_cleanenergylien'])) {
        setDirtyFlag()
        this['_cleanenergylien'] = __v__
      }
    }
  }
  get loanforeclosure() { return this['_loanforeclosure'] }
  set loanforeclosure(__a__) {
    if(__a__ == null) {
      if(this['_loanforeclosure'] == null) { return }
      setDirtyFlag()
      this['_loanforeclosure'] = null
      return
    } else {
      let __v__ = enumReader(['no','yes'],'no')(__a__)
      if(!_.isEqual(__v__,this['_loanforeclosure'])) {
        setDirtyFlag()
        this['_loanforeclosure'] = __v__
      }
    }
  }
  get downpaymentborrowed() { return this['_downpaymentborrowed'] }
  set downpaymentborrowed(__a__) {
    if(__a__ == null) {
      if(this['_downpaymentborrowed'] == null) { return }
      setDirtyFlag()
      this['_downpaymentborrowed'] = null
      return
    } else {
      let __v__ = enumReader(['no','yes'],'no')(__a__)
      if(!_.isEqual(__v__,this['_downpaymentborrowed'])) {
        setDirtyFlag()
        this['_downpaymentborrowed'] = __v__
      }
    }
  }
  get moneyborrowed() { return this['_moneyborrowed'] }
  set moneyborrowed(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_moneyborrowed'])) {
      setDirtyFlag()
      this['_moneyborrowed'] = __v__
    }
  }
  get comakeronnote() { return this['_comakeronnote'] }
  set comakeronnote(__a__) {
    if(__a__ == null) {
      if(this['_comakeronnote'] == null) { return }
      setDirtyFlag()
      this['_comakeronnote'] = null
      return
    } else {
      let __v__ = enumReader(['no','yes'],'no')(__a__)
      if(!_.isEqual(__v__,this['_comakeronnote'])) {
        setDirtyFlag()
        this['_comakeronnote'] = __v__
      }
    }
  }
  get occupyasprimary() { return this['_occupyasprimary'] }
  set occupyasprimary(__a__) {
    if(__a__ == null) {
      if(this['_occupyasprimary'] == null) { return }
      setDirtyFlag()
      this['_occupyasprimary'] = null
      return
    } else {
      let __v__ = enumReader(['no','yes'],'no')(__a__)
      if(!_.isEqual(__v__,this['_occupyasprimary'])) {
        setDirtyFlag()
        this['_occupyasprimary'] = __v__
      }
    }
  }
  get ownershipinterest() { return this['_ownershipinterest'] }
  set ownershipinterest(__a__) {
    if(__a__ == null) {
      if(this['_ownershipinterest'] == null) { return }
      setDirtyFlag()
      this['_ownershipinterest'] = null
      return
    } else {
      let __v__ = enumReader(['no','yes'],'no')(__a__)
      if(!_.isEqual(__v__,this['_ownershipinterest'])) {
        setDirtyFlag()
        this['_ownershipinterest'] = __v__
      }
    }
  }
  get servearmedforces() { return this['_servearmedforces'] }
  set servearmedforces(__a__) {
    if(__a__ == null) {
      if(this['_servearmedforces'] == null) { return }
      setDirtyFlag()
      this['_servearmedforces'] = null
      return
    } else {
      let __v__ = enumReader(['no','yes'],'no')(__a__)
      if(!_.isEqual(__v__,this['_servearmedforces'])) {
        setDirtyFlag()
        this['_servearmedforces'] = __v__
      }
    }
  }
  get militaryservice() { return this['_militaryservice'] }
  set militaryservice(__a__) {
    setDirtyFlag()
    this['_militaryservice'] = __a__
  }
  get propertyowned() { return this['_propertyowned'] }
  set propertyowned(__a__) {
    let __v__ = enumReader(['principal','secondhome','investment','fhasecond','other'],'principal')(__a__)
    if(!_.isEqual(__v__,this['_propertyowned'])) {
      setDirtyFlag()
      this['_propertyowned'] = __v__
    }
  }
  get titleheld() { return this['_titleheld'] }
  set titleheld(__a__) {
    let __v__ = enumReader(['yourself','jointwithspouse','jointwithother'],'yourself')(__a__)
    if(!_.isEqual(__v__,this['_titleheld'])) {
      setDirtyFlag()
      this['_titleheld'] = __v__
    }
  }
  get loansinforebearance() { return this['_loansinforebearance'] }
  set loansinforebearance(__a__) {
    if(__a__ == null) {
      if(this['_loansinforebearance'] == null) { return }
      setDirtyFlag()
      this['_loansinforebearance'] = null
      return
    } else {
      let __v__ = enumReader(['no','yes'],'no')(__a__)
      if(!_.isEqual(__v__,this['_loansinforebearance'])) {
        setDirtyFlag()
        this['_loansinforebearance'] = __v__
      }
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new declarations()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.judgements = __a__['judgements'] == null ? null : __a__['judgements']
       cls.bancrupt = __a__['bancrupt'] == null ? null : __a__['bancrupt']
       cls.chapter7 = __a__['chapter7']
       cls.chapter11 = __a__['chapter11']
       cls.chapter12 = __a__['chapter12']
       cls.chapter13 = __a__['chapter13']
       cls.propertyforeclosure = __a__['propertyforeclosure'] == null ? null : __a__['propertyforeclosure']
       cls.lawsuit = __a__['lawsuit'] == null ? null : __a__['lawsuit']
       cls.familyrelationship = __a__['familyrelationship'] == null ? null : __a__['familyrelationship']
       cls.conveyedtitle = __a__['conveyedtitle'] == null ? null : __a__['conveyedtitle']
       cls.delinquentondebt = __a__['delinquentondebt'] == null ? null : __a__['delinquentondebt']
       cls.applyingonanother = __a__['applyingonanother'] == null ? null : __a__['applyingonanother']
       cls.applyingnewcredit = __a__['applyingnewcredit'] == null ? null : __a__['applyingnewcredit']
       cls.cleanenergylien = __a__['cleanenergylien'] == null ? null : __a__['cleanenergylien']
       cls.loanforeclosure = __a__['loanforeclosure'] == null ? null : __a__['loanforeclosure']
       cls.downpaymentborrowed = __a__['downpaymentborrowed'] == null ? null : __a__['downpaymentborrowed']
       cls.moneyborrowed = __a__['moneyborrowed']
       cls.comakeronnote = __a__['comakeronnote'] == null ? null : __a__['comakeronnote']
       cls.occupyasprimary = __a__['occupyasprimary'] == null ? null : __a__['occupyasprimary']
       cls.ownershipinterest = __a__['ownershipinterest'] == null ? null : __a__['ownershipinterest']
       cls.servearmedforces = __a__['servearmedforces'] == null ? null : __a__['servearmedforces']
       cls.militaryservice = MilitaryService.fromJson(__a__['militaryservice'])
       cls.propertyowned = __a__['propertyowned']
       cls.titleheld = __a__['titleheld']
       cls.loansinforebearance = __a__['loansinforebearance'] == null ? null : __a__['loansinforebearance']
    } else {
       doAlert(`declarations: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class employmentincome {
  constructor() {
    this['_basemonthly'] = 'monthly'
    this['_basehoursperweek'] = ''
    this['_base'] = ''
    this['_overtimemonthly'] = 'monthly'
    this['_overtime'] = ''
    this['_bonusesmonthly'] = 'monthly'
    this['_bonuses'] = ''
    this['_commissionsmonthly'] = 'monthly'
    this['_commissions'] = ''
    this['_militarymonthly'] = 'monthly'
    this['_military'] = ''
    this['_othermonthly'] = 'monthly'
    this['_other'] = ''
  }
  get basemonthly() { return this['_basemonthly'] }
  set basemonthly(__a__) {
    let __v__ = enumReader(['monthly','yearly','daily','hourly'],'monthly')(__a__)
    if(!_.isEqual(__v__,this['_basemonthly'])) {
      setDirtyFlag()
      this['_basemonthly'] = __v__
    }
  }
  get basehoursperweek() { return this['_basehoursperweek'] }
  set basehoursperweek(__a__) {
    let __v__ = IntSReader('')(__a__)
    if(!_.isEqual(__v__,this['_basehoursperweek'])) {
      setDirtyFlag()
      this['_basehoursperweek'] = __v__
    }
  }
  get base() { return this['_base'] }
  set base(__a__) {
    let __v__ = FloatSReader('')(__a__)
    if(!_.isEqual(__v__,this['_base'])) {
      setDirtyFlag()
      this['_base'] = __v__
    }
  }
  get overtimemonthly() { return this['_overtimemonthly'] }
  set overtimemonthly(__a__) {
    let __v__ = enumReader(['monthly','yearly','daily','hourly'],'monthly')(__a__)
    if(!_.isEqual(__v__,this['_overtimemonthly'])) {
      setDirtyFlag()
      this['_overtimemonthly'] = __v__
    }
  }
  get overtime() { return this['_overtime'] }
  set overtime(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_overtime'])) {
      setDirtyFlag()
      this['_overtime'] = __v__
    }
  }
  get bonusesmonthly() { return this['_bonusesmonthly'] }
  set bonusesmonthly(__a__) {
    let __v__ = enumReader(['monthly','yearly','daily','hourly'],'monthly')(__a__)
    if(!_.isEqual(__v__,this['_bonusesmonthly'])) {
      setDirtyFlag()
      this['_bonusesmonthly'] = __v__
    }
  }
  get bonuses() { return this['_bonuses'] }
  set bonuses(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_bonuses'])) {
      setDirtyFlag()
      this['_bonuses'] = __v__
    }
  }
  get commissionsmonthly() { return this['_commissionsmonthly'] }
  set commissionsmonthly(__a__) {
    let __v__ = enumReader(['monthly','yearly','daily','hourly'],'monthly')(__a__)
    if(!_.isEqual(__v__,this['_commissionsmonthly'])) {
      setDirtyFlag()
      this['_commissionsmonthly'] = __v__
    }
  }
  get commissions() { return this['_commissions'] }
  set commissions(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_commissions'])) {
      setDirtyFlag()
      this['_commissions'] = __v__
    }
  }
  get militarymonthly() { return this['_militarymonthly'] }
  set militarymonthly(__a__) {
    let __v__ = enumReader(['monthly','yearly','daily','hourly'],'monthly')(__a__)
    if(!_.isEqual(__v__,this['_militarymonthly'])) {
      setDirtyFlag()
      this['_militarymonthly'] = __v__
    }
  }
  get military() { return this['_military'] }
  set military(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_military'])) {
      setDirtyFlag()
      this['_military'] = __v__
    }
  }
  get othermonthly() { return this['_othermonthly'] }
  set othermonthly(__a__) {
    let __v__ = enumReader(['monthly','yearly','daily','hourly'],'monthly')(__a__)
    if(!_.isEqual(__v__,this['_othermonthly'])) {
      setDirtyFlag()
      this['_othermonthly'] = __v__
    }
  }
  get other() { return this['_other'] }
  set other(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_other'])) {
      setDirtyFlag()
      this['_other'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new employmentincome()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.basemonthly = __a__['basemonthly']
       cls.basehoursperweek = __a__['basehoursperweek']
       cls.base = __a__['base']
       cls.overtimemonthly = __a__['overtimemonthly']
       cls.overtime = __a__['overtime']
       cls.bonusesmonthly = __a__['bonusesmonthly']
       cls.bonuses = __a__['bonuses']
       cls.commissionsmonthly = __a__['commissionsmonthly']
       cls.commissions = __a__['commissions']
       cls.militarymonthly = __a__['militarymonthly']
       cls.military = __a__['military']
       cls.othermonthly = __a__['othermonthly']
       cls.other = __a__['other']
    } else {
       doAlert(`employmentincome: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class equalopportunity {
  constructor() {
    this['_ethnicity'] = null
    this['_hispanic'] = new Hispanic()
    this['_race'] = new Race()
    this['_sex'] = null
  }
  get ethnicity() { return this['_ethnicity'] }
  set ethnicity(__a__) {
    if(__a__ == null) {
      if(this['_ethnicity'] == null) { return }
      setDirtyFlag()
      this['_ethnicity'] = null
      return
    } else {
      let __v__ = enumReader(['donttell','hispanic','nonhispanic'],'donttell')(__a__)
      if(!_.isEqual(__v__,this['_ethnicity'])) {
        setDirtyFlag()
        this['_ethnicity'] = __v__
      }
    }
  }
  get hispanic() { return this['_hispanic'] }
  set hispanic(__a__) {
    setDirtyFlag()
    this['_hispanic'] = __a__
  }
  get race() { return this['_race'] }
  set race(__a__) {
    setDirtyFlag()
    this['_race'] = __a__
  }
  get sex() { return this['_sex'] }
  set sex(__a__) {
    if(__a__ == null) {
      if(this['_sex'] == null) { return }
      setDirtyFlag()
      this['_sex'] = null
      return
    } else {
      let __v__ = enumReader(['donttell','male','female','other'],'donttell')(__a__)
      if(!_.isEqual(__v__,this['_sex'])) {
        setDirtyFlag()
        this['_sex'] = __v__
      }
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new equalopportunity()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.ethnicity = __a__['ethnicity'] == null ? null : __a__['ethnicity']
       cls.hispanic = Hispanic.fromJson(__a__['hispanic'])
       cls.race = Race.fromJson(__a__['race'])
       cls.sex = __a__['sex'] == null ? null : __a__['sex']
    } else {
       doAlert(`equalopportunity: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class escrowinfo {
  constructor() {
    this['_escrowopened'] = false
    this['_opendate'] = ''
    this['_estimatedsettlementstatementreceived'] = false
    this['_titlecompany'] = ''
    this['_escrowofficer'] = ''
    this['_email'] = ''
    this['_phone'] = ''
    this['_escrownumberrelatedcurrentfile'] = ''
    this['_datetitlesearchordered'] = ''
    this['_titlecompanyaddress1'] = ''
    this['_titlecompanyaddress2'] = ''
    this['_titlecompanycity'] = ''
    this['_titlecompanystate'] = ''
    this['_titlecompanyzip'] = ''
    this['_earnestmoneydepositamount'] = ''
    this['_earnestmoneydepositdate'] = ''
  }
  get escrowopened() { return this['_escrowopened'] }
  set escrowopened(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_escrowopened'])) {
      setDirtyFlag()
      this['_escrowopened'] = __v__
    }
  }
  get opendate() { return this['_opendate'] }
  set opendate(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_opendate'])) {
      setDirtyFlag()
      this['_opendate'] = __v__
    }
  }
  get estimatedsettlementstatementreceived() { return this['_estimatedsettlementstatementreceived'] }
  set estimatedsettlementstatementreceived(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_estimatedsettlementstatementreceived'])) {
      setDirtyFlag()
      this['_estimatedsettlementstatementreceived'] = __v__
    }
  }
  get titlecompany() { return this['_titlecompany'] }
  set titlecompany(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_titlecompany'])) {
      setDirtyFlag()
      this['_titlecompany'] = __v__
    }
  }
  get escrowofficer() { return this['_escrowofficer'] }
  set escrowofficer(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_escrowofficer'])) {
      setDirtyFlag()
      this['_escrowofficer'] = __v__
    }
  }
  get email() { return this['_email'] }
  set email(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_email'])) {
      setDirtyFlag()
      this['_email'] = __v__
    }
  }
  get phone() { return this['_phone'] }
  set phone(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_phone'])) {
      setDirtyFlag()
      this['_phone'] = __v__
    }
  }
  get escrownumberrelatedcurrentfile() { return this['_escrownumberrelatedcurrentfile'] }
  set escrownumberrelatedcurrentfile(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_escrownumberrelatedcurrentfile'])) {
      setDirtyFlag()
      this['_escrownumberrelatedcurrentfile'] = __v__
    }
  }
  get datetitlesearchordered() { return this['_datetitlesearchordered'] }
  set datetitlesearchordered(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_datetitlesearchordered'])) {
      setDirtyFlag()
      this['_datetitlesearchordered'] = __v__
    }
  }
  get titlecompanyaddress1() { return this['_titlecompanyaddress1'] }
  set titlecompanyaddress1(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_titlecompanyaddress1'])) {
      setDirtyFlag()
      this['_titlecompanyaddress1'] = __v__
    }
  }
  get titlecompanyaddress2() { return this['_titlecompanyaddress2'] }
  set titlecompanyaddress2(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_titlecompanyaddress2'])) {
      setDirtyFlag()
      this['_titlecompanyaddress2'] = __v__
    }
  }
  get titlecompanycity() { return this['_titlecompanycity'] }
  set titlecompanycity(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_titlecompanycity'])) {
      setDirtyFlag()
      this['_titlecompanycity'] = __v__
    }
  }
  get titlecompanystate() { return this['_titlecompanystate'] }
  set titlecompanystate(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_titlecompanystate'])) {
      setDirtyFlag()
      this['_titlecompanystate'] = __v__
    }
  }
  get titlecompanyzip() { return this['_titlecompanyzip'] }
  set titlecompanyzip(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_titlecompanyzip'])) {
      setDirtyFlag()
      this['_titlecompanyzip'] = __v__
    }
  }
  get earnestmoneydepositamount() { return this['_earnestmoneydepositamount'] }
  set earnestmoneydepositamount(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_earnestmoneydepositamount'])) {
      setDirtyFlag()
      this['_earnestmoneydepositamount'] = __v__
    }
  }
  get earnestmoneydepositdate() { return this['_earnestmoneydepositdate'] }
  set earnestmoneydepositdate(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_earnestmoneydepositdate'])) {
      setDirtyFlag()
      this['_earnestmoneydepositdate'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new escrowinfo()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.escrowopened = __a__['escrowopened']
       cls.opendate = __a__['opendate']
       cls.estimatedsettlementstatementreceived = __a__['estimatedsettlementstatementreceived']
       cls.titlecompany = __a__['titlecompany']
       cls.escrowofficer = __a__['escrowofficer']
       cls.email = __a__['email']
       cls.phone = __a__['phone']
       cls.escrownumberrelatedcurrentfile = __a__['escrownumberrelatedcurrentfile']
       cls.datetitlesearchordered = __a__['datetitlesearchordered']
       cls.titlecompanyaddress1 = __a__['titlecompanyaddress1']
       cls.titlecompanyaddress2 = __a__['titlecompanyaddress2']
       cls.titlecompanycity = __a__['titlecompanycity']
       cls.titlecompanystate = __a__['titlecompanystate']
       cls.titlecompanyzip = __a__['titlecompanyzip']
       cls.earnestmoneydepositamount = __a__['earnestmoneydepositamount']
       cls.earnestmoneydepositdate = __a__['earnestmoneydepositdate']
    } else {
       doAlert(`escrowinfo: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class expenses {
  constructor() {
    this['_currentrent'] = ''
    this['_currentrentperiod'] = 'monthly'
    this['_currentfirstmortgage'] = ''
    this['_currentfirstmortgageperiod'] = 'monthly'
    this['_currentotherfinancing'] = ''
    this['_currentotherfinancingperiod'] = 'monthly'
    this['_currenthazardinsurance'] = ''
    this['_currenthazardinsuranceperiod'] = 'monthly'
    this['_currentrealestatetaxes'] = ''
    this['_currentrealestatetaxesperiod'] = 'monthly'
    this['_currentdues'] = ''
    this['_currentduesperiod'] = 'monthly'
    this['_currentmortgageinsurance'] = ''
    this['_currentmortgageinsuranceperiod'] = 'monthly'
    this['_currentother'] = ''
    this['_currentotherperiod'] = 'monthly'
  }
  get currentrent() { return this['_currentrent'] }
  set currentrent(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_currentrent'])) {
      setDirtyFlag()
      this['_currentrent'] = __v__
    }
  }
  get currentrentperiod() { return this['_currentrentperiod'] }
  set currentrentperiod(__a__) {
    let __v__ = enumReader(['monthly','yearly','daily','hourly'],'monthly')(__a__)
    if(!_.isEqual(__v__,this['_currentrentperiod'])) {
      setDirtyFlag()
      this['_currentrentperiod'] = __v__
    }
  }
  get currentfirstmortgage() { return this['_currentfirstmortgage'] }
  set currentfirstmortgage(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_currentfirstmortgage'])) {
      setDirtyFlag()
      this['_currentfirstmortgage'] = __v__
    }
  }
  get currentfirstmortgageperiod() { return this['_currentfirstmortgageperiod'] }
  set currentfirstmortgageperiod(__a__) {
    let __v__ = enumReader(['monthly','yearly','daily','hourly'],'monthly')(__a__)
    if(!_.isEqual(__v__,this['_currentfirstmortgageperiod'])) {
      setDirtyFlag()
      this['_currentfirstmortgageperiod'] = __v__
    }
  }
  get currentotherfinancing() { return this['_currentotherfinancing'] }
  set currentotherfinancing(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_currentotherfinancing'])) {
      setDirtyFlag()
      this['_currentotherfinancing'] = __v__
    }
  }
  get currentotherfinancingperiod() { return this['_currentotherfinancingperiod'] }
  set currentotherfinancingperiod(__a__) {
    let __v__ = enumReader(['monthly','yearly','daily','hourly'],'monthly')(__a__)
    if(!_.isEqual(__v__,this['_currentotherfinancingperiod'])) {
      setDirtyFlag()
      this['_currentotherfinancingperiod'] = __v__
    }
  }
  get currenthazardinsurance() { return this['_currenthazardinsurance'] }
  set currenthazardinsurance(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_currenthazardinsurance'])) {
      setDirtyFlag()
      this['_currenthazardinsurance'] = __v__
    }
  }
  get currenthazardinsuranceperiod() { return this['_currenthazardinsuranceperiod'] }
  set currenthazardinsuranceperiod(__a__) {
    let __v__ = enumReader(['monthly','yearly','daily','hourly'],'monthly')(__a__)
    if(!_.isEqual(__v__,this['_currenthazardinsuranceperiod'])) {
      setDirtyFlag()
      this['_currenthazardinsuranceperiod'] = __v__
    }
  }
  get currentrealestatetaxes() { return this['_currentrealestatetaxes'] }
  set currentrealestatetaxes(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_currentrealestatetaxes'])) {
      setDirtyFlag()
      this['_currentrealestatetaxes'] = __v__
    }
  }
  get currentrealestatetaxesperiod() { return this['_currentrealestatetaxesperiod'] }
  set currentrealestatetaxesperiod(__a__) {
    let __v__ = enumReader(['monthly','yearly','daily','hourly'],'monthly')(__a__)
    if(!_.isEqual(__v__,this['_currentrealestatetaxesperiod'])) {
      setDirtyFlag()
      this['_currentrealestatetaxesperiod'] = __v__
    }
  }
  get currentdues() { return this['_currentdues'] }
  set currentdues(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_currentdues'])) {
      setDirtyFlag()
      this['_currentdues'] = __v__
    }
  }
  get currentduesperiod() { return this['_currentduesperiod'] }
  set currentduesperiod(__a__) {
    let __v__ = enumReader(['monthly','yearly','daily','hourly'],'monthly')(__a__)
    if(!_.isEqual(__v__,this['_currentduesperiod'])) {
      setDirtyFlag()
      this['_currentduesperiod'] = __v__
    }
  }
  get currentmortgageinsurance() { return this['_currentmortgageinsurance'] }
  set currentmortgageinsurance(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_currentmortgageinsurance'])) {
      setDirtyFlag()
      this['_currentmortgageinsurance'] = __v__
    }
  }
  get currentmortgageinsuranceperiod() { return this['_currentmortgageinsuranceperiod'] }
  set currentmortgageinsuranceperiod(__a__) {
    let __v__ = enumReader(['monthly','yearly','daily','hourly'],'monthly')(__a__)
    if(!_.isEqual(__v__,this['_currentmortgageinsuranceperiod'])) {
      setDirtyFlag()
      this['_currentmortgageinsuranceperiod'] = __v__
    }
  }
  get currentother() { return this['_currentother'] }
  set currentother(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_currentother'])) {
      setDirtyFlag()
      this['_currentother'] = __v__
    }
  }
  get currentotherperiod() { return this['_currentotherperiod'] }
  set currentotherperiod(__a__) {
    let __v__ = enumReader(['monthly','yearly','daily','hourly'],'monthly')(__a__)
    if(!_.isEqual(__v__,this['_currentotherperiod'])) {
      setDirtyFlag()
      this['_currentotherperiod'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new expenses()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.currentrent = __a__['currentrent']
       cls.currentrentperiod = __a__['currentrentperiod']
       cls.currentfirstmortgage = __a__['currentfirstmortgage']
       cls.currentfirstmortgageperiod = __a__['currentfirstmortgageperiod']
       cls.currentotherfinancing = __a__['currentotherfinancing']
       cls.currentotherfinancingperiod = __a__['currentotherfinancingperiod']
       cls.currenthazardinsurance = __a__['currenthazardinsurance']
       cls.currenthazardinsuranceperiod = __a__['currenthazardinsuranceperiod']
       cls.currentrealestatetaxes = __a__['currentrealestatetaxes']
       cls.currentrealestatetaxesperiod = __a__['currentrealestatetaxesperiod']
       cls.currentdues = __a__['currentdues']
       cls.currentduesperiod = __a__['currentduesperiod']
       cls.currentmortgageinsurance = __a__['currentmortgageinsurance']
       cls.currentmortgageinsuranceperiod = __a__['currentmortgageinsuranceperiod']
       cls.currentother = __a__['currentother']
       cls.currentotherperiod = __a__['currentotherperiod']
    } else {
       doAlert(`expenses: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class fees {
  constructor() {
    this['_closingCostsDetail'] = null
    this['_recordingandgovernmentfees'] = 0
    this['_transfertax'] = 0
    this['_othercosts'] = []
    this['_prepaids'] = []
    this['_initialescrowpaymentsatclosing'] = []
    this['_closingcostsfinanced'] = 0
    this['_downpayment'] = 0
    this['_deposit'] = 0
    this['_fundsforborrower'] = 0
    this['_sellerscredits'] = 0
    this['_adjustmentsothercredits'] = 0
  }
  get closingCostsDetail() { return this['_closingCostsDetail'] }
  set closingCostsDetail(__a__) {
    if(__a__ == null) {
      if(this['_closingCostsDetail'] == null) { return }
      setDirtyFlag()
      this['_closingCostsDetail'] = null
      return
    } else {
      setDirtyFlag()
      this['_closingCostsDetail'] = __a__
    }
  }
  get recordingandgovernmentfees() { return this['_recordingandgovernmentfees'] }
  set recordingandgovernmentfees(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_recordingandgovernmentfees'])) {
      setDirtyFlag()
      this['_recordingandgovernmentfees'] = __v__
    }
  }
  get transfertax() { return this['_transfertax'] }
  set transfertax(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_transfertax'])) {
      setDirtyFlag()
      this['_transfertax'] = __v__
    }
  }
  get othercosts() { return this['_othercosts'] }
  set othercosts(__a__) {
    setDirtyFlag()
    this['_othercosts'] = __a__
  }
  get prepaids() { return this['_prepaids'] }
  set prepaids(__a__) {
    setDirtyFlag()
    this['_prepaids'] = __a__
  }
  get initialescrowpaymentsatclosing() { return this['_initialescrowpaymentsatclosing'] }
  set initialescrowpaymentsatclosing(__a__) {
    setDirtyFlag()
    this['_initialescrowpaymentsatclosing'] = __a__
  }
  get closingcostsfinanced() { return this['_closingcostsfinanced'] }
  set closingcostsfinanced(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_closingcostsfinanced'])) {
      setDirtyFlag()
      this['_closingcostsfinanced'] = __v__
    }
  }
  get downpayment() { return this['_downpayment'] }
  set downpayment(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_downpayment'])) {
      setDirtyFlag()
      this['_downpayment'] = __v__
    }
  }
  get deposit() { return this['_deposit'] }
  set deposit(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_deposit'])) {
      setDirtyFlag()
      this['_deposit'] = __v__
    }
  }
  get fundsforborrower() { return this['_fundsforborrower'] }
  set fundsforborrower(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_fundsforborrower'])) {
      setDirtyFlag()
      this['_fundsforborrower'] = __v__
    }
  }
  get sellerscredits() { return this['_sellerscredits'] }
  set sellerscredits(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_sellerscredits'])) {
      setDirtyFlag()
      this['_sellerscredits'] = __v__
    }
  }
  get adjustmentsothercredits() { return this['_adjustmentsothercredits'] }
  set adjustmentsothercredits(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_adjustmentsothercredits'])) {
      setDirtyFlag()
      this['_adjustmentsothercredits'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new fees()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.closingCostsDetail = __a__['closingCostsDetail'] == null ? null : ClosingCostsDetail.fromJson(__a__['closingCostsDetail'])
       cls.recordingandgovernmentfees = __a__['recordingandgovernmentfees']
       cls.transfertax = __a__['transfertax']
       cls.othercosts = array1Reader(charge.fromJson)(__a__['othercosts'])
       cls.prepaids = array1Reader(payment.fromJson)(__a__['prepaids'])
       cls.initialescrowpaymentsatclosing = array1Reader(payment.fromJson)(__a__['initialescrowpaymentsatclosing'])
       cls.closingcostsfinanced = __a__['closingcostsfinanced']
       cls.downpayment = __a__['downpayment']
       cls.deposit = __a__['deposit']
       cls.fundsforborrower = __a__['fundsforborrower']
       cls.sellerscredits = __a__['sellerscredits']
       cls.adjustmentsothercredits = __a__['adjustmentsothercredits']
    } else {
       doAlert(`fees: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class file {
  constructor() {
    this['_serialId'] = 0
    this['_filename'] = ''
    this['_mimetype'] = ''
    this['_uploaded'] = ''
    this['_data'] = ''
    this['_comment'] = ''
    this['_forwhom'] = ''
  }
  get serialId() { return this['_serialId'] }
  set serialId(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_serialId'])) {
      setDirtyFlag()
      this['_serialId'] = __v__
    }
  }
  get filename() { return this['_filename'] }
  set filename(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_filename'])) {
      setDirtyFlag()
      this['_filename'] = __v__
    }
  }
  get mimetype() { return this['_mimetype'] }
  set mimetype(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_mimetype'])) {
      setDirtyFlag()
      this['_mimetype'] = __v__
    }
  }
  get uploaded() { return this['_uploaded'] }
  set uploaded(__a__) {
    let __v__ = DateSReader('')(__a__)
    if(!_.isEqual(__v__,this['_uploaded'])) {
      setDirtyFlag()
      this['_uploaded'] = __v__
    }
  }
  get data() { return this['_data'] }
  set data(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_data'])) {
      setDirtyFlag()
      this['_data'] = __v__
    }
  }
  get comment() { return this['_comment'] }
  set comment(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_comment'])) {
      setDirtyFlag()
      this['_comment'] = __v__
    }
  }
  get forwhom() { return this['_forwhom'] }
  set forwhom(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_forwhom'])) {
      setDirtyFlag()
      this['_forwhom'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new file()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.serialId = __a__['serialId']
       cls.filename = __a__['filename']
       cls.mimetype = __a__['mimetype']
       cls.uploaded = __a__['uploaded']
       cls.data = __a__['data']
       cls.comment = __a__['comment']
       cls.forwhom = __a__['forwhom']
    } else {
       doAlert(`file: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class finances {
  constructor() {
    this['_alimony'] = null
  }
  get alimony() { return this['_alimony'] }
  set alimony(__a__) {
    setDirtyFlag()
    this['_alimony'] = __a__
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new finances()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.alimony = __a__['alimony'] == null ? null : array1Reader(alimony.fromJson)(__a__['alimony'])
    } else {
       doAlert(`finances: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class gift {
  constructor() {
    this['_assettype'] = 'Bond'
    this['_deposited'] = null
    this['_sourcedescription'] = ''
    this['_source'] = 'Other'
    this['_value'] = ''
    this['_key'] = ''
    this['_attribution'] = null
    this['_ownership'] = 'Borrower'
  }
  get assettype() { return this['_assettype'] }
  set assettype(__a__) {
    let __v__ = enumReader(['Bond','BridgeLoanNotDeposited','CashOnHand','CertificateOfDepositTimeDeposit','CheckingAccount','GiftOfCash','GiftOfPropertyEquity','Grant','IndividualDevelopmentAccount','LifeInsurance','MoneyMarketFund','MutualFund','Other','PendingNetSaleProceedsFromRealEstateAssets','ProceedsFromSaleOfNonRealEstateAsset','ProceedsFromSecuredLoan','ProceedsFromUnsecuredLoan','RetirementFund','SavingsAccount','Stock','StockOptions','TrustAccount'],'Bond')(__a__)
    if(!_.isEqual(__v__,this['_assettype'])) {
      setDirtyFlag()
      this['_assettype'] = __v__
    }
  }
  get deposited() { return this['_deposited'] }
  set deposited(__a__) {
    if(__a__ == null) {
      if(this['_deposited'] == null) { return }
      setDirtyFlag()
      this['_deposited'] = null
      return
    } else {
      let __v__ = boolReader(false)(__a__)
      if(!_.isEqual(__v__,this['_deposited'])) {
        setDirtyFlag()
        this['_deposited'] = __v__
      }
    }
  }
  get sourcedescription() { return this['_sourcedescription'] }
  set sourcedescription(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_sourcedescription'])) {
      setDirtyFlag()
      this['_sourcedescription'] = __v__
    }
  }
  get source() { return this['_source'] }
  set source(__a__) {
    let __v__ = enumReader(['CommunityNonProfit','Employer','FederalAgency','LocalAgency','Relative','ReligiousNonProfit','StateAgency','UnmarriedPartner','Lender','Other'],'Other')(__a__)
    if(!_.isEqual(__v__,this['_source'])) {
      setDirtyFlag()
      this['_source'] = __v__
    }
  }
  get value() { return this['_value'] }
  set value(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_value'])) {
      setDirtyFlag()
      this['_value'] = __v__
    }
  }
  get key() { return this['_key'] }
  set key(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_key'])) {
      setDirtyFlag()
      this['_key'] = __v__
    }
  }
  get attribution() { return this['_attribution'] }
  set attribution(__a__) {
    if(__a__ == null) {
      if(this['_attribution'] == null) { return }
      setDirtyFlag()
      this['_attribution'] = null
      return
    } else {
      let __v__ = intReader(0)(__a__)
      if(!_.isEqual(__v__,this['_attribution'])) {
        setDirtyFlag()
        this['_attribution'] = __v__
      }
    }
  }
  get ownership() { return this['_ownership'] }
  set ownership(__a__) {
    let __v__ = enumReader(['Borrower','CoBorrower','Joint'],'Borrower')(__a__)
    if(!_.isEqual(__v__,this['_ownership'])) {
      setDirtyFlag()
      this['_ownership'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new gift()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.assettype = __a__['assettype']
       cls.deposited = __a__['deposited'] == null ? null : __a__['deposited']
       cls.sourcedescription = __a__['sourcedescription']
       cls.source = __a__['source']
       cls.value = __a__['value']
       cls.key = __a__['key']
       cls.attribution = __a__['attribution'] == null ? null : __a__['attribution']
       cls.ownership = __a__['ownership']
    } else {
       doAlert(`gift: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class income {
  constructor() {
    this['_hasdividends'] = null
    this['_dividendsmonthly'] = 'yearly'
    this['_dividends'] = ''
    this['_netrentalmonthly'] = 'monthly'
    this['_netrental'] = '0'
    this['_otherincomemonthly'] = 'monthly'
    this['_otherincome'] = null
  }
  get hasdividends() { return this['_hasdividends'] }
  set hasdividends(__a__) {
    if(__a__ == null) {
      if(this['_hasdividends'] == null) { return }
      setDirtyFlag()
      this['_hasdividends'] = null
      return
    } else {
      let __v__ = boolReader(false)(__a__)
      if(!_.isEqual(__v__,this['_hasdividends'])) {
        setDirtyFlag()
        this['_hasdividends'] = __v__
      }
    }
  }
  get dividendsmonthly() { return this['_dividendsmonthly'] }
  set dividendsmonthly(__a__) {
    let __v__ = enumReader(['monthly','yearly','daily','hourly'],'yearly')(__a__)
    if(!_.isEqual(__v__,this['_dividendsmonthly'])) {
      setDirtyFlag()
      this['_dividendsmonthly'] = __v__
    }
  }
  get dividends() { return this['_dividends'] }
  set dividends(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_dividends'])) {
      setDirtyFlag()
      this['_dividends'] = __v__
    }
  }
  get netrentalmonthly() { return this['_netrentalmonthly'] }
  set netrentalmonthly(__a__) {
    let __v__ = enumReader(['monthly','yearly','daily','hourly'],'monthly')(__a__)
    if(!_.isEqual(__v__,this['_netrentalmonthly'])) {
      setDirtyFlag()
      this['_netrentalmonthly'] = __v__
    }
  }
  get netrental() { return this['_netrental'] }
  set netrental(__a__) {
    let __v__ = DollarSReader('0')(__a__)
    if(!_.isEqual(__v__,this['_netrental'])) {
      setDirtyFlag()
      this['_netrental'] = __v__
    }
  }
  get otherincomemonthly() { return this['_otherincomemonthly'] }
  set otherincomemonthly(__a__) {
    let __v__ = enumReader(['monthly','yearly','daily','hourly'],'monthly')(__a__)
    if(!_.isEqual(__v__,this['_otherincomemonthly'])) {
      setDirtyFlag()
      this['_otherincomemonthly'] = __v__
    }
  }
  get otherincome() { return this['_otherincome'] }
  set otherincome(__a__) {
    setDirtyFlag()
    this['_otherincome'] = __a__
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new income()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.hasdividends = __a__['hasdividends'] == null ? null : __a__['hasdividends']
       cls.dividendsmonthly = __a__['dividendsmonthly']
       cls.dividends = __a__['dividends']
       cls.netrentalmonthly = __a__['netrentalmonthly']
       cls.netrental = __a__['netrental']
       cls.otherincomemonthly = __a__['otherincomemonthly']
       cls.otherincome = __a__['otherincome'] == null ? null : array1Reader(otherincome.fromJson)(__a__['otherincome'])
    } else {
       doAlert(`income: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class insurance {
  constructor() {
    this['_issuer'] = ''
    this['_netvalue'] = ''
    this['_facevalue'] = ''
    this['_key'] = ''
    this['_attribution'] = null
  }
  get issuer() { return this['_issuer'] }
  set issuer(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_issuer'])) {
      setDirtyFlag()
      this['_issuer'] = __v__
    }
  }
  get netvalue() { return this['_netvalue'] }
  set netvalue(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_netvalue'])) {
      setDirtyFlag()
      this['_netvalue'] = __v__
    }
  }
  get facevalue() { return this['_facevalue'] }
  set facevalue(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_facevalue'])) {
      setDirtyFlag()
      this['_facevalue'] = __v__
    }
  }
  get key() { return this['_key'] }
  set key(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_key'])) {
      setDirtyFlag()
      this['_key'] = __v__
    }
  }
  get attribution() { return this['_attribution'] }
  set attribution(__a__) {
    if(__a__ == null) {
      if(this['_attribution'] == null) { return }
      setDirtyFlag()
      this['_attribution'] = null
      return
    } else {
      let __v__ = intReader(0)(__a__)
      if(!_.isEqual(__v__,this['_attribution'])) {
        setDirtyFlag()
        this['_attribution'] = __v__
      }
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new insurance()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.issuer = __a__['issuer']
       cls.netvalue = __a__['netvalue']
       cls.facevalue = __a__['facevalue']
       cls.key = __a__['key']
       cls.attribution = __a__['attribution'] == null ? null : __a__['attribution']
    } else {
       doAlert(`insurance: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class interviewstep {
  constructor() {
    this['_step'] = 0
    this['_max'] = 0
    this['_interviewstarted'] = false
    this['_productselectionstarted'] = false
    this['_interviewfinished'] = false
  }
  get step() { return this['_step'] }
  set step(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_step'])) {
      setDirtyFlag()
      this['_step'] = __v__
    }
  }
  get max() { return this['_max'] }
  set max(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_max'])) {
      setDirtyFlag()
      this['_max'] = __v__
    }
  }
  get interviewstarted() { return this['_interviewstarted'] }
  set interviewstarted(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_interviewstarted'])) {
      setDirtyFlag()
      this['_interviewstarted'] = __v__
    }
  }
  get productselectionstarted() { return this['_productselectionstarted'] }
  set productselectionstarted(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_productselectionstarted'])) {
      setDirtyFlag()
      this['_productselectionstarted'] = __v__
    }
  }
  get interviewfinished() { return this['_interviewfinished'] }
  set interviewfinished(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_interviewfinished'])) {
      setDirtyFlag()
      this['_interviewfinished'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new interviewstep()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.step = __a__['step']
       cls.max = __a__['max']
       cls.interviewstarted = __a__['interviewstarted']
       cls.productselectionstarted = __a__['productselectionstarted']
       cls.interviewfinished = __a__['interviewfinished']
    } else {
       doAlert(`interviewstep: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class lender {
  constructor() {
    this['_name'] = ''
    this['_licenseid'] = 0
    this['_loanofficername'] = ''
    this['_loanofficerlicenseid'] = 0
    this['_email'] = ''
    this['_phone'] = ''
  }
  get name() { return this['_name'] }
  set name(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_name'])) {
      setDirtyFlag()
      this['_name'] = __v__
    }
  }
  get licenseid() { return this['_licenseid'] }
  set licenseid(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_licenseid'])) {
      setDirtyFlag()
      this['_licenseid'] = __v__
    }
  }
  get loanofficername() { return this['_loanofficername'] }
  set loanofficername(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_loanofficername'])) {
      setDirtyFlag()
      this['_loanofficername'] = __v__
    }
  }
  get loanofficerlicenseid() { return this['_loanofficerlicenseid'] }
  set loanofficerlicenseid(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_loanofficerlicenseid'])) {
      setDirtyFlag()
      this['_loanofficerlicenseid'] = __v__
    }
  }
  get email() { return this['_email'] }
  set email(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_email'])) {
      setDirtyFlag()
      this['_email'] = __v__
    }
  }
  get phone() { return this['_phone'] }
  set phone(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_phone'])) {
      setDirtyFlag()
      this['_phone'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new lender()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.name = __a__['name']
       cls.licenseid = __a__['licenseid']
       cls.loanofficername = __a__['loanofficername']
       cls.loanofficerlicenseid = __a__['loanofficerlicenseid']
       cls.email = __a__['email']
       cls.phone = __a__['phone']
    } else {
       doAlert(`lender: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class liabilities {
  constructor() {
    this['_loans'] = []
    this['_categories'] = new CategorizedLoans()
  }
  get loans() { return this['_loans'] }
  set loans(__a__) {
    setDirtyFlag()
    this['_loans'] = __a__
  }
  get categories() { return this['_categories'] }
  set categories(__a__) {
    setDirtyFlag()
    this['_categories'] = __a__
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new liabilities()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.loans = array1Reader(loan.fromJson)(__a__['loans'])
       cls.categories = CategorizedLoans.fromJson(__a__['categories'])
    } else {
       doAlert(`liabilities: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class loan {
  constructor() {
    this['_openeddate'] = ''
    this['_name'] = ''
    this['_address'] = ''
    this['_accountnumber'] = ''
    this['_monthlypayment'] = ''
    this['_monthlydefinedbycustomer'] = false
    this['_remainingbalance'] = ''
    this['_highbalance'] = ''
    this['_monthslefttopay'] = ''
    this['_mannerofpaymentcode'] = null
    this['_currentratingtype'] = null
    this['_creditloantype'] = null
    this['_creditliabilityShownOwnershipType'] = 'Borrower'
    this['_creditliabilityaccounttype'] = null
    this['_creditliabilityaccountownershiptype'] = null
    this['_creditliabilityaccountstatustype'] = null
    this['_detailcreditbusinesstype'] = null
    this['_creditliabilityhighestadverserating'] = null
    this['_reportedby'] = []
    this['_deferredpaymentamount'] = ''
    this['_deferredpaymentdate'] = ''
    this['_comment'] = ''
    this['_forsubjectproperty'] = null
    this['_forprimaryresidence'] = null
    this['_includesmi'] = null
    this['_isprimary'] = null
    this['_satisfiedupon'] = null
    this['_rate'] = ''
    this['_correction'] = 'none'
    this['_explanation'] = ''
    this['_attribution'] = null
    this['_propertyaddress'] = ''
    this['_partoforiginalpurchase'] = null
    this['_key'] = ''
    this['_paidoffatclosing'] = ''
    this['_creditlimit'] = ''
    this['_dataSource'] = ''
    this['_updateTime'] = ''
  }
  get openeddate() { return this['_openeddate'] }
  set openeddate(__a__) {
    let __v__ = DateSReader('')(__a__)
    if(!_.isEqual(__v__,this['_openeddate'])) {
      setDirtyFlag()
      this['_openeddate'] = __v__
    }
  }
  get name() { return this['_name'] }
  set name(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_name'])) {
      setDirtyFlag()
      this['_name'] = __v__
    }
  }
  get address() { return this['_address'] }
  set address(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_address'])) {
      setDirtyFlag()
      this['_address'] = __v__
    }
  }
  get accountnumber() { return this['_accountnumber'] }
  set accountnumber(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_accountnumber'])) {
      setDirtyFlag()
      this['_accountnumber'] = __v__
    }
  }
  get monthlypayment() { return this['_monthlypayment'] }
  set monthlypayment(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_monthlypayment'])) {
      setDirtyFlag()
      this['_monthlypayment'] = __v__
    }
  }
  get monthlydefinedbycustomer() { return this['_monthlydefinedbycustomer'] }
  set monthlydefinedbycustomer(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_monthlydefinedbycustomer'])) {
      setDirtyFlag()
      this['_monthlydefinedbycustomer'] = __v__
    }
  }
  get remainingbalance() { return this['_remainingbalance'] }
  set remainingbalance(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_remainingbalance'])) {
      setDirtyFlag()
      this['_remainingbalance'] = __v__
    }
  }
  get highbalance() { return this['_highbalance'] }
  set highbalance(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_highbalance'])) {
      setDirtyFlag()
      this['_highbalance'] = __v__
    }
  }
  get monthslefttopay() { return this['_monthslefttopay'] }
  set monthslefttopay(__a__) {
    let __v__ = IntSReader('')(__a__)
    if(!_.isEqual(__v__,this['_monthslefttopay'])) {
      setDirtyFlag()
      this['_monthslefttopay'] = __v__
    }
  }
  get mannerofpaymentcode() { return this['_mannerofpaymentcode'] }
  set mannerofpaymentcode(__a__) {
    if(__a__ == null) {
      if(this['_mannerofpaymentcode'] == null) { return }
      setDirtyFlag()
      this['_mannerofpaymentcode'] = null
      return
    } else {
      let __v__ = enumReader(['-','X','C','1','2','3','4','5','6','7','8','9'],'-')(__a__)
      if(!_.isEqual(__v__,this['_mannerofpaymentcode'])) {
        setDirtyFlag()
        this['_mannerofpaymentcode'] = __v__
      }
    }
  }
  get currentratingtype() { return this['_currentratingtype'] }
  set currentratingtype(__a__) {
    if(__a__ == null) {
      if(this['_currentratingtype'] == null) { return }
      setDirtyFlag()
      this['_currentratingtype'] = null
      return
    } else {
      let __v__ = enumReader(['NoDataAvailable','TooNew','AsAgreed','Late30Days','Late60Days','Late90Days','LateOver120Days','WageEarnerPlan','BankruptcyOrWageEarnerPlan','Foreclosure','Repossession','ForeclosureOrRepossession','Collection','ChargeOff','CollectionOrChargeOff'],'NoDataAvailable')(__a__)
      if(!_.isEqual(__v__,this['_currentratingtype'])) {
        setDirtyFlag()
        this['_currentratingtype'] = __v__
      }
    }
  }
  get creditloantype() { return this['_creditloantype'] }
  set creditloantype(__a__) {
    if(__a__ == null) {
      if(this['_creditloantype'] == null) { return }
      setDirtyFlag()
      this['_creditloantype'] = null
      return
    } else {
      let __v__ = enumReader(['Agriculture','Airplane','ApplianceOrFurniture','AttorneyFees','AutoLease','AutoLoanEquityTransfer','Automobile','AutoRefinance','BiMonthlyMortgageTermsInYears','Boat','Business','BusinessCreditCard','Camper','ChargeAccount','CheckCreditOrLineOfCredit','ChildSupport','Collection','CollectionAttorney','Comaker','CombinedCreditPlan','CommercialCreditObligation','CommercialLineOfCredit','CommercialMortgage','ConditionalSalesContract','ConditionalSalesContractRefinance','Consolidation','ConstructionLoan','ConventionalRealEstateMortgage','CreditCard','CreditLineSecured','DebitCard','DebtCounselingService','DeferredStudentLoan','DepositRelated','Educational','Employment','FactoringCompanyAccount','FamilySupport','FarmersHomeAdministrationFHMA','FederalConsolidatedLoan','FHAComakerNotBorrower','FHAHomeImprovement','FHARealEstateMortgage','FinanceStatement','GovernmentBenefit','GovernmentEmployeeAdvance','GovernmentFeeForService','GovernmentFine','GovernmentGrant','GovernmentMiscellaneousDebt','GovernmentOverpayment','GovernmentSecuredDirectLoan','GovernmentSecuredGuaranteeLoan','GovernmentUnsecuredDirectLoan','GovernmentUnsecuredGuaranteeLoan','HomeEquity','HomeEquityLineOfCredit','HomeImprovement','HouseholdGoods','HouseholdGoodsAndOtherCollateralAuto','HouseholdGoodsSecured','InstallmentLoan','InstallmentSalesContract','InsuranceClaims','Lease','LenderPlacedInsurance','ManualMortgage','ManufacturedHome','MedicalDebt','MobileHome','MobilePhone','Mortgage','NoteLoan','NoteLoanWithComaker','Other','PartiallySecured','PersonalLoan','RealEstateJuniorLiens','RealEstateLoanEquityTransfer','RealEstateMortgageWithoutOtherCollateral','RealEstateSpecificTypeUnknown','Recreational','RecreationalVehicle','Refinance','RefundAnticipationLoan','RentalAgreement','ResidentialLoan','ReturnedCheck','RevolvingBusinessLines','SecondMortgage','Secured','SecuredByCosigner','SecuredCreditCard','SecuredHomeImprovement','SemiMonthlyMortgagePayment','SinglePaymentLoan','SpouseSupport','SummaryOfAccountsWithSameStatus','TimeSharedLoan','Title1Loan','UnknownLoanType','Unsecured','USDA-RD','UtilityCompany','VeteransAdministrationLoan','VeteransAdministrationRealEstateMortgage'],'Agriculture')(__a__)
      if(!_.isEqual(__v__,this['_creditloantype'])) {
        setDirtyFlag()
        this['_creditloantype'] = __v__
      }
    }
  }
  get creditliabilityShownOwnershipType() { return this['_creditliabilityShownOwnershipType'] }
  set creditliabilityShownOwnershipType(__a__) {
    let __v__ = enumReader(['Borrower','CoBorrower','Joint'],'Borrower')(__a__)
    if(!_.isEqual(__v__,this['_creditliabilityShownOwnershipType'])) {
      setDirtyFlag()
      this['_creditliabilityShownOwnershipType'] = __v__
    }
  }
  get creditliabilityaccounttype() { return this['_creditliabilityaccounttype'] }
  set creditliabilityaccounttype(__a__) {
    if(__a__ == null) {
      if(this['_creditliabilityaccounttype'] == null) { return }
      setDirtyFlag()
      this['_creditliabilityaccounttype'] = null
      return
    } else {
      let __v__ = enumReader(['CreditLine','Installment','Mortgage','Open','Revolving','Unknown'],'CreditLine')(__a__)
      if(!_.isEqual(__v__,this['_creditliabilityaccounttype'])) {
        setDirtyFlag()
        this['_creditliabilityaccounttype'] = __v__
      }
    }
  }
  get creditliabilityaccountownershiptype() { return this['_creditliabilityaccountownershiptype'] }
  set creditliabilityaccountownershiptype(__a__) {
    if(__a__ == null) {
      if(this['_creditliabilityaccountownershiptype'] == null) { return }
      setDirtyFlag()
      this['_creditliabilityaccountownershiptype'] = null
      return
    } else {
      let __v__ = enumReader(['AuthorizedUser','Comaker','Deceased','Individual','JointContractualLiability','JointParticipating','Maker','OnBehalfOf','Terminated','Undesignated'],'AuthorizedUser')(__a__)
      if(!_.isEqual(__v__,this['_creditliabilityaccountownershiptype'])) {
        setDirtyFlag()
        this['_creditliabilityaccountownershiptype'] = __v__
      }
    }
  }
  get creditliabilityaccountstatustype() { return this['_creditliabilityaccountstatustype'] }
  set creditliabilityaccountstatustype(__a__) {
    if(__a__ == null) {
      if(this['_creditliabilityaccountstatustype'] == null) { return }
      setDirtyFlag()
      this['_creditliabilityaccountstatustype'] = null
      return
    } else {
      let __v__ = enumReader(['Closed','Frozen','Open','Paid','Refinanced','Transferred'],'Closed')(__a__)
      if(!_.isEqual(__v__,this['_creditliabilityaccountstatustype'])) {
        setDirtyFlag()
        this['_creditliabilityaccountstatustype'] = __v__
      }
    }
  }
  get detailcreditbusinesstype() { return this['_detailcreditbusinesstype'] }
  set detailcreditbusinesstype(__a__) {
    if(__a__ == null) {
      if(this['_detailcreditbusinesstype'] == null) { return }
      setDirtyFlag()
      this['_detailcreditbusinesstype'] = null
      return
    } else {
      let __v__ = enumReader(['AdvertisingAgencies','AdvertisingMiscellaneous','AdvertisingNewsMedia','AutomotiveAuctionsWholesale','AutomotiveDealersNew','AutomotiveDealersUsed','AutomotiveFarmImplementDealers','AutomotiveLeasing','AutomotiveMiscellaneous','AutomotiveParts','AutomotiveRental','AutomotiveRepairBodyShops','AutomotiveServiceStations','AutomotiveTBAStoresTireDealers','AutomotiveTruckDealers','BankingAllBanks','BankingBankcard','BankingCommercialIndustrial','BankingInstallmentLoansCreditLine','BankingMiscellaneous','BankingMortgageDepartment','BankingSavingsBanks','ClothingGeneral','ClothingMiscellaneous','ClothingSpecialtyShoeHatEtc','CollectionServicesACBOfA','CollectionServicesOther','ContractorsGeneral','ContractorsHomeImprovement','ContractorsMiscellaneous','ContractorsSubcontractors','DepartmentAndMailOrderCompleteDepartmentStores','DepartmentAndMailOrderMailOrderFirms','DepartmentAndMailOrderMiscellaneous','DepartmentAndMailOrderVarietyStores','EmploymentServices','FarmAndGardenSuppliesChemicalAndFertilizer','FarmAndGardenSuppliesFeedAndSeed','FarmAndGardenSuppliesMiscellaneous','FarmAndGardenSuppliesNurseryAndLandscaping','FinanceAutomobile','FinanceBailBonds','FinanceBrokerageAndInvestmentFirms','FinanceBulkPurchase','FinanceCreditUnions','FinanceEducation','FinanceFactoringCompanies','FinanceMiscellaneous','FinanceMortgageBrokers','FinanceMortgageCompanies','FinanceMortgageReporters','FinancePersonalLoanCompanies','FinanceSales','FinanceSavingsAndLoanAssociations','GovernmentCityAndCounty','GovernmentFederal','GovernmentMiscellaneous','GovernmentState','GroceryDairies','GroceryMiscellaneous','GroceryNeighborhood','GrocerySupermarkets','HomeFurnishingApplianceSalesAndService','HomeFurnishingCarpetAndFloorCoverings','HomeFurnishingElectronicsTelevisionAndRadio','HomeFurnishingFurniture','HomeFurnishingFurnitureRental','HomeFurnishingInteriorDecoratorsDesign','HomeFurnishingMiscellaneous','HomeFurnishingMusicAndRecords','InsuranceGeneral','InsuranceLife','InsuranceMiscellaneous','JewelryAndCameraCameras','JewelryAndCameraComputerSalesAndServices','JewelryAndCameraJewelry','JewelryAndCameraMiscellaneous','JewelryAndCameraVideoTapeRentalAndSales','LumberAndHardwareAirConditioningPlumbingElectrical','LumberAndHardwareFixtureAndCabinet','LumberAndHardwareLumberYards','LumberAndHardwareMiscellaneous','LumberAndHardwarePaintGlassAndPaper','LumberAndHardwareStores','MedicalAndHealthAnimalHospitals','MedicalAndHealthChiropractors','MedicalAndHealthDentists','MedicalAndHealthDoctorsAndClinics','MedicalAndHealthFuneralHomesAndCemeteries','MedicalAndHealthHospitals','MedicalAndHealthMedicalEquipment','MedicalAndHealthMiscellaneous','MedicalAndHealthOptometristsAndOpticalStores','MedicalAndHealthOsteopaths','MedicalAndHealthPharmaciesAndDrugs','MedicalAndHealthVeterinarians','MiscellaneousAuthenticationProducts','MiscellaneousCreditBureaus','MiscellaneousCreditReportBrokers','MiscellaneousOther','MiscellaneousRetail','MiscellaneousServices','MiscellaneousWholesale','OilAndNationalCreditCardsAirlineTravelCards','OilAndNationalCreditCardsCreditCardCompanies','OilAndNationalCreditCardsMiscellaneous','OilAndNationalCreditCardsOilCompanies','PersonalServicesNotMedicalAccountants','PersonalServicesNotMedicalBarbersBeautyShops','PersonalServicesNotMedicalCountryClubsRestaurants','PersonalServicesNotMedicalDetectiveInvestigativeServices','PersonalServicesNotMedicalDryCleaningLaundry','PersonalServicesNotMedicalEngineering','PersonalServicesNotMedicalEquipmentLeasing','PersonalServicesNotMedicalFlorists','PersonalServicesNotMedicalHealthAndFitnessClubs','PersonalServicesNotMedicalLegal','PersonalServicesNotMedicalMiscellaneous','PersonalServicesNotMedicalPestControl','PersonalServicesNotMedicalPhotographers','RealEstateAndPublicAccommodationApartments','RealEstateAndPublicAccommodationHotels','RealEstateAndPublicAccommodationMiscellaneous','RealEstateAndPublicAccommodationMobileHomes','RealEstateAndPublicAccommodationMotels','RealEstateAndPublicAccommodationOfficeLeasing','RealEstateAndPublicAccommodationPropertyManagement','RealEstateAndPublicAccommodationRealEstateSales','SportingGoodsAircraftSalesAndService','SportingGoodsBoatAndMarinas','SportingGoodsMiscellaneous','SportingGoodsMotorcycleAndBicycle','SportingGoodsStores','UtilitiesAndFuelCableSatelliteCompanies','UtilitiesAndFuelCoalAndWoodDealers','UtilitiesAndFuelElectricalLightAndPower','UtilitiesAndFuelFuelOilDealers','UtilitiesAndFuelGarbageAndRubbishDisposals','UtilitiesAndFuelGasNaturalAndBottled','UtilitiesAndFuelMiscellaneous','UtilitiesAndFuelTelephoneCompanies','UtilitiesAndFuelWaterCompanies','WholesaleAutomotiveSupplies','WholesaleBuildingAndHardwareSupply','WholesaleClothingAndDryGoods','WholesaleCreditCardProcessing','WholesaleDrugsAndChemicals','WholesaleGroceries','WholesaleHomeFurnishings','WholesaleMachineryAndEquipment','WholesaleMiscellaneous'],'AdvertisingAgencies')(__a__)
      if(!_.isEqual(__v__,this['_detailcreditbusinesstype'])) {
        setDirtyFlag()
        this['_detailcreditbusinesstype'] = __v__
      }
    }
  }
  get creditliabilityhighestadverserating() { return this['_creditliabilityhighestadverserating'] }
  set creditliabilityhighestadverserating(__a__) {
    if(__a__ == null) {
      if(this['_creditliabilityhighestadverserating'] == null) { return }
      setDirtyFlag()
      this['_creditliabilityhighestadverserating'] = null
      return
    } else {
      let __v__ = enumReader(['AsAgreed','BankruptcyOrWageEarnerPlan','ChargeOff','Collection','CollectionOrChargeOff','Foreclosure','ForeclosureOrRepossession','Late30Days','Late60Days','Late90Days','LateOver120Days','NoDataAvailable','Repossession','TooNew','WageEarnerPlan'],'AsAgreed')(__a__)
      if(!_.isEqual(__v__,this['_creditliabilityhighestadverserating'])) {
        setDirtyFlag()
        this['_creditliabilityhighestadverserating'] = __v__
      }
    }
  }
  get reportedby() { return this['_reportedby'] }
  set reportedby(__a__) {
    setDirtyFlag()
    this['_reportedby'] = __a__
  }
  get deferredpaymentamount() { return this['_deferredpaymentamount'] }
  set deferredpaymentamount(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_deferredpaymentamount'])) {
      setDirtyFlag()
      this['_deferredpaymentamount'] = __v__
    }
  }
  get deferredpaymentdate() { return this['_deferredpaymentdate'] }
  set deferredpaymentdate(__a__) {
    let __v__ = DateSReader('')(__a__)
    if(!_.isEqual(__v__,this['_deferredpaymentdate'])) {
      setDirtyFlag()
      this['_deferredpaymentdate'] = __v__
    }
  }
  get comment() { return this['_comment'] }
  set comment(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_comment'])) {
      setDirtyFlag()
      this['_comment'] = __v__
    }
  }
  get forsubjectproperty() { return this['_forsubjectproperty'] }
  set forsubjectproperty(__a__) {
    if(__a__ == null) {
      if(this['_forsubjectproperty'] == null) { return }
      setDirtyFlag()
      this['_forsubjectproperty'] = null
      return
    } else {
      let __v__ = boolReader(false)(__a__)
      if(!_.isEqual(__v__,this['_forsubjectproperty'])) {
        setDirtyFlag()
        this['_forsubjectproperty'] = __v__
      }
    }
  }
  get forprimaryresidence() { return this['_forprimaryresidence'] }
  set forprimaryresidence(__a__) {
    if(__a__ == null) {
      if(this['_forprimaryresidence'] == null) { return }
      setDirtyFlag()
      this['_forprimaryresidence'] = null
      return
    } else {
      let __v__ = boolReader(false)(__a__)
      if(!_.isEqual(__v__,this['_forprimaryresidence'])) {
        setDirtyFlag()
        this['_forprimaryresidence'] = __v__
      }
    }
  }
  get includesmi() { return this['_includesmi'] }
  set includesmi(__a__) {
    if(__a__ == null) {
      if(this['_includesmi'] == null) { return }
      setDirtyFlag()
      this['_includesmi'] = null
      return
    } else {
      let __v__ = boolReader(false)(__a__)
      if(!_.isEqual(__v__,this['_includesmi'])) {
        setDirtyFlag()
        this['_includesmi'] = __v__
      }
    }
  }
  get isprimary() { return this['_isprimary'] }
  set isprimary(__a__) {
    if(__a__ == null) {
      if(this['_isprimary'] == null) { return }
      setDirtyFlag()
      this['_isprimary'] = null
      return
    } else {
      let __v__ = boolReader(false)(__a__)
      if(!_.isEqual(__v__,this['_isprimary'])) {
        setDirtyFlag()
        this['_isprimary'] = __v__
      }
    }
  }
  get satisfiedupon() { return this['_satisfiedupon'] }
  set satisfiedupon(__a__) {
    if(__a__ == null) {
      if(this['_satisfiedupon'] == null) { return }
      setDirtyFlag()
      this['_satisfiedupon'] = null
      return
    } else {
      let __v__ = enumReader(['not','withproceeds','withownfunds'],'not')(__a__)
      if(!_.isEqual(__v__,this['_satisfiedupon'])) {
        setDirtyFlag()
        this['_satisfiedupon'] = __v__
      }
    }
  }
  get rate() { return this['_rate'] }
  set rate(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_rate'])) {
      setDirtyFlag()
      this['_rate'] = __v__
    }
  }
  get correction() { return this['_correction'] }
  set correction(__a__) {
    let __v__ = enumReader(['none','wrongperson','alreadyclosed','paidbybusiness','duplicate','other'],'none')(__a__)
    if(!_.isEqual(__v__,this['_correction'])) {
      setDirtyFlag()
      this['_correction'] = __v__
    }
  }
  get explanation() { return this['_explanation'] }
  set explanation(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_explanation'])) {
      setDirtyFlag()
      this['_explanation'] = __v__
    }
  }
  get attribution() { return this['_attribution'] }
  set attribution(__a__) {
    if(__a__ == null) {
      if(this['_attribution'] == null) { return }
      setDirtyFlag()
      this['_attribution'] = null
      return
    } else {
      let __v__ = intReader(0)(__a__)
      if(!_.isEqual(__v__,this['_attribution'])) {
        setDirtyFlag()
        this['_attribution'] = __v__
      }
    }
  }
  get propertyaddress() { return this['_propertyaddress'] }
  set propertyaddress(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_propertyaddress'])) {
      setDirtyFlag()
      this['_propertyaddress'] = __v__
    }
  }
  get partoforiginalpurchase() { return this['_partoforiginalpurchase'] }
  set partoforiginalpurchase(__a__) {
    if(__a__ == null) {
      if(this['_partoforiginalpurchase'] == null) { return }
      setDirtyFlag()
      this['_partoforiginalpurchase'] = null
      return
    } else {
      let __v__ = boolReader(false)(__a__)
      if(!_.isEqual(__v__,this['_partoforiginalpurchase'])) {
        setDirtyFlag()
        this['_partoforiginalpurchase'] = __v__
      }
    }
  }
  get key() { return this['_key'] }
  set key(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_key'])) {
      setDirtyFlag()
      this['_key'] = __v__
    }
  }
  get paidoffatclosing() { return this['_paidoffatclosing'] }
  set paidoffatclosing(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_paidoffatclosing'])) {
      setDirtyFlag()
      this['_paidoffatclosing'] = __v__
    }
  }
  get creditlimit() { return this['_creditlimit'] }
  set creditlimit(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_creditlimit'])) {
      setDirtyFlag()
      this['_creditlimit'] = __v__
    }
  }
  get dataSource() { return this['_dataSource'] }
  set dataSource(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_dataSource'])) {
      setDirtyFlag()
      this['_dataSource'] = __v__
    }
  }
  get updateTime() { return this['_updateTime'] }
  set updateTime(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_updateTime'])) {
      setDirtyFlag()
      this['_updateTime'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new loan()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.openeddate = __a__['openeddate']
       cls.name = __a__['name']
       cls.address = __a__['address']
       cls.accountnumber = __a__['accountnumber']
       cls.monthlypayment = __a__['monthlypayment']
       cls.monthlydefinedbycustomer = __a__['monthlydefinedbycustomer']
       cls.remainingbalance = __a__['remainingbalance']
       cls.highbalance = __a__['highbalance']
       cls.monthslefttopay = __a__['monthslefttopay']
       cls.mannerofpaymentcode = __a__['mannerofpaymentcode'] == null ? null : __a__['mannerofpaymentcode']
       cls.currentratingtype = __a__['currentratingtype'] == null ? null : __a__['currentratingtype']
       cls.creditloantype = __a__['creditloantype'] == null ? null : __a__['creditloantype']
       cls.creditliabilityShownOwnershipType = __a__['creditliabilityShownOwnershipType']
       cls.creditliabilityaccounttype = __a__['creditliabilityaccounttype'] == null ? null : __a__['creditliabilityaccounttype']
       cls.creditliabilityaccountownershiptype = __a__['creditliabilityaccountownershiptype'] == null ? null : __a__['creditliabilityaccountownershiptype']
       cls.creditliabilityaccountstatustype = __a__['creditliabilityaccountstatustype'] == null ? null : __a__['creditliabilityaccountstatustype']
       cls.detailcreditbusinesstype = __a__['detailcreditbusinesstype'] == null ? null : __a__['detailcreditbusinesstype']
       cls.creditliabilityhighestadverserating = __a__['creditliabilityhighestadverserating'] == null ? null : __a__['creditliabilityhighestadverserating']
       cls.reportedby = array1Reader(enumReader(['Equifax','Experian','TransUnion'],'Equifax'))(__a__['reportedby'])
       cls.deferredpaymentamount = __a__['deferredpaymentamount']
       cls.deferredpaymentdate = __a__['deferredpaymentdate']
       cls.comment = __a__['comment']
       cls.forsubjectproperty = __a__['forsubjectproperty'] == null ? null : __a__['forsubjectproperty']
       cls.forprimaryresidence = __a__['forprimaryresidence'] == null ? null : __a__['forprimaryresidence']
       cls.includesmi = __a__['includesmi'] == null ? null : __a__['includesmi']
       cls.isprimary = __a__['isprimary'] == null ? null : __a__['isprimary']
       cls.satisfiedupon = __a__['satisfiedupon'] == null ? null : __a__['satisfiedupon']
       cls.rate = __a__['rate']
       cls.correction = __a__['correction']
       cls.explanation = __a__['explanation']
       cls.attribution = __a__['attribution'] == null ? null : __a__['attribution']
       cls.propertyaddress = __a__['propertyaddress']
       cls.partoforiginalpurchase = __a__['partoforiginalpurchase'] == null ? null : __a__['partoforiginalpurchase']
       cls.key = __a__['key']
       cls.paidoffatclosing = __a__['paidoffatclosing']
       cls.creditlimit = __a__['creditlimit']
       cls.dataSource = __a__['dataSource']
       cls.updateTime = __a__['updateTime']
    } else {
       doAlert(`loan: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class loanOfficerTask {
  constructor() {
    this['_serialId'] = 0
    this['_id'] = ''
    this['_loanId'] = ''
    this['_task'] = ''
    this['_created'] = ''
    this['_deadline'] = ''
    this['_stage'] = 'TODOs'
    this['_subtasks'] = ''
    this['_listOfDocuments'] = []
  }
  get serialId() { return this['_serialId'] }
  set serialId(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_serialId'])) {
      setDirtyFlag()
      this['_serialId'] = __v__
    }
  }
  get id() { return this['_id'] }
  set id(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_id'])) {
      setDirtyFlag()
      this['_id'] = __v__
    }
  }
  get loanId() { return this['_loanId'] }
  set loanId(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_loanId'])) {
      setDirtyFlag()
      this['_loanId'] = __v__
    }
  }
  get task() { return this['_task'] }
  set task(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_task'])) {
      setDirtyFlag()
      this['_task'] = __v__
    }
  }
  get created() { return this['_created'] }
  set created(__a__) {
    let __v__ = DateSReader('')(__a__)
    if(!_.isEqual(__v__,this['_created'])) {
      setDirtyFlag()
      this['_created'] = __v__
    }
  }
  get deadline() { return this['_deadline'] }
  set deadline(__a__) {
    let __v__ = DateSReader('')(__a__)
    if(!_.isEqual(__v__,this['_deadline'])) {
      setDirtyFlag()
      this['_deadline'] = __v__
    }
  }
  get stage() { return this['_stage'] }
  set stage(__a__) {
    let __v__ = enumReader(['TODOs','In_Progress','Done'],'TODOs')(__a__)
    if(!_.isEqual(__v__,this['_stage'])) {
      setDirtyFlag()
      this['_stage'] = __v__
    }
  }
  get subtasks() { return this['_subtasks'] }
  set subtasks(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_subtasks'])) {
      setDirtyFlag()
      this['_subtasks'] = __v__
    }
  }
  get listOfDocuments() { return this['_listOfDocuments'] }
  set listOfDocuments(__a__) {
    setDirtyFlag()
    this['_listOfDocuments'] = __a__
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new loanOfficerTask()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.serialId = __a__['serialId']
       cls.id = __a__['id']
       cls.loanId = __a__['loanId']
       cls.task = __a__['task']
       cls.created = __a__['created']
       cls.deadline = __a__['deadline']
       cls.stage = __a__['stage']
       cls.subtasks = __a__['subtasks']
       cls.listOfDocuments = array1Reader(file.fromJson)(__a__['listOfDocuments'])
    } else {
       doAlert(`loanOfficerTask: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class loanofficercreditreport {
  constructor() {
    this['_errorMessages'] = null
    this['_creditscore'] = ''
    this['_personswithscoresandresidencies'] = []
    this['_liabilities'] = new liabilities()
    this['_publicrecords'] = []
  }
  get errorMessages() { return this['_errorMessages'] }
  set errorMessages(__a__) {
    setDirtyFlag()
    this['_errorMessages'] = __a__
  }
  get creditscore() { return this['_creditscore'] }
  set creditscore(__a__) {
    let __v__ = IntSReader('')(__a__)
    if(!_.isEqual(__v__,this['_creditscore'])) {
      setDirtyFlag()
      this['_creditscore'] = __v__
    }
  }
  get personswithscoresandresidencies() { return this['_personswithscoresandresidencies'] }
  set personswithscoresandresidencies(__a__) {
    setDirtyFlag()
    this['_personswithscoresandresidencies'] = __a__
  }
  get liabilities() { return this['_liabilities'] }
  set liabilities(__a__) {
    setDirtyFlag()
    this['_liabilities'] = __a__
  }
  get publicrecords() { return this['_publicrecords'] }
  set publicrecords(__a__) {
    setDirtyFlag()
    this['_publicrecords'] = __a__
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new loanofficercreditreport()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.errorMessages = __a__['errorMessages'] == null ? null : array1Reader(stringReader(''))(__a__['errorMessages'])
       cls.creditscore = __a__['creditscore']
       cls.personswithscoresandresidencies = array1Reader(personwithscoresandresidencies.fromJson)(__a__['personswithscoresandresidencies'])
       cls.liabilities = liabilities.fromJson(__a__['liabilities'])
       cls.publicrecords = array1Reader(publicrecordwithattribution.fromJson)(__a__['publicrecords'])
    } else {
       doAlert(`loanofficercreditreport: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class loanwithattribution {
  constructor() {
    this['_attribution'] = null
    this['_key'] = ''
    this['_loan'] = new loan()
  }
  get attribution() { return this['_attribution'] }
  set attribution(__a__) {
    if(__a__ == null) {
      if(this['_attribution'] == null) { return }
      setDirtyFlag()
      this['_attribution'] = null
      return
    } else {
      let __v__ = intReader(0)(__a__)
      if(!_.isEqual(__v__,this['_attribution'])) {
        setDirtyFlag()
        this['_attribution'] = __v__
      }
    }
  }
  get key() { return this['_key'] }
  set key(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_key'])) {
      setDirtyFlag()
      this['_key'] = __v__
    }
  }
  get loan() { return this['_loan'] }
  set loan(__a__) {
    setDirtyFlag()
    this['_loan'] = __a__
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new loanwithattribution()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.attribution = __a__['attribution'] == null ? null : __a__['attribution']
       cls.key = __a__['key']
       cls.loan = loan.fromJson(__a__['loan'])
    } else {
       doAlert(`loanwithattribution: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class locreditreportadditions {
  constructor() {
    this['_errorMessages'] = null
    this['_personswithscoresandresidencies'] = []
    this['_liabilities'] = new liabilities()
  }
  get errorMessages() { return this['_errorMessages'] }
  set errorMessages(__a__) {
    setDirtyFlag()
    this['_errorMessages'] = __a__
  }
  get personswithscoresandresidencies() { return this['_personswithscoresandresidencies'] }
  set personswithscoresandresidencies(__a__) {
    setDirtyFlag()
    this['_personswithscoresandresidencies'] = __a__
  }
  get liabilities() { return this['_liabilities'] }
  set liabilities(__a__) {
    setDirtyFlag()
    this['_liabilities'] = __a__
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new locreditreportadditions()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.errorMessages = __a__['errorMessages'] == null ? null : array1Reader(stringReader(''))(__a__['errorMessages'])
       cls.personswithscoresandresidencies = array1Reader(personwithscoresandresidencies.fromJson)(__a__['personswithscoresandresidencies'])
       cls.liabilities = liabilities.fromJson(__a__['liabilities'])
    } else {
       doAlert(`locreditreportadditions: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class newmortgage {
  constructor() {
    this['_creditor'] = ''
    this['_lientype'] = null
    this['_monthlyamount'] = ''
    this['_loanamount'] = ''
    this['_creditlimit'] = ''
    this['_key'] = ''
  }
  get creditor() { return this['_creditor'] }
  set creditor(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_creditor'])) {
      setDirtyFlag()
      this['_creditor'] = __v__
    }
  }
  get lientype() { return this['_lientype'] }
  set lientype(__a__) {
    if(__a__ == null) {
      if(this['_lientype'] == null) { return }
      setDirtyFlag()
      this['_lientype'] = null
      return
    } else {
      let __v__ = enumReader(['firstlien','subordinatelien'],'firstlien')(__a__)
      if(!_.isEqual(__v__,this['_lientype'])) {
        setDirtyFlag()
        this['_lientype'] = __v__
      }
    }
  }
  get monthlyamount() { return this['_monthlyamount'] }
  set monthlyamount(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_monthlyamount'])) {
      setDirtyFlag()
      this['_monthlyamount'] = __v__
    }
  }
  get loanamount() { return this['_loanamount'] }
  set loanamount(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_loanamount'])) {
      setDirtyFlag()
      this['_loanamount'] = __v__
    }
  }
  get creditlimit() { return this['_creditlimit'] }
  set creditlimit(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_creditlimit'])) {
      setDirtyFlag()
      this['_creditlimit'] = __v__
    }
  }
  get key() { return this['_key'] }
  set key(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_key'])) {
      setDirtyFlag()
      this['_key'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new newmortgage()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.creditor = __a__['creditor']
       cls.lientype = __a__['lientype'] == null ? null : __a__['lientype']
       cls.monthlyamount = __a__['monthlyamount']
       cls.loanamount = __a__['loanamount']
       cls.creditlimit = __a__['creditlimit']
       cls.key = __a__['key']
    } else {
       doAlert(`newmortgage: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class nonqm {
  constructor() {
    this['_nonqmincometype'] = []
    this['_nonqmincomeperiod'] = 'monthly'
    this['_nonqmincomeamount'] = ''
  }
  get nonqmincometype() { return this['_nonqmincometype'] }
  set nonqmincometype(__a__) {
    setDirtyFlag()
    this['_nonqmincometype'] = __a__
  }
  get nonqmincomeperiod() { return this['_nonqmincomeperiod'] }
  set nonqmincomeperiod(__a__) {
    let __v__ = enumReader(['monthly','yearly','daily','hourly'],'monthly')(__a__)
    if(!_.isEqual(__v__,this['_nonqmincomeperiod'])) {
      setDirtyFlag()
      this['_nonqmincomeperiod'] = __v__
    }
  }
  get nonqmincomeamount() { return this['_nonqmincomeamount'] }
  set nonqmincomeamount(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_nonqmincomeamount'])) {
      setDirtyFlag()
      this['_nonqmincomeamount'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new nonqm()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.nonqmincometype = array1Reader(enumReader(['FullDoc','FullDoc12Mo','FullDocWithAssets','VOE','VOE24Mo','PersonalBankStatement12Mo','PersonalBankStatement24Mo','BusinessBankStatement12Mo','BusinessBankStatement24Mo','Form109924Mo','Form109912Mo','PL24','PL12','PL','AssetDepletion','AssetUtilization','DebtServiceCoverageRatio','NoRatio'],'FullDoc'))(__a__['nonqmincometype'])
       cls.nonqmincomeperiod = __a__['nonqmincomeperiod']
       cls.nonqmincomeamount = __a__['nonqmincomeamount']
    } else {
       doAlert(`nonqm: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class notification {
  constructor() {
    this['_id'] = ''
    this['_text'] = ''
    this['_customer_id'] = ''
  }
  get id() { return this['_id'] }
  set id(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_id'])) {
      setDirtyFlag()
      this['_id'] = __v__
    }
  }
  get text() { return this['_text'] }
  set text(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_text'])) {
      setDirtyFlag()
      this['_text'] = __v__
    }
  }
  get customer_id() { return this['_customer_id'] }
  set customer_id(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_customer_id'])) {
      setDirtyFlag()
      this['_customer_id'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new notification()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.id = __a__['id']
       cls.text = __a__['text']
       cls.customer_id = __a__['customer_id']
    } else {
       doAlert(`notification: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class notifications {
  constructor() {
    this['_general'] = []
    this['_specific'] = []
  }
  get general() { return this['_general'] }
  set general(__a__) {
    setDirtyFlag()
    this['_general'] = __a__
  }
  get specific() { return this['_specific'] }
  set specific(__a__) {
    setDirtyFlag()
    this['_specific'] = __a__
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new notifications()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.general = array1Reader(notification.fromJson)(__a__['general'])
       cls.specific = array1Reader(notification.fromJson)(__a__['specific'])
    } else {
       doAlert(`notifications: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class occupation {
  constructor() {
    this['_hasoccupation'] = null
    this['_employername'] = ''
    this['_employeraddress'] = ''
    this['_from'] = ''
    this['_positiontitle'] = ''
    this['_typeofbusiness'] = ''
    this['_phone'] = ''
    this['_yearsatlineofwork'] = ''
    this['_monthsatlineofwork'] = ''
    this['_selfemployed'] = false
    this['_employedbyagent'] = false
    this['_percentownership'] = ''
    this['_incomeorloss'] = ''
    this['_incomeorlossperiod'] = 'monthly'
    this['_income'] = new employmentincome()
    this['_selfincomedoc'] = null
  }
  get hasoccupation() { return this['_hasoccupation'] }
  set hasoccupation(__a__) {
    if(__a__ == null) {
      if(this['_hasoccupation'] == null) { return }
      setDirtyFlag()
      this['_hasoccupation'] = null
      return
    } else {
      let __v__ = enumReader(['unemployed','retired','employed'],'unemployed')(__a__)
      if(!_.isEqual(__v__,this['_hasoccupation'])) {
        setDirtyFlag()
        this['_hasoccupation'] = __v__
      }
    }
  }
  get employername() { return this['_employername'] }
  set employername(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_employername'])) {
      setDirtyFlag()
      this['_employername'] = __v__
    }
  }
  get employeraddress() { return this['_employeraddress'] }
  set employeraddress(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_employeraddress'])) {
      setDirtyFlag()
      this['_employeraddress'] = __v__
    }
  }
  get from() { return this['_from'] }
  set from(__a__) {
    let __v__ = DateSReader('')(__a__)
    if(!_.isEqual(__v__,this['_from'])) {
      setDirtyFlag()
      this['_from'] = __v__
    }
  }
  get positiontitle() { return this['_positiontitle'] }
  set positiontitle(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_positiontitle'])) {
      setDirtyFlag()
      this['_positiontitle'] = __v__
    }
  }
  get typeofbusiness() { return this['_typeofbusiness'] }
  set typeofbusiness(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_typeofbusiness'])) {
      setDirtyFlag()
      this['_typeofbusiness'] = __v__
    }
  }
  get phone() { return this['_phone'] }
  set phone(__a__) {
    let __v__ = PhoneSReader('')(__a__)
    if(!_.isEqual(__v__,this['_phone'])) {
      setDirtyFlag()
      this['_phone'] = __v__
    }
  }
  get yearsatlineofwork() { return this['_yearsatlineofwork'] }
  set yearsatlineofwork(__a__) {
    let __v__ = IntSReader('')(__a__)
    if(!_.isEqual(__v__,this['_yearsatlineofwork'])) {
      setDirtyFlag()
      this['_yearsatlineofwork'] = __v__
    }
  }
  get monthsatlineofwork() { return this['_monthsatlineofwork'] }
  set monthsatlineofwork(__a__) {
    let __v__ = IntSReader('')(__a__)
    if(!_.isEqual(__v__,this['_monthsatlineofwork'])) {
      setDirtyFlag()
      this['_monthsatlineofwork'] = __v__
    }
  }
  get selfemployed() { return this['_selfemployed'] }
  set selfemployed(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_selfemployed'])) {
      setDirtyFlag()
      this['_selfemployed'] = __v__
    }
  }
  get employedbyagent() { return this['_employedbyagent'] }
  set employedbyagent(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_employedbyagent'])) {
      setDirtyFlag()
      this['_employedbyagent'] = __v__
    }
  }
  get percentownership() { return this['_percentownership'] }
  set percentownership(__a__) {
    let __v__ = IntSReader('')(__a__)
    if(!_.isEqual(__v__,this['_percentownership'])) {
      setDirtyFlag()
      this['_percentownership'] = __v__
    }
  }
  get incomeorloss() { return this['_incomeorloss'] }
  set incomeorloss(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_incomeorloss'])) {
      setDirtyFlag()
      this['_incomeorloss'] = __v__
    }
  }
  get incomeorlossperiod() { return this['_incomeorlossperiod'] }
  set incomeorlossperiod(__a__) {
    let __v__ = enumReader(['monthly','yearly','daily','hourly'],'monthly')(__a__)
    if(!_.isEqual(__v__,this['_incomeorlossperiod'])) {
      setDirtyFlag()
      this['_incomeorlossperiod'] = __v__
    }
  }
  get income() { return this['_income'] }
  set income(__a__) {
    setDirtyFlag()
    this['_income'] = __a__
  }
  get selfincomedoc() { return this['_selfincomedoc'] }
  set selfincomedoc(__a__) {
    if(__a__ == null) {
      if(this['_selfincomedoc'] == null) { return }
      setDirtyFlag()
      this['_selfincomedoc'] = null
      return
    } else {
      let __v__ = enumReader(['schedulec','schedulef','f1065','f1120S','f1120','w2paystub','schedulek1'],'schedulec')(__a__)
      if(!_.isEqual(__v__,this['_selfincomedoc'])) {
        setDirtyFlag()
        this['_selfincomedoc'] = __v__
      }
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new occupation()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.hasoccupation = __a__['hasoccupation'] == null ? null : __a__['hasoccupation']
       cls.employername = __a__['employername']
       cls.employeraddress = __a__['employeraddress']
       cls.from = __a__['from']
       cls.positiontitle = __a__['positiontitle']
       cls.typeofbusiness = __a__['typeofbusiness']
       cls.phone = __a__['phone']
       cls.yearsatlineofwork = __a__['yearsatlineofwork']
       cls.monthsatlineofwork = __a__['monthsatlineofwork']
       cls.selfemployed = __a__['selfemployed']
       cls.employedbyagent = __a__['employedbyagent']
       cls.percentownership = __a__['percentownership']
       cls.incomeorloss = __a__['incomeorloss']
       cls.incomeorlossperiod = __a__['incomeorlossperiod']
       cls.income = employmentincome.fromJson(__a__['income'])
       cls.selfincomedoc = __a__['selfincomedoc'] == null ? null : __a__['selfincomedoc']
    } else {
       doAlert(`occupation: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class otherasset {
  constructor() {
    this['_description'] = ''
    this['_assettype'] = 'ProceedsFromRealEstatePropertyToBeSoldOnOrBeforeClosing'
    this['_value'] = ''
    this['_key'] = ''
    this['_attribution'] = null
    this['_ownership'] = 'Borrower'
  }
  get description() { return this['_description'] }
  set description(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_description'])) {
      setDirtyFlag()
      this['_description'] = __v__
    }
  }
  get assettype() { return this['_assettype'] }
  set assettype(__a__) {
    let __v__ = enumReader(['ProceedsFromRealEstatePropertyToBeSoldOnOrBeforeClosing','ProceedsFromSaleOfNonRealEstateAsset','SecuredBorrowedFunds','UnsecuredBorrowedFunds','Other','EarnestMoney','EmployerAssistance','LotEquity','RelocationFunds','RentCredit','SweatEquity','TradeEquity'],'ProceedsFromRealEstatePropertyToBeSoldOnOrBeforeClosing')(__a__)
    if(!_.isEqual(__v__,this['_assettype'])) {
      setDirtyFlag()
      this['_assettype'] = __v__
    }
  }
  get value() { return this['_value'] }
  set value(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_value'])) {
      setDirtyFlag()
      this['_value'] = __v__
    }
  }
  get key() { return this['_key'] }
  set key(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_key'])) {
      setDirtyFlag()
      this['_key'] = __v__
    }
  }
  get attribution() { return this['_attribution'] }
  set attribution(__a__) {
    if(__a__ == null) {
      if(this['_attribution'] == null) { return }
      setDirtyFlag()
      this['_attribution'] = null
      return
    } else {
      let __v__ = intReader(0)(__a__)
      if(!_.isEqual(__v__,this['_attribution'])) {
        setDirtyFlag()
        this['_attribution'] = __v__
      }
    }
  }
  get ownership() { return this['_ownership'] }
  set ownership(__a__) {
    let __v__ = enumReader(['Borrower','CoBorrower','Joint'],'Borrower')(__a__)
    if(!_.isEqual(__v__,this['_ownership'])) {
      setDirtyFlag()
      this['_ownership'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new otherasset()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.description = __a__['description']
       cls.assettype = __a__['assettype']
       cls.value = __a__['value']
       cls.key = __a__['key']
       cls.attribution = __a__['attribution'] == null ? null : __a__['attribution']
       cls.ownership = __a__['ownership']
    } else {
       doAlert(`otherasset: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class otherincome {
  constructor() {
    this['_key'] = ''
    this['_incometype'] = 'Other'
    this['_description'] = ''
    this['_period'] = 'monthly'
    this['_amount'] = ''
  }
  get key() { return this['_key'] }
  set key(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_key'])) {
      setDirtyFlag()
      this['_key'] = __v__
    }
  }
  get incometype() { return this['_incometype'] }
  set incometype(__a__) {
    let __v__ = enumReader(['AccessoryUnitIncome','Alimony','AutomobileAllowance','Base','BoarderIncome','Bonus','CapitalGains','ChildSupport','Commissions','ContractBasis','DefinedContributionPlan','Disability','DividendsInterest','EmploymentRelatedAccount','FosterCare','HousingAllowance','HousingChoiceVoucherProgram','MilitaryBasePay','MilitaryClothesAllowance','MilitaryCombatPay','MilitaryFlightPay','MilitaryHazardPay','MilitaryOverseasPay','MilitaryPropPay','MilitaryQuartersAllowance','MilitaryRationsAllowance','MilitaryVariableHousingAllowance','MortgageCreditCertificate','MortgageDifferential','NetRentalIncome','NonBorrowerContribution','NonBorrowerHouseholdIncome','NotesReceivableInstallment','Other','Overtime','Pension','ProposedGrossRentForSubjectProperty','PublicAssistance','RealEstateOwnedGrossRentalIncome','Royalties','SeparateMaintenance','SocialSecurity','TemporaryLeave','TipIncome','Trust','Unemployment','VABenefitsNonEducational','VACompensation','Retirement','HousingParsonage'],'Other')(__a__)
    if(!_.isEqual(__v__,this['_incometype'])) {
      setDirtyFlag()
      this['_incometype'] = __v__
    }
  }
  get description() { return this['_description'] }
  set description(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_description'])) {
      setDirtyFlag()
      this['_description'] = __v__
    }
  }
  get period() { return this['_period'] }
  set period(__a__) {
    let __v__ = enumReader(['monthly','yearly','daily','hourly'],'monthly')(__a__)
    if(!_.isEqual(__v__,this['_period'])) {
      setDirtyFlag()
      this['_period'] = __v__
    }
  }
  get amount() { return this['_amount'] }
  set amount(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_amount'])) {
      setDirtyFlag()
      this['_amount'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new otherincome()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.key = __a__['key']
       cls.incometype = __a__['incometype']
       cls.description = __a__['description']
       cls.period = __a__['period']
       cls.amount = __a__['amount']
    } else {
       doAlert(`otherincome: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class otherlien {
  constructor() {
    this['_lender'] = ''
    this['_monthly'] = ''
    this['_balance'] = ''
    this['_monthslefttopay'] = 0
    this['_account'] = ''
    this['_owner'] = 'Individual'
    this['_isHELOC'] = null
    this['_forsubjectproperty'] = null
    this['_satisfiedupon'] = null
    this['_isprimary'] = null
    this['_partoforiginalpurchase'] = null
    this['_rate'] = ''
  }
  get lender() { return this['_lender'] }
  set lender(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_lender'])) {
      setDirtyFlag()
      this['_lender'] = __v__
    }
  }
  get monthly() { return this['_monthly'] }
  set monthly(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_monthly'])) {
      setDirtyFlag()
      this['_monthly'] = __v__
    }
  }
  get balance() { return this['_balance'] }
  set balance(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_balance'])) {
      setDirtyFlag()
      this['_balance'] = __v__
    }
  }
  get monthslefttopay() { return this['_monthslefttopay'] }
  set monthslefttopay(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_monthslefttopay'])) {
      setDirtyFlag()
      this['_monthslefttopay'] = __v__
    }
  }
  get account() { return this['_account'] }
  set account(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_account'])) {
      setDirtyFlag()
      this['_account'] = __v__
    }
  }
  get owner() { return this['_owner'] }
  set owner(__a__) {
    let __v__ = enumReader(['Individual','Joint','Terminated'],'Individual')(__a__)
    if(!_.isEqual(__v__,this['_owner'])) {
      setDirtyFlag()
      this['_owner'] = __v__
    }
  }
  get isHELOC() { return this['_isHELOC'] }
  set isHELOC(__a__) {
    if(__a__ == null) {
      if(this['_isHELOC'] == null) { return }
      setDirtyFlag()
      this['_isHELOC'] = null
      return
    } else {
      let __v__ = boolReader(false)(__a__)
      if(!_.isEqual(__v__,this['_isHELOC'])) {
        setDirtyFlag()
        this['_isHELOC'] = __v__
      }
    }
  }
  get forsubjectproperty() { return this['_forsubjectproperty'] }
  set forsubjectproperty(__a__) {
    if(__a__ == null) {
      if(this['_forsubjectproperty'] == null) { return }
      setDirtyFlag()
      this['_forsubjectproperty'] = null
      return
    } else {
      let __v__ = boolReader(false)(__a__)
      if(!_.isEqual(__v__,this['_forsubjectproperty'])) {
        setDirtyFlag()
        this['_forsubjectproperty'] = __v__
      }
    }
  }
  get satisfiedupon() { return this['_satisfiedupon'] }
  set satisfiedupon(__a__) {
    if(__a__ == null) {
      if(this['_satisfiedupon'] == null) { return }
      setDirtyFlag()
      this['_satisfiedupon'] = null
      return
    } else {
      let __v__ = enumReader(['not','withproceeds','withownfunds'],'not')(__a__)
      if(!_.isEqual(__v__,this['_satisfiedupon'])) {
        setDirtyFlag()
        this['_satisfiedupon'] = __v__
      }
    }
  }
  get isprimary() { return this['_isprimary'] }
  set isprimary(__a__) {
    if(__a__ == null) {
      if(this['_isprimary'] == null) { return }
      setDirtyFlag()
      this['_isprimary'] = null
      return
    } else {
      let __v__ = boolReader(false)(__a__)
      if(!_.isEqual(__v__,this['_isprimary'])) {
        setDirtyFlag()
        this['_isprimary'] = __v__
      }
    }
  }
  get partoforiginalpurchase() { return this['_partoforiginalpurchase'] }
  set partoforiginalpurchase(__a__) {
    if(__a__ == null) {
      if(this['_partoforiginalpurchase'] == null) { return }
      setDirtyFlag()
      this['_partoforiginalpurchase'] = null
      return
    } else {
      let __v__ = boolReader(false)(__a__)
      if(!_.isEqual(__v__,this['_partoforiginalpurchase'])) {
        setDirtyFlag()
        this['_partoforiginalpurchase'] = __v__
      }
    }
  }
  get rate() { return this['_rate'] }
  set rate(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_rate'])) {
      setDirtyFlag()
      this['_rate'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new otherlien()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.lender = __a__['lender']
       cls.monthly = __a__['monthly']
       cls.balance = __a__['balance']
       cls.monthslefttopay = __a__['monthslefttopay']
       cls.account = __a__['account']
       cls.owner = __a__['owner']
       cls.isHELOC = __a__['isHELOC'] == null ? null : __a__['isHELOC']
       cls.forsubjectproperty = __a__['forsubjectproperty'] == null ? null : __a__['forsubjectproperty']
       cls.satisfiedupon = __a__['satisfiedupon'] == null ? null : __a__['satisfiedupon']
       cls.isprimary = __a__['isprimary'] == null ? null : __a__['isprimary']
       cls.partoforiginalpurchase = __a__['partoforiginalpurchase'] == null ? null : __a__['partoforiginalpurchase']
       cls.rate = __a__['rate']
    } else {
       doAlert(`otherlien: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class otheroccupation {
  constructor() {
    this['_employername'] = ''
    this['_employeraddress'] = ''
    this['_from'] = ''
    this['_positiontitle'] = ''
    this['_typeofbusiness'] = ''
    this['_phone'] = ''
    this['_yearsatlineofwork'] = ''
    this['_monthsatlineofwork'] = ''
    this['_selfemployed'] = false
    this['_employedbyagent'] = false
    this['_percentownership'] = ''
    this['_incomeorloss'] = ''
    this['_incomeorlossperiod'] = 'monthly'
    this['_income'] = new employmentincome()
    this['_selfincomedoc'] = null
    this['_key'] = ''
  }
  get employername() { return this['_employername'] }
  set employername(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_employername'])) {
      setDirtyFlag()
      this['_employername'] = __v__
    }
  }
  get employeraddress() { return this['_employeraddress'] }
  set employeraddress(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_employeraddress'])) {
      setDirtyFlag()
      this['_employeraddress'] = __v__
    }
  }
  get from() { return this['_from'] }
  set from(__a__) {
    let __v__ = DateSReader('')(__a__)
    if(!_.isEqual(__v__,this['_from'])) {
      setDirtyFlag()
      this['_from'] = __v__
    }
  }
  get positiontitle() { return this['_positiontitle'] }
  set positiontitle(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_positiontitle'])) {
      setDirtyFlag()
      this['_positiontitle'] = __v__
    }
  }
  get typeofbusiness() { return this['_typeofbusiness'] }
  set typeofbusiness(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_typeofbusiness'])) {
      setDirtyFlag()
      this['_typeofbusiness'] = __v__
    }
  }
  get phone() { return this['_phone'] }
  set phone(__a__) {
    let __v__ = PhoneSReader('')(__a__)
    if(!_.isEqual(__v__,this['_phone'])) {
      setDirtyFlag()
      this['_phone'] = __v__
    }
  }
  get yearsatlineofwork() { return this['_yearsatlineofwork'] }
  set yearsatlineofwork(__a__) {
    let __v__ = IntSReader('')(__a__)
    if(!_.isEqual(__v__,this['_yearsatlineofwork'])) {
      setDirtyFlag()
      this['_yearsatlineofwork'] = __v__
    }
  }
  get monthsatlineofwork() { return this['_monthsatlineofwork'] }
  set monthsatlineofwork(__a__) {
    let __v__ = IntSReader('')(__a__)
    if(!_.isEqual(__v__,this['_monthsatlineofwork'])) {
      setDirtyFlag()
      this['_monthsatlineofwork'] = __v__
    }
  }
  get selfemployed() { return this['_selfemployed'] }
  set selfemployed(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_selfemployed'])) {
      setDirtyFlag()
      this['_selfemployed'] = __v__
    }
  }
  get employedbyagent() { return this['_employedbyagent'] }
  set employedbyagent(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_employedbyagent'])) {
      setDirtyFlag()
      this['_employedbyagent'] = __v__
    }
  }
  get percentownership() { return this['_percentownership'] }
  set percentownership(__a__) {
    let __v__ = IntSReader('')(__a__)
    if(!_.isEqual(__v__,this['_percentownership'])) {
      setDirtyFlag()
      this['_percentownership'] = __v__
    }
  }
  get incomeorloss() { return this['_incomeorloss'] }
  set incomeorloss(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_incomeorloss'])) {
      setDirtyFlag()
      this['_incomeorloss'] = __v__
    }
  }
  get incomeorlossperiod() { return this['_incomeorlossperiod'] }
  set incomeorlossperiod(__a__) {
    let __v__ = enumReader(['monthly','yearly','daily','hourly'],'monthly')(__a__)
    if(!_.isEqual(__v__,this['_incomeorlossperiod'])) {
      setDirtyFlag()
      this['_incomeorlossperiod'] = __v__
    }
  }
  get income() { return this['_income'] }
  set income(__a__) {
    setDirtyFlag()
    this['_income'] = __a__
  }
  get selfincomedoc() { return this['_selfincomedoc'] }
  set selfincomedoc(__a__) {
    if(__a__ == null) {
      if(this['_selfincomedoc'] == null) { return }
      setDirtyFlag()
      this['_selfincomedoc'] = null
      return
    } else {
      let __v__ = enumReader(['schedulec','schedulef','f1065','f1120S','f1120','w2paystub','schedulek1'],'schedulec')(__a__)
      if(!_.isEqual(__v__,this['_selfincomedoc'])) {
        setDirtyFlag()
        this['_selfincomedoc'] = __v__
      }
    }
  }
  get key() { return this['_key'] }
  set key(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_key'])) {
      setDirtyFlag()
      this['_key'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new otheroccupation()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.employername = __a__['employername']
       cls.employeraddress = __a__['employeraddress']
       cls.from = __a__['from']
       cls.positiontitle = __a__['positiontitle']
       cls.typeofbusiness = __a__['typeofbusiness']
       cls.phone = __a__['phone']
       cls.yearsatlineofwork = __a__['yearsatlineofwork']
       cls.monthsatlineofwork = __a__['monthsatlineofwork']
       cls.selfemployed = __a__['selfemployed']
       cls.employedbyagent = __a__['employedbyagent']
       cls.percentownership = __a__['percentownership']
       cls.incomeorloss = __a__['incomeorloss']
       cls.incomeorlossperiod = __a__['incomeorlossperiod']
       cls.income = employmentincome.fromJson(__a__['income'])
       cls.selfincomedoc = __a__['selfincomedoc'] == null ? null : __a__['selfincomedoc']
       cls.key = __a__['key']
    } else {
       doAlert(`otheroccupation: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class payment {
  constructor() {
    this['_paymentname'] = ''
    this['_amount'] = 0.0
    this['_period'] = 'monthly'
    this['_prepaidperiods'] = 0
    this['_yearstilltermination'] = 0
    this['_inescrow'] = false
    this['_initialescrowpaymentmonths'] = 0
  }
  get paymentname() { return this['_paymentname'] }
  set paymentname(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_paymentname'])) {
      setDirtyFlag()
      this['_paymentname'] = __v__
    }
  }
  get amount() { return this['_amount'] }
  set amount(__a__) {
    let __v__ = floatReader(0.0)(__a__)
    if(!_.isEqual(__v__,this['_amount'])) {
      setDirtyFlag()
      this['_amount'] = __v__
    }
  }
  get period() { return this['_period'] }
  set period(__a__) {
    let __v__ = enumReader(['monthly','yearly','daily','hourly'],'monthly')(__a__)
    if(!_.isEqual(__v__,this['_period'])) {
      setDirtyFlag()
      this['_period'] = __v__
    }
  }
  get prepaidperiods() { return this['_prepaidperiods'] }
  set prepaidperiods(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_prepaidperiods'])) {
      setDirtyFlag()
      this['_prepaidperiods'] = __v__
    }
  }
  get yearstilltermination() { return this['_yearstilltermination'] }
  set yearstilltermination(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_yearstilltermination'])) {
      setDirtyFlag()
      this['_yearstilltermination'] = __v__
    }
  }
  get inescrow() { return this['_inescrow'] }
  set inescrow(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_inescrow'])) {
      setDirtyFlag()
      this['_inescrow'] = __v__
    }
  }
  get initialescrowpaymentmonths() { return this['_initialescrowpaymentmonths'] }
  set initialescrowpaymentmonths(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_initialescrowpaymentmonths'])) {
      setDirtyFlag()
      this['_initialescrowpaymentmonths'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new payment()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.paymentname = __a__['paymentname']
       cls.amount = __a__['amount']
       cls.period = __a__['period']
       cls.prepaidperiods = __a__['prepaidperiods']
       cls.yearstilltermination = __a__['yearstilltermination']
       cls.inescrow = __a__['inescrow']
       cls.initialescrowpaymentmonths = __a__['initialescrowpaymentmonths']
    } else {
       doAlert(`payment: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class person {
  constructor() {
    this['_firstname'] = ''
    this['_middlename'] = ''
    this['_lastname'] = ''
    this['_suffix'] = ''
    this['_email'] = ''
    this['_socialsecurity'] = ''
    this['_dateofbirth'] = ''
  }
  get firstname() { return this['_firstname'] }
  set firstname(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_firstname'])) {
      setDirtyFlag()
      this['_firstname'] = __v__
    }
  }
  get middlename() { return this['_middlename'] }
  set middlename(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_middlename'])) {
      setDirtyFlag()
      this['_middlename'] = __v__
    }
  }
  get lastname() { return this['_lastname'] }
  set lastname(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_lastname'])) {
      setDirtyFlag()
      this['_lastname'] = __v__
    }
  }
  get suffix() { return this['_suffix'] }
  set suffix(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_suffix'])) {
      setDirtyFlag()
      this['_suffix'] = __v__
    }
  }
  get email() { return this['_email'] }
  set email(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_email'])) {
      setDirtyFlag()
      this['_email'] = __v__
    }
  }
  get socialsecurity() { return this['_socialsecurity'] }
  set socialsecurity(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_socialsecurity'])) {
      setDirtyFlag()
      this['_socialsecurity'] = __v__
    }
  }
  get dateofbirth() { return this['_dateofbirth'] }
  set dateofbirth(__a__) {
    let __v__ = DateSReader('')(__a__)
    if(!_.isEqual(__v__,this['_dateofbirth'])) {
      setDirtyFlag()
      this['_dateofbirth'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new person()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.firstname = __a__['firstname']
       cls.middlename = __a__['middlename']
       cls.lastname = __a__['lastname']
       cls.suffix = __a__['suffix']
       cls.email = __a__['email']
       cls.socialsecurity = __a__['socialsecurity']
       cls.dateofbirth = __a__['dateofbirth']
    } else {
       doAlert(`person: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class personwithresidencies {
  constructor() {
    this['_person'] = new person()
    this['_residencies'] = []
  }
  get person() { return this['_person'] }
  set person(__a__) {
    setDirtyFlag()
    this['_person'] = __a__
  }
  get residencies() { return this['_residencies'] }
  set residencies(__a__) {
    setDirtyFlag()
    this['_residencies'] = __a__
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new personwithresidencies()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.person = person.fromJson(__a__['person'])
       cls.residencies = array1Reader(address.fromJson)(__a__['residencies'])
    } else {
       doAlert(`personwithresidencies: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class personwithscoresandresidencies {
  constructor() {
    this['_person'] = new person()
    this['_scores'] = new scores()
    this['_residencies'] = []
  }
  get person() { return this['_person'] }
  set person(__a__) {
    setDirtyFlag()
    this['_person'] = __a__
  }
  get scores() { return this['_scores'] }
  set scores(__a__) {
    setDirtyFlag()
    this['_scores'] = __a__
  }
  get residencies() { return this['_residencies'] }
  set residencies(__a__) {
    setDirtyFlag()
    this['_residencies'] = __a__
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new personwithscoresandresidencies()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.person = person.fromJson(__a__['person'])
       cls.scores = scores.fromJson(__a__['scores'])
       cls.residencies = array1Reader(address.fromJson)(__a__['residencies'])
    } else {
       doAlert(`personwithscoresandresidencies: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class previousoccupation {
  constructor() {
    this['_employername'] = ''
    this['_employeraddress'] = ''
    this['_from'] = ''
    this['_to'] = ''
    this['_positiontitle'] = ''
    this['_typeofbusiness'] = ''
    this['_phone'] = ''
    this['_income'] = ''
    this['_incomeperiod'] = ''
    this['_selfemployed'] = false
    this['_employedbyagent'] = false
    this['_key'] = ''
  }
  get employername() { return this['_employername'] }
  set employername(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_employername'])) {
      setDirtyFlag()
      this['_employername'] = __v__
    }
  }
  get employeraddress() { return this['_employeraddress'] }
  set employeraddress(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_employeraddress'])) {
      setDirtyFlag()
      this['_employeraddress'] = __v__
    }
  }
  get from() { return this['_from'] }
  set from(__a__) {
    let __v__ = DateSReader('')(__a__)
    if(!_.isEqual(__v__,this['_from'])) {
      setDirtyFlag()
      this['_from'] = __v__
    }
  }
  get to() { return this['_to'] }
  set to(__a__) {
    let __v__ = DateSReader('')(__a__)
    if(!_.isEqual(__v__,this['_to'])) {
      setDirtyFlag()
      this['_to'] = __v__
    }
  }
  get positiontitle() { return this['_positiontitle'] }
  set positiontitle(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_positiontitle'])) {
      setDirtyFlag()
      this['_positiontitle'] = __v__
    }
  }
  get typeofbusiness() { return this['_typeofbusiness'] }
  set typeofbusiness(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_typeofbusiness'])) {
      setDirtyFlag()
      this['_typeofbusiness'] = __v__
    }
  }
  get phone() { return this['_phone'] }
  set phone(__a__) {
    let __v__ = PhoneSReader('')(__a__)
    if(!_.isEqual(__v__,this['_phone'])) {
      setDirtyFlag()
      this['_phone'] = __v__
    }
  }
  get income() { return this['_income'] }
  set income(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_income'])) {
      setDirtyFlag()
      this['_income'] = __v__
    }
  }
  get incomeperiod() { return this['_incomeperiod'] }
  set incomeperiod(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_incomeperiod'])) {
      setDirtyFlag()
      this['_incomeperiod'] = __v__
    }
  }
  get selfemployed() { return this['_selfemployed'] }
  set selfemployed(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_selfemployed'])) {
      setDirtyFlag()
      this['_selfemployed'] = __v__
    }
  }
  get employedbyagent() { return this['_employedbyagent'] }
  set employedbyagent(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_employedbyagent'])) {
      setDirtyFlag()
      this['_employedbyagent'] = __v__
    }
  }
  get key() { return this['_key'] }
  set key(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_key'])) {
      setDirtyFlag()
      this['_key'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new previousoccupation()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.employername = __a__['employername']
       cls.employeraddress = __a__['employeraddress']
       cls.from = __a__['from']
       cls.to = __a__['to']
       cls.positiontitle = __a__['positiontitle']
       cls.typeofbusiness = __a__['typeofbusiness']
       cls.phone = __a__['phone']
       cls.income = __a__['income']
       cls.incomeperiod = __a__['incomeperiod']
       cls.selfemployed = __a__['selfemployed']
       cls.employedbyagent = __a__['employedbyagent']
       cls.key = __a__['key']
    } else {
       doAlert(`previousoccupation: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class product {
  constructor() {
    this['_lendername'] = ''
    this['_lenderinfo'] = new lender()
    this['_productname'] = ''
    this['_mortgageapplied'] = 'conventional'
    this['_othermortgage'] = ''
    this['_agencycasenumber'] = ''
    this['_lendercasenumber'] = ''
    this['_interestrate'] = ''
    this['_mortgageterm'] = 'year30'
    this['_mortgagetermmonths'] = 0
    this['_amortization'] = 'fixed'
    this['_otheramortization'] = ''
  }
  get lendername() { return this['_lendername'] }
  set lendername(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_lendername'])) {
      setDirtyFlag()
      this['_lendername'] = __v__
    }
  }
  get lenderinfo() { return this['_lenderinfo'] }
  set lenderinfo(__a__) {
    setDirtyFlag()
    this['_lenderinfo'] = __a__
  }
  get productname() { return this['_productname'] }
  set productname(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_productname'])) {
      setDirtyFlag()
      this['_productname'] = __v__
    }
  }
  get mortgageapplied() { return this['_mortgageapplied'] }
  set mortgageapplied(__a__) {
    let __v__ = enumReader(['conventional','va','fha','usda','nonconventional','nonqm','landloan','constructionloan','heloc','hardmoneyloan','other'],'conventional')(__a__)
    if(!_.isEqual(__v__,this['_mortgageapplied'])) {
      setDirtyFlag()
      this['_mortgageapplied'] = __v__
    }
  }
  get othermortgage() { return this['_othermortgage'] }
  set othermortgage(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_othermortgage'])) {
      setDirtyFlag()
      this['_othermortgage'] = __v__
    }
  }
  get agencycasenumber() { return this['_agencycasenumber'] }
  set agencycasenumber(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_agencycasenumber'])) {
      setDirtyFlag()
      this['_agencycasenumber'] = __v__
    }
  }
  get lendercasenumber() { return this['_lendercasenumber'] }
  set lendercasenumber(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_lendercasenumber'])) {
      setDirtyFlag()
      this['_lendercasenumber'] = __v__
    }
  }
  get interestrate() { return this['_interestrate'] }
  set interestrate(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_interestrate'])) {
      setDirtyFlag()
      this['_interestrate'] = __v__
    }
  }
  get mortgageterm() { return this['_mortgageterm'] }
  set mortgageterm(__a__) {
    let __v__ = enumReader(['year30','year25','year20','year15','year10','year7','year5','other'],'year30')(__a__)
    if(!_.isEqual(__v__,this['_mortgageterm'])) {
      setDirtyFlag()
      this['_mortgageterm'] = __v__
    }
  }
  get mortgagetermmonths() { return this['_mortgagetermmonths'] }
  set mortgagetermmonths(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_mortgagetermmonths'])) {
      setDirtyFlag()
      this['_mortgagetermmonths'] = __v__
    }
  }
  get amortization() { return this['_amortization'] }
  set amortization(__a__) {
    let __v__ = enumReader(['fixed','fixed-biweekly','arm51','arm71','arm101','arm56','arm76','arm106','gpm','interestonly','statedincome','baloon','otheramortization','buydown321','buydown21','buydown11'],'fixed')(__a__)
    if(!_.isEqual(__v__,this['_amortization'])) {
      setDirtyFlag()
      this['_amortization'] = __v__
    }
  }
  get otheramortization() { return this['_otheramortization'] }
  set otheramortization(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_otheramortization'])) {
      setDirtyFlag()
      this['_otheramortization'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new product()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.lendername = __a__['lendername']
       cls.lenderinfo = lender.fromJson(__a__['lenderinfo'])
       cls.productname = __a__['productname']
       cls.mortgageapplied = __a__['mortgageapplied']
       cls.othermortgage = __a__['othermortgage']
       cls.agencycasenumber = __a__['agencycasenumber']
       cls.lendercasenumber = __a__['lendercasenumber']
       cls.interestrate = __a__['interestrate']
       cls.mortgageterm = __a__['mortgageterm']
       cls.mortgagetermmonths = __a__['mortgagetermmonths']
       cls.amortization = __a__['amortization']
       cls.otheramortization = __a__['otheramortization']
    } else {
       doAlert(`product: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class productfeatures {
  constructor() {
    this['_hasprepaymentpenalty'] = false
    this['_prepaymentpenaltyamount'] = 0
    this['_prepaymentpenaltyterm'] = 0
    this['_hasballoonpayment'] = false
    this['_balloonpaymentamount'] = 0
    this['_baloonpaymentterm'] = 0
  }
  get hasprepaymentpenalty() { return this['_hasprepaymentpenalty'] }
  set hasprepaymentpenalty(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_hasprepaymentpenalty'])) {
      setDirtyFlag()
      this['_hasprepaymentpenalty'] = __v__
    }
  }
  get prepaymentpenaltyamount() { return this['_prepaymentpenaltyamount'] }
  set prepaymentpenaltyamount(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_prepaymentpenaltyamount'])) {
      setDirtyFlag()
      this['_prepaymentpenaltyamount'] = __v__
    }
  }
  get prepaymentpenaltyterm() { return this['_prepaymentpenaltyterm'] }
  set prepaymentpenaltyterm(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_prepaymentpenaltyterm'])) {
      setDirtyFlag()
      this['_prepaymentpenaltyterm'] = __v__
    }
  }
  get hasballoonpayment() { return this['_hasballoonpayment'] }
  set hasballoonpayment(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_hasballoonpayment'])) {
      setDirtyFlag()
      this['_hasballoonpayment'] = __v__
    }
  }
  get balloonpaymentamount() { return this['_balloonpaymentamount'] }
  set balloonpaymentamount(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_balloonpaymentamount'])) {
      setDirtyFlag()
      this['_balloonpaymentamount'] = __v__
    }
  }
  get baloonpaymentterm() { return this['_baloonpaymentterm'] }
  set baloonpaymentterm(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_baloonpaymentterm'])) {
      setDirtyFlag()
      this['_baloonpaymentterm'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new productfeatures()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.hasprepaymentpenalty = __a__['hasprepaymentpenalty']
       cls.prepaymentpenaltyamount = __a__['prepaymentpenaltyamount']
       cls.prepaymentpenaltyterm = __a__['prepaymentpenaltyterm']
       cls.hasballoonpayment = __a__['hasballoonpayment']
       cls.balloonpaymentamount = __a__['balloonpaymentamount']
       cls.baloonpaymentterm = __a__['baloonpaymentterm']
    } else {
       doAlert(`productfeatures: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class progress {
  constructor() {
    this['_stage'] = ''
    this['_interview'] = new interviewstep()
    this['_loinput'] = new step()
    this['_tasks'] = new tasks()
    this['_lasttouch'] = null
  }
  get stage() { return this['_stage'] }
  set stage(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_stage'])) {
      setDirtyFlag()
      this['_stage'] = __v__
    }
  }
  get interview() { return this['_interview'] }
  set interview(__a__) {
    setDirtyFlag()
    this['_interview'] = __a__
  }
  get loinput() { return this['_loinput'] }
  set loinput(__a__) {
    setDirtyFlag()
    this['_loinput'] = __a__
  }
  get tasks() { return this['_tasks'] }
  set tasks(__a__) {
    setDirtyFlag()
    this['_tasks'] = __a__
  }
  get lasttouch() { return this['_lasttouch'] }
  set lasttouch(__a__) {
    if(__a__ == null) {
      if(this['_lasttouch'] == null) { return }
      setDirtyFlag()
      this['_lasttouch'] = null
      return
    } else {
      let __v__ = stringReader('')(__a__)
      if(!_.isEqual(__v__,this['_lasttouch'])) {
        setDirtyFlag()
        this['_lasttouch'] = __v__
      }
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new progress()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.stage = __a__['stage']
       cls.interview = interviewstep.fromJson(__a__['interview'])
       cls.loinput = step.fromJson(__a__['loinput'])
       cls.tasks = tasks.fromJson(__a__['tasks'])
       cls.lasttouch = __a__['lasttouch'] == null ? null : __a__['lasttouch']
    } else {
       doAlert(`progress: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class property {
  constructor() {
    this['_address'] = ''
    this['_ownedfreeandclear'] = null
    this['_creditor'] = null
    this['_account'] = null
    this['_status'] = 'pending'
    this['_propertytype'] = 'singlefamilyattached'
    this['_marketvalue'] = ''
    this['_liens'] = ''
    this['_grossrentalincome'] = ''
    this['_payment'] = ''
    this['_insurancemaintenancetaxes'] = ''
    this['_netrentalincome'] = ''
    this['_attribution'] = null
    this['_key'] = ''
  }
  get address() { return this['_address'] }
  set address(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_address'])) {
      setDirtyFlag()
      this['_address'] = __v__
    }
  }
  get ownedfreeandclear() { return this['_ownedfreeandclear'] }
  set ownedfreeandclear(__a__) {
    if(__a__ == null) {
      if(this['_ownedfreeandclear'] == null) { return }
      setDirtyFlag()
      this['_ownedfreeandclear'] = null
      return
    } else {
      let __v__ = boolReader(false)(__a__)
      if(!_.isEqual(__v__,this['_ownedfreeandclear'])) {
        setDirtyFlag()
        this['_ownedfreeandclear'] = __v__
      }
    }
  }
  get creditor() { return this['_creditor'] }
  set creditor(__a__) {
    if(__a__ == null) {
      if(this['_creditor'] == null) { return }
      setDirtyFlag()
      this['_creditor'] = null
      return
    } else {
      let __v__ = stringReader('')(__a__)
      if(!_.isEqual(__v__,this['_creditor'])) {
        setDirtyFlag()
        this['_creditor'] = __v__
      }
    }
  }
  get account() { return this['_account'] }
  set account(__a__) {
    if(__a__ == null) {
      if(this['_account'] == null) { return }
      setDirtyFlag()
      this['_account'] = null
      return
    } else {
      let __v__ = stringReader('')(__a__)
      if(!_.isEqual(__v__,this['_account'])) {
        setDirtyFlag()
        this['_account'] = __v__
      }
    }
  }
  get status() { return this['_status'] }
  set status(__a__) {
    let __v__ = enumReader(['pending','sold','retained'],'pending')(__a__)
    if(!_.isEqual(__v__,this['_status'])) {
      setDirtyFlag()
      this['_status'] = __v__
    }
  }
  get propertytype() { return this['_propertytype'] }
  set propertytype(__a__) {
    let __v__ = enumReader(['singlefamilyattached','singlefamilydetached','condominium','condominiumdetached','pudattached','puddetached','twotofourfamily','twofamily','threefamily','fourfamily','multistory','manufacturedhome','land','commercial','townhouse','mixeduse','mobilehome'],'singlefamilyattached')(__a__)
    if(!_.isEqual(__v__,this['_propertytype'])) {
      setDirtyFlag()
      this['_propertytype'] = __v__
    }
  }
  get marketvalue() { return this['_marketvalue'] }
  set marketvalue(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_marketvalue'])) {
      setDirtyFlag()
      this['_marketvalue'] = __v__
    }
  }
  get liens() { return this['_liens'] }
  set liens(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_liens'])) {
      setDirtyFlag()
      this['_liens'] = __v__
    }
  }
  get grossrentalincome() { return this['_grossrentalincome'] }
  set grossrentalincome(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_grossrentalincome'])) {
      setDirtyFlag()
      this['_grossrentalincome'] = __v__
    }
  }
  get payment() { return this['_payment'] }
  set payment(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_payment'])) {
      setDirtyFlag()
      this['_payment'] = __v__
    }
  }
  get insurancemaintenancetaxes() { return this['_insurancemaintenancetaxes'] }
  set insurancemaintenancetaxes(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_insurancemaintenancetaxes'])) {
      setDirtyFlag()
      this['_insurancemaintenancetaxes'] = __v__
    }
  }
  get netrentalincome() { return this['_netrentalincome'] }
  set netrentalincome(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_netrentalincome'])) {
      setDirtyFlag()
      this['_netrentalincome'] = __v__
    }
  }
  get attribution() { return this['_attribution'] }
  set attribution(__a__) {
    if(__a__ == null) {
      if(this['_attribution'] == null) { return }
      setDirtyFlag()
      this['_attribution'] = null
      return
    } else {
      let __v__ = intReader(0)(__a__)
      if(!_.isEqual(__v__,this['_attribution'])) {
        setDirtyFlag()
        this['_attribution'] = __v__
      }
    }
  }
  get key() { return this['_key'] }
  set key(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_key'])) {
      setDirtyFlag()
      this['_key'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new property()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.address = __a__['address']
       cls.ownedfreeandclear = __a__['ownedfreeandclear'] == null ? null : __a__['ownedfreeandclear']
       cls.creditor = __a__['creditor'] == null ? null : __a__['creditor']
       cls.account = __a__['account'] == null ? null : __a__['account']
       cls.status = __a__['status']
       cls.propertytype = __a__['propertytype']
       cls.marketvalue = __a__['marketvalue']
       cls.liens = __a__['liens']
       cls.grossrentalincome = __a__['grossrentalincome']
       cls.payment = __a__['payment']
       cls.insurancemaintenancetaxes = __a__['insurancemaintenancetaxes']
       cls.netrentalincome = __a__['netrentalincome']
       cls.attribution = __a__['attribution'] == null ? null : __a__['attribution']
       cls.key = __a__['key']
    } else {
       doAlert(`property: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class propertyflippingexperience {
  constructor() {
    this['_streetline1'] = ''
    this['_streetline2'] = ''
    this['_city'] = ''
    this['_state'] = ''
    this['_county'] = ''
    this['_zip'] = ''
    this['_purchaseprice'] = ''
    this['_purchasedate'] = ''
    this['_ownershipontitle'] = ''
    this['_propertytype'] = 'singlefamilyattached'
    this['_rehabbudget'] = ''
    this['_salesprice'] = ''
    this['_datesold'] = ''
    this['_profitorloss'] = ''
  }
  get streetline1() { return this['_streetline1'] }
  set streetline1(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_streetline1'])) {
      setDirtyFlag()
      this['_streetline1'] = __v__
    }
  }
  get streetline2() { return this['_streetline2'] }
  set streetline2(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_streetline2'])) {
      setDirtyFlag()
      this['_streetline2'] = __v__
    }
  }
  get city() { return this['_city'] }
  set city(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_city'])) {
      setDirtyFlag()
      this['_city'] = __v__
    }
  }
  get state() { return this['_state'] }
  set state(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_state'])) {
      setDirtyFlag()
      this['_state'] = __v__
    }
  }
  get county() { return this['_county'] }
  set county(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_county'])) {
      setDirtyFlag()
      this['_county'] = __v__
    }
  }
  get zip() { return this['_zip'] }
  set zip(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_zip'])) {
      setDirtyFlag()
      this['_zip'] = __v__
    }
  }
  get purchaseprice() { return this['_purchaseprice'] }
  set purchaseprice(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_purchaseprice'])) {
      setDirtyFlag()
      this['_purchaseprice'] = __v__
    }
  }
  get purchasedate() { return this['_purchasedate'] }
  set purchasedate(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_purchasedate'])) {
      setDirtyFlag()
      this['_purchasedate'] = __v__
    }
  }
  get ownershipontitle() { return this['_ownershipontitle'] }
  set ownershipontitle(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_ownershipontitle'])) {
      setDirtyFlag()
      this['_ownershipontitle'] = __v__
    }
  }
  get propertytype() { return this['_propertytype'] }
  set propertytype(__a__) {
    let __v__ = enumReader(['singlefamilyattached','singlefamilydetached','condominium','condominiumdetached','pudattached','puddetached','twotofourfamily','twofamily','threefamily','fourfamily','multistory','manufacturedhome','land','commercial','townhouse','mixeduse','mobilehome'],'singlefamilyattached')(__a__)
    if(!_.isEqual(__v__,this['_propertytype'])) {
      setDirtyFlag()
      this['_propertytype'] = __v__
    }
  }
  get rehabbudget() { return this['_rehabbudget'] }
  set rehabbudget(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_rehabbudget'])) {
      setDirtyFlag()
      this['_rehabbudget'] = __v__
    }
  }
  get salesprice() { return this['_salesprice'] }
  set salesprice(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_salesprice'])) {
      setDirtyFlag()
      this['_salesprice'] = __v__
    }
  }
  get datesold() { return this['_datesold'] }
  set datesold(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_datesold'])) {
      setDirtyFlag()
      this['_datesold'] = __v__
    }
  }
  get profitorloss() { return this['_profitorloss'] }
  set profitorloss(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_profitorloss'])) {
      setDirtyFlag()
      this['_profitorloss'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new propertyflippingexperience()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.streetline1 = __a__['streetline1']
       cls.streetline2 = __a__['streetline2']
       cls.city = __a__['city']
       cls.state = __a__['state']
       cls.county = __a__['county']
       cls.zip = __a__['zip']
       cls.purchaseprice = __a__['purchaseprice']
       cls.purchasedate = __a__['purchasedate']
       cls.ownershipontitle = __a__['ownershipontitle']
       cls.propertytype = __a__['propertytype']
       cls.rehabbudget = __a__['rehabbudget']
       cls.salesprice = __a__['salesprice']
       cls.datesold = __a__['datesold']
       cls.profitorloss = __a__['profitorloss']
    } else {
       doAlert(`propertyflippingexperience: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class publicrecord {
  constructor() {
    this['_accountownershiptype'] = 'Individual'
    this['_courtname'] = ''
    this['_dispositiondate'] = ''
    this['_dispositiontype'] = 'Adjudicated'
    this['_dispositiontypeotherdescription'] = ''
    this['_fileddate'] = ''
    this['_amount'] = ''
    this['_plaintiffname'] = ''
    this['_recordtype'] = 'Annulment'
    this['_recordtypeotherdescription'] = ''
  }
  get accountownershiptype() { return this['_accountownershiptype'] }
  set accountownershiptype(__a__) {
    let __v__ = enumReader(['Individual','Joint','Terminated'],'Individual')(__a__)
    if(!_.isEqual(__v__,this['_accountownershiptype'])) {
      setDirtyFlag()
      this['_accountownershiptype'] = __v__
    }
  }
  get courtname() { return this['_courtname'] }
  set courtname(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_courtname'])) {
      setDirtyFlag()
      this['_courtname'] = __v__
    }
  }
  get dispositiondate() { return this['_dispositiondate'] }
  set dispositiondate(__a__) {
    let __v__ = DateSReader('')(__a__)
    if(!_.isEqual(__v__,this['_dispositiondate'])) {
      setDirtyFlag()
      this['_dispositiondate'] = __v__
    }
  }
  get dispositiontype() { return this['_dispositiontype'] }
  set dispositiontype(__a__) {
    let __v__ = enumReader(['Adjudicated','Appealed','Canceled','Completed','Converted','Discharged','Dismissed','Distributed','Filed','Granted','InvoluntarilyDischarged','Nonadjudicated','Other','Paid','PaidNotSatisfied','Pending','RealEstateSold','Released','Rescinded','Satisfied','Settled','Unknown','Unreleased','Unsatisfied','Vacated','VoluntarilyDischarged','Withdrawn'],'Adjudicated')(__a__)
    if(!_.isEqual(__v__,this['_dispositiontype'])) {
      setDirtyFlag()
      this['_dispositiontype'] = __v__
    }
  }
  get dispositiontypeotherdescription() { return this['_dispositiontypeotherdescription'] }
  set dispositiontypeotherdescription(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_dispositiontypeotherdescription'])) {
      setDirtyFlag()
      this['_dispositiontypeotherdescription'] = __v__
    }
  }
  get fileddate() { return this['_fileddate'] }
  set fileddate(__a__) {
    let __v__ = DateSReader('')(__a__)
    if(!_.isEqual(__v__,this['_fileddate'])) {
      setDirtyFlag()
      this['_fileddate'] = __v__
    }
  }
  get amount() { return this['_amount'] }
  set amount(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_amount'])) {
      setDirtyFlag()
      this['_amount'] = __v__
    }
  }
  get plaintiffname() { return this['_plaintiffname'] }
  set plaintiffname(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_plaintiffname'])) {
      setDirtyFlag()
      this['_plaintiffname'] = __v__
    }
  }
  get recordtype() { return this['_recordtype'] }
  set recordtype(__a__) {
    let __v__ = enumReader(['Annulment','Attachment','BankruptcyChapter11','BankruptcyChapter12','BankruptcyChapter13','BankruptcyChapter7','BankruptcyChapter7Involuntary','BankruptcyChapter7Voluntary','BankruptcyTypeUnknown','ChildSupport','Collection','CustodyAgreement','DivorceDecree','FamilySupport','FictitiousName','FinancialCounseling','FinancingStatement','ForcibleDetainer','Foreclosure','Garnishment','Judgment','LawSuit','Lien','MechanicsLien','MedicalLien','NonResponsibility','NoticeOfDefault','Other','PublicSale','RealEstateRecording','Repossession','SpouseSupport','SupportDebt','TaxLienCity','TaxLienCounty','TaxLienFederal','TaxLienOther','TaxLienState','Trusteeship','Unknown','UnlawfulDetainer'],'Annulment')(__a__)
    if(!_.isEqual(__v__,this['_recordtype'])) {
      setDirtyFlag()
      this['_recordtype'] = __v__
    }
  }
  get recordtypeotherdescription() { return this['_recordtypeotherdescription'] }
  set recordtypeotherdescription(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_recordtypeotherdescription'])) {
      setDirtyFlag()
      this['_recordtypeotherdescription'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new publicrecord()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.accountownershiptype = __a__['accountownershiptype']
       cls.courtname = __a__['courtname']
       cls.dispositiondate = __a__['dispositiondate']
       cls.dispositiontype = __a__['dispositiontype']
       cls.dispositiontypeotherdescription = __a__['dispositiontypeotherdescription']
       cls.fileddate = __a__['fileddate']
       cls.amount = __a__['amount']
       cls.plaintiffname = __a__['plaintiffname']
       cls.recordtype = __a__['recordtype']
       cls.recordtypeotherdescription = __a__['recordtypeotherdescription']
    } else {
       doAlert(`publicrecord: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class publicrecordwithattribution {
  constructor() {
    this['_attribution'] = 0
    this['_publicrecord'] = new publicrecord()
  }
  get attribution() { return this['_attribution'] }
  set attribution(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_attribution'])) {
      setDirtyFlag()
      this['_attribution'] = __v__
    }
  }
  get publicrecord() { return this['_publicrecord'] }
  set publicrecord(__a__) {
    setDirtyFlag()
    this['_publicrecord'] = __a__
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new publicrecordwithattribution()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.attribution = __a__['attribution']
       cls.publicrecord = publicrecord.fromJson(__a__['publicrecord'])
    } else {
       doAlert(`publicrecordwithattribution: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class purchase {
  constructor() {
    this['_expectedgrossmonthlyrentalincome'] = ''
    this['_expectednetmonthlyrentalincome'] = ''
  }
  get expectedgrossmonthlyrentalincome() { return this['_expectedgrossmonthlyrentalincome'] }
  set expectedgrossmonthlyrentalincome(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_expectedgrossmonthlyrentalincome'])) {
      setDirtyFlag()
      this['_expectedgrossmonthlyrentalincome'] = __v__
    }
  }
  get expectednetmonthlyrentalincome() { return this['_expectednetmonthlyrentalincome'] }
  set expectednetmonthlyrentalincome(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_expectednetmonthlyrentalincome'])) {
      setDirtyFlag()
      this['_expectednetmonthlyrentalincome'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new purchase()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.expectedgrossmonthlyrentalincome = __a__['expectedgrossmonthlyrentalincome']
       cls.expectednetmonthlyrentalincome = __a__['expectednetmonthlyrentalincome']
    } else {
       doAlert(`purchase: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class refinance {
  constructor() {
    this['_yearacquired'] = ''
    this['_originalcost'] = ''
    this['_existingliens'] = ''
    this['_currentrate'] = ''
    this['_currentprogram'] = 'fixed'
    this['_purpose'] = 'debtconsolidation'
    this['_improvementsdesc'] = ''
    this['_improvementsstatus'] = 'noimprovements'
    this['_cost'] = '0'
    this['_estimatedpayoffsandpayments'] = '0'
    this['_explainotherpurpose'] = ''
  }
  get yearacquired() { return this['_yearacquired'] }
  set yearacquired(__a__) {
    let __v__ = YearSReader('')(__a__)
    if(!_.isEqual(__v__,this['_yearacquired'])) {
      setDirtyFlag()
      this['_yearacquired'] = __v__
    }
  }
  get originalcost() { return this['_originalcost'] }
  set originalcost(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_originalcost'])) {
      setDirtyFlag()
      this['_originalcost'] = __v__
    }
  }
  get existingliens() { return this['_existingliens'] }
  set existingliens(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_existingliens'])) {
      setDirtyFlag()
      this['_existingliens'] = __v__
    }
  }
  get currentrate() { return this['_currentrate'] }
  set currentrate(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_currentrate'])) {
      setDirtyFlag()
      this['_currentrate'] = __v__
    }
  }
  get currentprogram() { return this['_currentprogram'] }
  set currentprogram(__a__) {
    let __v__ = enumReader(['fixed','arm','baloon','heloc','negativeamortization','interestonly','noloan'],'fixed')(__a__)
    if(!_.isEqual(__v__,this['_currentprogram'])) {
      setDirtyFlag()
      this['_currentprogram'] = __v__
    }
  }
  get purpose() { return this['_purpose'] }
  set purpose(__a__) {
    let __v__ = enumReader(['debtconsolidation','homeimprovement','paytorelatives','cashforreserves','paidcashforsubjectproperty','payingoffheloc','payingotherproperties','payingstudentloans','other'],'debtconsolidation')(__a__)
    if(!_.isEqual(__v__,this['_purpose'])) {
      setDirtyFlag()
      this['_purpose'] = __v__
    }
  }
  get improvementsdesc() { return this['_improvementsdesc'] }
  set improvementsdesc(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_improvementsdesc'])) {
      setDirtyFlag()
      this['_improvementsdesc'] = __v__
    }
  }
  get improvementsstatus() { return this['_improvementsstatus'] }
  set improvementsstatus(__a__) {
    let __v__ = enumReader(['noimprovements','made','tobemade'],'noimprovements')(__a__)
    if(!_.isEqual(__v__,this['_improvementsstatus'])) {
      setDirtyFlag()
      this['_improvementsstatus'] = __v__
    }
  }
  get cost() { return this['_cost'] }
  set cost(__a__) {
    let __v__ = DollarSReader('0')(__a__)
    if(!_.isEqual(__v__,this['_cost'])) {
      setDirtyFlag()
      this['_cost'] = __v__
    }
  }
  get estimatedpayoffsandpayments() { return this['_estimatedpayoffsandpayments'] }
  set estimatedpayoffsandpayments(__a__) {
    let __v__ = DollarSReader('0')(__a__)
    if(!_.isEqual(__v__,this['_estimatedpayoffsandpayments'])) {
      setDirtyFlag()
      this['_estimatedpayoffsandpayments'] = __v__
    }
  }
  get explainotherpurpose() { return this['_explainotherpurpose'] }
  set explainotherpurpose(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_explainotherpurpose'])) {
      setDirtyFlag()
      this['_explainotherpurpose'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new refinance()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.yearacquired = __a__['yearacquired']
       cls.originalcost = __a__['originalcost']
       cls.existingliens = __a__['existingliens']
       cls.currentrate = __a__['currentrate']
       cls.currentprogram = __a__['currentprogram']
       cls.purpose = __a__['purpose']
       cls.improvementsdesc = __a__['improvementsdesc']
       cls.improvementsstatus = __a__['improvementsstatus']
       cls.cost = __a__['cost']
       cls.estimatedpayoffsandpayments = __a__['estimatedpayoffsandpayments']
       cls.explainotherpurpose = __a__['explainotherpurpose']
    } else {
       doAlert(`refinance: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class refinancedetails {
  constructor() {
    this['_originalPurchasePrice'] = ''
    this['_dateOfPurchase'] = ''
    this['_estimatedCurrentValue'] = ''
    this['_existingLoanAmount'] = ''
    this['_existingLender'] = ''
    this['_existingLoanRate'] = ''
    this['_existingLoanMaturityDate'] = ''
    this['_subordinateDebt'] = false
    this['_midConstruction'] = false
    this['_cashoutamount'] = ''
  }
  get originalPurchasePrice() { return this['_originalPurchasePrice'] }
  set originalPurchasePrice(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_originalPurchasePrice'])) {
      setDirtyFlag()
      this['_originalPurchasePrice'] = __v__
    }
  }
  get dateOfPurchase() { return this['_dateOfPurchase'] }
  set dateOfPurchase(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_dateOfPurchase'])) {
      setDirtyFlag()
      this['_dateOfPurchase'] = __v__
    }
  }
  get estimatedCurrentValue() { return this['_estimatedCurrentValue'] }
  set estimatedCurrentValue(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_estimatedCurrentValue'])) {
      setDirtyFlag()
      this['_estimatedCurrentValue'] = __v__
    }
  }
  get existingLoanAmount() { return this['_existingLoanAmount'] }
  set existingLoanAmount(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_existingLoanAmount'])) {
      setDirtyFlag()
      this['_existingLoanAmount'] = __v__
    }
  }
  get existingLender() { return this['_existingLender'] }
  set existingLender(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_existingLender'])) {
      setDirtyFlag()
      this['_existingLender'] = __v__
    }
  }
  get existingLoanRate() { return this['_existingLoanRate'] }
  set existingLoanRate(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_existingLoanRate'])) {
      setDirtyFlag()
      this['_existingLoanRate'] = __v__
    }
  }
  get existingLoanMaturityDate() { return this['_existingLoanMaturityDate'] }
  set existingLoanMaturityDate(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_existingLoanMaturityDate'])) {
      setDirtyFlag()
      this['_existingLoanMaturityDate'] = __v__
    }
  }
  get subordinateDebt() { return this['_subordinateDebt'] }
  set subordinateDebt(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_subordinateDebt'])) {
      setDirtyFlag()
      this['_subordinateDebt'] = __v__
    }
  }
  get midConstruction() { return this['_midConstruction'] }
  set midConstruction(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_midConstruction'])) {
      setDirtyFlag()
      this['_midConstruction'] = __v__
    }
  }
  get cashoutamount() { return this['_cashoutamount'] }
  set cashoutamount(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_cashoutamount'])) {
      setDirtyFlag()
      this['_cashoutamount'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new refinancedetails()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.originalPurchasePrice = __a__['originalPurchasePrice']
       cls.dateOfPurchase = __a__['dateOfPurchase']
       cls.estimatedCurrentValue = __a__['estimatedCurrentValue']
       cls.existingLoanAmount = __a__['existingLoanAmount']
       cls.existingLender = __a__['existingLender']
       cls.existingLoanRate = __a__['existingLoanRate']
       cls.existingLoanMaturityDate = __a__['existingLoanMaturityDate']
       cls.subordinateDebt = __a__['subordinateDebt']
       cls.midConstruction = __a__['midConstruction']
       cls.cashoutamount = __a__['cashoutamount']
    } else {
       doAlert(`refinancedetails: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class rehaborconstructiondetails {
  constructor() {
    this['_rehaborconstructionbudget'] = ''
    this['_rehaborconstructionbudgetremaining'] = ''
    this['_rehaborconstructioncostspenttodate'] = ''
    this['_interestreserves'] = ''
    this['_addingsqft'] = false
    this['_sqftadded'] = ''
    this['_addingunits'] = false
    this['_futurepropertytype'] = null
    this['_futuresqft'] = ''
    this['_futureunits'] = ''
    this['_futurebedrooms'] = ''
    this['_futurebathrooms'] = ''
    this['_currentsqft'] = ''
    this['_currentunits'] = ''
    this['_currentbedrooms'] = ''
    this['_currentbathrooms'] = ''
  }
  get rehaborconstructionbudget() { return this['_rehaborconstructionbudget'] }
  set rehaborconstructionbudget(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_rehaborconstructionbudget'])) {
      setDirtyFlag()
      this['_rehaborconstructionbudget'] = __v__
    }
  }
  get rehaborconstructionbudgetremaining() { return this['_rehaborconstructionbudgetremaining'] }
  set rehaborconstructionbudgetremaining(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_rehaborconstructionbudgetremaining'])) {
      setDirtyFlag()
      this['_rehaborconstructionbudgetremaining'] = __v__
    }
  }
  get rehaborconstructioncostspenttodate() { return this['_rehaborconstructioncostspenttodate'] }
  set rehaborconstructioncostspenttodate(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_rehaborconstructioncostspenttodate'])) {
      setDirtyFlag()
      this['_rehaborconstructioncostspenttodate'] = __v__
    }
  }
  get interestreserves() { return this['_interestreserves'] }
  set interestreserves(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_interestreserves'])) {
      setDirtyFlag()
      this['_interestreserves'] = __v__
    }
  }
  get addingsqft() { return this['_addingsqft'] }
  set addingsqft(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_addingsqft'])) {
      setDirtyFlag()
      this['_addingsqft'] = __v__
    }
  }
  get sqftadded() { return this['_sqftadded'] }
  set sqftadded(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_sqftadded'])) {
      setDirtyFlag()
      this['_sqftadded'] = __v__
    }
  }
  get addingunits() { return this['_addingunits'] }
  set addingunits(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_addingunits'])) {
      setDirtyFlag()
      this['_addingunits'] = __v__
    }
  }
  get futurepropertytype() { return this['_futurepropertytype'] }
  set futurepropertytype(__a__) {
    if(__a__ == null) {
      if(this['_futurepropertytype'] == null) { return }
      setDirtyFlag()
      this['_futurepropertytype'] = null
      return
    } else {
      let __v__ = enumReader(['singlefamilyattached','singlefamilydetached','condominium','condominiumdetached','pudattached','puddetached','twotofourfamily','twofamily','threefamily','fourfamily','multistory','manufacturedhome','land','commercial','townhouse','mixeduse','mobilehome'],'singlefamilyattached')(__a__)
      if(!_.isEqual(__v__,this['_futurepropertytype'])) {
        setDirtyFlag()
        this['_futurepropertytype'] = __v__
      }
    }
  }
  get futuresqft() { return this['_futuresqft'] }
  set futuresqft(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_futuresqft'])) {
      setDirtyFlag()
      this['_futuresqft'] = __v__
    }
  }
  get futureunits() { return this['_futureunits'] }
  set futureunits(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_futureunits'])) {
      setDirtyFlag()
      this['_futureunits'] = __v__
    }
  }
  get futurebedrooms() { return this['_futurebedrooms'] }
  set futurebedrooms(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_futurebedrooms'])) {
      setDirtyFlag()
      this['_futurebedrooms'] = __v__
    }
  }
  get futurebathrooms() { return this['_futurebathrooms'] }
  set futurebathrooms(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_futurebathrooms'])) {
      setDirtyFlag()
      this['_futurebathrooms'] = __v__
    }
  }
  get currentsqft() { return this['_currentsqft'] }
  set currentsqft(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_currentsqft'])) {
      setDirtyFlag()
      this['_currentsqft'] = __v__
    }
  }
  get currentunits() { return this['_currentunits'] }
  set currentunits(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_currentunits'])) {
      setDirtyFlag()
      this['_currentunits'] = __v__
    }
  }
  get currentbedrooms() { return this['_currentbedrooms'] }
  set currentbedrooms(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_currentbedrooms'])) {
      setDirtyFlag()
      this['_currentbedrooms'] = __v__
    }
  }
  get currentbathrooms() { return this['_currentbathrooms'] }
  set currentbathrooms(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_currentbathrooms'])) {
      setDirtyFlag()
      this['_currentbathrooms'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new rehaborconstructiondetails()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.rehaborconstructionbudget = __a__['rehaborconstructionbudget']
       cls.rehaborconstructionbudgetremaining = __a__['rehaborconstructionbudgetremaining']
       cls.rehaborconstructioncostspenttodate = __a__['rehaborconstructioncostspenttodate']
       cls.interestreserves = __a__['interestreserves']
       cls.addingsqft = __a__['addingsqft']
       cls.sqftadded = __a__['sqftadded']
       cls.addingunits = __a__['addingunits']
       cls.futurepropertytype = __a__['futurepropertytype'] == null ? null : __a__['futurepropertytype']
       cls.futuresqft = __a__['futuresqft']
       cls.futureunits = __a__['futureunits']
       cls.futurebedrooms = __a__['futurebedrooms']
       cls.futurebathrooms = __a__['futurebathrooms']
       cls.currentsqft = __a__['currentsqft']
       cls.currentunits = __a__['currentunits']
       cls.currentbedrooms = __a__['currentbedrooms']
       cls.currentbathrooms = __a__['currentbathrooms']
    } else {
       doAlert(`rehaborconstructiondetails: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class remotecoborrower {
  constructor() {
    this['_firstname'] = ''
    this['_lastname'] = ''
    this['_email'] = ''
    this['_invitationsent'] = false
    this['_status'] = 'created'
    this['_usetoqualify'] = true
    this['_key'] = ''
  }
  get firstname() { return this['_firstname'] }
  set firstname(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_firstname'])) {
      setDirtyFlag()
      this['_firstname'] = __v__
    }
  }
  get lastname() { return this['_lastname'] }
  set lastname(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_lastname'])) {
      setDirtyFlag()
      this['_lastname'] = __v__
    }
  }
  get email() { return this['_email'] }
  set email(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_email'])) {
      setDirtyFlag()
      this['_email'] = __v__
    }
  }
  get invitationsent() { return this['_invitationsent'] }
  set invitationsent(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_invitationsent'])) {
      setDirtyFlag()
      this['_invitationsent'] = __v__
    }
  }
  get status() { return this['_status'] }
  set status(__a__) {
    let __v__ = enumReader(['created','invited','accepted','prequalified','fullyfilled','documentsdone'],'created')(__a__)
    if(!_.isEqual(__v__,this['_status'])) {
      setDirtyFlag()
      this['_status'] = __v__
    }
  }
  get usetoqualify() { return this['_usetoqualify'] }
  set usetoqualify(__a__) {
    let __v__ = boolReader(true)(__a__)
    if(!_.isEqual(__v__,this['_usetoqualify'])) {
      setDirtyFlag()
      this['_usetoqualify'] = __v__
    }
  }
  get key() { return this['_key'] }
  set key(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_key'])) {
      setDirtyFlag()
      this['_key'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new remotecoborrower()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.firstname = __a__['firstname']
       cls.lastname = __a__['lastname']
       cls.email = __a__['email']
       cls.invitationsent = __a__['invitationsent']
       cls.status = __a__['status']
       cls.usetoqualify = __a__['usetoqualify']
       cls.key = __a__['key']
    } else {
       doAlert(`remotecoborrower: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class rentalpropertyexperience {
  constructor() {
    this['_streetline1'] = ''
    this['_streetline2'] = ''
    this['_city'] = ''
    this['_county'] = ''
    this['_state'] = ''
    this['_zip'] = ''
    this['_ownershipontitle'] = ''
    this['_propertytype'] = 'singlefamilyattached'
    this['_purchaseprice'] = ''
    this['_purchasedate'] = ''
    this['_tenantoccupied'] = false
    this['_monthlyrent'] = ''
    this['_datesold'] = ''
    this['_profitorloss'] = ''
  }
  get streetline1() { return this['_streetline1'] }
  set streetline1(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_streetline1'])) {
      setDirtyFlag()
      this['_streetline1'] = __v__
    }
  }
  get streetline2() { return this['_streetline2'] }
  set streetline2(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_streetline2'])) {
      setDirtyFlag()
      this['_streetline2'] = __v__
    }
  }
  get city() { return this['_city'] }
  set city(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_city'])) {
      setDirtyFlag()
      this['_city'] = __v__
    }
  }
  get county() { return this['_county'] }
  set county(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_county'])) {
      setDirtyFlag()
      this['_county'] = __v__
    }
  }
  get state() { return this['_state'] }
  set state(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_state'])) {
      setDirtyFlag()
      this['_state'] = __v__
    }
  }
  get zip() { return this['_zip'] }
  set zip(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_zip'])) {
      setDirtyFlag()
      this['_zip'] = __v__
    }
  }
  get ownershipontitle() { return this['_ownershipontitle'] }
  set ownershipontitle(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_ownershipontitle'])) {
      setDirtyFlag()
      this['_ownershipontitle'] = __v__
    }
  }
  get propertytype() { return this['_propertytype'] }
  set propertytype(__a__) {
    let __v__ = enumReader(['singlefamilyattached','singlefamilydetached','condominium','condominiumdetached','pudattached','puddetached','twotofourfamily','twofamily','threefamily','fourfamily','multistory','manufacturedhome','land','commercial','townhouse','mixeduse','mobilehome'],'singlefamilyattached')(__a__)
    if(!_.isEqual(__v__,this['_propertytype'])) {
      setDirtyFlag()
      this['_propertytype'] = __v__
    }
  }
  get purchaseprice() { return this['_purchaseprice'] }
  set purchaseprice(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_purchaseprice'])) {
      setDirtyFlag()
      this['_purchaseprice'] = __v__
    }
  }
  get purchasedate() { return this['_purchasedate'] }
  set purchasedate(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_purchasedate'])) {
      setDirtyFlag()
      this['_purchasedate'] = __v__
    }
  }
  get tenantoccupied() { return this['_tenantoccupied'] }
  set tenantoccupied(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_tenantoccupied'])) {
      setDirtyFlag()
      this['_tenantoccupied'] = __v__
    }
  }
  get monthlyrent() { return this['_monthlyrent'] }
  set monthlyrent(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_monthlyrent'])) {
      setDirtyFlag()
      this['_monthlyrent'] = __v__
    }
  }
  get datesold() { return this['_datesold'] }
  set datesold(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_datesold'])) {
      setDirtyFlag()
      this['_datesold'] = __v__
    }
  }
  get profitorloss() { return this['_profitorloss'] }
  set profitorloss(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_profitorloss'])) {
      setDirtyFlag()
      this['_profitorloss'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new rentalpropertyexperience()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.streetline1 = __a__['streetline1']
       cls.streetline2 = __a__['streetline2']
       cls.city = __a__['city']
       cls.county = __a__['county']
       cls.state = __a__['state']
       cls.zip = __a__['zip']
       cls.ownershipontitle = __a__['ownershipontitle']
       cls.propertytype = __a__['propertytype']
       cls.purchaseprice = __a__['purchaseprice']
       cls.purchasedate = __a__['purchasedate']
       cls.tenantoccupied = __a__['tenantoccupied']
       cls.monthlyrent = __a__['monthlyrent']
       cls.datesold = __a__['datesold']
       cls.profitorloss = __a__['profitorloss']
    } else {
       doAlert(`rentalpropertyexperience: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class score {
  constructor() {
    this['_score'] = 0
    this['_min'] = 0
    this['_max'] = 0
    this['_factors'] = []
  }
  get score() { return this['_score'] }
  set score(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_score'])) {
      setDirtyFlag()
      this['_score'] = __v__
    }
  }
  get min() { return this['_min'] }
  set min(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_min'])) {
      setDirtyFlag()
      this['_min'] = __v__
    }
  }
  get max() { return this['_max'] }
  set max(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_max'])) {
      setDirtyFlag()
      this['_max'] = __v__
    }
  }
  get factors() { return this['_factors'] }
  set factors(__a__) {
    setDirtyFlag()
    this['_factors'] = __a__
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new score()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.score = __a__['score']
       cls.min = __a__['min']
       cls.max = __a__['max']
       cls.factors = array1Reader(stringReader(''))(__a__['factors'])
    } else {
       doAlert(`score: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class scores {
  constructor() {
    this['_equifax'] = null
    this['_experian'] = null
    this['_transunion'] = null
  }
  get equifax() { return this['_equifax'] }
  set equifax(__a__) {
    if(__a__ == null) {
      if(this['_equifax'] == null) { return }
      setDirtyFlag()
      this['_equifax'] = null
      return
    } else {
      setDirtyFlag()
      this['_equifax'] = __a__
    }
  }
  get experian() { return this['_experian'] }
  set experian(__a__) {
    if(__a__ == null) {
      if(this['_experian'] == null) { return }
      setDirtyFlag()
      this['_experian'] = null
      return
    } else {
      setDirtyFlag()
      this['_experian'] = __a__
    }
  }
  get transunion() { return this['_transunion'] }
  set transunion(__a__) {
    if(__a__ == null) {
      if(this['_transunion'] == null) { return }
      setDirtyFlag()
      this['_transunion'] = null
      return
    } else {
      setDirtyFlag()
      this['_transunion'] = __a__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new scores()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.equifax = __a__['equifax'] == null ? null : score.fromJson(__a__['equifax'])
       cls.experian = __a__['experian'] == null ? null : score.fromJson(__a__['experian'])
       cls.transunion = __a__['transunion'] == null ? null : score.fromJson(__a__['transunion'])
    } else {
       doAlert(`scores: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class service {
  constructor() {
    this['_serviceName'] = ''
    this['_estimateAmount'] = 0.0
    this['_identifiedProvider'] = ''
    this['_contactInfo'] = ''
  }
  get serviceName() { return this['_serviceName'] }
  set serviceName(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_serviceName'])) {
      setDirtyFlag()
      this['_serviceName'] = __v__
    }
  }
  get estimateAmount() { return this['_estimateAmount'] }
  set estimateAmount(__a__) {
    let __v__ = floatReader(0.0)(__a__)
    if(!_.isEqual(__v__,this['_estimateAmount'])) {
      setDirtyFlag()
      this['_estimateAmount'] = __v__
    }
  }
  get identifiedProvider() { return this['_identifiedProvider'] }
  set identifiedProvider(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_identifiedProvider'])) {
      setDirtyFlag()
      this['_identifiedProvider'] = __v__
    }
  }
  get contactInfo() { return this['_contactInfo'] }
  set contactInfo(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_contactInfo'])) {
      setDirtyFlag()
      this['_contactInfo'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new service()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.serviceName = __a__['serviceName']
       cls.estimateAmount = __a__['estimateAmount']
       cls.identifiedProvider = __a__['identifiedProvider']
       cls.contactInfo = __a__['contactInfo']
    } else {
       doAlert(`service: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class step {
  constructor() {
    this['_step'] = 0
    this['_max'] = 0
  }
  get step() { return this['_step'] }
  set step(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_step'])) {
      setDirtyFlag()
      this['_step'] = __v__
    }
  }
  get max() { return this['_max'] }
  set max(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_max'])) {
      setDirtyFlag()
      this['_max'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new step()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.step = __a__['step']
       cls.max = __a__['max']
    } else {
       doAlert(`step: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class subjectproperty {
  constructor() {
    this['_address'] = ''
    this['_state'] = ''
    this['_county'] = ''
    this['_city'] = ''
    this['_zipcode'] = ''
    this['_description'] = ''
    this['_occupancy'] = 'principal'
    this['_hascontract'] = null
    this['_propertytype'] = 'singlefamilyattached'
    this['_purpose'] = null
    this['_units'] = '1'
    this['_yearbuilt'] = ''
    this['_lookupsuccessful'] = false
    this['_inwhatname'] = ''
    this['_inwhatmanner'] = ''
    this['_estateheldin'] = 'feesimple'
    this['_expirationdate'] = ''
    this['_sources'] = ''
    this['_purchase'] = new purchase()
    this['_refinance'] = new refinance()
    this['_construction'] = new construction()
    this['_appraisal'] = ''
    this['_salesprice'] = ''
    this['_projectreview'] = new ProjectReview()
    this['_solarpanels'] = new SolarPanels()
    this['_qualifiesForFHAsecondary'] = null
    this['_isManufacturedHome'] = null
    this['_isMixedUse'] = null
    this['_expenses'] = null
    this['_status'] = 'pending'
    this['_insurancemaintenancetaxes'] = ''
    this['_netrentalincome'] = ''
    this['_grossrentalincome'] = ''
    this['_loans'] = []
    this['_mobilehomeinfo'] = new MobileHomeInfo()
  }
  get address() { return this['_address'] }
  set address(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_address'])) {
      setDirtyFlag()
      this['_address'] = __v__
    }
  }
  get state() { return this['_state'] }
  set state(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_state'])) {
      setDirtyFlag()
      this['_state'] = __v__
    }
  }
  get county() { return this['_county'] }
  set county(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_county'])) {
      setDirtyFlag()
      this['_county'] = __v__
    }
  }
  get city() { return this['_city'] }
  set city(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_city'])) {
      setDirtyFlag()
      this['_city'] = __v__
    }
  }
  get zipcode() { return this['_zipcode'] }
  set zipcode(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_zipcode'])) {
      setDirtyFlag()
      this['_zipcode'] = __v__
    }
  }
  get description() { return this['_description'] }
  set description(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_description'])) {
      setDirtyFlag()
      this['_description'] = __v__
    }
  }
  get occupancy() { return this['_occupancy'] }
  set occupancy(__a__) {
    let __v__ = enumReader(['principal','secondhome','investment','fhasecond','other'],'principal')(__a__)
    if(!_.isEqual(__v__,this['_occupancy'])) {
      setDirtyFlag()
      this['_occupancy'] = __v__
    }
  }
  get hascontract() { return this['_hascontract'] }
  set hascontract(__a__) {
    if(__a__ == null) {
      if(this['_hascontract'] == null) { return }
      setDirtyFlag()
      this['_hascontract'] = null
      return
    } else {
      let __v__ = boolReader(false)(__a__)
      if(!_.isEqual(__v__,this['_hascontract'])) {
        setDirtyFlag()
        this['_hascontract'] = __v__
      }
    }
  }
  get propertytype() { return this['_propertytype'] }
  set propertytype(__a__) {
    let __v__ = enumReader(['singlefamilyattached','singlefamilydetached','condominium','condominiumdetached','pudattached','puddetached','twotofourfamily','twofamily','threefamily','fourfamily','multistory','manufacturedhome','land','commercial','townhouse','mixeduse','mobilehome'],'singlefamilyattached')(__a__)
    if(!_.isEqual(__v__,this['_propertytype'])) {
      setDirtyFlag()
      this['_propertytype'] = __v__
    }
  }
  get purpose() { return this['_purpose'] }
  set purpose(__a__) {
    if(__a__ == null) {
      if(this['_purpose'] == null) { return }
      setDirtyFlag()
      this['_purpose'] = null
      return
    } else {
      let __v__ = enumReader(['refinance','purchase','purchaserehab','construction','construction-permanent','improvement','cashoutrefinance'],'refinance')(__a__)
      if(!_.isEqual(__v__,this['_purpose'])) {
        setDirtyFlag()
        this['_purpose'] = __v__
      }
    }
  }
  get units() { return this['_units'] }
  set units(__a__) {
    let __v__ = IntSReader('1')(__a__)
    if(!_.isEqual(__v__,this['_units'])) {
      setDirtyFlag()
      this['_units'] = __v__
    }
  }
  get yearbuilt() { return this['_yearbuilt'] }
  set yearbuilt(__a__) {
    let __v__ = YearSReader('')(__a__)
    if(!_.isEqual(__v__,this['_yearbuilt'])) {
      setDirtyFlag()
      this['_yearbuilt'] = __v__
    }
  }
  get lookupsuccessful() { return this['_lookupsuccessful'] }
  set lookupsuccessful(__a__) {
    let __v__ = boolReader(false)(__a__)
    if(!_.isEqual(__v__,this['_lookupsuccessful'])) {
      setDirtyFlag()
      this['_lookupsuccessful'] = __v__
    }
  }
  get inwhatname() { return this['_inwhatname'] }
  set inwhatname(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_inwhatname'])) {
      setDirtyFlag()
      this['_inwhatname'] = __v__
    }
  }
  get inwhatmanner() { return this['_inwhatmanner'] }
  set inwhatmanner(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_inwhatmanner'])) {
      setDirtyFlag()
      this['_inwhatmanner'] = __v__
    }
  }
  get estateheldin() { return this['_estateheldin'] }
  set estateheldin(__a__) {
    let __v__ = enumReader(['feesimple','leasehold'],'feesimple')(__a__)
    if(!_.isEqual(__v__,this['_estateheldin'])) {
      setDirtyFlag()
      this['_estateheldin'] = __v__
    }
  }
  get expirationdate() { return this['_expirationdate'] }
  set expirationdate(__a__) {
    let __v__ = DateSReader('')(__a__)
    if(!_.isEqual(__v__,this['_expirationdate'])) {
      setDirtyFlag()
      this['_expirationdate'] = __v__
    }
  }
  get sources() { return this['_sources'] }
  set sources(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_sources'])) {
      setDirtyFlag()
      this['_sources'] = __v__
    }
  }
  get purchase() { return this['_purchase'] }
  set purchase(__a__) {
    setDirtyFlag()
    this['_purchase'] = __a__
  }
  get refinance() { return this['_refinance'] }
  set refinance(__a__) {
    setDirtyFlag()
    this['_refinance'] = __a__
  }
  get construction() { return this['_construction'] }
  set construction(__a__) {
    setDirtyFlag()
    this['_construction'] = __a__
  }
  get appraisal() { return this['_appraisal'] }
  set appraisal(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_appraisal'])) {
      setDirtyFlag()
      this['_appraisal'] = __v__
    }
  }
  get salesprice() { return this['_salesprice'] }
  set salesprice(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_salesprice'])) {
      setDirtyFlag()
      this['_salesprice'] = __v__
    }
  }
  get projectreview() { return this['_projectreview'] }
  set projectreview(__a__) {
    setDirtyFlag()
    this['_projectreview'] = __a__
  }
  get solarpanels() { return this['_solarpanels'] }
  set solarpanels(__a__) {
    setDirtyFlag()
    this['_solarpanels'] = __a__
  }
  get qualifiesForFHAsecondary() { return this['_qualifiesForFHAsecondary'] }
  set qualifiesForFHAsecondary(__a__) {
    if(__a__ == null) {
      if(this['_qualifiesForFHAsecondary'] == null) { return }
      setDirtyFlag()
      this['_qualifiesForFHAsecondary'] = null
      return
    } else {
      let __v__ = boolReader(false)(__a__)
      if(!_.isEqual(__v__,this['_qualifiesForFHAsecondary'])) {
        setDirtyFlag()
        this['_qualifiesForFHAsecondary'] = __v__
      }
    }
  }
  get isManufacturedHome() { return this['_isManufacturedHome'] }
  set isManufacturedHome(__a__) {
    if(__a__ == null) {
      if(this['_isManufacturedHome'] == null) { return }
      setDirtyFlag()
      this['_isManufacturedHome'] = null
      return
    } else {
      let __v__ = boolReader(false)(__a__)
      if(!_.isEqual(__v__,this['_isManufacturedHome'])) {
        setDirtyFlag()
        this['_isManufacturedHome'] = __v__
      }
    }
  }
  get isMixedUse() { return this['_isMixedUse'] }
  set isMixedUse(__a__) {
    if(__a__ == null) {
      if(this['_isMixedUse'] == null) { return }
      setDirtyFlag()
      this['_isMixedUse'] = null
      return
    } else {
      let __v__ = boolReader(false)(__a__)
      if(!_.isEqual(__v__,this['_isMixedUse'])) {
        setDirtyFlag()
        this['_isMixedUse'] = __v__
      }
    }
  }
  get expenses() { return this['_expenses'] }
  set expenses(__a__) {
    if(__a__ == null) {
      if(this['_expenses'] == null) { return }
      setDirtyFlag()
      this['_expenses'] = null
      return
    } else {
      setDirtyFlag()
      this['_expenses'] = __a__
    }
  }
  get status() { return this['_status'] }
  set status(__a__) {
    let __v__ = enumReader(['pending','sold','retained'],'pending')(__a__)
    if(!_.isEqual(__v__,this['_status'])) {
      setDirtyFlag()
      this['_status'] = __v__
    }
  }
  get insurancemaintenancetaxes() { return this['_insurancemaintenancetaxes'] }
  set insurancemaintenancetaxes(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_insurancemaintenancetaxes'])) {
      setDirtyFlag()
      this['_insurancemaintenancetaxes'] = __v__
    }
  }
  get netrentalincome() { return this['_netrentalincome'] }
  set netrentalincome(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_netrentalincome'])) {
      setDirtyFlag()
      this['_netrentalincome'] = __v__
    }
  }
  get grossrentalincome() { return this['_grossrentalincome'] }
  set grossrentalincome(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_grossrentalincome'])) {
      setDirtyFlag()
      this['_grossrentalincome'] = __v__
    }
  }
  get loans() { return this['_loans'] }
  set loans(__a__) {
    setDirtyFlag()
    this['_loans'] = __a__
  }
  get mobilehomeinfo() { return this['_mobilehomeinfo'] }
  set mobilehomeinfo(__a__) {
    setDirtyFlag()
    this['_mobilehomeinfo'] = __a__
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new subjectproperty()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.address = __a__['address']
       cls.state = __a__['state']
       cls.county = __a__['county']
       cls.city = __a__['city']
       cls.zipcode = __a__['zipcode']
       cls.description = __a__['description']
       cls.occupancy = __a__['occupancy']
       cls.hascontract = __a__['hascontract'] == null ? null : __a__['hascontract']
       cls.propertytype = __a__['propertytype']
       cls.purpose = __a__['purpose'] == null ? null : __a__['purpose']
       cls.units = __a__['units']
       cls.yearbuilt = __a__['yearbuilt']
       cls.lookupsuccessful = __a__['lookupsuccessful']
       cls.inwhatname = __a__['inwhatname']
       cls.inwhatmanner = __a__['inwhatmanner']
       cls.estateheldin = __a__['estateheldin']
       cls.expirationdate = __a__['expirationdate']
       cls.sources = __a__['sources']
       cls.purchase = purchase.fromJson(__a__['purchase'])
       cls.refinance = refinance.fromJson(__a__['refinance'])
       cls.construction = construction.fromJson(__a__['construction'])
       cls.appraisal = __a__['appraisal']
       cls.salesprice = __a__['salesprice']
       cls.projectreview = ProjectReview.fromJson(__a__['projectreview'])
       cls.solarpanels = SolarPanels.fromJson(__a__['solarpanels'])
       cls.qualifiesForFHAsecondary = __a__['qualifiesForFHAsecondary'] == null ? null : __a__['qualifiesForFHAsecondary']
       cls.isManufacturedHome = __a__['isManufacturedHome'] == null ? null : __a__['isManufacturedHome']
       cls.isMixedUse = __a__['isMixedUse'] == null ? null : __a__['isMixedUse']
       cls.expenses = __a__['expenses'] == null ? null : FutureExpenses.fromJson(__a__['expenses'])
       cls.status = __a__['status']
       cls.insurancemaintenancetaxes = __a__['insurancemaintenancetaxes']
       cls.netrentalincome = __a__['netrentalincome']
       cls.grossrentalincome = __a__['grossrentalincome']
       cls.loans = array1Reader(loan.fromJson)(__a__['loans'])
       cls.mobilehomeinfo = MobileHomeInfo.fromJson(__a__['mobilehomeinfo'])
    } else {
       doAlert(`subjectproperty: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class tasks {
  constructor() {
    this['_lastvisited'] = ''
  }
  get lastvisited() { return this['_lastvisited'] }
  set lastvisited(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_lastvisited'])) {
      setDirtyFlag()
      this['_lastvisited'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new tasks()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.lastvisited = __a__['lastvisited']
    } else {
       doAlert(`tasks: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class thirdpartycontact {
  constructor() {
    this['_name'] = ''
    this['_phone'] = ''
    this['_email'] = ''
    this['_company'] = ''
  }
  get name() { return this['_name'] }
  set name(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_name'])) {
      setDirtyFlag()
      this['_name'] = __v__
    }
  }
  get phone() { return this['_phone'] }
  set phone(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_phone'])) {
      setDirtyFlag()
      this['_phone'] = __v__
    }
  }
  get email() { return this['_email'] }
  set email(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_email'])) {
      setDirtyFlag()
      this['_email'] = __v__
    }
  }
  get company() { return this['_company'] }
  set company(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_company'])) {
      setDirtyFlag()
      this['_company'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new thirdpartycontact()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.name = __a__['name']
       cls.phone = __a__['phone']
       cls.email = __a__['email']
       cls.company = __a__['company']
    } else {
       doAlert(`thirdpartycontact: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

export class transaction {
  constructor() {
    this['_purchaseprice'] = 0
    this['_alterationsimprovements'] = 0
    this['_landifacquiredseparately'] = 0
    this['_refinanceincldebts'] = 0
    this['_estimatedprepaiditems'] = 0
    this['_estimatedclosingcosts'] = 0
    this['_pmifundingfee'] = 0
    this['_discountifborrowerpays'] = 0
    this['_totalcosts'] = 0
    this['_subordinatefinancing'] = 0
    this['_borrowerclosingcostspaidbyseller'] = 0
    this['_othercredits'] = 0
    this['_othercreditsexplanation'] = ''
    this['_loanamountexcludefees'] = 0
    this['_pmifundingfeefinanced'] = 0
    this['_loanamoount'] = 0
    this['_cashfromtoborrower'] = 0
    this['_cashdepositedby'] = ''
    this['_depositamount'] = ''
    this['_helocbalance'] = 0
    this['_helocamount'] = 0
  }
  get purchaseprice() { return this['_purchaseprice'] }
  set purchaseprice(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_purchaseprice'])) {
      setDirtyFlag()
      this['_purchaseprice'] = __v__
    }
  }
  get alterationsimprovements() { return this['_alterationsimprovements'] }
  set alterationsimprovements(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_alterationsimprovements'])) {
      setDirtyFlag()
      this['_alterationsimprovements'] = __v__
    }
  }
  get landifacquiredseparately() { return this['_landifacquiredseparately'] }
  set landifacquiredseparately(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_landifacquiredseparately'])) {
      setDirtyFlag()
      this['_landifacquiredseparately'] = __v__
    }
  }
  get refinanceincldebts() { return this['_refinanceincldebts'] }
  set refinanceincldebts(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_refinanceincldebts'])) {
      setDirtyFlag()
      this['_refinanceincldebts'] = __v__
    }
  }
  get estimatedprepaiditems() { return this['_estimatedprepaiditems'] }
  set estimatedprepaiditems(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_estimatedprepaiditems'])) {
      setDirtyFlag()
      this['_estimatedprepaiditems'] = __v__
    }
  }
  get estimatedclosingcosts() { return this['_estimatedclosingcosts'] }
  set estimatedclosingcosts(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_estimatedclosingcosts'])) {
      setDirtyFlag()
      this['_estimatedclosingcosts'] = __v__
    }
  }
  get pmifundingfee() { return this['_pmifundingfee'] }
  set pmifundingfee(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_pmifundingfee'])) {
      setDirtyFlag()
      this['_pmifundingfee'] = __v__
    }
  }
  get discountifborrowerpays() { return this['_discountifborrowerpays'] }
  set discountifborrowerpays(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_discountifborrowerpays'])) {
      setDirtyFlag()
      this['_discountifborrowerpays'] = __v__
    }
  }
  get totalcosts() { return this['_totalcosts'] }
  set totalcosts(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_totalcosts'])) {
      setDirtyFlag()
      this['_totalcosts'] = __v__
    }
  }
  get subordinatefinancing() { return this['_subordinatefinancing'] }
  set subordinatefinancing(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_subordinatefinancing'])) {
      setDirtyFlag()
      this['_subordinatefinancing'] = __v__
    }
  }
  get borrowerclosingcostspaidbyseller() { return this['_borrowerclosingcostspaidbyseller'] }
  set borrowerclosingcostspaidbyseller(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_borrowerclosingcostspaidbyseller'])) {
      setDirtyFlag()
      this['_borrowerclosingcostspaidbyseller'] = __v__
    }
  }
  get othercredits() { return this['_othercredits'] }
  set othercredits(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_othercredits'])) {
      setDirtyFlag()
      this['_othercredits'] = __v__
    }
  }
  get othercreditsexplanation() { return this['_othercreditsexplanation'] }
  set othercreditsexplanation(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_othercreditsexplanation'])) {
      setDirtyFlag()
      this['_othercreditsexplanation'] = __v__
    }
  }
  get loanamountexcludefees() { return this['_loanamountexcludefees'] }
  set loanamountexcludefees(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_loanamountexcludefees'])) {
      setDirtyFlag()
      this['_loanamountexcludefees'] = __v__
    }
  }
  get pmifundingfeefinanced() { return this['_pmifundingfeefinanced'] }
  set pmifundingfeefinanced(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_pmifundingfeefinanced'])) {
      setDirtyFlag()
      this['_pmifundingfeefinanced'] = __v__
    }
  }
  get loanamoount() { return this['_loanamoount'] }
  set loanamoount(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_loanamoount'])) {
      setDirtyFlag()
      this['_loanamoount'] = __v__
    }
  }
  get cashfromtoborrower() { return this['_cashfromtoborrower'] }
  set cashfromtoborrower(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_cashfromtoborrower'])) {
      setDirtyFlag()
      this['_cashfromtoborrower'] = __v__
    }
  }
  get cashdepositedby() { return this['_cashdepositedby'] }
  set cashdepositedby(__a__) {
    let __v__ = stringReader('')(__a__)
    if(!_.isEqual(__v__,this['_cashdepositedby'])) {
      setDirtyFlag()
      this['_cashdepositedby'] = __v__
    }
  }
  get depositamount() { return this['_depositamount'] }
  set depositamount(__a__) {
    let __v__ = DollarSReader('')(__a__)
    if(!_.isEqual(__v__,this['_depositamount'])) {
      setDirtyFlag()
      this['_depositamount'] = __v__
    }
  }
  get helocbalance() { return this['_helocbalance'] }
  set helocbalance(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_helocbalance'])) {
      setDirtyFlag()
      this['_helocbalance'] = __v__
    }
  }
  get helocamount() { return this['_helocamount'] }
  set helocamount(__a__) {
    let __v__ = intReader(0)(__a__)
    if(!_.isEqual(__v__,this['_helocamount'])) {
      setDirtyFlag()
      this['_helocamount'] = __v__
    }
  }

  toJson() { return JSON.stringify(this).split('"_').join('"') }

  static fromJson(__a__) {
    disableDF()
    let cls = new transaction()
    if(typeof __a__ === 'object' && __a__ != null) {
       cls.purchaseprice = __a__['purchaseprice']
       cls.alterationsimprovements = __a__['alterationsimprovements']
       cls.landifacquiredseparately = __a__['landifacquiredseparately']
       cls.refinanceincldebts = __a__['refinanceincldebts']
       cls.estimatedprepaiditems = __a__['estimatedprepaiditems']
       cls.estimatedclosingcosts = __a__['estimatedclosingcosts']
       cls.pmifundingfee = __a__['pmifundingfee']
       cls.discountifborrowerpays = __a__['discountifborrowerpays']
       cls.totalcosts = __a__['totalcosts']
       cls.subordinatefinancing = __a__['subordinatefinancing']
       cls.borrowerclosingcostspaidbyseller = __a__['borrowerclosingcostspaidbyseller']
       cls.othercredits = __a__['othercredits']
       cls.othercreditsexplanation = __a__['othercreditsexplanation']
       cls.loanamountexcludefees = __a__['loanamountexcludefees']
       cls.pmifundingfeefinanced = __a__['pmifundingfeefinanced']
       cls.loanamoount = __a__['loanamoount']
       cls.cashfromtoborrower = __a__['cashfromtoborrower']
       cls.cashdepositedby = __a__['cashdepositedby']
       cls.depositamount = __a__['depositamount']
       cls.helocbalance = __a__['helocbalance']
       cls.helocamount = __a__['helocamount']
    } else {
       doAlert(`transaction: an attempt to initialize from ${__a__}`)
    }
    enableDF()
    return cls
  }
}

const IntSReader = (() => {
  const r = RegExp('^\\d*$')
  return ((__dflt__) =>
    ((__a__) => {
      if(_.isString(__a__) && r.test(__a__)) {
        return __a__
      }
      doAlert(`IntSReader: ${__a__} is not an IntS`)
      if(_.isInteger(__a__)) {
        return __a__.toString()
      }
      return __dflt__
    })
  )
})()
const FloatSReader = (() => {
  const r = RegExp('^[-+]?\\d+[.]?\\d*([eE][-+]?\\d+)?$')
  return ((__dflt__) =>
    ((__a__) => {
      if(_.isString(__a__) && (__a__ === '' || r.test(__a__))) {
        return __a__
      }
      doAlert(`FloatSReader: ${__a__} is not a FloatS`)
      if(_.isFinite(__a__)) {
        return __a__.toString()
      }
      return __dflt__
    })
  )
})()
const DollarSReader = (() => {
  const r = RegExp('^\\d*$')
  return ((__dflt__) =>
    ((__a__) => {
      if(_.isString(__a__) && r.test(__a__)) {
        return __a__
      }
      doAlert(`DollarSReader: ${__a__} is not a DollarS`)
      if(_.isInteger(__a__)) {
        return __a__.toString()
      }
      return __dflt__
    })
  )
})()
const YearSReader = (() => {
  const r = RegExp('^\\d*$')
  return ((__dflt__) =>
    ((__a__) => {
      if(_.isString(__a__) && r.test(__a__)) {
        return __a__
      }
      doAlert(`YearSReader: ${__a__} is not a YearS`)
      if(_.isInteger(__a__)) {
        return __a__.toString()
      }
      return __dflt__
    })
  )
})()
const PhoneSReader = (() => {
  // const r = RegExp('^\\(\\d{3}\\)-\\d{3}-\\d{4}$')
  return ((__dflt__) =>
    ((__a__) => {
      if(_.isString(__a__)) {
        return __a__
      }
      doAlert(`PhoneSReader: ${__a__} is not a PhoneS`)
      return __dflt__
    })
  )
})()
const DateSReader = (() => {
  // const r = RegExp('^\\d{2}/\\d{2}/\\d{4}$')
  return ((__dflt__) =>
    ((__a__) => {
      if(_.isString(__a__)) {
        return __a__
      }
      doAlert(`DateSReader: ${__a__} is not a DateS`)
      return __dflt__
    })
  )
})()
function boolReader(__dflt__) {
  return ((__a__) => {
    if(_.isBoolean(__a__)) {
      return __a__
    }
    doAlert(`boolReader: ${__a__} is not a boolean`)
    if(__a__ === "yes" || __a__ === "true") {
      return true
    }
    if(__a__ === "no" || __a__ === "false") {
      return false
    }
    return __dflt__
  })
}
function intReader(__dflt__) {
  return ((__a__) => {
    if(_.isInteger(__a__)) {
      return __a__
    }
    doAlert(`intReader: ${__a__} is not an integer`)
    if(_.isString(__a__)) {
      let v = parseInt(__a__)
      if(_.isFinite(v)) {
        return v
      }
    }
    return __dflt__
  })
}
function floatReader(__dflt__) {
  return ((__a__) => {
    if(_.isFinite(__a__)) {
      return __a__
    }
    doAlert(`floatReader: ${__a__} is not a number`)
    if(_.isString(__a__)) {
      let v = parseFloat(__a__)
      if(_.isFinite(v)) {
        return v
      }
    }
    return __dflt__
  })
}
function stringReader(__dflt__) {
  return ((__a__) => {
    if(_.isString(__a__)) {
      return __a__
    }
    doAlert(`stringReader: ${__a__} is not a string`)
    return __dflt__
  })
}
function array1Reader(__r__) {
  return ((__a__) => {
    if(!_.isArray(__a__)) {
      doAlert(`arrayReader: ${__a__} is not an array`)
      return []
    }
    return __a__.map(__r__)
  })
}
function enumReader(__v__,__dflt__) {
  return ((__a__) => {
    if(!_.isString(__a__)) {
      doAlert(`enumReader: ${__a__} is not a string`)
      return __dflt__
    }
    if(__a__ !== __dflt__ && !_.includes(__v__,__a__)) {
      doAlert(`enumReader: ${__a__} is not in ${__v__}`)
      return __dflt__
    }
    return __a__
  })
}

let setDirtyFlag = () => { dirtyFlag = true }
let [disableDF,enableDF] = (() => {
    let n = 0
    return [() => {
      if(n === 0) {
        setDirtyFlag = () => {}
        n = 1
      } else {
        n += 1
      }
    },
    () => {
      if(n === 1) {
        setDirtyFlag = () => { dirtyFlag = true }
        n = 0
      } else {
        n -= 1
      }
    }]
})()
